/* eslint-disable */
// prettier-ignore
export { Day, CountryCode, CountrySubdivision } from "./types";
export type { Envelope } from "./types";
import { Day, CountryCode, CountrySubdivision } from "./types";

	export interface AuditInfo {
	}
	export interface LimitedAuditInfo {
	}
	export interface Message {
		Text: string;
		CssClass: string;
	}
	export enum SimpleError {
		Error = "Error",
		NotAllowSupportUser = "NotAllowSupportUser",
		NotFound = "NotFound",
		ItemHasBeenChanged = "ItemHasBeenChanged",
		VerificationValidationFailed = "VerificationValidationFailed",
	}
export namespace Accounting.Controllers {
	export interface AccountEntryDto {
		Account: number;
		Sum: Bokio.Common.Contract.AmountWithCurrency;
	}
	export interface ActivePeriodisationListItem {
		Id: string;
		OriginalVerificationId?: string;
		OriginalVerificationNumber: string;
		AdjustmentVerificationId: string;
		AdjustmentVerificationNumber: string;
		StartMonth: Day;
		EndMonth: Day;
		DraftVerificationCount: number;
		PublishedDraftCount: number;
		Status: Entities.Accounting.RecordingPeriodisationStatus;
		OriginalVerificationTitle: string;
		Reason: string;
		Entries: Accounting.Controllers.PeriodisationEntryDto[];
		Accounts: Accounting.Controllers.AccountEntryDto[];
	}
	export interface AoState {
		ReportId: string;
		Completed: boolean;
		Progress: string;
		Started: boolean;
		IsConnected: boolean;
		ReportUrl: string;
		BookkeepingImported: boolean;
		UserEmail: string;
		IsWrongUser: boolean;
		ConnectedUserEmail: string;
		OrgNumber: string;
		VerificationsInfo: Accounting.Viewmodels.Verifications.BasicVerificationInfo[];
	}
	export interface CashflowDayViewModel {
		Date: Day;
		Groups: Core.Reports.CashFlowItemGroup[];
	}
	export interface CashflowViewModel {
		Points: Accounting.Controllers.DataPoint[];
		FuturePoints: Accounting.Controllers.DataPoint[];
		StartDate: Day;
		EndDate: Day;
		PrognosisExplanation: Core.Reports.PrognosisExplanation;
	}
	export interface CombinedPreviewRequest {
		VerificationId: string;
		SelectedAccounts: number[];
		StartMonth?: Day;
		EndMonth?: Day;
	}
	export interface CombinedPreviewResponse {
		EligibleTransactions: Accounting.Controllers.EligibleTransactionDto[];
		AdjustmentVerification: Bokio.Accounting.Contract.Verifications.DTOs.VerificationPreviewDto;
		PlannedVerifications: Bokio.Accounting.Contract.Verifications.DTOs.VerificationPreviewDto[];
	}
	export interface ConnectToArsredovisningOnlineResult {
		NeedsAuthorization: boolean;
		Redirect: string;
	}
	export interface ConnectToVerificationRequest {
		ReceiptId: string;
		VerificationId: string;
	}
	export interface CreateCompanyCardRequest {
		Title: string;
		EmployeeId: string;
	}
	export interface CreateEmployeeExpenseAccountRequest {
		Title: string;
	}
	export interface CreatePeriodisationRequest {
		OriginalVerificationId?: string;
		SelectedTransactions: Accounting.Controllers.SelectedTransactionInput[];
		StartMonth: Day;
		EndMonth: Day;
		Reason: string;
	}
	export interface CreatePeriodisationResponse {
		PeriodisationId: string;
		AdjustmentVerificationId: string;
		DraftVerificationsCreated: number;
	}
	export interface CreateWithReceiptRequest {
		ReceiptId: string;
		EmployeeId: string;
	}
	export interface DataPoint {
		Date: Day;
		Value: number;
	}
	export interface DeleteMainPageRequest {
		ReceiptId: string;
		RemoveAllPages: boolean;
	}
	export interface DraftTransactionDto {
		Account: number;
		Sum: number;
	}
	export interface EditCompanyCardRequest {
		Title: string;
		EmployeeId: string;
	}
	export interface EligibleTransactionDto {
		Account: number;
		AccountName: string;
		Sum: number;
	}
	export interface EmployeeExpenseAccountViewModel {
		Id: string;
		EmployeeId: string;
		EmployeeName: string;
		Title: string;
		AccountType: Entities.Salary.EmployeeExpenseAccountType;
		IsDeleted: boolean;
	}
	export interface ExpensesOnboardingState {
		CompanyIsOnboarded: boolean;
		UserCanOnboard: boolean;
		ShouldShowOnboarding: boolean;
	}
	export interface FinishEarlyRequest {
		PeriodisationId: string;
		FinishDate: Day;
	}
	export interface FinishEarlyResponse {
		PublishedCount: number;
		EffectiveDate: Day;
		PostedToNextOpenPeriod: boolean;
	}
	export interface GetAccountsForEmployeeRequest {
		EmployeeId: string;
		IncludeDeleted?: boolean;
	}
	export interface GetAllMissingPredictionsResponse {
		ProcessedReceiptIds: string[];
		NeedsMoreProcessing: boolean;
		TotalProcessed: number;
		TotalRequested: number;
	}
	export interface GetAllPeriodisationsResponse {
		Periodisations: Accounting.Controllers.ActivePeriodisationListItem[];
	}
	export interface GetExpensesRequest {
		From?: Date;
		To?: Date;
		ForAllEmployees?: boolean;
		DisbursementId?: string;
		ExpenseAccountId?: string;
	}
	export enum GetPaymentInfoErrors {
		None = "None",
		InvalidCashAccounts = "InvalidCashAccounts",
	}
	export interface NEAttachmentViewModel {
		Data: { [key: string]: number; };
		Warnings: Bokio.Accounting.Web.Accounting.Controllers.NeAttachmentWarning[];
		SettingsId: string;
		Sections: Accounting.Viewmodels.Reports.Layouts.ReportSection[];
		Period: Classes.DateRange;
	}
	export interface PeriodisationDetailItem {
		CreatedAtUtc: Date;
		CreatedByUserId?: string;
		Id: string;
		OriginalVerificationId?: string;
		OriginalVerificationNumber: string;
		AdjustmentVerificationId: string;
		AdjustmentVerificationNumber: string;
		StartMonth: Day;
		EndMonth: Day;
		DraftVerificationCount: number;
		PublishedDraftCount: number;
		Status: Entities.Accounting.RecordingPeriodisationStatus;
		OriginalVerificationTitle: string;
		Reason: string;
		Entries: Accounting.Controllers.PeriodisationEntryDto[];
		Accounts: Accounting.Controllers.AccountEntryDto[];
	}
	export interface PeriodisationDraftVerificationDto {
		Id: string;
		Date: Day;
		Explanation: string;
		Transactions: Accounting.Controllers.DraftTransactionDto[];
		PeriodisationId: string;
		OriginalVerificationId?: string;
	}
	export interface PeriodisationDraftVerificationsResponse {
		DraftVerifications: Accounting.Controllers.PeriodisationDraftVerificationDto[];
	}
	export interface PeriodisationEntryDto {
		VerificationId?: string;
		VerificationNumber: string;
		Explanation: string;
		Date: Day;
		IsDraft: boolean;
	}
	export interface PeriodisationStatusResponse {
		PeriodisationId?: string;
		Status?: Entities.Accounting.RecordingPeriodisationStatus;
		StartMonth?: Day;
		EndMonth?: Day;
		AdjustmentVerificationId?: string;
		ReversalVerificationId?: string;
		DraftVerificationCount: number;
	}
	export interface PreviewByIdsRequest {
		VerificationIds: string[];
	}
	export interface PreviewPeriodisationResponse {
		AdjustmentVerification: Bokio.Accounting.Contract.Verifications.DTOs.VerificationPreviewDto;
		PlannedVerifications: Bokio.Accounting.Contract.Verifications.DTOs.VerificationPreviewDto[];
	}
	export interface PreviewTransactionDto {
		Account: number;
		Sum: number;
	}
	export interface PreviewUndoLastEntryResponse {
		VerificationDate: Day;
		VerificationNumber: string;
		Explanation: string;
		ReversalDate: Day;
		PostedToNextOpenPeriod: boolean;
	}
	export interface PreviewUndoResponse {
		ReversalTransactions: Accounting.Controllers.PreviewTransactionDto[];
		ReversalDate: Day;
		OriginalDate: Day;
		PostedToNextOpenPeriod: boolean;
		DraftsToRemove: number;
		PublishedDraftCount: number;
		Entries: Accounting.Controllers.UndoEntryPreviewDto[];
	}
	export interface ReportPeriod {
		StartDate: Day;
		EndDate: Day;
		Label: string;
		Key: string;
		LongLabel: string;
	}
	export interface ReportPeriodWithMonthSubs {
		Subs: Accounting.Controllers.ReportPeriod[];
		StartDate: Day;
		EndDate: Day;
		Label: string;
		Key: string;
		LongLabel: string;
	}
	export interface ScanResult {
		Receipt: Accounting.Viewmodels.ReceiptViewModel;
		EmployeeName: string;
	}
	export interface SelectedTransactionInput {
		Account: number;
		Sum: number;
	}
	export interface SetReceiptTypeRequest {
		ReceiptId: string;
		SelectedType: string;
	}
	export enum SupplierInvoiceDeleteError {
		General = "General",
		CannotDeleteVerification = "CannotDeleteVerification",
		HardDeleteVerificationNotAllowed = "HardDeleteVerificationNotAllowed",
	}
	export interface SupplierStatus {
		SupplierName: string;
		SupplierId: string;
		Balances: Bokio.Accounting.Contract.SupplierInvoices.Dtos.SupplierInvoicesBalance;
	}
	export interface TransactionForListVatDebug {
		OriginalAccount?: number;
		Account: number;
		AccountName: string;
		Debet: number;
		Credit: number;
		Id: number;
	}
	export interface UndoEntryPreviewDto {
		Date: Day;
		Explanation: string;
		VerificationNumber: string;
		Action: Bokio.Accounting.Services.Periodisations.UndoEntryAction;
	}
	export interface UndoLastEntryResponse {
		ReversalVerificationId: string;
		ReversalDate: Day;
		ReversedVerificationNumber: string;
		PostedToNextOpenPeriod: boolean;
	}
	export interface UndoPeriodisationResponse {
		ReversalVerificationId: string;
		ReversalDate: Day;
		DraftsRemoved: number;
		PostedToNextOpenPeriod: boolean;
	}
	export interface UpdateReceiptRequest {
		ReceiptId: string;
		Receipt?: Accounting.Controllers.UpdateReceiptValuesDto;
		Properties: string[];
		TryToAttest: boolean;
		SaveTemporaryPages: boolean;
		DeleteReceiptExtraPageIds: string[];
	}
	export interface UpdateReceiptValuesDto {
		Description: string;
		SelectedType?: Core.Contracts.Todo.ReceiptCategoryType;
		UserEnteredValues?: Accounting.Controllers.UserEnteredValuesDto;
	}
	export interface UploadExpenseImageRequest {
		File: Bokio.Common.Web.Helpers.ImageData;
		ExpenseForEmployeeId: string;
		StartRecepiptPredictionsNow?: boolean;
	}
	export interface UploadReceiptExtraPageRequest {
		File: Bokio.Common.Web.Helpers.ImageData;
		ReceiptId: string;
		Temporary?: boolean;
	}
	export interface UploadReceiptRequest {
		File: Bokio.Common.Web.Helpers.ImageData;
		SelectedType: string;
		VerificationId?: string;
		AutoVerificationRowId?: string;
		Description?: string;
		StartRecepiptPredictionsNow?: boolean;
	}
	export interface UploadReportToArsredovisningOnlineResult {
		NeedsAuthorization: boolean;
		UserFacingErrorMessageFromArsredovisningOnline: string;
		ReportUrl: string;
	}
	export interface UserEnteredValuesDto {
		Sum?: number;
		PaymentDate?: Day;
		Currency?: string;
	}
	export interface VerificationEditActionsViewModel {
		CanDelete: boolean;
		CanHardDelete: boolean;
		CanEdit: boolean;
		CorrectionAddress: string;
		ShouldNavigateToAddress: boolean;
		EntityType: Model.Commands.Accounting.Verifications.CorrectionEntityType;
	}
	export interface WebhookResponseData {
		Success: boolean;
	}
}
export namespace Accounting.Models {
	export interface BookkeepDisbursementRequest {
		DisbursementId: string;
		BookkeepingAccountNumber: number;
		UpdatedPaymentDate?: Date;
	}
	export enum ConnectDisbursementToAutoVerificationError {
		Unknown = "Unknown",
		DisbursementMarkedAsManuallyRecorded = "DisbursementMarkedAsManuallyRecorded",
		VerificationValidationFailed = "VerificationValidationFailed",
		ItemHasBeenChanged = "ItemHasBeenChanged",
		HasPendingTellerPayment = "HasPendingTellerPayment",
	}
	export interface ConnectDisbursementToAutoVerificationRowRequest {
		AutoVerificationRowId: string;
		DisbursementId: string;
		RowVersion: string;
	}
	export interface CreateDisbursementDto {
		EmployeeId: string;
		ExpenseIds: string[];
		Sum: number;
	}
	export interface CreateDisbursementPreviewDto {
		FirstName: string;
		EmployeeId: string;
		LastName: string;
		BankIdentifier: string;
		BankAccount: string;
		Sum: number;
		HasValidBankDetails: boolean;
	}
	export interface CreateDisbursementsRequest {
		PayDate: Day;
		PaymentRequests: Accounting.Models.CreateDisbursementDto[];
	}
	export interface CreateTellerDisbursementsRequest {
		BankAccountId: string;
		PayDate: Day;
		PaymentRequests: Accounting.Models.CreateDisbursementDto[];
	}
	export interface MarkAsManuallyRecordedRequest {
		DisbursementId: string;
		Reason: string;
	}
	export interface PreviewVerificationDto {
		Date: Day;
		Title: string;
		Transactions: Core.ViewData.TransactionForList[];
		AllowDraft?: boolean;
		IsCashSupplierInvoice?: boolean;
		ExpectPaymentAt?: Day;
		FailReasonsToBypass?: Core.Recipes.FailReason[];
	}
	export enum ReceiptFieldsPredictionError {
		ReceiptNotFound = "ReceiptNotFound",
		NotYetAvailable = "NotYetAvailable",
		UnableToPredict = "UnableToPredict",
		UnsupportedImageSize = "UnsupportedImageSize",
	}
	export enum ReceiptImagePredictionEffort {
		NoExternalCalls = "NoExternalCalls",
		AllowOcrCall = "AllowOcrCall",
		AllowAllExternalCalls = "AllowAllExternalCalls",
	}
	export interface UpdateExpenseRequest {
		ExpenseId: string;
		Description: string;
		Amount: number;
		PurchaseDate: Day;
		ExpenseAccountId?: string;
		EmployeeId?: string;
		ExpenseType?: Entities.ExpenseType;
		ForeignAmount?: Bokio.Common.Contract.AmountWithCurrency;
	}
}
export namespace Accounting.Viewmodels {
	export interface ReceiptExtraPageViewModel {
		Id: string;
		ReceiptId: string;
		PageNumber: number;
		ByteSize: number;
		Extension: string;
		ContentType: string;
		IsPdf: boolean;
	}
	export interface ReceiptForView {
		Id: string;
		Extrapages: Accounting.Viewmodels.ReceiptExtraPageViewModel[];
		IsPdf: boolean;
		Version: number;
		ReceiptType: Entities.ReceiptType;
		ExternalId: string;
		SelectedType: string;
		Description?: string;
		AllowDelete: boolean;
		Attested: boolean;
		VerificationId?: string;
		CanRecord: boolean;
		UploadedDate: Date;
		UploadedByUser?: string;
	}
	export interface ReceiptViewModel {
		Id: string;
		ReceiptContentType: string;
		SelectedType: string;
		PlannedPaymentAccount?: number;
		VerificationId?: string;
		Version: number;
		WaitingStatus: Entities.ReceiptWaitingStatus;
		SupportTickets: string[];
		Attestation: Entities.Attestation;
		ExpenseForEmployeeId?: string;
		SupplierInvoiceId?: string;
		ReceiptClass: Entities.ReceiptClass;
		CompanyId: string;
		Description?: string;
		ExpenseSum?: number;
		ExpenseDate?: Day;
		ExpenseTitle: string;
		ExpenseId?: string;
	}
	export interface UserInfo {
		Id: string;
		Name: string;
	}
}
export namespace Accounting.Viewmodels.Disbursements {
	export interface DisbursementHistoryViewModel {
		RestrictedToOwnHistory: boolean;
		CompletedDisbursements: Accounting.Viewmodels.Disbursements.DisbursementViewModel[];
	}
	export interface DisbursementListViewModel {
		HasPlanDisbursementsAccess: boolean;
		ExpensesNeedingPayment: Accounting.Viewmodels.Receipts.ExpenseListViewModel[];
		PlannedDisbursements: Accounting.Viewmodels.Disbursements.DisbursementViewModel[];
	}
	export interface DisbursementViewModel {
		Id: string;
		PayDate?: Day;
		Sum: number;
		Status: Entities.DisbursementStatus;
		VerificationId?: string;
		EmployeeId: string;
		EmployeeName: string;
		BankIdentifier: string;
		BankAccount: string;
		DisbursementPlannedByUserId: string;
		DisbursementPlannedByUserName: string;
		PaymentType: Entities.DisbursementPaymentType;
		TellerPaymentId?: string;
		TellerPaymentStatus?: Entities.Teller.TellerPaymentStatus;
		VerificationNumber?: string;
	}
	export interface DisbursementWithExpensesViewModel {
		Disbursement: Accounting.Viewmodels.Disbursements.DisbursementViewModel;
		Expenses: Accounting.Viewmodels.Receipts.ExpenseListViewModel[];
	}
}
export namespace Accounting.Viewmodels.Expenses {
	export interface AddFriskvardBalanceAdjustmentRequestDto {
		EmployeeId: string;
		Amount: number;
		Reason: string;
	}
	export interface AdjustExpenseRequestDto {
		NewAmount?: number;
		NewDate?: Day;
		Reason: string;
	}
	export interface BusinessTripDto {
		BusinessTripId: string;
		Purpose: string;
		Mileage?: Accounting.Viewmodels.Expenses.MileageDetailsDto;
		PerDiem?: Accounting.Viewmodels.Expenses.PerDiemDetailsDto;
	}
	export interface BusinessTripResultDto {
		BusinessTripId: string;
		MileageExpenseId?: string;
		PerDiemExpenseId?: string;
	}
	export interface CalculateMileageRequest {
		VehicleType: Entities.VehicleType;
		TotalDistanceKm: number;
	}
	export interface CalculateMileageResultDto {
		TotalDistanceKm: number;
		Mil: number;
		RatePerMil: number;
		TaxFreeAmount: number;
		TaxableAmount: number;
		TotalAmount: number;
	}
	export interface CalculatePerDiemRequest {
		CountryCode: string;
		DepartureDateTime: Date;
		ReturnDateTime: Date;
		DefaultBreakfastProvided: boolean;
		DefaultLunchProvided: boolean;
		DefaultDinnerProvided: boolean;
		DefaultAccommodationPaidByEmployee: boolean;
		DayOverrides?: Accounting.Viewmodels.Expenses.PerDiemDayOverrideDto[];
	}
	export interface CalculatePerDiemResultDto {
		Days: Accounting.Viewmodels.Expenses.PerDiemDayResultDto[];
		TotalTaxFreeAmount: number;
		TotalTaxableAmount: number;
		TotalAmount: number;
	}
	export interface ConvertToExpenseViewModel {
		ReceiptId: string;
		CanConvert: boolean;
		BlockedBySupplierInvoice: boolean;
		BlockedByBankConnection: boolean;
		BlockedByRecorded: boolean;
		BlockedByExpense: boolean;
		BlockedByNoEmployee: boolean;
	}
	export interface CountryRateDto {
		CountryCode: string;
		CountryName: string;
		FullDayRate: number;
		HalfDayRate: number;
		NightSupplement: number;
	}
	export interface CreateBusinessTripRequest {
		EmployeeId?: string;
		Purpose: string;
		Mileage?: Accounting.Viewmodels.Expenses.MileageSection;
		PerDiem?: Accounting.Viewmodels.Expenses.PerDiemSection;
	}
	export interface ExpenseAdjustmentDto {
		Id: string;
		ExpenseId: string;
		PreviousAmount?: number;
		NewAmount?: number;
		PreviousDate?: Day;
		NewDate?: Day;
		Reason: string;
		IsAutomatic: boolean;
		AdjustedAt: Date;
		AdjustedByUserId?: string;
	}
	export interface ExpensesEmployeeListItem {
		EmployeeId: string;
		UserId: string;
		Firstname: string;
		Lastname: string;
		Email: string;
	}
	export interface FriskvardBalanceAdjustmentDto {
		Id: string;
		EmployeeId: string;
		EmployeeName: string;
		Amount: number;
		Reason: string;
		PeriodStart: Day;
		AdjustedAt: Date;
		AdjustedByUserId?: string;
	}
	export interface FriskvardEmployeeBalanceDto {
		EmployeeId: string;
		EmployeeName: string;
		UsedAmount: number;
		RemainingAmount: number;
	}
	export interface FriskvardOverviewDto {
		IsEnabled: boolean;
		YearlyLimit: number;
		PeriodStart: Day;
		PeriodEnd: Day;
		Employees: Accounting.Viewmodels.Expenses.FriskvardEmployeeBalanceDto[];
	}
	export interface FriskvardSettingsDto {
		Id: string;
		YearlyLimitPerEmployee: number;
		RenewalMonth: number;
		RenewalDay: number;
		IsEnabled: boolean;
	}
	export interface FriskvardUsageDto {
		EmployeeId: string;
		EmployeeName: string;
		UsedAmount: number;
		YearlyLimit: number;
		RemainingAmount: number;
		PeriodStart: Day;
		PeriodEnd: Day;
	}
	export interface MileageDetailsDto {
		ExpenseId: string;
		VehicleType: Entities.VehicleType;
		TotalDistanceKm: number;
		TaxFreeAmount: number;
		TaxableAmount: number;
		TotalAmount: number;
		Legs: Accounting.Viewmodels.Expenses.MileageLegDto[];
	}
	export interface MileageLegDto {
		Id?: string;
		Date: Day;
		FromLocation: string;
		ToLocation: string;
		Purpose?: string;
		DistanceKm: number;
	}
	export interface MileageRatesDto {
		PrivateCarPerMil: number;
		ServiceCarFuelPerMil: number;
		ServiceCarElectricPerMil: number;
	}
	export interface MileageSection {
		VehicleType: Entities.VehicleType;
		Legs: Accounting.Viewmodels.Expenses.MileageLegDto[];
	}
	export interface PerDiemDayOverrideDto {
		Date: Day;
		BreakfastProvided?: boolean;
		LunchProvided?: boolean;
		DinnerProvided?: boolean;
		AccommodationPaidByEmployee?: boolean;
	}
	export interface PerDiemDayResultDto {
		Date: Day;
		IsFullDay: boolean;
		DailyRate: number;
		MealReduction: number;
		NightSupplement: number;
		DayAmount: number;
		BreakfastProvided: boolean;
		LunchProvided: boolean;
		DinnerProvided: boolean;
		AccommodationPaidByEmployee: boolean;
	}
	export interface PerDiemDetailsDto {
		ExpenseId: string;
		Destination: string;
		DestinationCountryCode: string;
		DepartureDateTime: Date;
		ReturnDateTime: Date;
		TotalTaxFreeAmount: number;
		TotalTaxableAmount: number;
		TotalAmount: number;
		Days: Accounting.Viewmodels.Expenses.PerDiemDayResultDto[];
	}
	export interface PerDiemRatesDto {
		DomesticFullDay: number;
		DomesticHalfDay: number;
		DomesticNightSupplement: number;
		Countries: Accounting.Viewmodels.Expenses.CountryRateDto[];
	}
	export interface PerDiemSection {
		DestinationCountryCode: string;
		Destination: string;
		DepartureDateTime: Date;
		ReturnDateTime: Date;
		DefaultBreakfastProvided: boolean;
		DefaultLunchProvided: boolean;
		DefaultDinnerProvided: boolean;
		DefaultAccommodationPaidByEmployee: boolean;
		DayOverrides?: Accounting.Viewmodels.Expenses.PerDiemDayOverrideDto[];
	}
	export interface UpdateBusinessTripRequest {
		BusinessTripId: string;
		EmployeeId?: string;
		Purpose: string;
		Mileage?: Accounting.Viewmodels.Expenses.MileageSection;
		PerDiem?: Accounting.Viewmodels.Expenses.PerDiemSection;
	}
	export interface UpdateFriskvardSettingsRequestDto {
		YearlyLimitPerEmployee: number;
		RenewalMonth: number;
		RenewalDay: number;
		IsEnabled: boolean;
	}
}
export namespace Accounting.Viewmodels.Files {
	export interface DeleteAssetRequest {
		AssetId: string;
		DeleteVerification: boolean;
	}
	export interface RecordVatTaxesDto {
		TaxDate: Day;
	}
	export interface RecordVatTaxesFromAutoVerificationDto {
		AutoVerificationRowId: string;
		RowVersion: string;
	}
	export interface SeVatReportLockRequest {
		ReportId: string;
		Year: number;
		Period: number;
		Cells: Entities.CellData[];
	}
	export interface SeVatReportRequest {
		ReportId: string;
		Year: number;
		Period: number;
	}
	export interface SeVatRequest {
		Year: number;
		Period: number;
	}
}
export namespace Accounting.Viewmodels.Receipts {
	export interface ExpenseListViewModel {
		ReceiptId: string;
		ClaimDate: Day;
		Amount?: number;
		ExpenseDate?: Day;
		Description: string;
		EmployeeId: string;
		EmployeeName: string;
		Status: Accounting.Viewmodels.Receipts.ExpenseStatus;
		PaymentDate?: Day;
		Id: string;
		VerificationId?: string;
		Attestation: Entities.Attestation;
		HasDisbursement: boolean;
		HasPaidDisbursement: boolean;
		DisbursementId?: string;
		ExpenseBookkeepingDate?: Day;
		VerificationNumber: string;
		ExpenseAccountId?: string;
		ExpenseAccountName: string;
		ExpenseAccountType?: Entities.Salary.EmployeeExpenseAccountType;
		ExpenseType: Entities.ExpenseType;
		BusinessTripId?: string;
		HasAdjustments: boolean;
		ForeignAmount?: Bokio.Common.Contract.AmountWithCurrency;
		IsDeletable: boolean;
		IsEditable: boolean;
	}
	export enum ExpenseStatus {
		Draft = "Draft",
		Submitted = "Submitted",
		Attested = "Attested",
		BookkeptCost = "BookkeptCost",
		PaymentPending = "PaymentPending",
		Done = "Done",
		Rejected = "Rejected",
	}
}
export namespace Accounting.Viewmodels.Recipes {
	export interface InitialRecipesViewModel {
		MostUsed: Bokio.Accounting.Contract.Recipes.Dtos.RecipeForList[];
	}
	export enum SearchError {
		NoError = "NoError",
		BuildingRecipeIndex = "BuildingRecipeIndex",
	}
	export interface SearchResult {
		Categories: string[];
		Matches: Bokio.Accounting.Contract.Recipes.Dtos.RecipeForList[];
		Search: string;
	}
}
export namespace Accounting.Viewmodels.Reports {
	export interface AccountsPayableResult {
		DueToAllSuppliers: number;
		Suppliers: Accounting.Viewmodels.Reports.SupplierDue[];
	}
	export interface BalanceReportViewModel {
		ReportSpan: Core.ViewData.FiscalYearViewModel;
		FiscalYears: Accounting.Viewmodels.Reports.FiscalYearSeries[];
		Rows: Core.ViewData.BalanceReportRowDto[];
		ReportWarnings: Bokio.Accounting.Contract.Reports.Dtos.ReportWarning[];
	}
	export interface CellInfo {
		Name: string;
		Value: number;
	}
	export interface ConnectWithHMRC {
		Code: string;
		CallbackState: string;
	}
	export interface ConnectWithHMRCError {
		Reason: Accounting.Viewmodels.Reports.ConnectWithHMRCErrorReason;
	}
	export enum ConnectWithHMRCErrorReason {
		Failure = "Failure",
	}
	export interface ConnectWithHMRCResult {
		RedirectUrl: string;
	}
	export interface DeleteVatReportRequest {
		ReportId: string;
		Year: number;
		Period: number;
	}
	export interface FiscalYearSeries {
		FiscalYear: Core.ViewData.FiscalYearViewModel;
		LatestVerificationSeriesEntries: string[];
	}
	export interface HMRCErrorBase {
		Reason: Accounting.Viewmodels.Reports.HMRCErrorReason;
		AuthenticationUrl?: string;
		ErrorMessage?: string;
		Endpoint?: string;
	}
	export enum HMRCErrorReason {
		Failure = "Failure",
		NoAuthToken = "NoAuthToken",
		AuthenticationRequired = "AuthenticationRequired",
		InvalidVatRegistrationNumber = "InvalidVatRegistrationNumber",
		MissingVatRegistrationNumber = "MissingVatRegistrationNumber",
		DuplicateSubmission = "DuplicateSubmission",
		ValuesChangedSinceCalculation = "ValuesChangedSinceCalculation",
		FiscalYearDoesNotExists = "FiscalYearDoesNotExists",
	}
	export interface InvoiceWithBalance {
		Id: string;
		Due: number;
		TotalSum: number;
		Title: string;
		ReferenceNumber: string;
		InvoiceDate: Day;
		Deadline: Date;
	}
	export interface LedgerReportRow {
		Account: number;
		AccountName: string;
		SubRows: Accounting.Viewmodels.Reports.LedgerReportSubRow[];
		IncomingSum: number;
		IncomingBalance: number;
		OutgoingDebit: number;
		OutgoingCredit: number;
		OutgoingBalance: number;
	}
	export interface LedgerReportSubRow {
		TransactionDate: Day;
		VerificationNumber: string;
		Text: string;
		Debet: number;
		Credit: number;
		AccumulatedSum: number;
		VerificationId: string;
		GeneratedId: string;
		IsInactive: boolean;
	}
	export interface LedgerReportViewModel {
		Rows: Accounting.Viewmodels.Reports.LedgerReportRow[];
		Print: boolean;
		PrintData: Accounting.Viewmodels.Reports.PrintData;
		ReportWarnings: Bokio.Accounting.Contract.Reports.Dtos.ReportWarning[];
	}
	export interface MarkVatTaxesAsPaid {
		Year: number;
		Month: number;
	}
	export interface PreviewHMRCVerificationResult {
		VATJournalEntry?: Core.ViewData.VerificationForList;
		ValidationErrors: Accounting.Viewmodels.Verifications.ValidationResultError[];
	}
	export interface PrintData {
		CompanyName: string;
		Period: string;
		FiscalYear: string;
		PrintDate: string;
		ReportSpan: Core.ViewData.FiscalYearViewModel;
		FiscalYears: Accounting.Viewmodels.Reports.FiscalYearSeries[];
	}
	export interface RegisterVatReportPayment {
		ReportId: string;
		Date: Day;
		Sum: number;
		Account: number;
	}
	export interface ResultReportViewModel {
		FiscalYears: Accounting.Viewmodels.Reports.FiscalYearSeries[];
		Periods: Core.Reports.ResultReportPeriod[];
		Rows: Core.ViewData.ResultReportRowDto[];
	}
	export interface ScheduledPaymentDto {
		VATPeriodId: string;
		RequestedAmount: number;
		Status: Entities.Teller.TellerPaymentStatus;
		VerificationId?: string;
		RequestedDate: Day;
	}
	export interface ScheduleVatPaymentRequest {
		Date: Day;
		Amount: number;
	}
	export enum SeVatReportError {
		Unknown = "Unknown",
		IllegalStateTransition = "IllegalStateTransition",
		DeleteVerification = "DeleteVerification",
	}
	export interface SeVatReportStateTransitionViewModel {
		ReportId: string;
	}
	export interface SubmitVatReportToHMRC {
		RedirectUrl: string;
		PeriodKey: string;
		Data: { [key: string]: number; };
	}
	export interface SubmitVatReportToHMRCError {
		Reason: Accounting.Viewmodels.Reports.HMRCErrorReason;
		AuthenticationUrl?: string;
		ErrorMessage?: string;
		Endpoint?: string;
	}
	export interface SubmitVatReportToHMRCResult {
	}
	export interface SupplierDue {
		Id: string;
		Due: number;
		Name: string;
		Invoices: Accounting.Viewmodels.Reports.InvoiceWithBalance[];
	}
	export interface UndoMarkVatTaxesAsPaid {
		Year: number;
		Month: number;
	}
	export enum VatPeriodDeclareState {
		NotDone = "NotDone",
		MarkedAsDoneManually = "MarkedAsDoneManually",
	}
	export interface VATPeriodForList {
		FromDate: Day;
		ToDate: Day;
		DueDate: Day;
		Status: Entities.VATPeriodStatus;
		ExternalKey: string;
		Received?: Day;
		LastSyncedUTC?: Date;
	}
	export enum VatPeriodLockState {
		NotDone = "NotDone",
		Locked = "Locked",
	}
	export enum VatPeriodPayState {
		NotDone = "NotDone",
		MarkedAsDoneManually = "MarkedAsDoneManually",
	}
	export enum VatPeriodRecordState {
		NotDone = "NotDone",
		Recorded = "Recorded",
	}
	export interface VATPeriodsError {
		Reason: Accounting.Viewmodels.Reports.HMRCErrorReason;
		AuthenticationUrl?: string;
		ErrorMessage?: string;
		Endpoint?: string;
	}
	export interface VATPeriodsForList {
		Periods: Accounting.Viewmodels.Reports.VATPeriodForList[];
		Endpoint?: string;
	}
	export enum VatReconcileState {
		NotDone = "NotDone",
		MarkedAsDoneManually = "MarkedAsDoneManually",
	}
	export interface VATReportActions {
		S1_ReconcileStepAction: Accounting.Viewmodels.Reports.VATReportStepAction;
		S2_SubmitStepAction: Accounting.Viewmodels.Reports.VATReportStepAction;
		S3_DeclareStepAction: Accounting.Viewmodels.Reports.VATReportStepAction;
		S4_CanUseBBA: boolean;
		S4_PaymentsStepAction: Accounting.Viewmodels.Reports.VATReportStepAction;
		S5_RecordStepAction: Accounting.Viewmodels.Reports.VATReportStepAction;
		CanQuickCompleteAction: Accounting.Viewmodels.Reports.VATReportStepAction;
		CanFullyDeleteReport: boolean;
	}
	export interface VATReportDebugViewModel {
		VerificationDebugList: Accounting.Viewmodels.Reports.VerificationDebugInfo[];
		PeriodDateRange: Classes.DateRange;
	}
	export interface VATReportErrorHMRC {
		Reason: Accounting.Viewmodels.Reports.HMRCErrorReason;
		AuthenticationUrl?: string;
		ErrorMessage?: string;
		Endpoint?: string;
	}
	export interface VATReportPaymentViewModel {
		VerificationId?: string;
		VerificationNumber: string;
	}
	export interface VATReportStatesViewModel {
		ReconcileState: Accounting.Viewmodels.Reports.VatReconcileState;
		LockState: Accounting.Viewmodels.Reports.VatPeriodLockState;
		DeclareState: Accounting.Viewmodels.Reports.VatPeriodDeclareState;
		PayState: Accounting.Viewmodels.Reports.VatPeriodPayState;
		RecordState: Accounting.Viewmodels.Reports.VatPeriodRecordState;
	}
	export enum VATReportStepAction {
		NotOpenYet = "NotOpenYet",
		CanComplete = "CanComplete",
		CanUndo = "CanUndo",
		BlockedByLaterStep = "BlockedByLaterStep",
		StepRequirementsNotMet = "StepRequirementsNotMet",
	}
	export interface VATReportTaxInfoViewModel {
		TaxDeadline: Day;
		NonEUTradeTaxDeadline?: Day;
		HasTaxAccountSync: boolean;
		TaxPaymentAccountNumber: string;
		TaxPaymentIdentifier: string;
		TaxesToPay?: number;
		EligableForTaxAccountSync: boolean;
		SuggestedTaxPaymentDate?: Day;
		ScheduledPayments: Accounting.Viewmodels.Reports.ScheduledPaymentDto[];
		ScheduledPaymentsSum: number;
		InvalidOrgNumber: boolean;
		TaxWasManuallyRecorded: boolean;
		TaxVerifications: Accounting.Viewmodels.Reports.VerificationInfo[];
	}
	export interface VATReportViewModel {
		Layout: Accounting.Viewmodels.Reports.Layouts.ReportLayout;
		ActivePeriod: Core.ViewData.ReportPeriodViewModel;
		SavedReport?: Core.ViewData.VATReportForView;
		HasSavedReport: boolean;
		ReportState: Core.Services.VAT.SeVatReportState;
		CanComplete: boolean;
		HasUnconnectedAccounts: boolean;
		UnconnectedAccounts: Core.ViewData.CustomAccountForView[];
		Cells: { [key: string]: number; };
		IncomingVatCell: string;
		TotalCell: string;
		EarlierOpen: boolean;
		FailedToRemap: string[];
		DidRemap: string[];
	}
	export interface VATReportViewModel2 {
		ReportViewModel: Accounting.Viewmodels.Reports.VATReportViewModel;
		TaxInfo: Accounting.Viewmodels.Reports.VATReportTaxInfoViewModel;
		Actions: Accounting.Viewmodels.Reports.VATReportActions;
		States: Accounting.Viewmodels.Reports.VATReportStatesViewModel;
		UnhandledEvents: Bokio.Accounting.Contract.UnhandledEvents.UnhandledEventDto[];
	}
	export interface VATReportViewModelHMRC {
		Layout: Accounting.Viewmodels.Reports.Layouts.ReportLayout;
		Data: { [key: string]: number; };
		DateRange: Classes.DateRange;
		DueDate: Day;
		HasSavedReport: boolean;
		ReportId?: string;
		VerificationId?: string;
		VerificationNumber: string;
		SubmissionReceiptId: string;
		SubmissionDate?: Day;
		ReportPaymentInfo: Accounting.Viewmodels.Reports.VATReportPaymentViewModel;
		IsZeroVATReport: boolean;
		ReportState: Entities.VatReportStateHMRC;
	}
	export interface VerificationDebugInfo {
		VerificationNumber: string;
		Date: Day;
		Errors: string[];
		Transactions: Accounting.Controllers.TransactionForListVatDebug[];
		Cells: Accounting.Viewmodels.Reports.CellInfo[];
		Title: string;
		Serie: string;
		Number: number;
		FailedToRemap: boolean;
		RemapState: Core.Reports.VAT.VerificationRemapperResultState;
		CanceledOrFromVatReport: boolean;
		WasDangerouslyBookkeptAfterLock: boolean;
	}
	export interface VerificationInfo {
		VerificationId?: string;
		Title: string;
		VerificationNumber: string;
		VerificationDate: Day;
	}
}
export namespace Accounting.Viewmodels.Reports.Layouts {
	export interface ReportBlock {
		Title: string;
		Cells: Accounting.Viewmodels.Reports.Layouts.ReportCell[];
		Print: boolean;
	}
	export interface ReportCell {
		Title: string;
		Key: string;
		Description: string;
		IsHeading: boolean;
		IsReadOnly: boolean;
		CssClass: string;
		Cells: Accounting.Viewmodels.Reports.Layouts.ReportCell[];
	}
	export interface ReportLayout {
		Sections: Accounting.Viewmodels.Reports.Layouts.ReportSection[];
		Period: Classes.DateRange;
	}
	export interface ReportSection {
		Title: string;
		Blocks: Accounting.Viewmodels.Reports.Layouts.ReportBlock[];
	}
}
export namespace Accounting.Viewmodels.TaxAccounts {
	export interface PreviewAccountDetails {
		Account: number;
		Balance: number;
	}
	export interface SearchViewModel {
		SearchString: string;
		UsedAccountMatches: Classes.Account[];
		Matches: Classes.AccountCategory[];
	}
}
export namespace Accounting.Viewmodels.Verifications {
	export interface BasicVerificationInfo {
		Id: string;
		VerificationNumber: string;
		VerificationDate: Day;
		Title: string;
	}
	export interface DeletePreviewViewModel {
		CanMakeHardDelete: boolean;
		Preview: Core.ViewData.VerificationForList;
	}
	export interface DeleteResult {
		DidHardDelete: boolean;
		NewVerificationId: string;
	}
	export interface DeleteVerificationPreviewViewModel {
		CancelVerification: Accounting.Viewmodels.Verifications.VerificationPreviewDetails;
		OriginalVerification: Accounting.Viewmodels.Verifications.VerificationPreviewDetails;
		AlreadyEdited: boolean;
	}
	export interface ListViewModel {
		Verifications: Core.ViewData.VerificationForList[];
		Years: number[];
		Correction: boolean;
		ActiveYearStart?: number;
		ActiveYearEnd?: number;
	}
	export interface PreviewDto {
		Verification: Core.ViewData.VerificationForList;
		Preview: Core.ViewData.VerificationPreview;
		ValidationResult: Accounting.Viewmodels.Verifications.ValidationResult;
		PaymentVerification: Core.ViewData.VerificationForList;
		PaymentVerificationValidationResult: Accounting.Viewmodels.Verifications.ValidationResult;
		NoticeToShow: Accounting.Viewmodels.Verifications.VerificationPreviewNoticeEnum;
		AllowVatAccountsOnlyBypass: boolean;
	}
	export interface RegisterPaymentViewModel {
		Sum: number;
		Account: number;
		Date: Day;
		MoneyAccounts: Bokio.Bank.Contract.MoneyAccount.MoneyAccountSettingsForView;
	}
	export interface ToAttestItem {
		CompanyId: string;
		ItemId: string;
		Name: string;
		User: Accounting.Viewmodels.UserInfo;
		AuditDate: Date;
		ExpenseId?: string;
		ExpenseSum?: number;
		ExpenseDate?: Date;
		ExpenseTitle: string;
	}
	export interface ToAttestViewModel {
		ToAttest: Accounting.Viewmodels.Verifications.ToAttestItem[];
	}
	export interface ValidationResult {
		IsValid: boolean;
		Errors: Accounting.Viewmodels.Verifications.ValidationResultError[];
		DuplicateVerificationIds: string[];
	}
	export interface ValidationResultError {
		FailReason: Core.Recipes.FailReason;
		FailReasonMessage: string;
	}
	export interface VerificationPreviewDetails {
		FailReason?: Core.Recipes.FailReason;
		Warning?: Core.Recipes.FailReason;
		Verification: Core.ViewData.VerificationForList;
	}
	export enum VerificationPreviewNoticeEnum {
		None = "None",
		TaxAccountBumper = "TaxAccountBumper",
		AccrualFundsBumper = "AccrualFundsBumper",
		SyncedAccountWarning = "SyncedAccountWarning",
		ClosureAccountsWarning = "ClosureAccountsWarning",
	}
	export interface VerificationPreviewViewModel {
		NewVerification: Accounting.Viewmodels.Verifications.VerificationPreviewDetails;
		CancelVerification: Accounting.Viewmodels.Verifications.VerificationPreviewDetails;
		OriginalVerification: Accounting.Viewmodels.Verifications.VerificationPreviewDetails;
		AlreadyEdited: boolean;
	}
}
export namespace Bokio.Accounting.Contract.AnnualReport.Dtos {
	export enum AnnualReportEntryDataType {
		Text = "Text",
		MultilineText = "MultilineText",
		Number = "Number",
		PositiveNumber = "PositiveNumber",
		Options = "Options",
		Date = "Date",
		OrganisationNumber = "OrganisationNumber",
		PhoneNumber = "PhoneNumber",
		Email = "Email",
		Address = "Address",
		Persons = "Persons",
		Yield = "Yield",
		Boolean = "Boolean",
		Information = "Information",
		Signature = "Signature",
		Json = "Json",
		Hidden = "Hidden",
	}
	export interface AnnualReportEntryGroupViewModel {
		Key: string;
		Status: Bokio.Accounting.Contract.AnnualReport.Dtos.AnnualReportEntryGroupViewModelStatus;
		Entries: Bokio.Accounting.Contract.AnnualReport.Dtos.AnnualReportEntryViewModel[];
		EntryCount: number;
		CompletedCount: number;
		SuggestedOrCompletedCount: number;
	}
	export enum AnnualReportEntryGroupViewModelStatus {
		Open = "Open",
		Disabled = "Disabled",
		Completed = "Completed",
	}
	export interface AnnualReportEntryViewModel {
		EntryKey: string;
		State: Bokio.Accounting.Contract.AnnualReport.Dtos.AnnualReportEntryViewModelState;
		DataType: Bokio.Accounting.Contract.AnnualReport.Dtos.AnnualReportEntryDataType;
		Disabled: boolean;
		JsonValue: string;
		OptionValues: string[];
		SuggestedJsonValue: string;
	}
	export enum AnnualReportEntryViewModelState {
		Open = "Open",
		Disabled = "Disabled",
		Completed = "Completed",
	}
	export interface AnnualReportStatusFormViewModel {
		Id: string;
		Entries: number;
		CompletedEntries: number;
		SuggestedEntries: number;
		Finished: boolean;
	}
	export interface AnnualReportStatusViewModel {
		Form?: Bokio.Accounting.Contract.AnnualReport.Dtos.AnnualReportStatusFormViewModel;
		MightBeOldClosure: boolean;
	}
	export interface AnnualReportViewModel {
		Id: string;
		System: Classes.SystemName;
		Groups: Bokio.Accounting.Contract.AnnualReport.Dtos.AnnualReportEntryGroupViewModel[];
		StartYear: number;
		EndYear: number;
		EntryCount: number;
		CompletedCount: number;
		SuggestedOrCompletedCount: number;
	}
	export interface BoardPerson {
		Name: string;
		Role: string;
	}
	export interface BoardPersonsDto {
		Persons: Bokio.Accounting.Contract.AnnualReport.Dtos.BoardPerson[];
	}
	export interface ClosureAccountResultDto {
		YearResultBalance: number;
		IsYearResultRecorded: boolean;
		ResultVerificationPreview: Bokio.Accounting.Contract.Verifications.DTOs.VerificationPreviewDto;
	}
	export interface ClosureFileDto {
		FileName: string;
		ContentType: string;
	}
	export enum ClosureFlow {
		ChoosePackage = "ChoosePackage",
		LegacyClosure = "LegacyClosure",
		DigitalAnnualReport = "DigitalAnnualReport",
		ArchivedClosure = "ArchivedClosure",
	}
}
export namespace Bokio.Accounting.Contract.AnnualReport.Errors {
	export interface AnnualReportSaveEntriesErrors {
		Errors: Bokio.Accounting.Contract.AnnualReport.Errors.AnnualReportSaveEntryError[];
	}
	export interface AnnualReportSaveEntryError {
		Key: string;
		Error: Bokio.Accounting.Contract.AnnualReport.Exceptions.AnnualReportResponseValidationError;
	}
}
export namespace Bokio.Accounting.Contract.AnnualReport.Exceptions {
	export enum AnnualReportResponseValidationError {
		NotANumber = "NotANumber",
		NotPositiveNumber = "NotPositiveNumber",
		NotADate = "NotADate",
		InvalidAddress = "InvalidAddress",
		InvalidOption = "InvalidOption",
		NoBoardMembers = "NoBoardMembers",
		InvalidJsonSchema = "InvalidJsonSchema",
		Required = "Required",
		NotABoolean = "NotABoolean",
		DuplicateEntry = "DuplicateEntry",
		InvalidSignature = "InvalidSignature",
	}
}
export namespace Bokio.Accounting.Contract.AnnualReport.Requests {
	export interface AnnualReportEntryToSave {
		Key: string;
		JsonValue: string;
	}
	export interface AnnualReportSaveEntriesRequest {
		ReportId: string;
		Entries: Bokio.Accounting.Contract.AnnualReport.Requests.AnnualReportEntryToSave[];
	}
}
export namespace Bokio.Accounting.Contract.Assets.Constants {
	export namespace FixedAssetLimitConstants {
		export const AssetLimit_ExclVat = {
			2023: 26250,
			2024: 28650,
			2025: 29400,
			2026: 29600 } as const;
		export const AssetLimit_InclVat = {
			2023: 32812.50,
			2024: 35812.50,
			2025: 36750.00,
			2026: 37000.00 } as const;
		export const AssetLimitUk_ExclVat = 250;
		export const AssetLimitUk_InclVat = 300;
	}
}
export namespace Bokio.Accounting.Contract.Assets.DTOs {
	export interface AssetDepreciationDto {
		Depreciations: Bokio.Accounting.Contract.Assets.DTOs.DepreciationForAssetDto[];
	}
	export interface AssetDepreciationPreviewDto {
		AssetId: string;
		AssetName: string;
		Amount: number;
		Verification: Bokio.Accounting.Contract.Assets.DTOs.VerificationRowDto[];
	}
	export interface AssetForListDto {
		AssetId: string;
		AssetTitle: string;
		AssetLifetime: number;
		Status: Entities.Accounting.AssetStatus;
		Category: string;
		PurchaseDate: Day;
		PurchaseAmount: number;
		AccumulatedAmount: number;
		LeftToDepreciate: number;
		PurchaseVerificationIds: string[];
		DepreciationVerificationIds: string[];
		LastDepreciationVerificationId?: string;
		DepreciationsUpToDate: boolean;
		DepreciatedUntil?: Day;
		AssetDepreciateFromDate?: Day;
		ResidualValue: number;
		HasDepreciations: boolean;
	}
	export interface AssetListDto {
		Assets: Bokio.Accounting.Contract.Assets.DTOs.AssetForListDto[];
	}
	export interface CreateAssetFromVerificationRequest {
		AssetVerificationId: string;
		CreateAsLegacyAsset?: boolean;
		AssetLifetime: number;
		AssetTitle: string;
	}
	export interface CreateManualAssetRequest {
		AssetPurchaseDate: Day;
		PurchaseAmount: number;
		AmountDepreciated: number;
		AssetAccount: number;
		VerificationIdToConnect?: string;
		AssetDepreciateFromDate?: Day;
		ResidualValue: number;
		DepreciatedToDate?: Day;
		AssetLifetime: number;
		AssetTitle: string;
	}
	export interface DepreciatableAssetDto {
		Account: number;
		AccountText: string;
	}
	export interface DepreciationForAssetDto {
		AssetId: string;
		DepreciationId: string;
	}
	export interface DepreciationPeriodDto {
		Year: number;
		Month: number;
		IsDefault: boolean;
		IsLocked: boolean;
		RecordingDate: Day;
	}
	export enum VerificationAssetStatus {
		NoActionsAvaliable = "NoActionsAvaliable",
		CanCreateAsset = "CanCreateAsset",
	}
	export interface VerificationRowDto {
		AccountCode: string;
		Debit: number;
		Credit: number;
	}
}
export namespace Bokio.Accounting.Contract.Assets.Errors {
	export interface AssetBalanceErrorData {
		AssetAccount: number;
		AllowedAssetAmount: number;
		DepreciationAccount: number;
		AllowedDepreciationAmount: number;
	}
	export interface RegisterAssetError {
		Type: Bokio.Accounting.Contract.Assets.Errors.RegisterAssetErrorType;
		BalanceErrorData?: Bokio.Accounting.Contract.Assets.Errors.AssetBalanceErrorData;
	}
	export enum RegisterAssetErrorType {
		Unknown = "Unknown",
		BalanceAccountsDoNotAgree = "BalanceAccountsDoNotAgree",
	}
}
export namespace Bokio.Accounting.Contract.Assets.Requests {
	export interface AddAllPendingDepreciationsRequest {
		UntilDate: Day;
	}
	export interface AddDepreciationRequest {
		AssetIds: string[];
		Year?: number;
		Month?: number;
		RecordingDate?: Day;
	}
	export enum AssetFilterState {
		All = "All",
		Active = "Active",
		Archived = "Archived",
	}
	export interface GetAssetDepreciationPerPeriodRequest {
		Year: number;
		Month: number;
	}
	export interface GetAssetsRequest {
		State: Bokio.Accounting.Contract.Assets.Requests.AssetFilterState;
		DepreciatedUntil?: Day;
	}
	export interface RemoveDepreciationRequest {
		DepreciationVerificationId: string;
	}
	export interface SearchForAssetVerificationRequest {
		Account: number;
		PurchaseAmount: number;
		PurchaseDate: Day;
	}
	export interface UpdateAssetRequest {
		AssetId: string;
		Title: string;
		LifeTime: number;
		AssetDepreciateFromDate?: Day;
		ResidualValue: number;
	}
}
export namespace Bokio.Accounting.Contract.AttestationOrgTree {
	export interface ApprovalRuleRequestDto {
		ApprovalLimit: number;
	}
	export interface AttestationApprovalRuleDto {
		Id: string;
		ApprovalLimit: number;
	}
	export interface AttestationAssignableCostOwnerDto {
		Id: string;
		UserId: string;
		UserName: string;
		Title?: string;
		Department?: string;
	}
	export interface AttestationCompanyUserDto {
		Id: string;
		Name: string;
		Email?: string;
	}
	export interface AttestationOrgNodeDto {
		Id: string;
		UserId: string;
		UserName: string;
		Title?: string;
		Department?: string;
		ParentId?: string;
		IsBoardNode: boolean;
		CoApproverNodeId?: string;
		DeadlineDays?: number;
		ApprovalRules: Bokio.Accounting.Contract.AttestationOrgTree.AttestationApprovalRuleDto[];
	}
	export interface AttestationOrgTreeDto {
		Id: string;
		Nodes: Bokio.Accounting.Contract.AttestationOrgTree.AttestationOrgNodeDto[];
	}
	export interface AttestationSettingsDto {
		IsEnabled: boolean;
		TreeNeedsReview: boolean;
	}
	export interface AttestationTreeImpactCategoryPreviewDto {
		Count: number;
		SampleRequests: Bokio.Accounting.Contract.AttestationOrgTree.AttestationTreeImpactSampleDto[];
	}
	export interface AttestationTreeImpactPreviewDto {
		Cosmetic: Bokio.Accounting.Contract.AttestationOrgTree.AttestationTreeImpactCategoryPreviewDto;
		Structural: Bokio.Accounting.Contract.AttestationOrgTree.AttestationTreeImpactCategoryPreviewDto;
		CostOwnerRemoved: Bokio.Accounting.Contract.AttestationOrgTree.AttestationTreeImpactCategoryPreviewDto;
	}
	export interface AttestationTreeImpactSampleDto {
		RequestId: string;
		AttestableEntityType: Entities.AttestationFlow.AttestableEntityType;
		AttestableEntityId: string;
		Amount: number;
		CostOwnerName?: string;
	}
	export interface RebuildSelectionsDto {
		Structural: boolean;
		CostOwnerRemoved: boolean;
		All: boolean;
	}
	export interface SaveOrgTreeNodeDto {
		UserId: string;
		Title?: string;
		Department?: string;
		ParentNodeKey?: string;
		IsBoardNode: boolean;
		CoApproverNodeKey?: string;
		DeadlineDays?: number;
		ApprovalRules: Bokio.Accounting.Contract.AttestationOrgTree.ApprovalRuleRequestDto[];
		NodeKey: string;
	}
	export interface SaveOrgTreeRequestDto {
		CurrentTreeId?: string;
		Nodes: Bokio.Accounting.Contract.AttestationOrgTree.SaveOrgTreeNodeDto[];
		Rebuild?: Bokio.Accounting.Contract.AttestationOrgTree.RebuildSelectionsDto;
	}
	export interface SetAttestationEnabledRequestDto {
		IsEnabled: boolean;
	}
}
export namespace Bokio.Accounting.Contract.AttestationRequest {
	export interface ApproverLimitedInvoiceDto {
		Id: string;
		Title?: string;
		ReferenceNumber?: string;
		Date: Day;
		Deadline: Day;
		Sum: number;
		SumInInvoiceCurrency?: number;
		CurrencyCode?: string;
		Supplier: Bokio.Accounting.Contract.AttestationRequest.ApproverLimitedSupplierDto;
		ReceiptId?: string;
	}
	export interface ApproverLimitedSupplierDto {
		Name: string;
	}
	export interface ApproveStepApiDto {
		RequestId: string;
		StepId: string;
	}
	export interface AssignCostOwnersApiDto {
		SupplierInvoiceId: string;
		CostOwners: Bokio.Accounting.Contract.AttestationRequest.CostOwnerAssignmentRequestDto[];
	}
	export interface AttestationApprovalViewDto {
		Invoice: Bokio.Accounting.Contract.AttestationRequest.ApproverLimitedInvoiceDto;
		Groups: Bokio.Accounting.Contract.AttestationRequest.AttestationRequestGroupDto[];
	}
	export interface AttestationRequestDto {
		Id: string;
		AttestableEntityType: Entities.AttestationFlow.AttestableEntityType;
		AttestableEntityId: string;
		Status: Entities.AttestationFlow.AttestationRequestStatus;
		Amount: number;
		CostOwnerUserId?: string;
		CostOwnerUserName?: string;
		AssignedByUserId?: string;
		AssignedByUserName?: string;
		CreatedAtUtc: Date;
		CompletedAtUtc?: Date;
		IsTestRun: boolean;
		Steps: Bokio.Accounting.Contract.AttestationRequest.AttestationRequestStepDto[];
	}
	export interface AttestationRequestGroupDto {
		Id: string;
		SupersededByGroupId?: string;
		Requests: Bokio.Accounting.Contract.AttestationRequest.AttestationRequestDto[];
	}
	export interface AttestationRequestStepDto {
		Id: string;
		StepType: Bokio.Accounting.Contract.AttestationRequest.AttestationStepType;
		Status: Entities.AttestationFlow.AttestationStepStatus;
		ApproverOrgNodeId: string;
		ApproverUserId: string;
		ApproverUserName: string;
		ApproverEmail?: string;
		ApproverTitle?: string;
		ApprovalLimit?: number;
		Comment?: string;
		ActionAtUtc?: Date;
		DeadlineUtc: Date;
		CreatedAtUtc: Date;
		CanEscalate: boolean;
	}
	export enum AttestationStepType {
		CostOwnerConfirmation = "CostOwnerConfirmation",
		Approval = "Approval",
		BoardApproval = "BoardApproval",
	}
	export interface CostOwnerAssignmentRequestDto {
		OrgNodeId: string;
		Amount: number;
	}
	export interface DenyStepApiDto {
		RequestId: string;
		StepId: string;
		Comment: string;
	}
	export interface EscalateStepApiDto {
		RequestId: string;
		StepId: string;
	}
	export interface ReassignCostOwnerApiDto {
		RequestId: string;
		NewCostOwners: Bokio.Accounting.Contract.AttestationRequest.CostOwnerAssignmentRequestDto[];
	}
}
export namespace Bokio.Accounting.Contract.AttestationSimulator {
	export interface CreateSimulationRequestDto {
		AttestableEntityType: Entities.AttestationFlow.AttestableEntityType;
		CostOwners: Bokio.Accounting.Contract.AttestationSimulator.SimulationCostOwnerDto[];
		IsSelfAssigned: boolean;
	}
	export interface SimulationActionRequestDto {
		RequestId: string;
		StepId: string;
	}
	export interface SimulationCostOwnerDto {
		OrgNodeId: string;
		Amount: number;
	}
	export interface SimulationDenyRequestDto {
		RequestId: string;
		StepId: string;
		Comment: string;
	}
}
export namespace Bokio.Accounting.Contract.AutomationRules.Dtos {
	export interface AutomationRuleActionDto {
		ActionType: Entities.AutomationRules.AutomationRuleActionType;
		Recipe: Bokio.Accounting.Contract.Recipes.Dtos.RecipeForList;
		VatArea?: string;
	}
	export interface AutomationRuleActionForMatching {
		Id: string;
		ActionType: Entities.AutomationRules.AutomationRuleActionType;
		Recipe: Bokio.Accounting.Contract.Recipes.Dtos.RecipeForList;
		VatArea?: string;
	}
	export interface AutomationRuleConstraintCombinationDto {
		ConstraintField: Entities.AutomationRules.AutomationRuleConstraintField;
		AllowedConstraintTypes: Entities.AutomationRules.AutomationRuleConstraintType[];
	}
	export interface AutomationRuleConstraintDto {
		ConstraintField: Entities.AutomationRules.AutomationRuleConstraintField;
		ConstraintType: Entities.AutomationRules.AutomationRuleConstraintType;
		NumberData?: number;
		StringData?: string;
		BooleanData?: boolean;
		ChildLogicOperator: Entities.AutomationRules.AutomationRuleLogicOperator;
		Children: Bokio.Accounting.Contract.AutomationRules.Dtos.AutomationRuleConstraintDto[];
		ParentConstraintId?: string;
		Id?: string;
		Key?: string;
	}
	export interface AutomationRuleConstraintForMatching {
		Id: string;
		ConstraintField: Entities.AutomationRules.AutomationRuleConstraintField;
		ConstraintType: Entities.AutomationRules.AutomationRuleConstraintType;
		NumberData?: number;
		StringData: string;
		BooleanData?: boolean;
		ChildConstraintsLogicOperator: Entities.AutomationRules.AutomationRuleLogicOperator;
		ParentConstraintId?: string;
	}
	export interface AutomationRuleDto {
		Id: string;
		Name: string;
		Status: Entities.AutomationRules.AutomationRuleStatus;
		Direction: Entities.AutomationRules.AutomationRuleDirection;
		Priority?: number;
		CreatedBy?: string;
		CreationDate: Day;
		Constraints: Bokio.Accounting.Contract.AutomationRules.Dtos.AutomationRuleConstraintDto[];
		Actions: Bokio.Accounting.Contract.AutomationRules.Dtos.AutomationRuleActionDto[];
		ConstraintsLogicOperator: Entities.AutomationRules.AutomationRuleLogicOperator;
		Source: Entities.AutomationRules.AutomationRuleSource;
		UsageArea: Entities.RecipeUsageArea;
		CreatedUserId?: string;
	}
	export interface AutomationRuleEventsMatchDto {
		Events: Bokio.Accounting.Contract.EventsToRecord.Dtos.EventToRecordForList[];
		Rule: Bokio.Accounting.Contract.AutomationRules.Dtos.AutomationRuleForMatching;
	}
	export interface AutomationRuleForMatching {
		Id: string;
		Name: string;
		Direction: Entities.AutomationRules.AutomationRuleDirection;
		Actions: Bokio.Accounting.Contract.AutomationRules.Dtos.AutomationRuleActionForMatching[];
		ConstraintsLogicOperator: Entities.AutomationRules.AutomationRuleLogicOperator;
		RuleUsageArea: Entities.RecipeUsageArea;
	}
	export interface AutomationRuleMatchDto {
		EventId: string;
		Rule: Bokio.Accounting.Contract.AutomationRules.Dtos.AutomationRuleForMatching;
		ValidForBulkRecording: boolean;
	}
	export interface AutomationRuleSuggestionRequest {
		AutoVerificationRowIds: string[];
		Type: Bokio.Accounting.Contract.AutomationRules.Dtos.AutomationRuleSuggestionRequestRowType;
	}
	export enum AutomationRuleSuggestionRequestRowType {
		AutoVerificationRow = "AutoVerificationRow",
		SupplierInvoice = "SupplierInvoice",
		Expense = "Expense",
	}
	export interface AutomationRuleSuggestionResponse {
		SuggestedRuleConstraint: Bokio.Accounting.Contract.AutomationRules.Dtos.AutomationRuleConstraintDto;
		Recipes: Bokio.Accounting.Contract.Recipes.Dtos.RecipeForList[];
		Direction: Entities.AutomationRules.AutomationRuleDirection;
	}
	export interface EventToMatchDto {
		EventId: string;
		EventType: Bokio.Accounting.Contract.EventsToRecord.Dtos.EventType;
		Amount: number;
		EffectiveDate: Date;
		Account: number;
		Text: string;
		SupplierInvoiceSupplierName: string;
		ReceiptVendorName: string;
		ReceiptVendorOrgNumber: string;
		ReceiptVendorVatNumber: string;
		SupplierInvoiceType?: Entities.Payment.SupplierInvoiceType;
	}
}
export namespace Bokio.Accounting.Contract.AutomationRules.Errors {
	export enum AutomationRuleError {
		InvalidConstraint = "InvalidConstraint",
		InvalidRecipeAction = "InvalidRecipeAction",
		InvalidStatusChange = "InvalidStatusChange",
		MaxConstraintCountExceeded = "MaxConstraintCountExceeded",
		MaxRuleCountExceeded = "MaxRuleCountExceeded",
		FeatureNotAvailable = "FeatureNotAvailable",
		InvalidEditOfEditedRule = "InvalidEditOfEditedRule",
		InvalidVatArea = "InvalidVatArea",
	}
}
export namespace Bokio.Accounting.Contract.AutomationRules.Requests {
	export interface ChangeAutomationRulesPriorityRequest {
		RuleIdsOrder: string[];
	}
	export interface ChangeAutomationRuleStatusRequest {
		RuleId: string;
		NewStatus: Entities.AutomationRules.AutomationRuleStatus;
	}
	export interface CreateAutomationRuleRequest {
		Name: string;
		Direction: Entities.AutomationRules.AutomationRuleDirection;
		Constraints: Bokio.Accounting.Contract.AutomationRules.Dtos.AutomationRuleConstraintDto[];
		Actions: Bokio.Accounting.Contract.AutomationRules.Dtos.AutomationRuleActionDto[];
		ConstraintsLogicOperator: Entities.AutomationRules.AutomationRuleLogicOperator;
		Source: Entities.AutomationRules.AutomationRuleSource;
	}
	export interface DebugAutomationRuleRequest {
		RuleRequest: Bokio.Accounting.Contract.AutomationRules.Requests.CreateAutomationRuleRequest;
		RowData: Bokio.Accounting.Contract.AutomationRules.Requests.DebugAutomationRuleRequestRowData;
	}
	export interface DebugAutomationRuleRequestRowData {
		Message: string;
		Account: number;
		Amount: number;
		SupplierName: string;
		ReceiptVendorName: string;
		ReceiptVendorOrgNumber: string;
		ReceiptVendorVatNumber: string;
	}
	export interface DebugAutomationRuleResponse {
		RuleDidMatch: boolean;
		DirectionMatched: boolean;
		Constraints: Bokio.Accounting.Contract.AutomationRules.Requests.DebugAutomationRuleResponseConstraintMatch[];
		UsageAreaMatched: boolean;
	}
	export interface DebugAutomationRuleResponseConstraintMatch {
		ConstraintKey: string;
		DidMatch: boolean;
	}
	export interface EditAutomationRuleRequest {
		Id: string;
		Name: string;
		Direction: Entities.AutomationRules.AutomationRuleDirection;
		Constraints: Bokio.Accounting.Contract.AutomationRules.Dtos.AutomationRuleConstraintDto[];
		Actions: Bokio.Accounting.Contract.AutomationRules.Dtos.AutomationRuleActionDto[];
		ConstraintsLogicOperator: Entities.AutomationRules.AutomationRuleLogicOperator;
		Source: Entities.AutomationRules.AutomationRuleSource;
	}
}
export namespace Bokio.Accounting.Contract.AutoVerification.DTOs {
	export interface AccountingAutoVerificationRowViewModel {
		AutomationRuleMatch?: Bokio.Accounting.Contract.AutomationRules.Dtos.AutomationRuleMatchDto;
		Category: Bokio.Accounting.Contract.Verifications.ReceiptCategory;
		Id: string;
		EffectiveDate?: Day;
		TransactionDate: Day;
		OriginalTransactionDate?: Day;
		Text?: string;
		Amount: number;
		Removed: boolean;
		Pending: boolean;
		VerificationId?: string;
		VerificationNumber: string;
		Account: number;
		MoneyAccountName: string;
		ReceiptIds: string[];
		Bank?: Bokio.Bank.Contract.Dtos.BankForView;
		Matches: Bokio.Bank.Contract.AutoVerificationRows.Matching.AutoVerificationMatch[];
		CanBeModified: boolean;
		CanBeSplit: boolean;
		CanBeMerged: boolean;
		OriginalId: string;
		InvoiceId?: string;
		RowVersion: string;
	}
	export interface AutomationRuleMatchable {
		Id: string;
		Text: string;
		Amount: number;
		Account: number;
		MoneyAccountName: string;
		ReceiptVendorName: string;
		ReceiptVendorOrgNumber: string;
		ReceiptVendorVatNumber: string;
		TransactionDate: Date;
		AutomationRuleMatch?: Bokio.Accounting.Contract.AutomationRules.Dtos.AutomationRuleMatchDto;
		RowType: Bokio.Accounting.Contract.AutoVerification.DTOs.RowType;
	}
	export enum AutomationRulePreviewMatchInfo {
		DidNotMatch = "DidNotMatch",
		MatchedRule = "MatchedRule",
		MatchedRuleButOtherHadPriority = "MatchedRuleButOtherHadPriority",
	}
	export interface AutoVerificationFilterAccountOptionDto {
		AccountNumber: number;
		AccountName: string;
	}
	export interface AutoVerificationFilterDto {
		SearchTerm: string;
		Account?: number;
		Matches: Bokio.Accounting.Contract.AutoVerification.DTOs.MatchFilterOptions;
		PaymentDirection: Bokio.Accounting.Contract.AutoVerification.DTOs.PaymentDirectionFilterOptions;
	}
	export interface AutoVerificationFilterRequestDto {
		Pagination: Bokio.Common.Contract.Pagination.Pagination;
		Sort: Bokio.Common.Contract.Utils.ListSortChoice<Bokio.Accounting.Contract.AutoVerification.DTOs.AutoVerificationSortableProperties>;
		Filter: Bokio.Accounting.Contract.AutoVerification.DTOs.AutoVerificationFilterDto;
	}
	export interface AutoVerificationFilterResponseDto {
		Items: Bokio.Accounting.Contract.AutoVerification.DTOs.AccountingAutoVerificationRowViewModel[];
		Filter: Bokio.Accounting.Contract.AutoVerification.DTOs.AutoVerificationFilterDto;
		Page: number;
		PageSize: number;
		TotalItems: number;
	}
	export enum AutoVerificationSortableProperties {
		Date = "Date",
		Text = "Text",
		Amount = "Amount",
		Account = "Account",
		AutomationRules = "AutomationRules",
	}
	export interface BankRowRuleMatch {
		Row: Bokio.Accounting.Contract.AutoVerification.DTOs.AutomationRuleMatchable;
		Match: Bokio.Accounting.Contract.AutoVerification.DTOs.AutomationRulePreviewMatchInfo;
	}
	export enum MatchFilterOptions {
		All = "All",
		WithMatches = "WithMatches",
		WithoutMatches = "WithoutMatches",
	}
	export enum PaymentDirectionFilterOptions {
		All = "All",
		In = "In",
		Out = "Out",
	}
	export interface PreviewTransactionVerificationsRequest {
		TransactionForms: Bokio.Accounting.Contract.AutoVerification.DTOs.TransactionForms[];
		IsVatFree: boolean;
	}
	export enum RowType {
		Invalid = "Invalid",
		BankTransaction = "BankTransaction",
		SupplierInvoice = "SupplierInvoice",
		Expense = "Expense",
	}
	export interface TransactionForms {
		RecipeForms: Bokio.Accounting.Contract.Verifications.DTOs.RecipeInfo[];
		GeneralForms: { [key: string]: string; };
		TransactionId?: string;
		OverrideTransactions?: Bokio.Accounting.Contract.Verifications.Requests.AccountDto[];
	}
}
export namespace Bokio.Accounting.Contract.BoookkeepingTutorial.Dtos {
	export interface ActiveTutorialDto {
		Title: string;
		Description: string;
		EstimatedMinutes: number;
		Status: Bokio.Accounting.Contract.BoookkeepingTutorial.Dtos.TutorialDtoStatus;
		ReceiptId: string;
		Key: string;
		TutorialSteps: Bokio.Accounting.Contract.BoookkeepingTutorial.Dtos.ActiveTutorialStepDto[];
	}
	export interface ActiveTutorialStepDto {
		HighligtItem: Entities.Accounting.HighligtItems;
		WhenToShow: string;
		Progress: number;
		Title: string;
		Ingress: string;
		DescriptionTitle: string;
		DescriptionText: string;
	}
	export interface TutorialDto {
		Title: string;
		Description: string;
		EstimatedMinutes: number;
		Status: Bokio.Accounting.Contract.BoookkeepingTutorial.Dtos.TutorialDtoStatus;
		Key: string;
	}
	export enum TutorialDtoStatus {
		NotStarted = "NotStarted",
		Started = "Started",
		Completed = "Completed",
	}
	export interface TutorialStateDto {
		AvailableTutorials: Bokio.Accounting.Contract.BoookkeepingTutorial.Dtos.TutorialDto[];
	}
}
export namespace Bokio.Accounting.Contract.Closures {
	export namespace ExportedClosureConstants {
		export const NEAttatchmentActivationCost = 99;
	}
}
export namespace Bokio.Accounting.Contract.Closures.Commands {
	export interface ReactivateClosure {
		ClosureId: string;
		SettingsId: string;
	}
	export interface SavePayDividendsPart {
		ClosureId: string;
		TotalNumberOfShares?: number;
		Shareholders: Bokio.Accounting.Contract.Closures.Commands.Shareholder[];
	}
	export interface Shareholder {
		Id: string;
		Name: string;
		BankAccount: string;
		ClearingNumber: string;
		NumberOfShares?: number;
	}
}
export namespace Bokio.Accounting.Contract.Commands.Accounting.Closures {
	export interface UndoBookkeepTransferEquityPart {
		ClosureId: string;
	}
}
export namespace Bokio.Accounting.Contract.CustomAccounts {
	export interface AccountDetailsBaseDto {
		Number: number;
		Name: string;
	}
	export interface AccountDetailsDto {
		IsCustomAccount: boolean;
		ConnectedAccount?: Bokio.Accounting.Contract.CustomAccounts.AccountDetailsBaseDto;
		CanBeRenamed: boolean;
		Mappings: Bokio.Accounting.Contract.CustomAccounts.AccountMappingDto[];
		CanBeResetted: boolean;
		Number: number;
		Name: string;
	}
	export interface AccountMappingDto {
		Name: string;
		Value: string;
		Key: Bokio.Accounting.Contract.CustomAccounts.AccountMappingKey;
	}
	export enum AccountMappingKey {
		Type = "Type",
		BalanceMapping = "BalanceMapping",
		ResultMapping = "ResultMapping",
		Deductable = "Deductable",
		VatMapping = "VatMapping",
	}
	export interface CreateCustomAccountDto {
		AccountNumber: number;
		ConnectedTo: number;
		Name: string;
	}
	export enum CustomAccountError {
		NoError = "NoError",
		AccountAlreadyExist = "AccountAlreadyExist",
		InvalidAccountNumber = "InvalidAccountNumber",
		MappedAccountIsNotValidForThisAccount = "MappedAccountIsNotValidForThisAccount",
		MappedAccoutDoesntExist = "MappedAccoutDoesntExist",
	}
	export interface DeleteCustomAccountDto {
		AccountNumber: number;
	}
	export interface EditCustomAccountDto {
		AccountNumber: number;
		ConnectedTo: number;
		Name: string;
	}
	export interface SetCustomAccountNameDto {
		AccountNumber: number;
		Name: string;
	}
	export interface UpdateCustomAccountsDto {
		CustomAccounts: Bokio.Accounting.Contract.CustomAccounts.EditCustomAccountDto[];
	}
}
export namespace Bokio.Accounting.Contract.Dashboard.Dtos {
	export interface AccountDto {
		Name: string;
		Balance: number;
		MapsTo: number;
	}
	export interface ExpenseDto {
		Account: number;
		AccountName: string;
		Amount: number;
	}
	export interface FinancialSummaryDto {
		TotalIncome: number;
		TotalExpense: number;
	}
	export interface IncomeAndExpenseByMonthDto {
		Periods: Bokio.Accounting.Contract.Dashboard.Dtos.IncomeAndExpenseDataPoint[];
	}
	export interface IncomeAndExpenseDataPoint {
		Year: number;
		Month: number;
		Income: number;
		Expense: number;
		Difference: number;
	}
	export interface InvoiceOverviewDto {
		Total: number;
		Overdue: number;
		DueToday: number;
		DueBetween1And7Days: number;
		DueBetween8And14Days: number;
		DueBetween15And21Days: number;
		DueAfter21Days: number;
	}
	export interface MoneyReportDto {
		Profit: number;
		TaxProfitAdjustment: number;
		BankAccountBalances: Bokio.Accounting.Contract.Dashboard.Dtos.AccountDto[];
		BankAccountBalance: number;
		TaxesToPay?: number;
		CompanyType: Entities.CompanyType;
		SocialFees: number;
		IncomeTax: number;
		LocalTax: number;
		SocialFeeRate: number;
		TaxReduction: number;
		MissingRequirements: string[];
		TaxWarning: string;
		CorporateTaxRate: number;
		BankAccounts: Bokio.Bank.Contract.Dtos.ListBankAccountsResponse;
		ReportWarnings: Bokio.Accounting.Contract.Reports.Dtos.ReportWarning[];
	}
	export interface ProprietorshipSettingsDto {
		LocalTax?: number;
		OtherIncome?: number;
	}
	export interface TopArticleDto {
		Amount: number;
		ArticleName: string;
	}
	export interface TopCustomerDto {
		CustomerName: string;
		Amount: number;
	}
	export interface TopFiveCustomersAndArticlesDto {
		TopFiveArticles: Bokio.Accounting.Contract.Dashboard.Dtos.TopArticleDto[];
		TopCustomers: Bokio.Accounting.Contract.Dashboard.Dtos.TopCustomerDto[];
	}
	export interface TopFiveExpensesDto {
		Expense: Bokio.Accounting.Contract.Dashboard.Dtos.ExpenseDto[];
		OtherAmmount: number;
	}
}
export namespace Bokio.Accounting.Contract.Errors {
	export enum VatSettingErrorType {
		SameSetting = "SameSetting",
		StartDateMustBeAfterLatest = "StartDateMustBeAfterLatest",
		ClosedFiscalYears = "ClosedFiscalYears",
		LockedVatReports = "LockedVatReports",
		NoFiscalYears = "NoFiscalYears",
		MustStartAtFirstFiscalYear = "MustStartAtFirstFiscalYear",
		MustStartAtFiscalYearStart = "MustStartAtFiscalYearStart",
		MustStartAtQuarterStart = "MustStartAtQuarterStart",
		MustBeInExistingFiscalYear = "MustBeInExistingFiscalYear",
	}
	export interface VatSettingValidationError {
		ErrorType: Bokio.Accounting.Contract.Errors.VatSettingErrorType;
		DateRanges?: Classes.DateRange[];
		LatestVatSettingStartDate?: Day;
		CurrentVatSetting?: Entities.VatSetting;
		NewVatSetting?: Entities.VatSetting;
		FirstFiscalYearStartDate?: Day;
		DateAfterWhichAllowed?: Day;
	}
}
export namespace Bokio.Accounting.Contract.EventsToRecord {
	export enum EventToRecordViewError {
		General = "General",
		ItemNotFound = "ItemNotFound",
		ItemAlreadyRecorded = "ItemAlreadyRecorded",
		InNonExistingFiscalYear = "InNonExistingFiscalYear",
		InClosedYear = "InClosedYear",
		NoBookkeepingAccount = "NoBookkeepingAccount",
		ItemIsInTheFuture = "ItemIsInTheFuture",
		InBlockedPeriod = "InBlockedPeriod",
		AlreadyAdjusted = "AlreadyAdjusted",
		ExpectedDateMismatch = "ExpectedDateMismatch",
	}
}
export namespace Bokio.Accounting.Contract.EventsToRecord.Dtos {
	export interface AddVerificationAttributeDto {
		Comment: string;
		VerificationId: string;
		Type: Entities.Accounting.VerificationAttributeType;
	}
	export interface AttributesForVerificationDto {
		Attributes: Bokio.Accounting.Contract.EventsToRecord.Dtos.VerificationAttributeForList[];
	}
	export interface BankAccountForEventsToRecordList {
		BankAccountId: string;
		BankAccountName: string;
		BankId: string;
		BankName: string;
		BookkeepingAccount?: number;
		LastSync?: Day;
		NeedReconnection: boolean;
		ExternalSystem: Entities.Bank.ExternalSystem;
		Status: Bokio.Accounting.Contract.EventsToRecord.Dtos.BankAccountForEventsToRecordListStatus;
		LogoPath?: string;
	}
	export enum BankAccountForEventsToRecordListStatus {
		OK = "OK",
		AlmostUpToDate = "AlmostUpToDate",
		NeedsAction = "NeedsAction",
	}
	export interface BankAccountsSyncStatusSummary {
		UpToDateUntill?: Day;
		WorstStatus: Bokio.Accounting.Contract.EventsToRecord.Dtos.BankAccountForEventsToRecordListStatus;
		UnmappedAccounts: string[];
		DuplicateBookkeepingAccounts: string[];
	}
	export interface BankgiroRowForList {
		ItemId: string;
		BankgiroNumber: string;
		Amount: number;
		Date: Day;
		Text: string;
		BookkeepingAccount: number;
	}
	export enum EventsToRecordEmptyState {
		ConnectBank = "ConnectBank",
		NoEvents = "NoEvents",
	}
	export interface EventsToRecordListView {
		EmptyState?: Bokio.Accounting.Contract.EventsToRecord.Dtos.EventsToRecordEmptyState;
		Items: Bokio.Accounting.Contract.EventsToRecord.Dtos.EventToRecordForList[];
		OldRowCount?: number;
		BankAccountSyncStatuses: Bokio.Accounting.Contract.EventsToRecord.Dtos.BankAccountForEventsToRecordList[];
		SyncStatusSummary: Bokio.Accounting.Contract.EventsToRecord.Dtos.BankAccountsSyncStatusSummary;
	}
	export interface EventToRecordActions {
		CanSplit: boolean;
		CanBeDeleted: boolean;
		CanBeMatched: boolean;
		CanAlterReceipt: boolean;
		CanDoReceiptMatching: boolean;
		CanUndoSplit: boolean;
		CanRequestReceipt: boolean;
	}
	export interface EventToRecordBookkeepingSuggestions {
		AutomationRuleMatch: Bokio.Accounting.Contract.AutomationRules.Dtos.AutomationRuleMatchDto;
		PredictionResult: Bokio.Accounting.Contract.Recipes.Dtos.PredictionResult;
		VerificationPreview: Bokio.Accounting.Contract.Verifications.DTOs.VerificationPreviewDto;
	}
	export interface EventToRecordDetails {
		Metadata: Bokio.Accounting.Contract.EventsToRecord.Dtos.VerificationMetadata[];
		SplitInfo?: Bokio.Accounting.Contract.EventsToRecord.Dtos.EventToRecordDetailsSplitInfo;
		ItemId: string;
		EventType: Bokio.Accounting.Contract.EventsToRecord.Dtos.EventType;
		AccountingType?: Entities.AccountingType;
		ItemActions: Bokio.Accounting.Contract.EventsToRecord.Dtos.EventToRecordActions;
		RowVersion: string;
		Date: Day;
		OriginalTransactionDate?: Day;
		Amount: Bokio.Common.Contract.AmountWithCurrency;
		Text?: string;
		VerificationId?: string;
		VerificationNumber?: string;
		BookkeepingAccount: number;
		MoneyAccountName: string;
		Category: Bokio.Accounting.Contract.Verifications.ReceiptCategory;
		ReceiptIds: string[];
		ReceiptRequestStatus: Entities.Accounting.ReceiptRequestStatus;
		ReceiptUploadedByUserId?: string;
		ReceiptRequestedByUserId?: string;
		TellerTransactionId?: string;
		SupplierData?: Bokio.Accounting.Contract.EventsToRecord.Dtos.SupplierInvoiceEtrData;
		ExpenseData?: Bokio.Accounting.Contract.EventsToRecord.Dtos.ExpenseEtrData;
	}
	export interface EventToRecordDetailsSplitInfo {
		OriginalAmount: Bokio.Common.Contract.AmountWithCurrency;
		NewRowCount: number;
		OriginalRowId?: string;
	}
	export interface EventToRecordForList {
		ItemId: string;
		EventType: Bokio.Accounting.Contract.EventsToRecord.Dtos.EventType;
		AccountingType?: Entities.AccountingType;
		ItemActions: Bokio.Accounting.Contract.EventsToRecord.Dtos.EventToRecordActions;
		RowVersion: string;
		Date: Day;
		OriginalTransactionDate?: Day;
		Amount: Bokio.Common.Contract.AmountWithCurrency;
		Text?: string;
		VerificationId?: string;
		VerificationNumber?: string;
		BookkeepingAccount: number;
		MoneyAccountName: string;
		Category: Bokio.Accounting.Contract.Verifications.ReceiptCategory;
		ReceiptIds: string[];
		ReceiptRequestStatus: Entities.Accounting.ReceiptRequestStatus;
		ReceiptUploadedByUserId?: string;
		ReceiptRequestedByUserId?: string;
		TellerTransactionId?: string;
		SupplierData?: Bokio.Accounting.Contract.EventsToRecord.Dtos.SupplierInvoiceEtrData;
		ExpenseData?: Bokio.Accounting.Contract.EventsToRecord.Dtos.ExpenseEtrData;
	}
	export interface EventToRecordReceiptMatch {
		Id: string;
		Date?: Date;
		Amount?: number;
		TotalPercentage: number;
		DatePercentage: number;
		AmountPercentage: number;
	}
	export interface EventToRecordReceiptMatchingView {
		ReceiptCount: number;
		NonScannedCount: number;
		RemainingScanDurationSeconds: number;
		Matches: Bokio.Accounting.Contract.EventsToRecord.Dtos.EventToRecordReceiptMatch[];
	}
	export interface EventToRecordView {
		Item: Bokio.Accounting.Contract.EventsToRecord.Dtos.EventToRecordDetails;
		BankRowMatches: Bokio.Bank.Contract.AutoVerificationRows.Matching.AutoVerificationMatch[];
		BookkeepingSuggestions: Bokio.Accounting.Contract.EventsToRecord.Dtos.EventToRecordBookkeepingSuggestions;
		VatPeriodIsLocked: boolean;
	}
	export enum EventType {
		Invalid = "Invalid",
		AutoVerificationRow = "AutoVerificationRow",
		SupplierInvoice = "SupplierInvoice",
		Expense = "Expense",
	}
	export interface ExpenseEtrData {
		EmployeeName: string;
		ExpenseAccountName: string;
		ExpenseAccountType?: Entities.Salary.EmployeeExpenseAccountType;
		VendorName?: string;
		VendorOrgNumber?: string;
		VendorVatNumber?: string;
	}
	export interface ParsedBankgiroExcelData {
		DateGroups: Bokio.Accounting.Contract.EventsToRecord.Dtos.ParsedBankgiroExcelDateGroup[];
	}
	export interface ParsedBankgiroExcelDateGroup {
		Date: Day;
		Rows: Bokio.Accounting.Contract.EventsToRecord.Dtos.ParsedBankgiroExcelRow[];
		TotalAmount: number;
	}
	export interface ParsedBankgiroExcelRow {
		Sender: string;
		Amount: number;
		PaymentReference?: string;
		BankgiroNumber?: string;
	}
	export interface PreRecordingChecksView {
		ReceiptsNeedingOcrScan: number;
		UnmatchedVerificationsCount: number;
		BankgiroRowsToSplit: number;
	}
	export interface RecordingPeriodStatus {
		IsBeforeFirstFiscalYear: boolean;
		IsInFiscalYearGap: boolean;
		IsInClosedFiscalYear: boolean;
		IsInLockedPeriod: boolean;
		IsInLockedVatPeriod: boolean;
		FirstOpenFiscalYearDate?: Day;
		FirstDateAfterLockPeriod?: Day;
		FirstDateAfterVatPeriod?: Day;
		NextRecordableDate?: Day;
		IsBlocked: boolean;
		CanAdjustDate: boolean;
	}
	export interface SupplierInvoiceEtrData {
		SupplierName: string;
		Type: Entities.Payment.SupplierInvoiceType;
		OriginalInvoice?: Bokio.Accounting.Contract.EventsToRecord.Dtos.SupplierInvoiceEtrDataOriginalInvoice;
	}
	export interface SupplierInvoiceEtrDataOriginalInvoice {
		Id: string;
		Sum: Bokio.Common.Contract.AmountWithCurrency;
		Date: Day;
		PrefillData: string;
		VerificationId?: string;
		AccountingType: Entities.AccountingType;
		IsRecorded: boolean;
		InvoiceSystem: Entities.Payment.SupplierInvoiceSystem;
		SumInInvoiceCurrency?: number;
		IsConnectedCreditInvoice: boolean;
		Type: Entities.Payment.SupplierInvoiceType;
	}
	export interface VerificationAttributeDto {
		VerificationId: string;
		Type: Entities.Accounting.VerificationAttributeType;
	}
	export interface VerificationAttributeForList {
		Type: Entities.Accounting.VerificationAttributeType;
		Comment: string;
		CreatedUtc: Date;
		UserEmail: string;
		UserId?: string;
	}
	export interface VerificationMetadata {
		Id: string;
		DataProvider: Entities.Bank.DataProvider;
		Key: Entities.Bank.MetadataKey;
		Value: string;
	}
}
export namespace Bokio.Accounting.Contract.EventsToRecord.Requests {
	export interface AdjustRecordingDateRequest {
		ItemId: string;
		Type: Bokio.Accounting.Contract.EventsToRecord.Dtos.EventType;
		ExpectedDate: Day;
	}
	export interface BankgiroSplitItem {
		Amount: number;
		Text?: string;
	}
	export interface RecordEvent {
		SaveVerificationFromMultipleRecipesRequest?: Bokio.Accounting.Contract.Verifications.Requests.SaveVerificationFromMultipleRecipesRequest;
		RegisterViewModel?: Core.ViewData.RegisterViewModel;
		CheckForMatches: boolean;
		RowVersion?: string;
	}
	export interface RevertRecordingDateRequest {
		ItemId: string;
		Type: Bokio.Accounting.Contract.EventsToRecord.Dtos.EventType;
	}
	export interface SplitBankgiroRowRequest {
		OriginalRowId: string;
		SplitItems: Bokio.Accounting.Contract.EventsToRecord.Requests.BankgiroSplitItem[];
	}
}
export namespace Bokio.Accounting.Contract.FiscalYears.Dtos {
	export interface FiscalYearsViewModel {
		FiscalYears: Bokio.Accounting.Contract.FiscalYears.Dtos.FiscalYearViewModel[];
	}
	export interface FiscalYearViewModel {
		StartDate: Day;
		EndDate: Day;
		CompanySettingsId: string;
		IsClosed: boolean;
	}
	export interface MoveFirstFiscalYearStartDateResult {
		NewStartDate?: Day;
		NewEndDate?: Day;
		MovedVerifications: Core.ViewData.VerificationForList[];
		FirstFiscalYearStartMatch: Bokio.Accounting.Contract.Services.FiscalYears.FirstFiscalYearStartMatch;
		SettingId: string;
		OldEndDate: Day;
		OldStartDate: Day;
	}
}
export namespace Bokio.Accounting.Contract.FiscalYears.Errors {
	export enum ClosureError {
		EndDateInTheFuture = "EndDateInTheFuture",
		PreviousFiscalYearsOpen = "PreviousFiscalYearsOpen",
		NoFollowingFiscalYear = "NoFollowingFiscalYear",
		FiscalYearIsAlreadyClosed = "FiscalYearIsAlreadyClosed",
		UnknownFiscalYear = "UnknownFiscalYear",
		OverlappingFiscalYear = "OverlappingFiscalYear",
		FiscalYearIsAlreadyOpen = "FiscalYearIsAlreadyOpen",
		FollowingFiscalYearIsClosed = "FollowingFiscalYearIsClosed",
		PreviousOpenFiscalYear = "PreviousOpenFiscalYear",
		OK = "OK",
		ImbalancedFiscalYear = "ImbalancedFiscalYear",
		EndDateIsTooClose = "EndDateIsTooClose",
		UserSetIncomingBalanceInFutureFiscalYear = "UserSetIncomingBalanceInFutureFiscalYear",
	}
	export enum DeleteFiscalYearError {
		CouldNotDelete = "CouldNotDelete",
		VatReportExists = "VatReportExists",
	}
	export interface QuickActionYearErrorsWarnings {
		Warnings: Bokio.Accounting.Contract.FiscalYears.Errors.QuickActionYearWarnings[];
		Errors: Bokio.Accounting.Contract.FiscalYears.Errors.ClosureError[];
		Information: Bokio.Accounting.Contract.FiscalYears.Errors.QuickActionYearInformation[];
		WarningMessages: string[];
		ErrorMessages: string[];
		InformationMessages: string[];
	}
	export enum QuickActionYearInformation {
		FollowingClosedYears = "FollowingClosedYears",
	}
	export enum QuickActionYearWarnings {
		BalanceDiffWithoutTransactions = "BalanceDiffWithoutTransactions",
	}
}
export namespace Bokio.Accounting.Contract.ImportSi.DTOs {
	export interface ErrorOrWarning {
		Code: Core.Recipes.FailReason;
		Message: string;
	}
	export interface FileValidationDto {
		VerificationValidationList: Bokio.Accounting.Contract.ImportSi.DTOs.VerificationValidation[];
		IsValid: boolean;
		ParseErrors: string[];
	}
	export interface ValidationDto {
		FileGroupId: string;
		FilesValidation: Bokio.Accounting.Contract.ImportSi.DTOs.FileValidationDto[];
	}
	export interface VerificationValidation {
		Verification: Core.ViewData.VerificationForList;
		Errors: Bokio.Accounting.Contract.ImportSi.DTOs.ErrorOrWarning[];
		Warnings: Bokio.Accounting.Contract.ImportSi.DTOs.ErrorOrWarning[];
	}
}
export namespace Bokio.Accounting.Contract.PowerFunctions.Dtos {
	export interface BankRowMatch {
		AccuracyScore: number;
		BankRow: Bokio.Accounting.Contract.PowerFunctions.Dtos.MatchItem;
		Match: Bokio.Bank.Contract.AutoVerificationRows.Matching.AutoVerificationMatch;
	}
	export interface BankRowMatchView {
		PerfectMatches: Bokio.Accounting.Contract.PowerFunctions.Dtos.BankRowMatch[];
		PotentialMatches: Bokio.Accounting.Contract.PowerFunctions.Dtos.BankRowMatch[];
		ExcludedMatchesCount: number;
	}
	export interface MatchItem {
		Id: string;
		Title: string;
		Description?: string;
		Date: Date;
		Amount: number;
		Currency: string;
		RowVersion?: string;
	}
	export interface ReceiptMatch {
		EventType: Bokio.Accounting.Contract.EventsToRecord.Dtos.EventType;
		AccuracyScore: number;
		TextAccuracy: number;
		SumAccuracy: number;
		DateAccuracy: number;
		DuplicatePenalty: number;
		Receipt: Bokio.Accounting.Contract.PowerFunctions.Dtos.MatchItem;
		Match: Bokio.Accounting.Contract.PowerFunctions.Dtos.MatchItem;
	}
	export interface ReceiptMatchView {
		PerfectMatches: Bokio.Accounting.Contract.PowerFunctions.Dtos.ReceiptMatch[];
		PotentialMatches: Bokio.Accounting.Contract.PowerFunctions.Dtos.ReceiptMatch[];
	}
}
export namespace Bokio.Accounting.Contract.Receipts.Commands {
	export interface MergeReceipts {
		MergeIntoReceiptId: string;
		ConvertToExtraPageReceiptIds: string[];
	}
}
export namespace Bokio.Accounting.Contract.Receipts.DTOs {
	export interface FinishClosureDto {
		ClosureId: string;
		SettingsId: string;
		IgnoreImbalanced: boolean;
		IgnoreUserSetIncomingBalances: boolean;
	}
	export interface ReceiptBankRowMatch {
		Id: string;
		Date: Date;
		Amount: Bokio.Common.Contract.AmountWithCurrency;
		Text: string;
		BookkeepingAccount: number;
		TotalPercentage: number;
		DatePercentage: number;
		AmountPercentage: number;
	}
	export enum ReceiptBankRowMatchingStatus {
		OK = "OK",
		MatchDisabledBecauseNoData = "MatchDisabledBecauseNoData",
	}
	export interface ReceiptBankRowMatchingView {
		Status: Bokio.Accounting.Contract.Receipts.DTOs.ReceiptBankRowMatchingStatus;
		Matches: Bokio.Accounting.Contract.Receipts.DTOs.ReceiptBankRowMatch[];
		TotalAvailableRows: number;
	}
	export interface ReceiptListWithMatchScoresDto {
		Receipts: Bokio.Accounting.Contract.ViewData.ReceiptWithUploadInfo[];
		Scores: Bokio.Accounting.Contract.Receipts.DTOs.ReceiptMatchScoreDto[];
		Currency?: string;
	}
	export interface ReceiptMatchScoreDto {
		ReceiptId: string;
		DatePercentage: number;
		SumPercentage: number;
		TotalPercentage: number;
		NoData: boolean;
	}
}
export namespace Bokio.Accounting.Contract.Recipes {
	export enum CustomRecipeError {
		Error = "Error",
		OverridableError = "OverridableError",
	}
	export enum RecipeType {
		Income = "Income",
		Cost = "Cost",
		Transfer = "Transfer",
	}
	export enum VatType {
		NotApplicable = "NotApplicable",
		Goods = "Goods",
		Service = "Service",
	}
}
export namespace Bokio.Accounting.Contract.Recipes.Common {
	export namespace Constants {
		export const TransactionValidationPattern = "^([0-9\u002B-\\/*\\(\\)\\s]|(total))\u002B$";
	}
}
export namespace Bokio.Accounting.Contract.Recipes.Dtos {
	export interface AdvancedCustomRecipeDto {
		CustomRecipeId?: string;
		Title: string;
		Description: string;
		RecipeType: Bokio.Accounting.Contract.Recipes.RecipeType;
		ParentCustomRecipeId?: string;
		Transactions: Bokio.Accounting.Contract.Recipes.Dtos.Transaction[];
	}
	export interface AiTemplateSearchPromptRebuildContext {
		Country: string;
		CompanyType: Entities.CompanyType;
		Vertical: string;
		Category: Bokio.Accounting.Contract.Verifications.ReceiptCategory;
		IsVatFree: boolean;
	}
	export interface AiTemplateSearchResponse {
		Matches: Bokio.Accounting.Contract.Recipes.Dtos.AiTemplateSearchResponseListItem[];
		HelpText: string;
		Content: string;
		TotalTokens: number;
		ConversationId: string;
	}
	export interface AiTemplateSearchResponseListItem {
		Template: Bokio.Accounting.Contract.Recipes.Dtos.RecipeForList;
		Reason: string;
	}
	export interface CostOrIncomeRecipeDto {
		CustomRecipeId?: string;
		Title: string;
		Description: string;
		RecipeType: Bokio.Accounting.Contract.Recipes.RecipeType;
		ParentCustomRecipeId?: string;
		VatRate: number;
		VatType: Bokio.Accounting.Contract.Recipes.VatType;
		Account: number;
	}
	export interface CustomRecipeListItemDto {
		CustomRecipeId: string;
		Title: string;
		Description: string;
		IsAdvanced: boolean;
		IsShared: boolean;
	}
	export interface PredictionResult {
		Supplier?: Bokio.Accounting.Contract.Recipes.Dtos.PredictionSupplierDto;
	}
	export interface PredictionSupplierDto {
		Name: string;
		Id: string;
		OrgNumber: string;
		ForceVATAreaChoice: boolean;
		Type: Entities.Accounting.Predictions.SharedBookkeepingPredictionRuleType;
		Suggestions: Bokio.Accounting.Contract.Recipes.Dtos.RecipeForList[];
	}
	export interface RecipeForList {
		Id: string;
		Name: string;
		Description: string;
		FixedName: string;
		VatPercentage?: number;
		IsPublic: boolean;
		Direction: Entities.PaymentDirection;
		CategoryList: string[];
		AliasNames: string[];
		IsCustom: boolean;
	}
	export interface SharedCustomRecipeViewModel {
		IsAdvanced: boolean;
		AdvancedRecipe?: Bokio.Accounting.Contract.Recipes.Dtos.AdvancedCustomRecipeDto;
		SimpleRecipe?: Bokio.Accounting.Contract.Recipes.ViewModels.CustomRecipeViewModel;
	}
	export interface Transaction {
		Account: number;
		CreditExpression: string;
		DebetExpression: string;
	}
	export interface TransferRecipeDto {
		CustomRecipeId?: string;
		Title: string;
		Description: string;
		ParentCustomRecipeId?: string;
		CreditAccount: number;
		DebitAccount: number;
	}
}
export namespace Bokio.Accounting.Contract.Recipes.Requests {
	export interface AiTemplateSearchRequest {
		Category: Bokio.Accounting.Contract.Verifications.ReceiptCategory;
		IsVatFree: boolean;
		Feature: Bokio.Common.Contract.Services.AiProxy.AiFeature;
		ConversationHistory: Bokio.Common.Contract.Services.AiProxy.ConversationMessage[];
		ConversationId: string;
	}
	export interface GetInitialRecipesRequest {
		Category: Bokio.Accounting.Contract.Verifications.ReceiptCategory;
		IsVatFree: boolean;
	}
	export interface GetRecipeFormsRequest {
		RecipeIds: string[];
		IsInvoice: boolean;
		IsVatFree: boolean;
	}
	export interface MultiRecipePreviewRequest {
		RecipePreviews: Bokio.Accounting.Contract.Recipes.Requests.RecipeInfoPreview[];
		AllowDraft?: boolean;
		IsCashSupplierInvoice?: boolean;
		Source?: Entities.Source;
		IsVatFree: boolean;
		OverrideOriginal: Bokio.Accounting.Contract.Verifications.Requests.AccountDto[];
	}
	export interface PreviewRequest {
		Id: string;
		Values: { [key: string]: string; };
		Source?: Entities.Source;
		OverrideOriginal: Bokio.Accounting.Contract.Verifications.Requests.AccountDto[];
	}
	export interface RecipeInfoPreview {
		RecipeId: string;
		Values: { [key: string]: string; };
	}
	export interface SaveAdvancedCustomRecipeRequest {
		CustomRecipe: Bokio.Accounting.Contract.Recipes.Dtos.AdvancedCustomRecipeDto;
		OverrideWarnings: boolean;
	}
	export interface SearchRecipesRequest {
		Search?: string;
		Category?: Bokio.Accounting.Contract.Verifications.ReceiptCategory;
		IsVatFree: boolean;
	}
	export interface ShowAllRecipesRequest {
		Category: Bokio.Accounting.Contract.Verifications.ReceiptCategory;
		IsVatFree: boolean;
	}
}
export namespace Bokio.Accounting.Contract.Recipes.ViewModels {
	export interface CostOrIncomeRecipeViewModel {
		CustomRecipeId?: string;
		Title: string;
		Description: string;
		RecipeType: Bokio.Accounting.Contract.Recipes.RecipeType;
		IsDeleted: boolean;
		IsShared: boolean;
		ParentCustomRecipeId?: string;
		VatRate: number;
		VatType: Bokio.Accounting.Contract.Recipes.VatType;
		Account: number;
	}
	export interface CustomRecipeViewModel {
		CostOrIncomeRecipeViewModel?: Bokio.Accounting.Contract.Recipes.ViewModels.CostOrIncomeRecipeViewModel;
		TransferRecipeViewModel?: Bokio.Accounting.Contract.Recipes.ViewModels.TransferRecipeViewModel;
	}
	export interface TransferRecipeViewModel {
		CustomRecipeId?: string;
		Title: string;
		Description: string;
		RecipeType: Bokio.Accounting.Contract.Recipes.RecipeType;
		IsDeleted: boolean;
		IsShared: boolean;
		ParentCustomRecipeId?: string;
		CreditAccount: number;
		DebitAccount: number;
	}
}
export namespace Bokio.Accounting.Contract.Reports {
	export interface ReportBoxMappingRow {
		VerificationId: string;
		VerificationNumber: string;
		Title: string;
		AccountNumber: number;
		Sum: number;
		IsMagicMapping: boolean;
		VerificationDate: Day;
		CellKey: string;
	}
	export interface ReportBoxMappingsDto {
		MappedAccounts: Classes.AccountBase[];
		HasMagicMappings: boolean;
		IsSumCell: boolean;
		Mappings: Bokio.Accounting.Contract.Reports.ReportBoxMappingRow[];
		OpeningBalances?: Bokio.Accounting.Contract.Reports.ReportBoxOpeningBalanceRow[];
		SumCellFormula?: string;
		CellKey: string;
	}
	export interface ReportBoxOpeningBalanceRow {
		AccountNumber: number;
		Sum: number;
		AccountName: string;
	}
	export enum ReportControllerErrors {
		None = "None",
		NonExistentFiscalYear = "NonExistentFiscalYear",
	}
}
export namespace Bokio.Accounting.Contract.Reports.Dtos {
	export enum ReportWarning {
		OpeningBalanceUncertainForPeriod = "OpeningBalanceUncertainForPeriod",
	}
}
export namespace Bokio.Accounting.Contract.Services.AdditionalFiles {
	export interface AdditionalFileListItemDto {
		Id: string;
		Name: string;
		UploadedDateTime: Date;
		FileExtension: string;
		UploadedBy: string;
	}
	export interface AdditionalFilesListDto {
		Files: Bokio.Accounting.Contract.Services.AdditionalFiles.AdditionalFileListItemDto[];
	}
}
export namespace Bokio.Accounting.Contract.Services.FiscalYears {
	export enum FirstFiscalYearStartMatch {
		OfficialStartedAtDateNotFound = "OfficialStartedAtDateNotFound",
		MatchesOfficialStartedAtDate = "MatchesOfficialStartedAtDate",
		BeforeOfficialStartedAtDate = "BeforeOfficialStartedAtDate",
		AfterOfficialStartedAtDate = "AfterOfficialStartedAtDate",
		AfterOfficialStartedAtDateAndLikelyPreviousFiscalYear = "AfterOfficialStartedAtDateAndLikelyPreviousFiscalYear",
	}
}
export namespace Bokio.Accounting.Contract.SIE.Dtos {
	export interface FaultyVerification {
		Verification: string;
		Date: Day;
		FailReason?: Core.Recipes.FailReason;
		FailReasonMessage: string;
	}
	export interface FiscalYearMismatch {
		FirstYear: string;
		SecondYear: string;
		FirstYearEndDate: Date;
		SecondYearStartDate: Date;
	}
	export interface SettingMissmatch {
		ImportYear: string;
		SettingYear: string;
	}
}
export namespace Bokio.Accounting.Contract.SupplierInvoices.Commands {
	export interface SetSupplierInvoiceScheduledPayment {
		InvoiceId: string;
		Planned: boolean;
	}
	export enum SupplierInvoicePaymentType {
		Payment = "Payment",
		Repayment = "Repayment",
	}
}
export namespace Bokio.Accounting.Contract.SupplierInvoices.Dtos {
	export interface AddSupplierInvoicePaymentDto {
		PaymentId: string;
		SupplierInvoiceId: string;
	}
	export interface ConnectSupplierInvoiceToAutoverificationRowPreviewDto {
		SupplierInvoiceId: string;
		Title: string;
		WillClose: boolean;
		WillRegisterPayment: boolean;
		PaymentAmount: Bokio.Common.Contract.AmountWithCurrency;
		ReferenceNumber: string;
		Supplier: Bokio.Accounting.Contract.Suppliers.Dtos.SupplierDto;
		RemainingAmountAfterPayment: Bokio.Common.Contract.AmountWithCurrency;
		PaymentDate: Day;
		RemainingAmountBeforePayment: Bokio.Common.Contract.AmountWithCurrency;
		AlreadyRegisteredAmount: Bokio.Common.Contract.AmountWithCurrency;
		InvoiceAmountInInvoiceCurrency?: Bokio.Common.Contract.AmountWithCurrency;
		InvoiceAmount: Bokio.Common.Contract.AmountWithCurrency;
		InvoiceDate: Day;
		InvoiceDueDate: Day;
		SettlementAmount?: Bokio.Common.Contract.AmountWithCurrency;
		BookkeepingAccount: number;
		AvailableSettlementTypes: Bokio.Accounting.Contract.SupplierInvoices.Dtos.SupplierInvoiceSettlementType[];
		CanBeMatched: boolean;
		PaymentType: Bokio.Accounting.Contract.SupplierInvoices.Commands.SupplierInvoicePaymentType;
		ShouldPeriodiseForCashMethod: boolean;
		BlockedByInvalidPreparedBookkeeping: boolean;
	}
	export interface ConnectToAutoVerificationRowRequest {
		SupplierInvoiceId: string;
		AutoVerificationRowId: string;
		SettlementType: Bokio.Accounting.Contract.SupplierInvoices.Dtos.SupplierInvoiceSettlementType;
		PreviousRemainingSum: number;
		RowVersion: string;
	}
	export interface ConnectToAutoVerificationRowResult {
		PaymentVerificationId?: string;
		PaymentVerificationNumber?: string;
	}
	export interface DeletePaymentPreviewDto {
		WarnForLaterSettlement: boolean;
	}
	export enum DeleteSupplierInvoiceFailReason {
		VatPeriodClosed = "VatPeriodClosed",
		VatPeriodStarted = "VatPeriodStarted",
	}
	export interface DeleteSupplierInvoicePreviewDto {
		VerificationNumber: string;
		VerificationId?: string;
		Payments: Bokio.Accounting.Contract.SupplierInvoices.Dtos.PaymentDto[];
		Warning?: Bokio.Accounting.Contract.SupplierInvoices.Dtos.DeleteSupplierInvoiceFailReason;
		WarningMessage: string;
	}
	export interface DuplicateSupplierInvoiceCheckResult {
		DuplicateInvoiceId?: string;
	}
	export interface MatchingPaymentVerificationDto {
		VerificationId: string;
		VerificationNumber: string;
		Date: Date;
		Amount: number;
		Explanation: string;
	}
	export interface OneClickPaymentOption {
		Type: Bokio.Accounting.Contract.SupplierInvoices.Dtos.OneClickPaymentOptionType;
		Title: string;
	}
	export enum OneClickPaymentOptionType {
		NotSet = "NotSet",
		SwedishQrCode = "SwedishQrCode",
	}
	export interface PaymentDto {
		Date: Day;
		Sum: number;
		VerificationNumber: string;
		VerificationId: string;
	}
	export enum SupplierInvoiceActionsAddTellerPaymentStatus {
		Allowed = "Allowed",
		NotAllowedForCreditInvoice = "NotAllowedForCreditInvoice",
		NotAllowedNoBba = "NotAllowedNoBba",
		NotAllowedNoPermission = "NotAllowedNoPermission",
	}
	export enum SupplierInvoiceActionsCanBookkeepStatus {
		Allowed = "Allowed",
		NotAllowed = "NotAllowed",
		NotAllowedAwaitingAttestation = "NotAllowedAwaitingAttestation",
	}
	export enum SupplierInvoiceActionsCanConnectToExistingVerification {
		Allowed = "Allowed",
		NotAllowed = "NotAllowed",
	}
	export enum SupplierInvoiceActionsCanConnectToOriginal {
		Allowed = "Allowed",
		NotAllowed = "NotAllowed",
	}
	export enum SupplierInvoiceActionsDeleteStatus {
		Allowed = "Allowed",
		NotAllowedHasVerifications = "NotAllowedHasVerifications",
		NotAllowedHasPayments = "NotAllowedHasPayments",
		NotAllowedHasConnectedCreditInvoices = "NotAllowedHasConnectedCreditInvoices",
	}
	export interface SupplierInvoiceActionsDto {
		CanRegisterPayment: Bokio.Accounting.Contract.SupplierInvoices.Dtos.SupplierInvoiceActionsRegisterPaymentStatus;
		CanEdit: Bokio.Accounting.Contract.SupplierInvoices.Dtos.SupplierInvoiceActionsEditStatus;
		CanDelete: Bokio.Accounting.Contract.SupplierInvoices.Dtos.SupplierInvoiceActionsDeleteStatus;
		CanToggleScheduled: Bokio.Accounting.Contract.SupplierInvoices.Dtos.SupplierInvoiceActionsToggleScheduledStatus;
		CanAddTellerPayment: Bokio.Accounting.Contract.SupplierInvoices.Dtos.SupplierInvoiceActionsAddTellerPaymentStatus;
		CanBookkeep: Bokio.Accounting.Contract.SupplierInvoices.Dtos.SupplierInvoiceActionsCanBookkeepStatus;
		CanConnectToOriginal: Bokio.Accounting.Contract.SupplierInvoices.Dtos.SupplierInvoiceActionsCanConnectToOriginal;
		CanConnectToExistingVerification: Bokio.Accounting.Contract.SupplierInvoices.Dtos.SupplierInvoiceActionsCanConnectToExistingVerification;
	}
	export enum SupplierInvoiceActionsEditStatus {
		Allowed = "Allowed",
		NotAllowedEInvoice = "NotAllowedEInvoice",
		NotAllowedHasPayments = "NotAllowedHasPayments",
	}
	export enum SupplierInvoiceActionsRegisterPaymentStatus {
		Allowed = "Allowed",
		NotAllowedInvoiceNotBookkept = "NotAllowedInvoiceNotBookkept",
		NotAllowedForCreditInvoiceWithOriginalInvoice = "NotAllowedForCreditInvoiceWithOriginalInvoice",
		NotAllowedInForeignCurrency = "NotAllowedInForeignCurrency",
		NotAllowedAwaitingAttestation = "NotAllowedAwaitingAttestation",
	}
	export enum SupplierInvoiceActionsToggleScheduledStatus {
		Allowed = "Allowed",
		NotAllowedForCreditInvoice = "NotAllowedForCreditInvoice",
		NotAllowedAlreadyPaid = "NotAllowedAlreadyPaid",
	}
	export interface SupplierInvoiceDetailsDto {
		Id: string;
		Type: Entities.Payment.SupplierInvoiceType;
		Date: Day;
		Deadline: Day;
		Title: string;
		ReferenceNumber: string;
		SupplierId: string;
		Supplier: Bokio.Accounting.Contract.Suppliers.Dtos.SupplierDto;
		ExternalSystem: Core.ViewData.SupplierInvoiceExternalSystem;
		Saved: Date;
		History: Bokio.Accounting.Contract.SupplierInvoices.Dtos.SupplierInvoiceHistoryDto[];
		CurrencyCode?: string;
		ExchangeRate?: number;
		Sum: number;
		SumInInvoiceCurrency?: number;
		RemainingSum: number;
		RemainingSumInInvoiceCurrency?: number;
		VerificationId?: string;
		VerificationNumber: string;
		ReceiptId?: string;
		ReceiptVersion?: number;
		InvoiceSystem: Entities.Payment.SupplierInvoiceSystem;
		InvoiceAccountingType: Entities.AccountingType;
		isBookkept: boolean;
		PaymentMessage: string;
		PaymentMessageType: Entities.Payment.PaymentMessageType;
		HasScheduledPayment: boolean;
		ScheduledPaymentIds: string[];
		Payments: Bokio.Accounting.Contract.SupplierInvoices.Dtos.SupplierPaymentDto[];
		OneClickPaymentOptions: Bokio.Accounting.Contract.SupplierInvoices.Dtos.OneClickPaymentOption[];
		PaymentMethod?: Bokio.Accounting.Contract.Suppliers.Dtos.SupplierPaymentMethodDto;
		Actions?: Bokio.Accounting.Contract.SupplierInvoices.Dtos.SupplierInvoiceActionsDto;
		AttestationRequests?: Bokio.Accounting.Contract.AttestationRequest.AttestationRequestGroupDto[];
		AttestationStatus?: Entities.AttestationFlow.AttestationRequestStatus;
		CanBeMatched: boolean;
		InvoiceErrors: Core.ViewData.SupplierInvoiceErrorsDto;
	}
	export interface SupplierInvoiceHistoryDto {
		Type: Bokio.Accounting.Contract.SupplierInvoices.Dtos.SupplierInvoiceHistoryType;
		State: Bokio.Accounting.Contract.SupplierInvoices.Dtos.SupplierInvoiceHistoryState;
		PaymentId?: string;
		ScheduledPaymentId?: string;
		VerificationId?: string;
		VerificationNumber?: string;
		Date?: Date;
		ResponsibleUserName: string;
		Amount: number;
		AdjustedAmount?: number;
		AmountInInvoiceCurrency?: number;
		RemainingAmount?: number;
		RemainingAmountInInvoiceCurrency?: number;
		CurrencyCode?: string;
		PaymentDate?: Date;
		CanBeDeleted: boolean;
		CreditInvoiceId?: string;
		OriginalInvoiceId?: string;
		ReferenceNumber: string;
	}
	export enum SupplierInvoiceHistoryState {
		NotSet = "NotSet",
		Completed = "Completed",
		MarkedAsPaid = "MarkedAsPaid",
	}
	export enum SupplierInvoiceHistoryType {
		NotSet = "NotSet",
		InvoiceRecording = "InvoiceRecording",
		PaymentRequest = "PaymentRequest",
		PaymentSignature = "PaymentSignature",
		PaymentSchedule = "PaymentSchedule",
		PaymentRecording = "PaymentRecording",
		PaymentCancelled = "PaymentCancelled",
		ManualPaymentRecording = "ManualPaymentRecording",
		PaymentRejected = "PaymentRejected",
		CreditInvoice = "CreditInvoice",
		OriginalInvoice = "OriginalInvoice",
	}
	export interface SupplierInvoiceListDto {
		Invoices: Core.ViewData.SupplierInvoiceForView[];
		SelectableStatuses: Core.ViewData.SupplierInvoiceStatus[];
		PageNumber: number;
		TotalItems: number;
		PageSize: number;
		AttestationEnabled: boolean;
	}
	export interface SupplierInvoicesBalance {
		NumberOfActiveInvoice: number;
		TotalNumberOfInvoices: number;
		OutstandingAmount: number;
		OverdueAmount: number;
	}
	export enum SupplierInvoiceSettlementType {
		LeaveOpen = "LeaveOpen",
		Close = "Close",
		CurrencyWinOrLoss = "CurrencyWinOrLoss",
		RoundedOffCurrency = "RoundedOffCurrency",
		ReminderFee = "ReminderFee",
	}
	export interface SupplierInvoiceVerificationsDto {
		InvoiceVerificationId?: string;
		PaymentVerificationIds: string[];
	}
	export interface SupplierPaymentDto {
		Id: string;
		Date: Day;
		Sum: number;
		AdjustedSum: number;
		VerificationNumber: string;
		VerificationId: string;
		Balance: number;
		ScheduledPaymentId?: string;
	}
}
export namespace Bokio.Accounting.Contract.SupplierInvoices.Requests {
	export interface AddSupplierInvoicePaymentRequest {
		Type: Bokio.Accounting.Contract.SupplierInvoices.Commands.SupplierInvoicePaymentType;
		Date: Day;
		Sum: number;
		SupplierInvoiceId: string;
		AutoVerificationRowId?: string;
		Account: number;
		Settlement?: Bokio.Accounting.Contract.SupplierInvoices.Dtos.SupplierInvoiceSettlementType;
		InvoiceSystem: Entities.Payment.SupplierInvoiceSystem;
		PreviousRemainingSum: number;
	}
	export interface AddSupplierInvoiceRequest {
		SupplierId: string;
		Type: Entities.Payment.SupplierInvoiceType;
		Date: Day;
		Deadline: Day;
		ReferenceNumber?: string;
		InvoiceTitle: string;
		Sum: number;
		CurrencyCode?: string;
		ReceiptId?: string;
		OriginalInvoiceId?: string;
		PrefillData?: Entities.Payment.PreVerificationData;
		PaymentMessage?: string;
		PaymentMessageType?: Entities.Payment.PaymentMessageType;
		PaymentType?: Entities.Teller.TellerPaymentType;
		PaymentInfoUnion?: Classes.Teller.TellerPaymentInformationUnion;
		CostOwnerAssignments?: Bokio.Accounting.Contract.AttestationRequest.CostOwnerAssignmentRequestDto[];
	}
	export interface ConnectCreditToOriginalRequest {
		CreditInvoiceId: string;
		OriginalInvoiceId: string;
	}
	export interface ConnectExistingVerificationToInvoiceRequest {
		SupplierInvoiceId: string;
		VerificationId: string;
		PreviousRemainingSum: number;
	}
	export interface ConnectSupplierInvoicesToReceipt {
		ReceiptId: string;
		SupplierInvoiceId: string;
	}
	export interface CreateAlienSupplierInvoiceRequest {
		Deadline: Day;
		Sum: number;
		SupplierId: string;
		Date: Day;
	}
	export interface CreateSupplierInvoiceAndAddPaymentRequest {
		ExistingSupplierId?: string;
		TellerPaymentInfoDto: Bokio.Bank.Contract.Teller.Dtos.TellerPaymentInfoDto;
		InvoiceDate: Day;
		ReceiptId?: string;
	}
	export enum DeleteSupplierInvoicePreviewError {
		TellerPaymentsConnected = "TellerPaymentsConnected",
		ToManyPayments = "ToManyPayments",
	}
	export interface EditAlienSupplierInvoiceRequest {
		SupplierInvoiceId: string;
		SupplierId: string;
		Deadline: Day;
		Sum: number;
		Date: Day;
	}
	export interface EditSupplierInvoiceRequest {
		Deadline: Day;
		ReferenceNumber?: string;
		InvoiceTitle: string;
		SumInInvoiceCurrency: number;
		SupplierId: string;
		SupplierInvoiceId: string;
		Date: Day;
		PaymentMessage?: string;
		PaymentMessageType: Entities.Payment.PaymentMessageType;
	}
	export interface ScheduleTellerSupplierInvoicePaymentRequest {
		TellerPaymentInfoDto: Bokio.Bank.Contract.Teller.Dtos.TellerPaymentInfoDto;
		SupplierInvoiceId: string;
	}
	export interface SupplierInvoiceListRequest {
		Pagination: Bokio.Common.Contract.Pagination.Pagination;
		Sort: Bokio.Common.Contract.Utils.ListSortChoice<Bokio.Accounting.Contract.SupplierInvoices.Requests.SupplierInvoiceSortableProperties>;
		Filter: Bokio.Accounting.Contract.SupplierInvoices.Requests.SupplierInvoicesFilterDto;
		SupplierId?: string;
	}
	export enum SupplierInvoiceListTab {
		Active = "Active",
		All = "All",
	}
	export interface SupplierInvoicePrefillData {
		RecipeForms: Bokio.Accounting.Contract.Verifications.DTOs.RecipeInfo[];
		GeneralForms: { [key: string]: string; };
		Transactions: Core.ViewData.TransactionForList[];
	}
	export interface SupplierInvoicesFilterDto {
		SearchTerm: string;
		Status?: Core.ViewData.SupplierInvoiceStatus;
		AttestationStatus?: Entities.AttestationFlow.AttestationRequestStatus;
		Tab: Bokio.Accounting.Contract.SupplierInvoices.Requests.SupplierInvoiceListTab;
	}
	export enum SupplierInvoiceSortableProperties {
		Supplier = "Supplier",
		Amount = "Amount",
		RemainingAmount = "RemainingAmount",
		Date = "Date",
		Deadline = "Deadline",
	}
	export interface ToggleSupplierInvoicePeriodisationRequest {
		SupplierInvoiceId: string;
		Periodise: boolean;
	}
	export interface UpdateSupplierInvoiceRequest {
		SupplierInvoiceId: string;
		PrefillData: Bokio.Accounting.Contract.SupplierInvoices.Requests.SupplierInvoicePrefillData;
		VerificationId?: string;
	}
}
export namespace Bokio.Accounting.Contract.Suppliers.Dtos {
	export enum AddOrEditSupplierError {
		SupplierNameDuplicated = "SupplierNameDuplicated",
		PaymentRecipientNameDuplicated = "PaymentRecipientNameDuplicated",
		SupplierAccountNumberDuplicated = "SupplierAccountNumberDuplicated",
		PaymentRecipientAccountNumberDuplicated = "PaymentRecipientAccountNumberDuplicated",
		ReceiptAlreadyConnected = "ReceiptAlreadyConnected",
		OtherError = "OtherError",
	}
	export interface SupplierDto {
		Id: string;
		CompanyId: string;
		Name: string;
		OrgNumber: string;
		TaxRegistrationNumber: string;
		Address: Entities.Address;
		Email: string;
		Phone: string;
		ReferenceName: string;
		DefaultCurrencyCode?: string;
		DefaultBookkeepingCurrencyCode?: string;
		PaymentMethod?: Bokio.Accounting.Contract.Suppliers.Dtos.SupplierPaymentMethodDto;
		ExternalSystem?: string;
	}
	export interface SupplierPaymentMethodDto {
		PaymentType: Entities.Teller.TellerPaymentType;
		PaymentData: Classes.Teller.TellerPaymentInformationUnion;
	}
}
export namespace Bokio.Accounting.Contract.Suppliers.Requests {
	export interface AddSupplierRequest {
		Name: string;
		OrgNumber: string;
		TaxRegistrationNumber: string;
		Address: Entities.Address;
		Email: string;
		Phone: string;
		ReferenceName: string;
		PaymentMethodData?: Classes.Teller.TellerPaymentInformationUnion;
		BookkeepingCurrencyCode?: string;
		CurrencyCode?: string;
		PaymentMethodType?: Entities.Teller.TellerPaymentType;
	}
	export interface EditSupplierRequest {
		SupplierId: string;
		Name: string;
		OrgNumber: string;
		TaxRegistrationNumber: string;
		Address: Entities.Address;
		Email: string;
		Phone: string;
		ReferenceName: string;
		PaymentMethodData?: Classes.Teller.TellerPaymentInformationUnion;
		BookkeepingCurrencyCode?: string;
		CurrencyCode?: string;
		PaymentMethodType?: Entities.Teller.TellerPaymentType;
	}
}
export namespace Bokio.Accounting.Contract.Support {
	export interface SupportTicketForList {
		Id: string;
		CompanyId: string;
		CompanyName: string;
		OrgNumber: string;
		CompanyType: Entities.CompanyType;
		WaitingFor: Core.Contracts.Todo.TodoSupportState;
		CreatedUtc: Date;
		UpdatedUtc: Date;
		MarkedForBilling: boolean;
	}
	export interface SupportTicketRevisionViewModel {
		CreatedUtc: Date;
		Role: Entities.Support.SupportTicketRole;
		UserId: string;
		UserEmail: string;
		Comment: string;
		ActionRequired: boolean;
		OldStatus?: Entities.Support.SupportTicketStatus;
		NewStatus?: Entities.Support.SupportTicketStatus;
		UserLastName: string;
		UserFirstName: string;
	}
	export interface SupportTicketViewModel {
		CreatedUtc: Date;
		UpdatedUtc: Date;
		TicketStatus: Entities.Support.SupportTicketStatus;
		CloseReason: Entities.Support.CloseReason;
		Id: string;
		ReceiptId?: string;
		CompanyId: string;
		CompanyName: string;
		CompanyPlan: Entities.BokioPlan;
		OrgNumber: string;
		Vertical: string;
		Revisions: Bokio.Accounting.Contract.Support.SupportTicketRevisionViewModel[];
		WaitingFor: Core.Contracts.Todo.TodoSupportState;
		AccountingForm?: Entities.AccountingType;
		CompanyType: Entities.CompanyType;
		Verification?: Core.ViewData.VerificationForList;
	}
}
export namespace Bokio.Accounting.Contract.Tax.Dtos {
	export interface FinalTaxCalculationAdjustmentsDto {
		IncomeFromAccrualFundsAdjustment: Bokio.Accounting.Contract.Tax.Dtos.IncomeFromAccrualFundsAdjustmentDto;
		IncomeFromInvestmentFundsAdjustment: Bokio.Accounting.Contract.Tax.Dtos.IncomeFromInvestmentFundsAdjustmentDto;
		NonRecordedCostsAdjustment: Bokio.Accounting.Contract.Tax.Dtos.NonRecordedCostsAdjustmentDto;
		NonRecordedIncomeAdjustment: Bokio.Accounting.Contract.Tax.Dtos.NonRecordedIncomeAdjustmentDto;
		LossFromPreviousYearsAdjustment: Bokio.Accounting.Contract.Tax.Dtos.LossFromPreviousYearsAdjustmentDto;
		YearEndAppropriationsAdjustment: Bokio.Accounting.Contract.Tax.Dtos.YearEndAppropriationsAdjustmentDto;
	}
	export interface FinalTaxCalculationResultDto {
		ResultBeforeTax: number;
		Result: number;
		Rounding: number;
		TaxableIncome: number;
		Tax: number;
		TaxRate: number;
		ResultAfterAdjustments: number;
		ResultBeforeAllocation: number;
		MaxAllocationToAccrualFund: number;
		UsedLossFromPreviousYears: number;
		NonDeductibleCosts: Bokio.Accounting.Contract.Tax.Dtos.NonDeductibleCostsDto;
		NonTaxableIncome: Bokio.Accounting.Contract.Tax.Dtos.NonTaxableIncomeDto;
		IncomeFromAccrualFunds: Bokio.Accounting.Contract.Tax.Dtos.IncomeFromAccrualFundsDto;
		IncomeFromInvestmentFunds: Bokio.Accounting.Contract.Tax.Dtos.IncomeFromInvestmentFundsDto;
		LossFromPreviousYears: Bokio.Accounting.Contract.Tax.Dtos.LossFromPreviousYearsDto;
		YearEndAppropriations: Bokio.Accounting.Contract.Tax.Dtos.YearEndAppropriationsDto;
		Adjustments: Bokio.Accounting.Contract.Tax.Dtos.FinalTaxCalculationAdjustmentsDto;
		ValidationErrors: Bokio.Accounting.Contract.Tax.Dtos.FinalTaxCalculationValidationErrorDto[];
	}
	export interface FinalTaxCalculationValidationErrorDto {
		Field: Bokio.Accounting.Contract.Tax.Exceptions.FinalTaxCalculatorValidationField;
		Error: Bokio.Accounting.Contract.Tax.Exceptions.FinalTaxCalculatorValidationError;
	}
	export interface IncomeFromAccrualFundsAdjustmentDto {
		IncomeForRemainingAccrualFunds: number;
	}
	export interface IncomeFromAccrualFundsDto {
		IncomeForRemainingAccrualFunds: number;
	}
	export interface IncomeFromInvestmentFundsAdjustmentDto {
		IncomeForRemainingInvestmentFunds: number;
	}
	export interface IncomeFromInvestmentFundsDto {
		IncomeForRemainingInvestmentFunds: number;
	}
	export interface LossFromPreviousYearsAdjustmentDto {
		UnusedLossFromPreviousYear: number;
	}
	export interface LossFromPreviousYearsDto {
		UnusedLossFromPreviousYear: number;
	}
	export interface NonDeductibleCostsDto {
		Representation: number;
		TaxAndFeeInterest: number;
		OtherNonDeductibleCosts: number;
		TotalSum: number;
	}
	export interface NonRecordedCostsAdjustmentDto {
		OtherNonRecordedCosts: number;
	}
	export interface NonRecordedIncomeAdjustmentDto {
		OtherNonRecordedIncome: number;
	}
	export interface NonTaxableIncomeDto {
		InterestLongTermAsset: number;
		InterestShortTermAsset: number;
		OtherNonTaxableIncome: number;
		TotalSum: number;
	}
	export interface OtherTaxCostsCalculationDto {
		LoanFromShareholderAmount: number;
		PensionCostsAmount: number;
	}
	export interface SpecialPayrollTaxOnPensionCostsCalculationDto {
		BasisAmount: number;
		CalculatedAmount: number;
		RecordedAmount: number;
	}
	export interface TaxCalculationWithVerificationPreviewDto {
		VerificationPreview: Bokio.Accounting.Contract.Verifications.DTOs.VerificationPreviewDto;
		TaxCalculationResult: Bokio.Accounting.Contract.Tax.Dtos.FinalTaxCalculationResultDto;
		TaxCalculationRows: Bokio.Accounting.Contract.Tax.Dtos.TaxRowDto[];
	}
	export enum TaxRowDirection {
		None = "None",
		Positive = "Positive",
		Negative = "Negative",
	}
	export interface TaxRowDto {
		Label: string;
		Amount: number;
		Adjusted: boolean;
		Direction: Bokio.Accounting.Contract.Tax.Dtos.TaxRowDirection;
		Rows: Bokio.Accounting.Contract.Tax.Dtos.TaxSubRowDto[];
	}
	export interface TaxSubRowDto {
		Label: string;
		Amount: number;
		Adjusted: boolean;
		Accounts: number[];
	}
	export interface YearEndAppropriationsAdjustmentDto {
		AllocationToAccrualFund: number;
	}
	export interface YearEndAppropriationsDto {
		AllocationToAccrualFund: number;
	}
}
export namespace Bokio.Accounting.Contract.Tax.Exceptions {
	export enum FinalTaxCalculatorValidationError {
		PeriodisationFundWithdrawalOverLimit = "PeriodisationFundWithdrawalOverLimit",
		InvalidIncomeAdjustmentValue = "InvalidIncomeAdjustmentValue",
	}
	export enum FinalTaxCalculatorValidationField {
		IncomeForRemainingAccrualFunds = "IncomeForRemainingAccrualFunds",
		IncomeForRemainingInvestmentFunds = "IncomeForRemainingInvestmentFunds",
		OtherNonRecordedCosts = "OtherNonRecordedCosts",
		OtherNonRecordedIncome = "OtherNonRecordedIncome",
		UnusedLossFromPreviousYear = "UnusedLossFromPreviousYear",
		AllocationToAccrualFund = "AllocationToAccrualFund",
	}
}
export namespace Bokio.Accounting.Contract.Tax.Requests {
	export interface TaxCalculationRequest {
		SettingId: string;
		TaxCalculationAdjustments?: Bokio.Accounting.Contract.Tax.Dtos.FinalTaxCalculationAdjustmentsDto;
	}
}
export namespace Bokio.Accounting.Contract.UnhandledEvents {
	export interface UnhandledEventDto {
		UnhandledEventType: Bokio.Accounting.Contract.UnhandledEvents.UnhandledEventType;
		EventCount: number;
	}
	export enum UnhandledEventType {
		AutoVerificationRow = "AutoVerificationRow",
		Invoice = "Invoice",
	}
}
export namespace Bokio.Accounting.Contract.Verifications {
	export enum ReceiptCategory {
		Other = "Other",
		Cost = "Cost",
		Income = "Income",
		SupplierInvoice = "SupplierInvoice",
		Expense = "Expense",
		TaxAccountIn = "TaxAccountIn",
		TaxAccountOut = "TaxAccountOut",
	}
}
export namespace Bokio.Accounting.Contract.Verifications.DTOs {
	export enum AiVerificationExplanationIssue {
		None = "None",
		UsedPreviousFiscalYear = "UsedPreviousFiscalYear",
	}
	export interface AiVerificationExplanationResponse {
		Summary: string;
		RowExplanations: Bokio.Accounting.Contract.Verifications.DTOs.AiVerificationExplanationRowExplanation[];
		Issue?: Bokio.Accounting.Contract.Verifications.DTOs.AiVerificationExplanationIssue;
		Content: string;
		TotalTokens: number;
		ConversationId: string;
	}
	export interface AiVerificationExplanationRowExplanation {
		AccountNumber: number;
		Explanation: string;
		VatInfo?: string;
	}
	export interface BankTransactionVerificationPreviewDto {
		RecipeForms: Bokio.Accounting.Contract.Verifications.DTOs.RecipeInfo[];
		GeneralForms: { [key: string]: string; };
		TransactionId?: string;
		Id: string;
		VerificationNumber: string;
		Date: Day;
		Title: string;
		Transactions: Core.ViewData.TransactionForList[];
	}
	export interface DeleteVerificationFeedback {
		Reason: Bokio.Accounting.Contract.Verifications.DTOs.DeleteVerificationReason[];
		Message: string;
	}
	export enum DeleteVerificationReason {
		CustomMessage = "CustomMessage",
		WrongBookkeeping = "WrongBookkeeping",
		WrongReceipt = "WrongReceipt",
		RecordedTwice = "RecordedTwice",
		Other = "Other",
	}
	export interface RecipeInfo {
		RecipeId: string;
		Values: { [key: string]: string; };
	}
	export interface VerificationEditRules {
		DateChangeProhibited: boolean;
		TitleChangeProhibited: boolean;
		LockedTransactions: Core.ViewData.TransactionForList[];
		Verification: Core.ViewData.VerificationForList;
	}
	export interface VerificationPreviewDto {
		Id: string;
		VerificationNumber: string;
		Date: Day;
		Title: string;
		Transactions: Core.ViewData.TransactionForList[];
	}
}
export namespace Bokio.Accounting.Contract.Verifications.Requests {
	export interface AccountDto {
		Key: number;
		Value: number;
	}
	export interface AiVerificationExplanationRequest {
		Description: string;
		Rows: Bokio.Accounting.Contract.Verifications.Requests.VerificationExplanationTransactionRow[];
		Date: Date;
		Feature: Bokio.Common.Contract.Services.AiProxy.AiFeature;
		ConversationHistory: Bokio.Common.Contract.Services.AiProxy.ConversationMessage[];
		ConversationId: string;
	}
	export interface DeleteVerificationRequest {
		VerificationId: string;
		HardDelete: boolean;
		Feedback: Bokio.Accounting.Contract.Verifications.DTOs.DeleteVerificationFeedback;
	}
	export interface EditVerificationRequest {
		OldVerificationId: string;
		Title: string;
		Date: Day;
		Transactions: Bokio.Accounting.Contract.Verifications.Requests.EditVerificationTransaction[];
	}
	export interface EditVerificationTransaction {
		Account: number;
		Sum: number;
	}
	export enum ImportKind {
		Se = "Se",
		Si = "Si",
	}
	export interface RemoveImportRequest {
		Kind: Bokio.Accounting.Contract.Verifications.Requests.ImportKind;
		SettingsId: string;
	}
	export interface SaveVerificationFromMultipleRecipesRequest {
		RecieptId?: string;
		FailReasonsToIgnore?: Core.Recipes.FailReason[];
		RecipeForms: Bokio.Accounting.Contract.Verifications.DTOs.RecipeInfo[];
		GeneralForms: { [key: string]: string; };
		OverrideOriginal?: Bokio.Accounting.Contract.Verifications.Requests.AccountDto[];
		SavePayment: boolean;
		VerificationSource?: Entities.Source;
		Comment?: string;
		IsVatFree: boolean;
	}
	export interface VerificationExplanationTransactionRow {
		Account: number;
		Debit: number;
		Credit: number;
	}
}
export namespace Bokio.Accounting.Contract.ViewData {
	export interface ReceiptExtraPageDto {
		Id: string;
		ReceiptId: string;
		PageNumber: number;
	}
	export interface ReceiptListWithUploadInfo {
		Receipts: Bokio.Accounting.Contract.ViewData.ReceiptWithUploadInfo[];
	}
	export enum ReceiptPaymentStatus {
		NotSigned = "NotSigned",
		Scheduled = "Scheduled",
		OnTheWay = "OnTheWay",
		Completed = "Completed",
		Cancelled = "Cancelled",
		Rejected = "Rejected",
	}
	export interface ReceiptWithUploadInfo {
		Description: string;
		HasPrediction: boolean;
		PredictedTotalSum?: number;
		PredictedPaymentDate?: Day;
		PredictedDate?: Day;
		PredictedVendor?: string;
		PredictedCurrency?: string;
		Category: Core.Contracts.Todo.ReceiptCategoryType;
		VerificationId?: string;
		PaymentDate?: Day;
		TotalSum?: number;
		AutoVerificationRowId?: string;
		IsPdf: boolean;
		Attested: boolean;
		IsAutoVerificationRowPending: boolean;
		IsNonSignedOrScheduledPayment: boolean;
		PaymentStatus?: Bokio.Accounting.Contract.ViewData.ReceiptPaymentStatus;
		Id: string;
		UploadedDate: Date;
		/** @deprecated Use UploadedDate instead */
		Date: Day;
		Version: number;
		UploadedByUser: string;
		ExtraPages: Bokio.Accounting.Contract.ViewData.ReceiptExtraPageDto[];
	}
}
export namespace Bokio.Accounting.Services.Periodisations {
	export enum UndoEntryAction {
		Reverse = "Reverse",
		AlreadyBooked = "AlreadyBooked",
		Delete = "Delete",
	}
}
export namespace Bokio.Accounting.Web.Accounting.Controllers {
	export interface BankTransactionForReconciliationTest {
		Date: Day;
		Amount: number;
		Text: string;
		VerificationNumber?: string;
	}
	export interface CreateDraftVerificationRequest {
		Explanation: string;
		Date: Day;
		Transactions: Core.ViewData.TransactionForList[];
		ReceiptId?: string;
		Source: Entities.Source;
		Comment?: string;
	}
	export interface DeleteTagDto {
		Id: string;
	}
	export interface DiagnoseNoMatchRequest {
		Account: number;
		Amount: number;
		VerificationDate: Day;
		From: Day;
		To: Day;
	}
	export interface DiagnoseNoMatchResponse {
		HasDeletedMatchingTransaction: boolean;
		OtherAccountsWithMatch: number[];
		IsPossiblyNotYetRegistered: boolean;
	}
	export interface DraftVerificationError {
		FailReasons: Core.Recipes.FailReason[];
	}
	export enum DrilldownReportComparisonType {
		Invalid = "Invalid",
		PreviousPeriod = "PreviousPeriod",
		PreviousYear = "PreviousYear",
	}
	export interface DrilldownReportConfig {
		SelectedTags: string[];
		IncludeUntaggedTag: boolean;
		PeriodType: Bokio.Accounting.Web.Accounting.Controllers.DrilldownReportPeriodType;
	}
	export interface DrilldownReportData {
		PeriodType: Bokio.Accounting.Web.Accounting.Controllers.DrilldownReportPeriodType;
		Periods: Bokio.Accounting.Web.Accounting.Controllers.DrilldownReportDataPeriodInfo[];
		Root: Bokio.Accounting.Web.Accounting.Controllers.DrilldownReportDataRow;
	}
	export interface DrilldownReportDataPeriodInfo {
		Year: number;
		Period: number;
	}
	export interface DrilldownReportDataRow {
		Key: Bokio.Accounting.Web.Accounting.Controllers.DrilldownReportRowKeys;
		InvertResult: boolean;
		FromAccount?: number;
		ToAccount?: number;
		Rows: Bokio.Accounting.Web.Accounting.Controllers.DrilldownReportDataRow[];
		Series: Bokio.Accounting.Web.Accounting.Controllers.DrilldownReportDataSerie[];
		AccountName?: string;
	}
	export interface DrilldownReportDataSerie {
		Key: string;
		Name: string;
		Values: number[];
	}
	export enum DrilldownReportPeriodType {
		Default = "Default",
		Quarter = "Quarter",
		Month = "Month",
		Week = "Week",
	}
	export enum DrilldownReportRowKeys {
		Invalid = "Invalid",
		Result = "Result",
		Income = "Income",
		NetRevenue = "NetRevenue",
		OtherIncome = "OtherIncome",
		Costs = "Costs",
		CostsOfGoods = "CostsOfGoods",
		OfficeCosts = "OfficeCosts",
		SalesCosts = "SalesCosts",
		AdministrationCosts = "AdministrationCosts",
		SalaryCosts = "SalaryCosts",
		DepreciationCosts = "DepreciationCosts",
		OtherCosts = "OtherCosts",
		AccountLevel = "AccountLevel",
	}
	export interface DrilldownReportStructureRow {
		Key: Bokio.Accounting.Web.Accounting.Controllers.DrilldownReportRowKeys;
		Rows: Bokio.Accounting.Web.Accounting.Controllers.DrilldownReportStructureRow[];
		InvertResult: boolean;
		FromAccount?: number;
		ToAccount?: number;
	}
	export interface EditDraftVerificationRequest {
		DraftId: string;
		Explanation: string;
		Date?: Day;
		ReceiptId?: string;
	}
	export interface GetPossibleComparisonOption {
		From: Day;
		To: Day;
		ComparisonType: Bokio.Accounting.Web.Accounting.Controllers.DrilldownReportComparisonType;
		Offset: number;
	}
	export enum GetPossibleComparisonsError {
		GeneralError = "GeneralError",
		NotYearMonthOrQuarter = "NotYearMonthOrQuarter",
		NoEarlierPeriods = "NoEarlierPeriods",
	}
	export interface GetVerificationsToMatchCountRequest {
		From: Day;
		To: Day;
	}
	export interface GetVerificationsToMatchCountResponse {
		AccountCounts: Bokio.Accounting.Web.Accounting.Controllers.VerificationCountByAccount[];
	}
	export interface ListVerificationsThatNeedMatchingOptionsResponse {
		Accounts: Bokio.Accounting.Web.Accounting.Controllers.SyncedAccountDto[];
		Periods: Bokio.Accounting.Web.Accounting.Controllers.ReportPeriodWithMonthSubs2[];
	}
	export interface ListVerificationsThatNeedMatchingRequest {
		From: Day;
		To: Day;
		Account: number;
	}
	export interface ListVerificationsThatNeedMatchingResponse {
		Verifications: Bokio.Accounting.Web.Accounting.Controllers.VerificationWithMatches[];
		Transactions: Bokio.Accounting.Web.Accounting.Controllers.TransactionWithMatches[];
	}
	export interface MatchGroup {
		Transactions: string[];
	}
	export interface NeAttachmentWarning {
		Type: Bokio.Accounting.Web.Accounting.Controllers.NeAttachmentWarningType;
	}
	export enum NeAttachmentWarningType {
		NegativeCells = "NegativeCells",
	}
	export enum RecordVatTaxesFromBankRowError {
		Unknown = "Unknown",
		PeriodIsNotMarkedAsReady = "PeriodIsNotMarkedAsReady",
		PeriodIsAlreadyDone = "PeriodIsAlreadyDone",
		SumIsIncorrect = "SumIsIncorrect",
		VerificationValidationFailed = "VerificationValidationFailed",
		ItemHasBeenChanged = "ItemHasBeenChanged",
	}
	export interface ReportPeriodWithMonthSubs2 {
		StartDate: Day;
		EndDate: Day;
		Label: string;
		Key: string;
		LongLabel: string;
	}
	export interface ReportStructureDto {
		RootRow: Bokio.Accounting.Web.Accounting.Controllers.DrilldownReportStructureRow;
	}
	export interface SetupEventsToRecordForTestingBulkRecordingResponse {
		MinDate: Day;
	}
	export interface SetupVerificationsAndTransactionsForBbaReconciliationRequest {
		Verifications: Bokio.Accounting.Web.Accounting.Controllers.VerificationForReconciliationTest[];
		BankTransactions: Bokio.Accounting.Web.Accounting.Controllers.BankTransactionForReconciliationTest[];
		Account: number;
	}
	export interface StartBookkeepingTutorialDto {
		TutorialKey: string;
	}
	export interface SyncedAccountDto {
		Account: number;
		Name: string;
	}
	export interface TagDto {
		VerificationId: string;
		TransactionId?: number;
		AllowedTagId: string;
		Weight: number;
	}
	export interface TagListAutocompleteDto {
		Tag: string;
		Id: string;
		TagTypeId: string;
	}
	export interface TagListDto {
		Tag: string;
		Weight: number;
		Id: string;
		HasVerificationTag: boolean;
		AllowedTagTypeValueId: string;
		TagTypeId: string;
		QuickAlias: string;
		TransactionId?: number;
	}
	export enum TagMode {
		NoTags = "NoTags",
		Verification = "Verification",
		Rows = "Rows",
	}
	export interface TagReportAccountRowConfig {
		Config: Bokio.Accounting.Web.Accounting.Controllers.TagReportTagConfig;
		Account: number;
		BreakDownPath: string[];
	}
	export interface TagReportTagConfig {
		FilterOnTag?: string;
		TagBreakdowns: string[];
	}
	export interface TagsForVerificationDto {
		VerificationTags: Bokio.Accounting.Web.Accounting.Controllers.TagListDto[];
		TransactionTags: Bokio.Accounting.Web.Accounting.Controllers.TagListDto[];
	}
	export interface TagTypeGroupAutocompleteDto {
		Name: string;
		QuickAlias: string;
		Tags: Bokio.Accounting.Web.Accounting.Controllers.TagListAutocompleteDto[];
		Id: string;
	}
	export enum TagVerificationError {
		GeneralError = "GeneralError",
		DuplicateTag = "DuplicateTag",
		InvalidWeight = "InvalidWeight",
	}
	export interface TagVerificationFormData {
		Id: string;
		VerificationNumber: string;
		Date: Day;
		Title: string;
		TagMode: Bokio.Accounting.Web.Accounting.Controllers.TagMode;
		Transactions: Bokio.Accounting.Web.Accounting.Controllers.TagVerificationTransactionData[];
		Tags: Bokio.Accounting.Web.Accounting.Controllers.TagListDto[];
	}
	export interface TagVerificationsFormData {
		VerificationData: Bokio.Accounting.Web.Accounting.Controllers.TagVerificationFormData[];
	}
	export interface TagVerificationTransactionData {
		Id: number;
		AccountNumber: number;
		AccountName: string;
		Debit: number;
		Credit: number;
		IsTaggable: boolean;
		Tags: Bokio.Accounting.Web.Accounting.Controllers.TagListDto[];
	}
	export interface TransactionWithMatches {
		Transaction: Bokio.Bank.Contract.AutoVerificationRows.AutoVerificationRowViewModel;
		FoundInMatchesForVerifications: string[];
	}
	export enum VatReportError {
		NoError = "NoError",
		FiscalYearsNotAligned = "FiscalYearsNotAligned",
		OtherError = "OtherError",
	}
	export enum VerificationAttributeError {
		GeneralError = "GeneralError",
		DuplicateAttribute = "DuplicateAttribute",
	}
	export interface VerificationCountByAccount {
		Account: number;
		Count: number;
		FromDate: Date;
	}
	export interface VerificationForReconciliationTest {
		Date: Day;
		Sum: number;
		ReverseAccount: number;
		VerificationNumber: string;
	}
	export interface VerificationWithMatches {
		Account: number;
		Verification: Core.ViewData.VerificationForList;
		MatchGroups: Bokio.Accounting.Web.Accounting.Controllers.MatchGroup[];
		Amount: number;
	}
}
export namespace Bokio.Accounting.Web.Accounting.Models {
	export interface ImportArsredovisningBookkeepingDto {
		ClosureId: string;
		FiscalId: string;
	}
	export interface RegisterPaymentDto {
		VerificationId: string;
		Date: Day;
		Sum: number;
		Title: string;
		Account: number;
	}
}
export namespace Bokio.Accounting.Web.Accounting.Services {
	export interface ImportCompanyResponse {
		CompanyId: string;
	}
}
export namespace Bokio.Accounting.Web.Accounting.Viewmodels.Accounts {
	export interface BookkeepingAccountForListViewModel {
		AccountType: Bokio.Accounting.Web.Accounting.Viewmodels.Accounts.CustomAccountType;
		Name: string;
		Account: number;
		VatMapping: string[];
		CanBeResetted: boolean;
		UnmappedCustomAccount: boolean;
	}
	export enum CustomAccountType {
		CustomAccount = "CustomAccount",
		CustomName = "CustomName",
		BasePlanAccount = "BasePlanAccount",
	}
	export interface NonExistingAccountViewModel {
		Count: number;
	}
}
export namespace Bokio.Accounting.Web.Accounting.Viewmodels.LockPeriod {
	export interface LockPeriodRequest {
		LockedUntil: Day;
	}
	export interface LockPeriodViewModel {
		Id?: string;
		LatestAllowedLockDate: Day;
		LockedUntil?: Day;
	}
	export interface PendingAssetDepreciationsResult {
		PendingAssetsCount: number;
	}
	export interface RemoveLockPeriodRequest {
		Id: string;
	}
	export interface UpdateLockPeriodRequest {
		Id: string;
		LockedUntil: Day;
		LockWithUnhandledEvents: boolean;
	}
	export interface UpdateLockPeriodResult {
		DidUpdateLockPeriod: boolean;
		UpdatedDate: Day;
		UnhandledEvents: Bokio.Accounting.Contract.UnhandledEvents.UnhandledEventDto[];
	}
}
export namespace Bokio.Accounting.Web.AutoVerification.Controllers {
	export interface SaveAutoVerificationError {
		UserMessage: string;
		CanOverride: boolean;
	}
	export interface SaveAutoVerificationRequest {
		RecipeForms: Bokio.Accounting.Contract.Verifications.DTOs.RecipeInfo[];
		GeneralForms: { [key: string]: string; };
		AutoVerificationRowId: string;
		ReceiptId?: string;
		OverrideWarning: boolean;
		Comment?: string;
		AutomationRuleId?: string;
		OverrideOriginal?: Bokio.Accounting.Contract.Verifications.Requests.AccountDto[];
		IsVatFree: boolean;
		RowVersion: string;
	}
}
export namespace Bokio.Accounting.Web.Settings.Controllers {
	export interface BookkeepingImportStateVM {
		PreviousBookkeepingMethod: Entities.PreviousBookkepingMethod;
		ImportMethod: Entities.CompanyImportMethod;
		PreviousBookkeepingTool: Entities.BookkeepingTools;
		PreviousBookkeepingToolOtherName: string;
		CurrentStep: Entities.BookkeepingImportSteps;
	}
	export interface SaveCompanyImportMethodDto {
		Method: Entities.CompanyImportMethod;
	}
	export interface SavePreviousBookkeepingMethodDto {
		Method: Entities.PreviousBookkepingMethod;
	}
	export interface SavePreviousBookkeepingToolDto {
		PreviousBookkeepingTool: Entities.BookkeepingTools;
		PreviousBookkeepingToolOtherName: string;
	}
}
export namespace Bokio.Accounting.Web.Settings.Models {
	export interface ImportYearsDto {
		YearsToClose: Model.Commands.Accounting.Imports.YearToClose[];
		BypassWarnings?: boolean;
	}
}
export namespace Bokio.Accounting.Web.SupplierInvoices.Controllers {
	export enum ToggleSupplierInvoicePeriodisationBlockReason {
		NoBlocker = "NoBlocker",
		HasPayments = "HasPayments",
		IsConnectedCreditInvoice = "IsConnectedCreditInvoice",
		IsRecorded = "IsRecorded",
		HasRecordedCreditInvoices = "HasRecordedCreditInvoices",
	}
	export interface ToggleSupplierInvoicePeriodisationResult {
		IsPeriodised: boolean;
		CanPeriodise: boolean;
		ShowPeriodiseOption: boolean;
		BlockReason?: Bokio.Accounting.Web.SupplierInvoices.Controllers.ToggleSupplierInvoicePeriodisationBlockReason;
	}
}
export namespace Bokio.Backbone.Web.Controllers {
	export interface AddBokioPayExternalLoginMethodRequest {
		PersonalNumber: string;
		InitUserAccount: Bokio.Backbone.Web.Controllers.InitUserAccountDto;
	}
	export enum AnonymousExperimentNames {
		NotSet = "NotSet",
		SignupScreen1 = "SignupScreen1",
	}
	export interface AnonymousExperimentResult {
		Enabled: boolean;
		ActivatedNow: boolean;
		UserVariant?: Bokio.Backbone.Web.Controllers.AnonymousExperimentResultVariant;
	}
	export enum AnonymousExperimentResultVariant {
		Original = "Original",
		Variant = "Variant",
	}
	export interface CashbackOfferDto {
		Key: string;
		OfferValidTo: string;
		DepositedCapitalCashbackPercentage?: number;
		CardSpendCashbackPercentage?: number;
		ExtraCashbackPerMonthExclVat?: number;
	}
	export interface CompanySelectFromMailDto {
		Companies: SettingsNoConflict.ViewModels.CompanyMembershipDto[];
		Username: string;
		RedirectLocation: Bokio.Backbone.Web.Controllers.RedirectLocation;
	}
	export interface CompanySetupDto {
		EnabledFeatureToggles: string[];
		Plan?: Entities.BokioPlan;
		InTrial: boolean;
		IsCompanyAuthenticated: boolean;
		CreateImportPreviousBookkeepingWizard: boolean;
		InsertDefaultTutorialReceiptSpecs: boolean;
		LoginRestrictionType: Entities.Security.CompanyLoginRestrictionType;
		PaymentState?: Entities.BillingSubscriptionPaymentState;
	}
	export interface CreateCompanyInSignUpDto {
		OrgNumber: string;
		CompanyName: string;
		CompanyType: Entities.CompanyType;
		AccountingType: Entities.AccountingType;
		VatSetting: Entities.VatSetting;
		City: string;
		PostalCode: string;
		Street: string;
		Street2: string;
		CompanySystem: Entities.CompanySystem;
		Country?: string;
	}
	export interface DisableAllBokioPayExternalLoginMethodsRequest {
		PersonalNumber: string;
	}
	export enum ExponentialOfTwo {
		Zero = "Zero",
		One = "One",
		Two = "Two",
		Four = "Four",
		Eight = "Eight",
		Sixteen = "Sixteen",
	}
	export interface InitUserAccountDto {
		Email: string;
		Password: string;
		FirstName: string;
		LastName: string;
	}
	export interface IntegrationTestAddEInvoiceRequest {
		InvoiceType: string;
		IssueDate: Day;
		DueDate: Day;
		Amount: number;
		OriginalInvoiceIds: string[];
		MeansCode: string;
		PaymentId: string;
		PayeeFinancialAccount: string;
		FinancialInstitutionBranch: string;
		PartyCountryCode: string;
		DocumentCurrencyCode: string;
	}
	export interface IntegrationTestAddUserToAgencyRequest {
		Org: string;
		UserToAdd: string;
		MembershipType: Entities.PartnerMembershipType;
	}
	export interface IntegrationTestAddUserToCompanyRequest {
		Org: string;
		UserToAdd: string;
	}
	export interface IntegrationTestAddUserToPartnerCompanyRequest {
		PartnerId: string;
		PartnerCompanyId: string;
		UserId: string;
	}
	export interface IntegrationTestChooseUserExperimentVariantRequest {
		ExperimentUserId: string;
		Request: Bokio.Backbone.Web.Controllers.Requests.ChooseUserExperimentVariantRequestDto;
	}
	export interface IntegrationTestCreateCompanyRequest {
		Command: Bokio.Backbone.Web.Controllers.CreateCompanyInSignUpDto;
		CompanySetup: Bokio.Backbone.Web.Controllers.CompanySetupDto;
	}
	export interface IntegrationTestEditPartnerUserMembershipType {
		MembershipType: Entities.MembershipType;
		PartnerId: string;
		PartnerCompanyId: string;
		UserId: string;
	}
	export interface IntegrationTestNotificationRequest {
		Targets: Entities.Notifications.NotificationTarget[];
		Area: Entities.Notifications.NotificationArea;
		AreaType: Entities.Notifications.NotificationAreaType;
		MessageVariables: string[];
		IsGroup: boolean;
		ItemId?: string;
		ItemType?: Entities.Notifications.NotificationItemType;
		ItemTypeVariant?: Entities.Notifications.NotificationItemTypeVariant;
	}
	export interface IntegrationTestRemoveUserToPartnerCompanyRequest {
		PartnerId: string;
		PartnerCompanyId: string;
		UserId: string;
	}
	export interface LinkClickTrackRequest {
		CompanyId?: string;
		Group: string;
		Key: string;
	}
	export interface OnboardingChecklistDto {
		Status: Entities.Onboarding.OnboardingChecklistStatus;
		Items: Bokio.Backbone.Web.Controllers.OnboardingChecklistItemDto[];
	}
	export interface OnboardingChecklistItemDto {
		OnboardingChecklistItemName: Entities.Onboarding.OnboardingChecklistItemName;
		Status: Entities.Onboarding.OnboardingChecklistItemStatus;
	}
	export interface OnboardingWizardDto {
		StartWithBookkeeping: boolean;
		StartWithSendInvoice: boolean;
		StartWithSalary: boolean;
		StartWithInviteAccountant: boolean;
		ConnectWithBBA: boolean;
		ConnectWithOtherBank: boolean;
		CurrentStep: Entities.Onboarding.OnboardingWizardStep;
		CurrentStepNr: number;
		TotalNrOfSteps: number;
		WantExtraExperience: Entities.Onboarding.OnboardingExtraExperienceType;
		UserDiscoverySource?: Entities.Onboarding.UserDiscoverySourceType;
		UserDiscoverySourceOtherText: string;
		DirectionOnSave: Bokio.Backbone.Web.Controllers.OnboardingWizardStepDirection;
	}
	export interface OnboardingWizardResponseDto {
		Status: Entities.Onboarding.OnboardingChecklistStatus;
		TestCompanyId?: string;
	}
	export enum OnboardingWizardStepDirection {
		Undefined = "Undefined",
		Backward = "Backward",
		Forward = "Forward",
	}
	export interface PublishInvoiceDto {
		PaymentMethodStatus: Entities.Payment.PaymentMethodStatus;
		PaymentType: Entities.Payment.PaymentType;
		IsPaymentMethodPrimary: boolean;
		CompanySenderDataPaymentMethodKey: Entities.Invoices.InvoicePaymentMethodKey;
		CompanySenderDataPaymentMethodPrimaryValue: string;
		InvoiceType?: Entities.Invoices.InvoiceType;
		Deadline: Date;
		InvoiceDate: Date;
		InvoiceFee: number;
		RecurringInvoiceEnabled: boolean;
		CustomerName: string;
		CustomerNumber: number;
		CustomerType: Entities.CustomerType;
		Email: string;
		ValidDays: number;
		PaymentTerms: string;
		DeliveryTerms: string;
		DelayInterest: string;
		Street1: string;
		City: string;
		PostalCode: string;
		Country: string;
		RowDescription: string;
		Units: number;
		UnitPrice: number;
		UnitType: Entities.Invoices.InvoiceRowUnitType;
		VAT: number;
		InvoiceRowKind: Entities.Invoices.InvoiceRowKind;
		OccurranceType: Entities.Invoices.OccurranceType;
		NumberOfOccurrances: number;
		IsTaxRegistered: boolean;
	}
	export interface ReconcilliationSetupDateDto {
		Date: Day;
		Sum: number;
		Vernum: string;
	}
	export interface ReconcilliationSetupDto {
		Account: number;
		ReverseAccount: number;
		Dates: Bokio.Backbone.Web.Controllers.ReconcilliationSetupDateDto[];
	}
	export enum RedirectLocation {
		Default = "Default",
		PriceplanPage = "PriceplanPage",
	}
	export interface RotRutErrandSetupItem {
		PaymentDate: Date;
	}
	export enum SaveOnboardingWizardError {
		Unknown = "Unknown",
		WizardResponseNotFound = "WizardResponseNotFound",
		NotAllowedToGoBackFromStart = "NotAllowedToGoBackFromStart",
		NotAllowedToGoForwardFromEnd = "NotAllowedToGoForwardFromEnd",
		NotAllowedToSaveWithUnknownDirection = "NotAllowedToSaveWithUnknownDirection",
	}
	export interface SavePageViewRequest {
		Key: string;
	}
	export interface SerializationTestDto {
		DateTimeUtc: Date;
		NullableDateTimeUtc?: Date;
		NullableDateTimeNull?: Date;
	}
	export interface SetupRotRutErrandsDto {
		Errands: Bokio.Backbone.Web.Controllers.RotRutErrandSetupItem[];
	}
	export interface UpdateChecklistItemDto {
		Name: Entities.Onboarding.OnboardingChecklistItemName;
		NewStatus: Entities.Onboarding.OnboardingChecklistItemStatus;
	}
	export interface UpdateEInvoiceStatusRequest {
		Org: string;
		Status: Bokio.Common.Contract.EInvoice.EInvoiceStatus;
	}
	export interface UserAcquisitionCampaignDataDto {
		UserToBeConfirmed: Entities.AcquisitionCampaignData;
		User: Entities.AcquisitionCampaignData[];
	}
	export interface UserReferralDataDto {
		UserToBeConfirmed: Entities.UserReferralSource;
		User: Entities.UserReferralSource;
	}
}
export namespace Bokio.Backbone.Web.Controllers.Accounts {
	export interface CanDeleteResponse {
		CanDelete: boolean;
		DeleteUserAccountErrors: Bokio.Services.Account.DeleteUserAccountErrors[];
	}
	export interface ConfirmBankIdLoginOrCreateResponse {
		BankIdStatus: Bokio.Common.Contract.BankId.BankIdCollectionStatus;
		HintCode?: Bokio.Common.Contract.BankId.BankIdHintCode;
		LoginOrCreateType: Bokio.Backbone.Web.Controllers.Accounts.LoginOrCreateType;
		FirstName: string;
		LastName: string;
		Id?: string;
		ClientSecret: string;
		AvailableAccounts: Bokio.Services.Account.LoginUserResult[];
	}
	export interface ConfirmBankIdLoginResponse {
		BankIdStatus: Bokio.Common.Contract.BankId.BankIdCollectionStatus;
		HintCode?: Bokio.Common.Contract.BankId.BankIdHintCode;
		SuccessfulLoginResult: Bokio.Services.Account.LoginUserResult;
	}
	export interface GetPossibleLoginMethodsRequest {
		Username: string;
	}
	export enum LoginOrCreateType {
		NoAccount = "NoAccount",
		SoloAccount = "SoloAccount",
		MultiAccount = "MultiAccount",
	}
	export enum PasswordSafety {
		Unknown = "Unknown",
		Safe = "Safe",
		NotSafe = "NotSafe",
	}
	export interface PasswordSafetyRequest {
		Password: string;
	}
	export interface StartBankIdLoginOrCreateResponse {
		AutoStartToken: string;
		QrStartToken: string;
	}
	export interface StartBankIdLoginResponse {
		AutoStartToken: string;
		QrStartToken: string;
	}
	export interface SuccessfulLoginActivity {
		LoginUtc: Date;
		LoginType: Bokio.Backbone.Web.Controllers.Accounts.SuccessfulLoginActivityType;
		Ip: string;
	}
	export enum SuccessfulLoginActivityType {
		Unknown = "Unknown",
		Token = "Token",
		Password = "Password",
		TwoFactor = "TwoFactor",
		BankId = "BankId",
	}
	export interface UserInfoDto {
		Id: string;
		Email: string;
		Name: string;
		FirstName: string;
		LastName: string;
		Lang: string;
		HasPassword: boolean;
		LoggedIn: boolean;
	}
}
export namespace Bokio.Backbone.Web.Controllers.Comments {
	export enum CommentErrors {
		Unknown = "Unknown",
		Unauthorized = "Unauthorized",
	}
}
export namespace Bokio.Backbone.Web.Controllers.Requests {
	export interface ChooseUserExperimentVariantRequestDto {
		ExperimentId: string;
		VariantId?: string;
		IsEnabled: boolean;
	}
}
export namespace Bokio.Backbone.Web.Controllers.Settings {
	export interface ActivatedPricePlanModel {
		Key: Entities.BokioPlan;
		SubscriptionInterval: Bokio.Common.Billing.Model.SubscriptionInterval;
		PaidUntil?: Day;
		IsTrialing: boolean;
		CashbackContract?: Bokio.Common.Billing.Model.CashbackContract;
		ActiveCashbackCampaign?: Bokio.Common.Billing.Model.AppliedCashbackCampaign;
		PlanPriceExVat?: number;
		CampaignKeys: string[];
		AppliedDiscount?: Bokio.Backbone.Web.Controllers.Settings.AppliedDiscount;
		AppliedAddons: Bokio.Billing.Contract.Models.Subscriptions.AddonsDto[];
		RemainingMonths: number;
	}
	export interface AddAllowedTagTypeValueDto {
		Tag: string;
		TagTypeId: string;
	}
	export interface AddonPreviewItem {
		AddonType: Bokio.Billing.Contract.Models.SubscriptionAddonType;
		AddonName: string;
		AddonCostPerMonth: number;
		Quantity: number;
		TotalCostForAddon: number;
		WillBeRemovedAtEndOfPeriod: boolean;
		RemainingMonths: number;
	}
	export interface AddSubscriptionAddonsDto {
		Addons: Bokio.Backbone.Web.Controllers.Settings.SubscriptionAddonItem[];
	}
	export interface AllowedTagTypeValueForListDto {
		Id: string;
		Tag: string;
	}
	export interface AppliedDiscount {
		Key: string;
		DiscountedAmount: number;
		StartDate: Day;
		EndDate: Day;
	}
	export interface Authenticated3DSecureChallenge {
		ChangeId: string;
		PurchaseId: string;
		SubscriptionId: string;
	}
	export interface BeginSetUpNewSubscriptionDto {
		BokioPlan: Entities.BokioPlan;
		Interval: Bokio.Common.Billing.Model.SubscriptionInterval;
		Source: Bokio.Billing.Contract.Models.Subscriptions.SubscriptionChangeSource;
	}
	export interface BillingSetupSubscriptionViewModel {
		PayNow: boolean;
		TrialEnds?: Day;
		ClientSecret: string;
	}
	export interface CancelSubscriptionAddonErrorDto {
		Type: Bokio.Billing.Contract.Models.Subscriptions.CancelSubscriptionAddonStatus;
		Message: string;
		ErrorKey: string;
	}
	export interface CancelSubscriptionAddonsDto {
		AddonTypes: Bokio.Billing.Contract.Models.SubscriptionAddonType[];
	}
	export interface CashbackContractsDto {
		PremiumPlusMonthlyCost: number;
		PremiumQuarterlyMonthlyCost: number;
		PremiumYearlyMonthlyCost: number;
		DefaultCashback: Bokio.Common.Billing.Model.CashbackContract;
		AvailableCashbackOffer?: Bokio.Common.Billing.Model.CashbackContractOffer;
	}
	export interface CashbackValuesDto {
		CardSpend: number;
		DepositedCapital: number;
	}
	export interface CashbackValuesResponse {
		BBAValues: Bokio.Backbone.Web.Controllers.Settings.CashbackValuesDto;
		BookkeepingValues: Bokio.Backbone.Web.Controllers.Settings.CashbackValuesDto;
	}
	export interface ChangePlan3DSecureChallenge {
		ChangeId: string;
		PurchaseId: string;
		SubscriptionId: string;
		PaymentIntentClientSecret: string;
	}
	export interface ChangePlanDto {
		Success: boolean;
		ChangePlan3DSecureChallenge?: Bokio.Backbone.Web.Controllers.Settings.ChangePlan3DSecureChallenge;
		Status?: Bokio.Backbone.Web.Controllers.Settings.ChangePricePurchaseStatus;
		Message: string;
	}
	export interface ChangePricePlanDto {
		BokioPlan: Entities.BokioPlan;
		Interval: Bokio.Common.Billing.Model.SubscriptionInterval;
		Source: Bokio.Billing.Contract.Models.Subscriptions.SubscriptionChangeSource;
		Addons: Bokio.Backbone.Web.Controllers.Settings.SubscriptionAddonItem[];
		Feedback?: Bokio.Backbone.Web.Controllers.Settings.ChangePricePlanFeedback;
	}
	export enum ChangePricePlanError {
		Unknown = "Unknown",
		PurchaseFailed = "PurchaseFailed",
		UpgradeFailed = "UpgradeFailed",
		PurchaseFailed_InsufficientFunds = "PurchaseFailed_InsufficientFunds",
		PurchaseFailed_ExpiredCard = "PurchaseFailed_ExpiredCard",
		PurchaseFailed_CardDeclined = "PurchaseFailed_CardDeclined",
	}
	export interface ChangePricePlanFeedback {
		FeedbackOption: Entities.Feedback.FeedbackOption;
		FeedbackText: string;
	}
	export enum ChangePricePurchaseStatus {
		Unknown = "Unknown",
		Successful = "Successful",
		InsufficientFunds = "InsufficientFunds",
		ExpiredCard = "ExpiredCard",
		CardDeclined = "CardDeclined",
	}
	export interface CompanyDataStorageSettingDto {
		CompanyId: string;
		Name: string;
		OrgNumber: string;
		IsTestCompany: boolean;
		StoreDataAfterSubscriptionEnded: boolean;
	}
	export interface CompleteSetupIntentDto {
		SetupIntentId: string;
	}
	export interface ConfirmChangePricePlanData {
		MonthsLeftOfPreviousPlan: number;
		DaysLeftOfPreviousPlan: number;
		ProrationEnds: Date;
		UnusedAmountExclVat: number;
		UnusedPlanAmountExclVat: number;
		UnusedAddonAmountExclVat: number;
		NewPlanCostExclVat: number;
		OrdinaryPlanPermanentDiscount: number;
		OrdinaryPlanCostExclVat: number;
		NewPeriodStart: Date;
		NewPeriodEnd: Date;
		DiscountEnd?: Date;
		AmountToPayExclVat: number;
		AmountToPayInclVat: number;
		Card: Bokio.Common.Billing.Model.CardInfo;
		UpcomingDiscountedPayments: Bokio.Billing.Contract.Models.Subscriptions.UpcomingDiscountedPayment[];
		AddonProrationDetails: Bokio.Billing.Contract.Models.Subscriptions.AddonProrationDetail[];
		AddonPreviews: Bokio.Backbone.Web.Controllers.Settings.AddonPreviewItem[];
		TotalAddonChargeExclVat: number;
		TotalAddonChargeInclVat: number;
		NumberOfMonthsInPlan: number;
		FullApplicableProration: number;
		FullApplicableProrationMonthly: number;
	}
	export interface CostOverviewAddon {
		Addon: Entities.PricePlanFeature;
		IsActive: boolean;
		AddonCostPerMonth: number;
		AddonCostPerInterval: number;
	}
	export interface CostOverviewCostItem {
		Name: string;
		IsActive: boolean;
		Quantity: number;
		PricePerUnit: number;
		Unit: Bokio.Backbone.Web.Controllers.Settings.CostOverviewCostItemUnit;
		ItemType: Bokio.Backbone.Web.Controllers.Settings.CostOverviewCostItemType;
		PricePerMonth: number;
	}
	export enum CostOverviewCostItemType {
		None = "None",
		User = "User",
		Verification = "Verification",
		Payslip = "Payslip",
		EInvoice = "EInvoice",
		SwishMonthly = "SwishMonthly",
		SwishTransaction = "SwishTransaction",
	}
	export enum CostOverviewCostItemUnit {
		None = "None",
		User = "User",
		Verification = "Verification",
		Payslip = "Payslip",
		EInvoice = "EInvoice",
		Transaction = "Transaction",
	}
	export interface CostOverviewDiscount {
		Name: string;
		DiscountedSumPerInterval: number;
		DiscountedSumPerMonth: number;
		ValidTo?: Date;
	}
	export interface CostOverviewHeader {
		NextPaymentDate?: Date;
		PaymentAmountExclVAT: number;
		PaymentAmountInclVAT: number;
		NextPeriodPaymentAmountExclVAT?: number;
		NextMonthlyPaymentAmountExclVAT?: number;
		ProrationAmount: number;
		IsAgencyPaying: boolean;
		NextPaymentContext: Bokio.Backbone.Web.Controllers.Settings.CostOverviewNextPaymentContext;
	}
	export interface CostOverviewMonthlyCosts {
		CostItems: Bokio.Backbone.Web.Controllers.Settings.CostOverviewCostItem[];
		MontlyCostsTotalExclVAT: number;
		NextMonthlyPaymentDate?: Date;
		ForeignOutgoingPaymentThreshold: number;
		ForeignOutgoingPaymentCost: number;
		ForeignIncomingPaymentCost: number;
		CardCurrencyExchangeSurchargePercent: number;
	}
	export enum CostOverviewNextPaymentContext {
		PeriodCosts = "PeriodCosts",
		MonthlyCosts = "MonthlyCosts",
		CombinedMonthlyCostsAndPeriodCosts = "CombinedMonthlyCostsAndPeriodCosts",
	}
	export interface CostOverviewPeriodCosts {
		PlanInterval: Bokio.Common.Billing.Model.SubscriptionInterval;
		Plan: Entities.BokioPlan;
		PlanPricePerMonth: number;
		PlanPricePerInterval: number;
		Addons: Bokio.Backbone.Web.Controllers.Settings.CostOverviewAddon[];
		NextPlanPaymentDate?: Date;
		PeriodCostsTotalExclVAT: number;
		Discount?: Bokio.Backbone.Web.Controllers.Settings.CostOverviewDiscount;
	}
	export interface CostOverviewViewModel {
		Status: boolean;
		ErrorMessage: string;
		ErrorType?: Bokio.Billing.Contract.CostOverviewResponseErrorType;
		Header: Bokio.Backbone.Web.Controllers.Settings.CostOverviewHeader;
		PeriodCosts: Bokio.Backbone.Web.Controllers.Settings.CostOverviewPeriodCosts;
		MonthlyCosts: Bokio.Backbone.Web.Controllers.Settings.CostOverviewMonthlyCosts;
	}
	export interface CreateTagTypeDto {
		DimensionNumber?: number;
		Name: string;
		QuickAlias: string;
	}
	export interface DeleteAllowedTagTypeValueDto {
		Id: string;
	}
	export enum DeleteAllowedTagTypeValueError {
		GeneralError = "GeneralError",
		UsedValue = "UsedValue",
	}
	export interface DeleteTagTypeDto {
		Id: string;
	}
	export enum DeleteTagTypeError {
		GeneralError = "GeneralError",
		UsedValue = "UsedValue",
	}
	export interface DismissNotificationRequest {
		NotificationId: string;
	}
	export enum EditAllowedTagTypeValueError {
		GeneralError = "GeneralError",
		DuplicateValue = "DuplicateValue",
	}
	export enum EditTagTypeError {
		GeneralError = "GeneralError",
		DuplicateValue = "DuplicateValue",
		DuplicateDimension = "DuplicateDimension",
	}
	export interface FetchAndUpdateCompanyInfoDto {
		OrgNumber: string;
	}
	export interface GetStripeCustomerSetupIntentDto {
		StripePublishableKey: string;
		SetupIntentId: string;
		SetupIntentClientSecret: string;
	}
	export enum LoyalCustomerPurchaseError {
		Unknown = "Unknown",
		PurchaseFailed = "PurchaseFailed",
		AlreadyCompletedPurchase = "AlreadyCompletedPurchase",
	}
	export enum PartnerSubscriptionStatus {
		None = "None",
		InterestSubmitted = "InterestSubmitted",
		PartnerSubscribed = "PartnerSubscribed",
	}
	export enum PreviewBokioPlanChangeError {
		Unknown = "Unknown",
		UnableToUpgrade = "UnableToUpgrade",
		CantChangePlan = "CantChangePlan",
	}
	export interface PreviewBokioPlanChangeErrorDto {
		Type: Bokio.Backbone.Web.Controllers.Settings.PreviewBokioPlanChangeError;
		Message: string;
		ErrorKey: string;
	}
	export interface PreviewPricePlanChangeResponse {
		ConfirmationNeeded: boolean;
		ConfirmPricePlanChangeData: Bokio.Backbone.Web.Controllers.Settings.ConfirmChangePricePlanData;
		PublishableStripeKey: string;
	}
	export interface PreviewSubscriptionAddonsDto {
		Mode: Bokio.Billing.Contract.Models.Subscriptions.PreviewSubscriptionMode;
		Addons: Bokio.Backbone.Web.Controllers.Settings.SubscriptionAddonItem[];
	}
	export interface PreviewSubscriptionAddonsResponseDto {
		AddonPreviews: Bokio.Backbone.Web.Controllers.Settings.AddonPreviewItem[];
		TotalChargeExclVat: number;
		TotalChargeInclVat: number;
		RemainingMonths: number;
		NextPaymentDate?: Date;
		SubscriptionPriceExclVat: number;
		SubscriptionPriceInclVat: number;
		NextPeriodTotalExclVat: number;
		NextPeriodTotalInclVat: number;
		SubscriptionPlanName: string;
		SubscriptionPlan: Bokio.Billing.Contract.Models.BillingPlan;
		SubscriptionInterval: Bokio.Common.Billing.Model.SubscriptionInterval;
		Error: Bokio.Backbone.Web.Controllers.Settings.SubscriptionAddonErrorDto;
		Mode: Bokio.Billing.Contract.Models.Subscriptions.PreviewSubscriptionMode;
	}
	export interface PriceplansModel {
		Plans: Bokio.Backbone.Web.Controllers.Settings.PriceplansPlanModel[];
		CurrentPlan?: Bokio.Backbone.Web.Controllers.Settings.ActivatedPricePlanModel;
		NextPlan?: Bokio.Backbone.Web.Controllers.Settings.ActivatedPricePlanModel;
		CanUpgrade: boolean;
		AgencyIsPayingForCustomer: boolean;
		IsPaidByAgencyButHaveOwnSubscription: boolean;
		DidCompletePurchase: boolean;
		Currency: string;
		PublishableStripeKey: string;
		BillingDisabled: boolean;
		BillingDisabledMessage: string;
		BokioStartCampaign: Bokio.Common.Billing.BokioStartCampaign;
		HasFetchedCompanyInfo: boolean;
		IsEligibleForUserExtendedTrial: boolean;
		UserExtendedTrialOfferExtensionDays: number;
	}
	export interface PriceplansPlanModel {
		Key: Entities.BokioPlan;
		IsRecommended: boolean;
		IntervalOptions: Bokio.Common.Billing.Model.BillingIntervalOptions;
	}
	export interface SaveCompanyDataStorageSettingRequest {
		Items: Bokio.Backbone.Web.Controllers.Settings.SaveCompanyDataStorageSettingRequestItem[];
	}
	export interface SaveCompanyDataStorageSettingRequestItem {
		CompanyId: string;
		StoreDataAfterSubscriptionEnded: boolean;
	}
	export interface SetUpNewSubscriptionDto {
		BokioPlan: Entities.BokioPlan;
		Interval: Bokio.Common.Billing.Model.SubscriptionInterval;
		Source: Bokio.Billing.Contract.Models.Subscriptions.SubscriptionChangeSource;
		PurchaseId: string;
	}
	export interface SetupNewSubscriptionResponse {
		AmountExclVat: number;
		AmountInclVat: number;
		BokioPlan: Entities.BokioPlan;
		Interval: Bokio.Common.Billing.Model.SubscriptionInterval;
		IsTestMode: boolean;
		PurchaseId: string;
	}
	export interface StartAddonTrialDto {
		AddonType: Bokio.Billing.Contract.Models.SubscriptionAddonType;
	}
	export interface StartAddOnTrialErrorDto {
		Type: Bokio.Billing.Contract.Models.Subscriptions.StartAddonTrialErrorType;
		Message: string;
		ErrorKey: string;
	}
	export interface StartAddonTrialViewModel {
		Success: boolean;
		TrialEndDate?: Day;
	}
	export enum SubscriptionAddonError {
		General = "General",
		UnableToAddAddon = "UnableToAddAddon",
	}
	export interface SubscriptionAddonErrorDto {
		Type: Bokio.Backbone.Web.Controllers.Settings.SubscriptionAddonError;
		Message: string;
		ErrorKey: string;
	}
	export interface SubscriptionAddonItem {
		AddonType: Bokio.Billing.Contract.Models.SubscriptionAddonType;
		Quantity: number;
		EndDate?: Date;
	}
	export interface SubscriptionStatusViewModel {
		PrioSupportSubscribed: boolean;
		PrioSupportStarted?: Date;
		PartnerSubscribed: Bokio.Backbone.Web.Controllers.Settings.PartnerSubscriptionStatus;
	}
	export interface TagTypeForListDto {
		DimensionNumber?: number;
		Id: string;
		Name: string;
		QuickAlias: string;
		AllowedValues: Bokio.Backbone.Web.Controllers.Settings.AllowedTagTypeValueForListDto[];
	}
	export interface UpdateAllowedTagTypeValueDto {
		Id: string;
		Tag: string;
	}
	export interface UpdateTagTypeDto {
		Id: string;
		Name: string;
		QuickAlias: string;
	}
	export interface UserExtendTrialDto {
		ReasonCategory: Bokio.Common.Billing.Model.BokioUserExtendedTrialReasonCategory;
		ReasonDetails?: string;
		ExpectedStartDate?: Date;
	}
}
export namespace Bokio.Backbone.Web.Controllers.Settings.Models {
	export interface BroadcastMessage {
		Id: string;
		AffectedCompanyIds: string[];
		Level: Bokio.Common.Broadcast.Level;
		TargetCategories: Bokio.Common.Broadcast.TargetCategory[];
		Message: string;
		Dismissible: boolean;
	}
	export interface CompanyMembershipViewModel {
		CompanyName: string;
		Type: Entities.MembershipType;
		CompanyId: string;
		OrgNumber: string;
		OtherMembers: boolean;
		IsOwner: boolean;
	}
	export interface CompanyUserRolesViewModel {
		CompanyUserRoles: Bokio.Backbone.Web.Controllers.Settings.Models.CompanyUserRoleViewModel[];
	}
	export interface CompanyUserRoleViewModel {
		CompanyId: string;
		UserId: string;
		FirstName: string;
		LastName: string;
		Email: string;
		Type: Entities.CompanyUserRoleType;
	}
	export interface UpdateUsernamePreviewViewModel {
		OldUsername: string;
		Has2FA: boolean;
	}
	export interface UserViewModel {
		Email: string;
		FirstName: string;
		LastName: string;
		PhoneNumber: string;
		Language: string;
		EmailConfirmed: boolean;
		UserResearchGroup: boolean;
		Languages: Core.Culture.CultureChoice[];
		Id: string;
		PartnerMembershipsCount?: number;
		CompanyMemberships: Bokio.Backbone.Web.Controllers.Settings.Models.CompanyMembershipViewModel[];
		UserFeatureToggles: Bokio.Common.Services.UserFeatureToggles.UserFeatureToggleViewModel[];
		Broadcasts: Bokio.Backbone.Web.Controllers.Settings.Models.BroadcastMessage[];
	}
}
export namespace Bokio.BackOffice {
	export interface AgencyClientDetailsDto {
		Id: string;
		Name: string;
		CompanyType: Entities.CompanyType;
		CompanySystem: Entities.CompanySystem;
		StartedAt?: Date;
		SenderData: Entities.InvoiceSenderData;
		FiscalYear: Bokio.Services.FiscalYears.FiscalYearDto;
		Country: CountryCode;
		VatSetting?: Entities.VatSetting;
		Partner: Bokio.BackOffice.PartnerDto;
		PartnerCompanyId: string;
		ResponsibleAccountants: Bokio.BackOffice.CompanyMemberDto[];
		OrgNumber: string;
		Responsibilities: Entities.PartnerCompanyResponsibilities[];
		BokioPlan: Bokio.Common.Contract.ViewData.BokioPlanDto;
		HasBBA: boolean;
		FreeTextReasonForApplication?: string;
	}
	export interface AgencyCountViewModel {
		TotalCount: number;
		ClientRequestCount: number;
		QuoteRequestCount: number;
	}
	export interface AgencyDetailsDto {
		Id: string;
		Name: string;
		OrgNumber: string;
		CompanyType: Entities.CompanyType;
		Address: Entities.Address;
		PhoneNumber: string;
		ContractStatus: Entities.ContractStatus;
	}
	export interface AgencyDraftDetailsDto {
		Id: string;
		Name: string;
		OrgNumber: string;
		CompanyType: Entities.CompanyType;
		Address: Entities.Address;
		PhoneNumber: string;
		ContractStatus: Entities.ContractStatus;
	}
	export interface AgencyForView {
		Id: string;
		AgencyName: string;
		OrgNumber: string;
	}
	export interface AgencyOwner {
		UserId: string;
		FirstName: string;
		LastName: string;
		Email: string;
	}
	export interface AssociatedCompany {
		CompanyId: string;
		OrgNumber: string;
		Name: string;
		LastActivity?: Date;
		AlreadyAdded: boolean;
	}
	export interface CompaniesUserIsMemberOfDto {
		User?: Classes.UserDto;
		Companies: Bokio.BackOffice.AssociatedCompany[];
	}
	export interface CompanyMemberDto {
		User: Classes.UserDto;
		MembershipType: Entities.MembershipType;
	}
	export interface PartnerAccessDto {
		SupportResponsible: boolean;
		BookkeepResponsible: boolean;
		ClosureResponsible: boolean;
		ManageUsers: boolean;
		ManageCompanies: boolean;
		ManageSettings: boolean;
		SelfAssign: boolean;
		ManageQuoteRequests: boolean;
	}
	export interface PartnerAgencyDto {
		NumClients: number;
		AuditTime: Date;
		Deleted: boolean;
		Id: string;
		Name: string;
		OrgNumber: string;
		PartnerType?: Entities.PartnerType;
		IsRoot: boolean;
		AgencyOwner?: Bokio.BackOffice.AgencyOwner;
		Country: CountryCode;
		PartnershipKinds: Entities.PartnershipKind[];
		AccountantsCount?: number;
		ContractStatus: Entities.ContractStatus;
		PhoneNumber: string;
		Features: Core.FeatureState[];
	}
	export interface PartnerCompanyApplicationDto {
		Id: string;
		PartnerStartDate: Day;
		YearlyTurnover: Entities.DecimalRange;
		NumberOfEmployees: Entities.NumberRange;
		NumberOfMonthlyVerifications: Entities.NumberRange;
		CompanyMainActivity: string;
		Status: Entities.Partners.ApplicationStatus;
		SubmittedByUser?: Classes.UserDto;
		OnboardingStatus: Entities.Partners.OnboardingQueueStatus;
		TypeOfApplication: Entities.PartnerCompanyType;
		FreeTextReasonForApplication?: string;
	}
	export interface PartnerCompanyApplicationListDto {
		Id: string;
		SubmitTime: Date;
		Status: Entities.Partners.OnboardingQueueStatus;
		CompanyId: string;
		CompanyName: string;
		CompanyType: Entities.CompanyType;
		Type: Entities.PartnerCompanyType;
		UserHasAccess: boolean;
		CompanyOrgNumber: string;
		NotesStatus: Bokio.BackOffice.Models.NotesStatusDto[];
	}
	export interface PartnerCompanyContractDto {
		StartDate: Day;
		EndDate?: Day;
		Price?: number;
		Id: string;
	}
	export interface PartnerCompanyDetailsDto {
		Id: string;
		Name: string;
		CompanyType: Entities.CompanyType;
		StartedAt?: Date;
		Vertical: string;
		SenderData: Entities.InvoiceSenderData;
		FiscalYear: Bokio.Services.FiscalYears.FiscalYearDto;
		VatSetting?: Entities.VatSetting;
		UserHasAccess: boolean;
		Contracts?: Bokio.BackOffice.PartnerCompanyContractDto[];
		Country: CountryCode;
		Partner: Bokio.BackOffice.PartnerDto;
		PartnerCompanyType: Entities.PartnerCompanyType;
		PartnerCompanyId: string;
		ResponsibleAccountants: Bokio.BackOffice.ResponsibleAccountantDto[];
		OrgNumber: string;
		Currency: string;
		Responsibilities: Entities.PartnerCompanyResponsibilities[];
		BokioPlan: Bokio.Common.Contract.ViewData.BokioPlanDto;
		PricePlan: Entities.BokioPlan;
		HasBBA?: boolean;
	}
	export interface PartnerCompanyGetApplicationDto {
		Application?: Bokio.BackOffice.PartnerCompanyApplicationDto;
	}
	export interface PartnerCompanyInfo {
		Id: string;
		AgencyType: Model.Commands.Partners.PartnerCompanyApplicationCommands.Agency;
		Description: Model.Commands.Partners.PartnerCompanyApplicationCommands.BusinessDescriptionObject;
	}
	export interface PartnerDto {
		Id: string;
		Name: string;
		OrgNumber: string;
		PartnerType?: Entities.PartnerType;
		IsRoot: boolean;
		AgencyOwner?: Bokio.BackOffice.AgencyOwner;
		Country: CountryCode;
		PartnershipKinds: Entities.PartnershipKind[];
		AccountantsCount?: number;
		ContractStatus: Entities.ContractStatus;
		PhoneNumber: string;
		Features: Core.FeatureState[];
	}
	export interface PartnerStatusDto {
		Access: Bokio.BackOffice.PartnerAccessDto;
		Id: string;
		Name: string;
		OrgNumber: string;
		PartnerType?: Entities.PartnerType;
		IsRoot: boolean;
		AgencyOwner?: Bokio.BackOffice.AgencyOwner;
		Country: CountryCode;
		PartnershipKinds: Entities.PartnershipKind[];
		AccountantsCount?: number;
		ContractStatus: Entities.ContractStatus;
		PhoneNumber: string;
		Features: Core.FeatureState[];
	}
	export interface PartnerUserDto {
		User: Classes.UserDto;
		MembershipType: Entities.PartnerMembershipType;
	}
	export interface PartnerUserInvitationDto {
		Id: string;
		Email: string;
		MembershipType: Entities.PartnerMembershipType;
	}
	export interface ResponsibleAccountantDto {
		UserInfo: Classes.UserDto;
	}
	export interface SearchRequest {
		Query: string;
	}
	export interface UsersPageViewDto {
		Users: Bokio.BackOffice.PartnerUserDto[];
		Invites: Bokio.BackOffice.PartnerUserInvitationDto[];
	}
}
export namespace Bokio.BackOffice.Models {
	export interface AgencyOverviewDto {
		NumClients: number;
		NumSubscribedClients: number;
		ActiveQuoteCount: number;
		NewClientCount: number;
		ClientIds: string[];
		Id: string;
		Name: string;
		OrgNumber: string;
		PartnerType?: Entities.PartnerType;
		IsRoot: boolean;
		AgencyOwner?: Bokio.BackOffice.AgencyOwner;
		Country: CountryCode;
		PartnershipKinds: Entities.PartnershipKind[];
		AccountantsCount?: number;
		ContractStatus: Entities.ContractStatus;
		PhoneNumber: string;
		Features: Core.FeatureState[];
	}
	export interface ChangeOwnerDto {
		UserId: string;
	}
	export interface ClientCompaniesToConnectRequest {
		CompanyIds: string[];
	}
	export interface ClientCompanyDto {
		Name: string;
		OrgNumber: string;
		CompanyType: Entities.CompanyType;
		CompanySystem: Entities.CompanySystem;
		CompanyId: string;
		IsAccountantCompanyMember: boolean;
		AssignedAccountantNames: string[];
		NotesStatus: Bokio.BackOffice.Models.NotesStatusDto[];
		CurrentBokioPlan: Entities.BokioPlan;
		HasBBA: boolean;
		HasBankConnection: boolean;
		IsTrial: boolean;
		PlanEndDate?: Date;
		FiscalYearEnd?: Date;
		ConnectionDate?: Date;
		Email: string;
		CreatedByAgency: boolean;
	}
	export interface ClientCompanyToConnectDto {
		CompanyId: string;
		CompanyName: string;
		CompanyType: Entities.CompanyType;
		OrgNumber: string;
		CompanyOwner: string;
		Status: Bokio.BackOffice.Models.ConnectStatus;
	}
	export interface ClientDto {
		Name: string;
		CompanySystem: Entities.CompanySystem;
		CompanyId: string;
	}
	export interface ClientRequestDto {
		InvitationId: string;
		CompanyId: string;
		CompanyName: string;
		CompanyType: Entities.CompanyType;
		OrgNumber: string;
		AssignedAccountant: string;
		CompanyOwner: string;
		HasExpired: boolean;
	}
	export enum ConnectStatus {
		CanConnect = "CanConnect",
		ConnectedToAnotherAgency = "ConnectedToAnotherAgency",
		AccountantDoesNotHaveEnoughPermissions = "AccountantDoesNotHaveEnoughPermissions",
		AnAccountantOwnsTheCompany = "AnAccountantOwnsTheCompany",
	}
	export enum CreatePartnerQuoteRequestError {
		NoError = "NoError",
		OtherError = "OtherError",
		RecentLoginRequired = "RecentLoginRequired",
		NotApplicableForUK = "NotApplicableForUK",
	}
	export interface MentionableAccountantsDto {
		Accountants: Classes.UserDto[];
	}
	export interface NotesStatusDto {
		Type: Entities.NoteKind;
		Count: number;
		LastStatusTime?: Date;
		LatestNoteText: string;
		LatestNoteAuthor: string;
		LatestNoteStatus: Entities.Partners.WorkStatusType;
	}
	export interface PartnerCompanyApplicationCompanyInfoDto {
		Email: string;
		Phone: string;
		ReferenceName: string;
		StartedAt?: Day;
	}
	export interface PendingClientCompanyDto {
		Name: string;
		CompanyId: string;
		PendingInvitationDateSent: string;
		PendingInvitationStatus: Entities.CompanyInvitationStatus;
		PendingInvitationCompanyOwnerEmail: string;
	}
	export interface RequiredDeleteAgencyActionDto {
		Type: Bokio.BackOffice.Models.RequiredDeleteAgencyType;
		Data: string;
	}
	export enum RequiredDeleteAgencyType {
		MoreClientsConnected = "MoreClientsConnected",
		MoreUsersConnected = "MoreUsersConnected",
		PendingClientRequest = "PendingClientRequest",
		PendingQuoteRequest = "PendingQuoteRequest",
	}
}
export namespace Bokio.BackOffice.Notes {
	export interface AgencyTaskDto {
		Id: string;
		State: Core.Services.Notes.TasksStateDto;
		Author: Classes.UserDto;
		TimeCreated: Date;
		NotificationStatus: Core.Services.Notes.NotificationStatusDto;
		UpdateInfo: Core.Services.Notes.UpdateInfo;
		CompanyId: string;
		CompanyName: string;
	}
}
export namespace Bokio.BackOffice.Requests {
	export interface AddFullAccessUserRequest {
		AgencyId: string;
		Username: string;
	}
	export interface CreateAgencyDraftRequest {
		InvitationId?: string;
		DraftSource?: Entities.AgencyDraftSource;
	}
	export interface CreateAgencyRequest {
		AgencyName: string;
		OrgNumber: string;
		CompanyType: Entities.CompanyType;
		Address: Entities.Address;
		IsPartnerAgency?: boolean;
		PhoneNumber: string;
	}
	export interface EditAgencyDetailsRequest {
		AgencyName: string;
		OrgNumber: string;
		CompanyType: Entities.CompanyType;
		Address: Entities.Address;
		PhoneNumber: string;
	}
	export interface RootFirmCreateAgencyRequest {
		Name: string;
	}
	export interface TransferClientRequest {
		ClientId: string;
		SourceAgencyId: string;
		DestinationAgencyId: string;
	}
}
export namespace Bokio.BackOffice.Web.Controllers {
	export interface AgencyOnboardingChecklistDto {
		Status: Entities.Partners.AgencyOnboarding.AgencyOnboardingChecklistStatus;
		Items: Bokio.BackOffice.Web.Controllers.AgencyOnboardingChecklistItemDto[];
	}
	export interface AgencyOnboardingChecklistItemDto {
		OnboardingChecklistItemName: Entities.Partners.AgencyOnboarding.AgencyOnboardingChecklistItemName;
		Status: Entities.Partners.AgencyOnboarding.AgencyOnboardingChecklistItemStatus;
	}
	export interface AgencyUpdateChecklistItemDto {
		Name: Entities.Partners.AgencyOnboarding.AgencyOnboardingChecklistItemName;
		NewStatus: Entities.Partners.AgencyOnboarding.AgencyOnboardingChecklistItemStatus;
	}
	export interface AssignSupportTicketRequest {
		SupportTicketId: string;
		AssignToUser: string;
	}
	export interface CanLeaveAgencyDto {
		CanLeave: boolean;
		CannotLeaveReason: Bokio.BackOffice.Web.Controllers.CannotLeaveReason;
	}
	export enum CannotLeaveReason {
		None = "None",
		IsOwner = "IsOwner",
		NoOwner = "NoOwner",
	}
	export interface MarkForBillingRequest {
		SupportTicketsToBill: Bokio.BackOffice.Web.Controllers.SupportTicketsToBill[];
	}
	export interface RejectApplicationRequest {
		PartnerCompanyId: string;
		ApplicationId: string;
		Reason: string;
		Message: string;
	}
	export interface RemoveAgencyClientRequest {
		AgencyId: string;
		CompanyId: string;
	}
	export interface SupportTicketsToBill {
		SupportTicketId: string;
		CompanyId: string;
	}
}
export namespace Bokio.Bank.Contract.AutoVerificationRows {
	export interface AutoVerificationRowPreviewResult {
		AutoVerifications: Bokio.Bank.Contract.AutoVerificationRows.Commands.AutoVerificationDto[];
	}
	export interface AutoVerificationRowViewModel {
		Id: string;
		EffectiveDate?: Day;
		TransactionDate: Day;
		OriginalTransactionDate?: Day;
		Text?: string;
		Amount: number;
		Removed: boolean;
		Pending: boolean;
		VerificationId?: string;
		VerificationNumber: string;
		Account: number;
		MoneyAccountName: string;
		ReceiptIds: string[];
		Bank?: Bokio.Bank.Contract.Dtos.BankForView;
		Matches: Bokio.Bank.Contract.AutoVerificationRows.Matching.AutoVerificationMatch[];
		CanBeModified: boolean;
		CanBeSplit: boolean;
		CanBeMerged: boolean;
		OriginalId: string;
		InvoiceId?: string;
		RowVersion: string;
	}
	export interface ConnectToRecieptRequest {
		ReceiptId: string;
		AutoVerificationRowId: string;
	}
	export interface ImportGroupedAutoVerificationViewModel {
		Items: Bokio.Bank.Contract.AutoVerificationRows.ImportGroupedListItem[];
	}
	export interface ImportGroupedListItem {
		ImportDate?: Date;
		AutoVerifications: Bokio.Bank.Contract.AutoVerificationRows.AutoVerificationRowViewModel[];
	}
	export interface PaginatedAutoVerificationRowList {
		Rows: Bokio.Bank.Contract.AutoVerificationRows.AutoVerificationRowViewModel[];
		PaginationTotalItems: number;
		Filter: Bokio.Bank.Contract.Utils.TransactionsFilter;
	}
	export interface SaveAllAutoVerificationRowsRequest {
		AutoVerifications: Bokio.Bank.Contract.AutoVerificationRows.Commands.AutoVerificationDto[];
	}
	export interface SaveParseFailureRequest {
		Bank: string;
		Data: string;
	}
}
export namespace Bokio.Bank.Contract.AutoVerificationRows.Commands {
	export interface AutoVerificationDto {
		Account: number;
		BankAccountId?: string;
		EffectiveDate?: Day;
		Text: string;
		Amount: number;
		Ignore: boolean;
		IsPending: boolean;
		Removed: boolean;
		DuplicationState: Bokio.Bank.Contract.AutoVerificationRows.Commands.AutoVerificationDuplicationState;
		Id: string;
		Category: string[];
		TransactionDate: Day;
		ForeignAmount?: number;
		ForeignCurrency?: string;
	}
	export enum AutoVerificationDuplicationState {
		None = "None",
		Deleted = "Deleted",
		InQueueOrBookkeept = "InQueueOrBookkeept",
		Unknown = "Unknown",
	}
	export interface RemoveAutoVerificationRows {
		AutoVerificationRowIds: string[];
	}
}
export namespace Bokio.Bank.Contract.AutoVerificationRows.Matching {
	export interface AutoVerificationGroupMatches {
		AutoVerificationRowIds: string[];
		Matches: Core.Contracts.Todo.TodoAutoVerificationMatch[];
	}
	export interface AutoVerificationMatch {
		AutoVerificationRowId?: string;
		Type: Core.Contracts.Todo.MatchType;
		AccuracyScore: number;
		InvoiceId?: string;
		SupplierInvoiceId?: string;
		VerificationId?: string;
		Data: Core.Contracts.Todo.AutoVerificationMatchData;
		RowData: Core.Contracts.Todo.AutoVerificationMatchRowData;
		SalaryTaxPeriodId?: string;
		VatReportId?: string;
		MatchBlockers: Bokio.Bank.Contract.AutoVerificationRows.Matching.MatchBlocker[];
		PayslipId?: string;
		DisbursementId?: string;
	}
	export interface AutoVerificationMatches {
		AutoVerificationRowId: string;
		Matches: Bokio.Bank.Contract.AutoVerificationRows.Matching.AutoVerificationMatch[];
	}
	export enum MatchBlocker {
		Unknown = "Unknown",
		WrongBookkeeping = "WrongBookkeeping",
		AlreadyConnectedToAccount = "AlreadyConnectedToAccount",
		IsDeleted = "IsDeleted",
		NotRecordedSupplierInvoice = "NotRecordedSupplierInvoice",
	}
}
export namespace Bokio.Bank.Contract.AutoVerificationRows.Requests {
	export interface AutoVerificationGroupMatchesRequest {
		AutoVerificationRowIds: string[];
	}
	export interface ClearReceiptRequest {
		Entities: Bokio.Bank.Contract.AutoVerificationRows.Requests.ReceiptRequestEntity[];
	}
	export interface ConnectAutoVerificationRowToSupplierInvoicePaymentRequest {
		AutoVerificationRowId: string;
		SupplierInvoicePaymentId: string;
		RowVersion: string;
	}
	export interface ConnectAutoVerificationRowToVerificationRequest {
		AutoVerificationRowIds: string[];
		VerificationId: string;
		RowVersions: { [key: string]: string; };
	}
	export interface DisableAutoVerificationRowMatchingRequest {
		AutoVerificationRowId: string;
	}
	export interface DisconnectAutoVerificationRowsFromVerificationRequest {
		VerificationId: string;
		BookkeepingAccount: number;
	}
	export interface EnableAutoVerificationRowMatchingRequest {
		AutoVerificationRowId: string;
	}
	export interface MergeAutoVerificationRowRequest {
		OriginalAutoVerificationRowId: string;
	}
	export interface ReceiptRequest {
		Entities: Bokio.Bank.Contract.AutoVerificationRows.Requests.ReceiptRequestEntity[];
		UserIdsToNotify: string[];
	}
	export interface ReceiptRequestEntity {
		EntityType: Entities.Accounting.EntityType;
		EntityId: string;
		Status: Entities.Accounting.ReceiptRequestStatus;
	}
	export interface SplitBankRowRequest {
		AutoVerificationRowId: string;
		AmountsInNewRows: number[];
	}
}
export namespace Bokio.Bank.Contract.Bank {
	export enum BankAccountSyncMode {
		Automatic = "Automatic",
		Manual = "Manual",
		Realtime = "Realtime",
	}
}
export namespace Bokio.Bank.Contract.CodeExampleFeature {
	export interface CodeExampleFeatureItemDto {
		Id: string;
		Name: string;
		LaunchDate: Day;
		CreatedAt: Date;
		UpdatedAt: Date;
	}
	export interface CreateCodeExampleFeatureItemRequestDto {
		Name: string;
		LaunchDate: Day;
	}
	export interface UpdateCodeExampleFeatureItemRequestDto {
		Name: string;
		LaunchDate: Day;
	}
}
export namespace Bokio.Bank.Contract.Dtos {
	export interface AddressDto {
		Street1: string;
		Street2?: string;
		City: string;
		PostalCode: string;
		Co?: string;
		CountryCode?: string;
	}
	export interface BankAccountConfiguration {
		RequiresEmptyAccount: boolean;
		PrimaryAccountPaymentType?: Entities.Teller.TellerPaymentType;
		PrimaryAccountNumber?: string;
		PrimaryAccountLabel?: string;
		PrimaryAccountShortLabel?: string;
		LocalizedAccountName?: string;
	}
	export interface BankAccountConnection {
		Id: string;
		LastSyncDate?: Date;
		SyncFromDate?: Day;
		Status: Entities.ProgressStatus;
		Balance?: number;
		Currency: string;
		Bank: Bokio.Bank.Contract.Dtos.BankDto;
		PrimaryAccountNumber?: string;
		PrimaryAccountLabel?: string;
		PrimaryAccountShortLabel?: string;
		Type: Entities.Bank.BankAccountType;
		PendingTransactionCount: number;
		SyncMode: Bokio.Bank.Contract.Bank.BankAccountSyncMode;
		BankAccountName?: string;
		ExternalId: string;
	}
	export interface BankAccountDetailsResponse {
		BookKeepingAccount: number;
		AccountName: string;
		ClearingNumber?: string;
		AccountNumber?: string;
		AccountType: Entities.Bank.BankAccountType;
		NoOfActiveCards: number;
		AccountBalance: number;
		AccountCurrency: string;
		Iban?: string;
		Bic?: string;
		SwishNumber?: string;
		HasInternationalPayments: boolean;
		OverdraftLimit?: number;
		InterestRate?: number;
		AccruedInterest?: number;
		TotalInterest?: number;
		InterestLastDate?: string;
	}
	export interface BankAccountDto {
		Id: string;
		Name: string;
		Type: Entities.Bank.BankAccountType;
		Balance?: number;
		Currency: string;
		BookkeepingAccount: number;
		ConnectionStatus: Entities.ProgressStatus;
		LastSync?: Date;
		SyncFromDate?: Day;
		Configuration: Bokio.Bank.Contract.Dtos.BankAccountConfiguration;
		PendingTransactionCount: number;
		ExternalId: string;
	}
	export interface BankAccountForListDto {
		Id?: string;
		BankId?: string;
		BankName: string;
		Account: number;
		LastRowDate?: Day;
		LastSyncDate?: Date;
		AccountName?: string;
		AccountType: Entities.Bank.BankAccountType;
		AccountData?: Classes.Teller.TellerBankAccountInformationUnion;
		BankConfiguration: Bokio.Bank.Contract.Dtos.BankConfiguration;
		Configuration: Bokio.Bank.Contract.Dtos.BankAccountConfiguration;
	}
	export interface BankAccountTypePaymentOptions {
		BankAccountType: Entities.Bank.BankAccountType;
		PaymentTypes: Entities.Teller.TellerPaymentType[];
	}
	export interface BankAuthenticationPrompt {
		ExternalSystem: Entities.Bank.ExternalSystem;
		PrefilledPersonalId?: string;
	}
	export interface BankConfiguration {
		SupportsPayment: boolean;
		SupportsInstantPayments: boolean;
		SupportsReconnection: boolean;
		AllowsManualImport: boolean;
		SupportsCard: boolean;
		SupportsBankInbox?: boolean;
		SupportsNonConsent: boolean;
		PastMonthsPossibleToSync?: number;
		ExternalSystem: Entities.Bank.ExternalSystem;
		AllowsManuallyTriggeredSync: boolean;
		SyncMode: Bokio.Bank.Contract.Bank.BankAccountSyncMode;
		SupportedInternationalOutgoingPaymentTypes: Entities.Teller.TellerPaymentType[];
		SupportsInternationalPayment: boolean;
		SupportsReceivingInternationalPayments: boolean;
		SupportedPaymentMethods: Bokio.Bank.Contract.Dtos.BankAccountTypePaymentOptions[];
	}
	export interface BankDto {
		Accounts: Bokio.Bank.Contract.Dtos.BankAccountDto[];
		NeedsReAuthentication: boolean;
		ExternalSystem: Entities.Bank.ExternalSystem;
		Configuration: Bokio.Bank.Contract.Dtos.BankConfiguration;
		Id: string;
		Name: string;
		LogoPath?: string;
	}
	export interface BankError {
		Message: string;
		BankAuthenticationPrompt?: Bokio.Bank.Contract.Dtos.BankAuthenticationPrompt;
	}
	export interface BankForView {
		Id: string;
		Name: string;
		LogoPath?: string;
	}
	export interface BankNeedReAuthenticationDto {
		BankId: string;
		BankName: string;
		ExternalSystem: Entities.Bank.ExternalSystem;
		Configuration: Bokio.Bank.Contract.Dtos.BankConfiguration;
	}
	export interface BanksDto {
		Banks: Bokio.Bank.Contract.Dtos.BankDto[];
	}
	export interface CardDetailsDto {
		ConnectedAccountLabel: string;
		ActivatedDate?: Day;
		AllowInternationalPurchase: boolean;
		AllowOnlinePurchase: boolean;
		AllowAtmWithdrawal?: boolean;
		AllowContactless?: boolean;
		LimitAmountPerWeek?: Bokio.Bank.Contract.Utils.TellerTransactionAmount;
		OrganizationNameOnCard?: string;
		CardHolderNameOnCard: string;
		CardHolderName: string;
		DeliveryAddress?: Entities.ExtendedAddress;
		Activated: boolean;
		PhoneNumber?: string;
		CardHolderPersonalId?: string;
		CanReplaceCard?: boolean;
		CanTerminateCard?: boolean;
		ExternalSystem: Entities.Bank.ExternalSystem;
		Id: string;
		ExternalId: string;
		Status: Bokio.Bank.Contract.Dtos.CardStatus;
		CreatedDate?: Day;
		ExpiryDate?: Day;
		CardRenewals: Bokio.Bank.Contract.Dtos.CardRenewalInfo[];
		IsRenewing: boolean;
	}
	export interface CardListCardItemDto {
		Status: Bokio.Bank.Contract.Dtos.CardStatus;
		Mask?: string;
		ConnectedAccountName: string;
		Id?: string;
		ConnectedAccountId: string;
		ConnectedAccountMapsTo: number;
		CreatedDate?: Day;
		ExpiryDate?: Day;
		IsRenewing: boolean;
		UserId: string;
	}
	export interface CardListDto {
		Users: Bokio.Bank.Contract.Dtos.CardListUserDto[];
	}
	export interface CardListUserDto {
		UserName: string;
		Cards: Bokio.Bank.Contract.Dtos.CardListCardItemDto[];
		UserId: string;
		AnyCardInRenewal: boolean;
	}
	export interface CardRenewalInfo {
		Time: Date;
		ActivatedDate?: Date;
		Activated: boolean;
	}
	export enum CardStatus {
		Invalid = "Invalid",
		ReadyToOrder = "ReadyToOrder",
		Active = "Active",
		Destroyed = "Destroyed",
		Blocked = "Blocked",
		NotActivated = "NotActivated",
		Expired = "Expired",
		OrderOngoing = "OrderOngoing",
	}
	export interface CheckDuplicatePaymentResult {
		DuplicatePaymentId?: string;
		DuplicatePaymentGroupId?: string;
		HasDuplicate: boolean;
	}
	export interface CountryInfoDto {
		Name: string;
		Code: string;
		IsEuEeaCountry: boolean;
		SupportsSepa: boolean;
		DefaultCurrency: string;
	}
	export interface CreatePaymentResponseDto {
		PaymentId: string;
	}
	export interface CurrencyInfoDto {
		Name: string;
		Code: string;
		InternationalPaymentOutgoingSupport: boolean;
		InternationalPaymentIncomingSupport: boolean;
		DomesticPaymentSupport: boolean;
	}
	export interface CurrentUserCardsDto {
		Cards: Bokio.Bank.Contract.Dtos.CardListCardItemDto[];
		UserId: string;
	}
	export interface FailedPaymentGroup {
		FailedPayments: { [key: string]: Bokio.Bank.Contract.Dtos.FailedPaymentInfo; };
	}
	export interface FailedPaymentInfo {
		ErrorMessage?: string;
	}
	export interface FromAccountInfoDto {
		AccountNumber: number;
		AccountName: string;
		Balance?: number;
		CurrencyCode: string;
	}
	export interface GiroNumberSearchResultDto {
		Type: Entities.Teller.TellerPaymentType;
		GiroNumber: string;
		OrganisationName: string;
		Address: Entities.ExtendedAddress;
	}
	export interface GiroRecipientDto {
		Type: Entities.Teller.TellerPaymentType;
		FormattedGiroNumber: string;
		GiroDigits: string;
		OrganisationName: string;
		ShouldAskUserToInputRecipientName: boolean;
		Address: Entities.ExtendedAddress;
		PrefillInformation?: Entities.Teller.TellerPaymentPrefilledInformation;
	}
	export interface ListBankAccountsResponse {
		HasConnectedBanks: boolean;
		HasAllBankConnectionsConnected: boolean;
		MoneyAccounts: Bokio.Bank.Contract.Dtos.MoneyAccountWithInfo[];
		SoftBankError?: Bokio.Bank.Contract.Dtos.BankError;
	}
	export interface MoneyAccountWithInfo {
		MapsTo: number;
		Name?: string;
		LastRowDate?: Day;
		Connection?: Bokio.Bank.Contract.Dtos.BankAccountConnection;
		BankConfiguration?: Bokio.Bank.Contract.Dtos.BankConfiguration;
		BankAccountConfiguration?: Bokio.Bank.Contract.Dtos.BankAccountConfiguration;
	}
	export interface NonBankingDay {
		Date: Day;
	}
	export interface PaymentCentralPageSummaryDto {
		AvailableAmount: number;
		AvailableAfterPayment: number;
		Currency: string;
		UpcomingPaymentAmount: number;
		ApproximateAmount: boolean;
	}
	export interface PaymentDetailsForTransactionDto {
		SenderReference: string;
		PaymentReference: string;
		PaymentInfoUnion: Classes.Teller.TellerPaymentInformationUnion;
	}
	export interface PaymentDetailsViewModel {
		Id: string;
		Type?: Entities.Teller.TellerPaymentType;
		From: string;
		SenderReference: string;
		PaymentInfoUnion: Classes.Teller.TellerPaymentInformationUnion;
		Date: Date;
		Sum: number;
		PaidAmount?: number;
		Status: Entities.Teller.TellerPaymentStatus;
		Currency: string;
		ExternalId: string;
		PaymentReference: string;
		ReviewedByUserName: string;
		ReviewedStatus: Entities.Teller.TellerPaymentStatus;
		Consumer: Entities.Teller.TellerConsumer;
		CanBeCancelled: boolean;
		CanBeSigned: boolean;
		PaymentGroupId?: string;
		Warnings?: Bokio.Bank.Contract.Dtos.PaymentWarning[];
		ReceiptId?: string;
		ConsumerItemId?: string;
	}
	export interface PaymentForListDto {
		Id: string;
		SenderReference: string;
		PaymentReference: string;
		PaymentInfoUnion: Classes.Teller.TellerPaymentInformationUnion;
		Date: Day;
		Sum: number;
		ApproximateDomesticSum: number;
		PaidAmount?: number;
		Status: Entities.Teller.TellerPaymentStatus;
		Currency: string;
		ExternalId: string;
		CanBeSigned: boolean;
		CanBeCancelled: boolean;
		Category: Entities.Teller.TellerConsumer;
		IsReadyToSign: boolean;
		Warnings?: Bokio.Bank.Contract.Dtos.PaymentWarning[];
		ExternalSystem: Entities.Bank.ExternalSystem;
	}
	export interface PaymentGroupForAuthorization {
		Id: string;
		Date: Day;
	}
	export interface PaymentGroupForListDto {
		Id: string;
		From: string;
		FromBankAccount: string;
		Date: Day;
		Category: Entities.Teller.TellerConsumer;
		GroupReference: string;
		Sum: number;
		CanBeCancelled: boolean;
		CanBeSigned: boolean;
		IsBatch: boolean;
		Payments: Bokio.Bank.Contract.Dtos.PaymentForListDto[];
		Hidden: boolean;
		Warnings?: Bokio.Bank.Contract.Dtos.PaymentWarning[];
	}
	export interface PaymentReasonCodeCategory {
		Label: string;
		SubCategories: Bokio.Bank.Contract.Dtos.PaymentReasonCodeCategory[];
		Options: Bokio.Bank.Contract.Dtos.PaymentReasonCodeDto[];
	}
	export interface PaymentReasonCodeDto {
		Key: string;
		Code: string;
		Label: string;
	}
	export interface PaymentReasonRequirementsDto {
		RequiredBySenderCountry: boolean;
		RequiredByRecipientCountry: boolean;
	}
	export interface PaymentRecipientDto {
		Id: string;
		Consumer: Entities.Teller.TellerConsumer;
		CanConvertToSupplier: boolean;
		RecipientName?: string;
		AccountNumberLabel?: string;
		Type: Entities.Teller.TellerPaymentType;
		PaymentInfoUnion: Classes.Teller.TellerPaymentInformationUnion;
		CountryCode?: string;
		Currency?: string;
		PrefillInformation?: Entities.Teller.TellerPaymentPrefilledInformation;
		PrimaryAccountNumber?: string;
	}
	export interface PaymentSenderDto {
		BankAccountId: string;
		Name: string;
		AccountNumber: string;
		Type: Entities.Bank.BankAccountType;
		CurrentBalance: number;
	}
	export interface PaymentsForListDto {
		Filter: Bokio.Bank.Contract.Utils.PaymentsFilter;
		FromAccountsInfo: { [key: string]: Bokio.Bank.Contract.Dtos.FromAccountInfoDto; };
		PaymentGroups: Bokio.Bank.Contract.Dtos.PaymentGroupForListDto[];
		Page: number;
		TotalItems: number;
		PageSize: number;
	}
	export interface PaymentsToSignTodoData {
		PaymentCount: number;
		CurrencyAmounts: Classes.Teller.CurrencyAmount[];
	}
	export interface PaymentValidationRulesDto {
		MinimumRequestedDayDiffFromToday: number;
		NonBankingDays: Bokio.Bank.Contract.Dtos.NonBankingDay[];
		PaymentDateMaxValue: Day;
		NextPossiblePaymentDateIncludingToday: Day;
	}
	export interface PaymentWarning {
		Type: Bokio.Bank.Contract.Dtos.PaymentWarningType;
		Level: Bokio.Bank.Contract.Dtos.PaymentWarningLevel;
		Message: string;
		SigningMessageOverride: string;
	}
	export enum PaymentWarningLevel {
		Info = "Info",
		Warning = "Warning",
		Error = "Error",
	}
	export enum PaymentWarningType {
		PastDate = "PastDate",
		NewReceiver = "NewReceiver",
		OnTheWay = "OnTheWay",
		NewCreator = "NewCreator",
		BankAccountOffboarded = "BankAccountOffboarded",
		CreatedThroughBokioApi = "CreatedThroughBokioApi",
	}
	export interface PossibleNamesDto {
		Normal: string[];
		Reversed: string[];
	}
	export interface PreviousBankAccountDto {
		BankAccountId: string;
	}
	export enum RecipientType {
		SupplierInvoice = "SupplierInvoice",
		ManualPayment = "ManualPayment",
		OwnAccount = "OwnAccount",
		SwiftBic = "SwiftBic",
	}
	export interface RenderedDetailRow {
		Name: string;
		Value: Bokio.Bank.Contract.Dtos.RenderedDetailRowValue;
	}
	export interface RenderedDetailRowValue {
		Type: Bokio.Bank.Contract.Dtos.RenderedDetailRowValueType;
		Text?: string;
		Date?: Day;
		Decimal?: number;
	}
	export enum RenderedDetailRowValueType {
		Invalid = "Invalid",
		Text = "Text",
		Date = "Date",
		Decimal = "Decimal",
	}
	export interface SearchRecipientDto {
		SearchString: string;
		Pagination?: Bokio.Common.Contract.Pagination.Pagination;
		ExcludeRecipentTypes?: Bokio.Bank.Contract.Dtos.RecipientType[];
	}
	export interface SearchRecipientResponseDto {
		Items: Bokio.Bank.Contract.Dtos.PaymentRecipientDto[];
		PageNumber: number;
		PageSize: number;
		TotalItems: number;
	}
	export interface SendAndAuthorizePaymentsResultDto {
		SuccessfulPaymentIds: string[];
		FailedPayments: { [key: string]: Bokio.Bank.Contract.Dtos.FailedPaymentInfo; };
		FailedPaymentGroups: { [key: string]: Bokio.Bank.Contract.Dtos.FailedPaymentGroup; };
		ConfirmationId?: string;
		AutostartToken: string;
		QrCode?: string;
	}
	export interface SenderBankAccountResponseDto {
		Items: Bokio.Bank.Contract.Dtos.PaymentSenderDto[];
	}
	export interface SetBookkeepingAccountDto {
		BankAccountId: string;
		BookkeepingAccount: number;
		BookkeepingAccountNameForCreation?: string;
		SyncFromDate?: Day;
		IsKlarnaToEnableBankingMigration?: boolean;
	}
	export interface StateHistoryWithAudit {
		Status: Entities.Teller.TellerPaymentStatus;
		SerialNumber: number;
		AuditUserId?: string;
	}
	export interface TransactionAutoVerificationRowInfo {
		VerificationId?: string;
		VerificationNumber: string;
		AutoVerificationRowId: string;
	}
	export interface TransactionDetailsDto {
		Id: string;
		TransactionDate: Day;
		Description: string;
		Amount: number;
		FormattedAmount: string;
		FormattedForeignAmount?: string;
		Status: Entities.Teller.TellerTransactionStatus;
		ReceiptIds: string[];
		AutoVerificationRowInfos: Bokio.Bank.Contract.Dtos.TransactionAutoVerificationRowInfo[];
		PaymentDetails?: Bokio.Bank.Contract.Dtos.PaymentDetailsForTransactionDto;
		RenderedDetailRows: Bokio.Bank.Contract.Dtos.RenderedDetailRow[];
		CanAttachReceipt: boolean;
		ConsumerItemRoute?: string;
		Consumer?: Entities.Teller.TellerConsumer;
		MatchingRecipientName?: string;
	}
	export interface TransactionForListDto {
		Id: string;
		BookkeepingAccount: number;
		TransactionDate: Day;
		EffectiveDate?: Day;
		Status: Entities.Teller.TellerTransactionStatus;
		Description: string;
		ReferenceTextOrDescription: string;
		Amount: number;
		EffectiveBalance: number;
		ReceiptIds: string[];
		AutoVerificationRowInfos: Bokio.Bank.Contract.Dtos.TransactionAutoVerificationRowInfo[];
		RemotePartyName: string;
		CanDisconnectBookkeeping: boolean;
		Type: string;
		OriginalTransactionDate?: Day;
	}
	export interface TransactionListPageSumaryDto {
		AccountBalance: number;
		ReservedAmount: number;
		AvailableAmount: number;
		Currency: string;
		ApproximateAmount: boolean;
	}
	export interface TransactionsForListDto {
		PendingTransactions: Bokio.Bank.Contract.Dtos.TransactionForListDto[];
		CompletedTransactions: Bokio.Bank.Contract.Dtos.TransactionForListDto[];
		PageNumber: number;
		PageSize: number;
		PaginationTotalItems: number;
	}
	export interface UserInformationDto {
		Address?: Entities.ExtendedAddress;
		PhoneNumber: string;
		PossibleNames: Bokio.Bank.Contract.Dtos.PossibleNamesDto;
		OrganisationDisplayNames: string[];
		AccountMapsTo: number;
		AccountName: string;
		UserBokioName: string;
		PersonalNumber: string;
	}
	export interface UserPaymentPermissionDto {
		CanSignPayment: boolean;
	}
}
export namespace Bokio.Bank.Contract.Dtos.IntegrationTests {
	export enum CardPurchaseType {
		Online = "Online",
		PoS = "PoS",
	}
	export interface CompletePaymentDto {
		ExternalPaymentId: string;
		ExchangeRate?: number;
	}
	export interface CreateMockCardTransactionDto {
		CardId: string;
		PurchaseType: Bokio.Bank.Contract.Dtos.IntegrationTests.CardPurchaseType;
		BankAccountId: string;
		Amount: number;
		TransactionDate: Day;
		SenderReference: string;
		ReceiverMessage: string;
		ForeignAmount?: number;
		ForeignCurrency?: string;
		ExternalSystem: Entities.Bank.ExternalSystem;
		Type: Entities.Teller.TellerTransactionType;
		IsBankGiroDepositForSvea: boolean;
	}
	export interface CreateMockTransactionDto {
		BankAccountId: string;
		Amount: number;
		TransactionDate: Day;
		SenderReference: string;
		ReceiverMessage: string;
		ForeignAmount?: number;
		ForeignCurrency?: string;
		ExternalSystem: Entities.Bank.ExternalSystem;
		Type: Entities.Teller.TellerTransactionType;
		IsBankGiroDepositForSvea: boolean;
	}
	export interface RejectPaymentDto {
		ExternalPaymentId: string;
	}
	export enum SveaAsyncApiElinTransactionDeductionType {
		Invalid = "Invalid",
		CompleteDeductionNoRest = "CompleteDeductionNoRest",
		PartialDeductionWithRest = "PartialDeductionWithRest",
		FinalDeductionWithPartialDeductionNoRest = "FinalDeductionWithPartialDeductionNoRest",
		Other = "Other",
		ReservedForFutureUse = "ReservedForFutureUse",
	}
	export interface SveaAsyncApiElinTransactionRequest {
		Amount: number;
		DebtorBankgiroNumber?: string;
		DebtorName: string;
		HasImage: boolean;
		InformationText: string;
		Reference: string;
		DeductionType?: Bokio.Bank.Contract.Dtos.IntegrationTests.SveaAsyncApiElinTransactionDeductionType;
	}
}
export namespace Bokio.Bank.Contract.EnableBanking {
	export interface AspspDataDto {
		Name: string;
		Country: string;
		Logo: string;
		PsuTypes: Bokio.Bank.Contract.EnableBanking.EnableBankingPsuType[];
	}
	export enum CashAccountTypeDto {
		Invalid = "Invalid",
		CACC = "CACC",
		CASH = "CASH",
		CARD = "CARD",
		LOAN = "LOAN",
		SVGS = "SVGS",
		OTHR = "OTHR",
	}
	export interface EnableBankingAccountDetails {
		Name: string;
		Currency: string;
		Uid: string;
		Iban?: string;
		Bic?: string;
		ClearingNumber?: string;
		AccountNumber?: string;
		CashAccountType: Bokio.Bank.Contract.EnableBanking.CashAccountTypeDto;
		AccountIdentificationHash: string;
		ExistingMatchingBankAccount?: Bokio.Bank.Contract.EnableBanking.ExistingMatchingAccountDetailsDto;
	}
	export enum EnableBankingPsuType {
		Invalid = "Invalid",
		Business = "Business",
		Personal = "Personal",
	}
	export interface ExistingMatchingAccountDetailsDto {
		MatchedAccountBankName?: string;
		MatchedBankAccountName?: string;
		MatchedBankAccountNumber?: string;
		MatchedBankAccountClearingNumber?: string;
		MatchedBankAccountIban?: string;
		MatchedBankAccountLastSyncDate?: Date;
		MatchedBankAccountBookkeeping: number;
		MatchedMoneyAccount?: string;
		MatchedExternalSystem: Entities.Bank.ExternalSystem;
	}
	export interface SelectedExternalBankAccountsDto {
		SelectedExternalBankAccountIds: string[];
	}
	export interface SessionAccountResponseDto {
		Accounts: Bokio.Bank.Contract.EnableBanking.EnableBankingAccountDetails[];
	}
	export interface StartAuthorizationRequestDto {
		AspspName: string;
		AspspCountry: string;
		PsuType: Bokio.Bank.Contract.EnableBanking.EnableBankingPsuType;
	}
	export interface StartAuthorizationResponseDto {
		AuthorizationId: string;
		Url: string;
		WidgetScriptSrc: string;
	}
}
export namespace Bokio.Bank.Contract.Klarna.Dtos {
	export interface KlarnaStartSessionDto {
		ClientToken: string;
	}
}
export namespace Bokio.Bank.Contract.Mir.Card {
	export interface StartActivateCardRequest {
		CardId: string;
		LastFourDigitsOfCard: string;
		PhoneNumber: string;
	}
}
export namespace Bokio.Bank.Contract.Mir.Onboarding {
	export interface ConfirmationIdDto {
		ConfirmationId: string;
		AutostartToken: string;
	}
}
export namespace Bokio.Bank.Contract.MoneyAccount {
	export interface BankFeedMoneyAccountSuggestionDto {
		ConnectableAccounts: Bokio.Bank.Contract.MoneyAccount.ConnectableAccountDto[];
		SuggestedAccount: number;
		AccountsInUse: { [key: number]: number; };
	}
	export interface ConnectableAccountDto {
		Account: number;
		Name: string;
		EarliestSyncFromDate?: Day;
	}
	export interface MoneyAccountDto {
		MapsTo: number;
		Name: string;
		BankAccount: Bokio.Bank.Contract.Dtos.BankAccountForListDto;
		PreviousBankAccount?: Bokio.Bank.Contract.Dtos.PreviousBankAccountDto;
	}
	export interface MoneyAccountForView {
		Name: string;
		MapsTo: number;
		IsDefault: boolean;
		IsSalaryAccount: boolean;
		IsInvoiceAccount: boolean;
		Type: Entities.Bank.BankAccountType;
		Pinned: boolean;
		ExternalSystem?: Entities.Bank.ExternalSystem;
	}
	export interface MoneyAccountSettingsForView {
		Accounts: Bokio.Bank.Contract.MoneyAccount.MoneyAccountForView[];
	}
}
export namespace Bokio.Bank.Contract.Plaid {
	export interface PlaidOptionsDto {
		AuthScriptSrc: string;
	}
}
export namespace Bokio.Bank.Contract.Requests {
	export interface BankIdTokenOperationRequest {
		BankIdToken: string;
	}
	export interface ConfirmGetSetPinWidgetLinkRequest {
		BankIdToken: string;
		CardId: string;
	}
	export interface ConnectManualPaymentToReceiptRequest {
		ManualPaymentId: string;
		ReceiptId: string;
	}
	export interface ConvertRecipientToSupplierAndCreateSupplierInvoicePaymentRequest {
		PaymentRecipientId: string;
		TellerPaymentInfoDto: Bokio.Bank.Contract.Teller.Dtos.TellerPaymentInfoDto;
		InvoiceDate: Day;
		ReceiptId?: string;
	}
	export interface OrderCardFrontendRequest {
		AccountId: string;
		Address: Bokio.Bank.Contract.Dtos.AddressDto;
		CardDisplayName: string;
		PhoneNumber: string;
		ShowCompanyNameOnCard: boolean;
		CompanyNameOnCard: string;
	}
	export interface SveaAuthStatusRequest {
		BankIdToken: string;
	}
	export interface SveaAuthStatusResponse {
		Status: Bokio.Common.Contract.BankId.BankIdCollectionStatus;
		HintCode?: Bokio.Common.Contract.BankId.BankIdHintCode;
		QrCode?: string;
		ShouldRefreshCompanyInfo: boolean;
	}
	export interface SveaBankIdAuthStartRequest {
		PersonalId?: string;
	}
	export interface SveaBankIdAuthStartResponse {
		BankIdToken: string;
		QrCode: string;
	}
}
export namespace Bokio.Bank.Contract.Requests.IntegrationTests {
	export interface CreateEnableBankingMockTransactionDto {
		Amount: number;
		Reference: string;
		BookingDate: string;
		ForeignCurrency?: string;
		ForeignAmount?: number;
	}
	export interface SveaBypassOnboardingRequest {
		GiveConsent: boolean;
		Addons?: Bokio.Bank.Contract.Svea.Requests.SveaAddon[];
	}
}
export namespace Bokio.Bank.Contract.Svea.Dtos {
	export interface ApplicationIdBeneficialOwners {
		CompanyShare: Bokio.Bank.Contract.Svea.Dtos.SveaPercentInterval;
		FirstName: string;
		LastName: string;
		BeneficialOwnerQuestionKey: string;
	}
	export interface ApplicationIdBeneficialOwnership {
		BeneficialOwners: Bokio.Bank.Contract.Svea.Dtos.ApplicationIdBeneficialOwners[];
		ForeignBeneficialOwners: Bokio.Bank.Contract.Svea.Dtos.ApplicationIdBeneficialOwners[];
		BeneficialOwnershipStatus: Bokio.Bank.Contract.Svea.Dtos.SveaBeneficialOwnershipStatus;
		ConfirmationText?: string;
	}
	export enum AutogiroRecipientEligibilityStatus {
		NotEligible = "NotEligible",
		EligibleNoConsent = "EligibleNoConsent",
		HasExistingConsent = "HasExistingConsent",
	}
	export interface BankIdSigningDto {
		AutoStartToken?: string;
		HintCode?: Bokio.Common.Contract.BankId.BankIdHintCode;
		QrCode?: string;
		Scope?: string;
		Status: Bokio.Common.Contract.BankId.BankIdCollectionStatus;
		IfMatchRevision: string;
	}
	export interface ConfirmBeneficiaryOwnershipResponse {
		HasApplicationStatusNotValidIssue: boolean;
	}
	export interface GetNotConnectedBankAccountsResponse {
		BankAccounts: Bokio.Bank.Contract.Svea.Dtos.NotConnectedBankAccount[];
		IsAnyBookkeepingAccountNotConnected: boolean;
	}
	export interface KycAmlQuestionsForProduct {
		ProductId: string;
		Questions: Bokio.Bank.Contract.Svea.Dtos.KycQuestion[];
	}
	export interface KycAnswer {
		AnswerChoiceId?: string;
		AnswerValue: Bokio.Bank.Contract.Svea.Dtos.KycAnswerValue;
	}
	export interface KycAnswerChoice {
		AnswerChoiceId?: string;
		Value: Bokio.Bank.Contract.Svea.Dtos.KycAnswerValue;
		SubQuestions: Bokio.Bank.Contract.Svea.Dtos.KycQuestion[];
	}
	export interface KycAnswerValue {
		StringValue?: string;
		CountryAndTinValue?: Bokio.Bank.Contract.Svea.Dtos.KycCountryAndTin;
		PepQuestionDataValue?: Bokio.Bank.Contract.Svea.Dtos.KycPepQuestionData;
	}
	export interface KycAnswerWrapper {
		AnswerChoiceId?: string;
		AnswerValue: Bokio.Bank.Contract.Svea.Dtos.KycAnswer;
	}
	export interface KycCountryAndTin {
		Alpha2Code?: string;
		Tin: string;
		Type: string;
	}
	export interface KycPepQuestionData {
		BirthDate: Day;
		Name: string;
		PepReasons: string[];
	}
	export interface KycQuestion {
		AnswerChoices: Bokio.Bank.Contract.Svea.Dtos.KycAnswerChoice[];
		Answers: Bokio.Bank.Contract.Svea.Dtos.KycAnswerWrapper[];
		HelpText?: string;
		Question: string;
		QuestionId: string;
		QuestionType: Bokio.Bank.Contract.Svea.Dtos.KycQuestionType;
		QuestionTypeContext?: Bokio.Bank.Contract.Svea.Dtos.KycQuestionTypeContext;
		QuestionTypeContext_Range?: Bokio.Bank.Contract.Svea.Dtos.KycQuestionTypeContextRange;
		QuestionTypeContext_PepRelation?: Bokio.Bank.Contract.Svea.Dtos.KycQuestionTypeContextPepRelation;
	}
	export enum KycQuestionType {
		SingleChoice = "SingleChoice",
		MultipleChoice = "MultipleChoice",
		Text = "Text",
		NonEesCountriesMultipleChoice = "NonEesCountriesMultipleChoice",
		AllCountriesMultipleChoice = "AllCountriesMultipleChoice",
		CountryAndTinMultipleChoice = "CountryAndTinMultipleChoice",
		InternationalPaymentsCountriesMultipleChoice = "InternationalPaymentsCountriesMultipleChoice",
		CountryAndTinSingleChoice = "CountryAndTinSingleChoice",
		PepRelationQuestion = "PepRelationQuestion",
	}
	export interface KycQuestionTypeContext {
	}
	export interface KycQuestionTypeContextPepRelation {
		ValidPepReasons: string[];
	}
	export interface KycQuestionTypeContextRange {
		High?: number;
		Low: number;
		Step: number;
		Type: Bokio.Bank.Contract.Svea.Dtos.KycQuestionTypeContextRangeType;
	}
	export enum KycQuestionTypeContextRangeType {
		SEK = "SEK",
		Integer = "Integer",
	}
	export interface NotConnectedBankAccount {
		Id: string;
	}
	export enum OnboardingStatus {
		Completed = "Completed",
		NotCompleted = "NotCompleted",
		Optional = "Optional",
	}
	export interface SveaAddProductAmlQuestionsStep {
		State: Bokio.Bank.Contract.Svea.Dtos.SveaAddProductAmlQuestionStepStateItem[];
		Status: Bokio.Bank.Contract.Svea.Dtos.OnboardingStatus;
	}
	export interface SveaAddProductAmlQuestionStepStateItem {
		Completed: boolean;
		ProductId: string;
		ProductDefinitionId: Bokio.Bank.Contract.Svea.Dtos.SveaProductDefinitionId;
	}
	export interface SveaAddProductAssignGuarantorStep {
		Status: Bokio.Bank.Contract.Svea.Dtos.OnboardingStatus;
	}
	export interface SveaAddProductAssignSignatoriesStep {
		Status: Bokio.Bank.Contract.Svea.Dtos.OnboardingStatus;
	}
	export interface SveaAddProductConfigureBankGiroProductStep {
		Status: Bokio.Bank.Contract.Svea.Dtos.OnboardingStatus;
	}
	export interface SveaAddProductConfigureCreditAccountStep {
		State?: Bokio.Bank.Contract.Svea.Dtos.SveaConfigureCreditAccountStepState;
		Status: Bokio.Bank.Contract.Svea.Dtos.OnboardingStatus;
	}
	export interface SveaAddProductConfigureCreditProductStep {
		State?: Bokio.Bank.Contract.Svea.Dtos.SveaConfigureCreditProductStepState;
		Status: Bokio.Bank.Contract.Svea.Dtos.OnboardingStatus;
	}
	export interface SveaAddProductConfigureInternationalPaymentsStep {
		Status: Bokio.Bank.Contract.Svea.Dtos.OnboardingStatus;
	}
	export interface SveaAddProductConfigureMastercardDirectStep {
		Status: Bokio.Bank.Contract.Svea.Dtos.OnboardingStatus;
	}
	export interface SveaAddProductConfigureSwishStep {
		State?: Bokio.Bank.Contract.Svea.Dtos.SveaConfigureSwishStepState;
		Status: Bokio.Bank.Contract.Svea.Dtos.OnboardingStatus;
	}
	export interface SveaAddProductCreditScoreStep {
		Assessment?: Bokio.Bank.Contract.Svea.Dtos.SveaCreditScoreAssessment;
		Status: Bokio.Bank.Contract.Svea.Dtos.OnboardingStatus;
	}
	export interface SveaAddProductData {
		ApplicationId: string;
		ProductType: Bokio.Bank.Contract.Svea.Requests.SveaAddon;
	}
	export interface SveaAddProductFinalizeStep {
		Status: Bokio.Bank.Contract.Svea.Dtos.OnboardingStatus;
	}
	export interface SveaAddProductInitiateStep {
		State: Bokio.Bank.Contract.Svea.Dtos.SveaInitiateStepState;
		Status: Bokio.Bank.Contract.Svea.Dtos.OnboardingStatus;
	}
	export interface SveaAddProductSelectPackageStep {
		State?: Bokio.Bank.Contract.Svea.Dtos.SveaAddProductSelectPackageStepState;
		Status: Bokio.Bank.Contract.Svea.Dtos.OnboardingStatus;
	}
	export interface SveaAddProductSelectPackageStepState {
		MonthlyFee?: Bokio.Bank.Contract.Svea.Dtos.SveaMoneyAmount;
	}
	export interface SveaAddProductSelectProductStep {
		State?: Bokio.Bank.Contract.Svea.Dtos.SveaAddProductSelectProductStepState;
		Status: Bokio.Bank.Contract.Svea.Dtos.OnboardingStatus;
	}
	export interface SveaAddProductSelectProductStepState {
		SelectedProducts: Bokio.Bank.Contract.Svea.Dtos.SveaSelectedProduct[];
	}
	export interface SveaAddProductSetupGuarantorAgreementStep {
		Status: Bokio.Bank.Contract.Svea.Dtos.OnboardingStatus;
	}
	export interface SveaAddProductSetupPackageAgreementStep {
		Status: Bokio.Bank.Contract.Svea.Dtos.OnboardingStatus;
	}
	export interface SveaAddProductSignGuarantorAgreementStep {
		State?: Bokio.Bank.Contract.Svea.Dtos.SveaAddProductSignGuarantorAgreementStepState;
		Status: Bokio.Bank.Contract.Svea.Dtos.OnboardingStatus;
	}
	export interface SveaAddProductSignGuarantorAgreementStepState {
		IsSigned: boolean;
		HasDocument: boolean;
		Signers: Bokio.Bank.Contract.Svea.Dtos.SveaSigner[];
	}
	export interface SveaAddProductSignPackageAgreementStep {
		State: Bokio.Bank.Contract.Svea.Dtos.SveaAddProductSignPackageAgreementStepState;
		Status: Bokio.Bank.Contract.Svea.Dtos.OnboardingStatus;
	}
	export interface SveaAddProductSignPackageAgreementStepState {
		IsSigned: boolean;
		Signers: Bokio.Bank.Contract.Svea.Dtos.SveaSigner[];
	}
	export enum SveaAddProductStatus {
		Invalid = "Invalid",
		CanOnboard = "CanOnboard",
		OngoingOnboardingWithRightProduct = "OngoingOnboardingWithRightProduct",
		OngoingOnboardingWithAnotherProduct = "OngoingOnboardingWithAnotherProduct",
		Onboarded = "Onboarded",
		CannotOnboard = "CannotOnboard",
	}
	export interface SveaAddProductStatusDto {
		Status: Bokio.Bank.Contract.Svea.Dtos.SveaAddProductStatus;
		Data?: Bokio.Bank.Contract.Svea.Dtos.SveaAddProductData;
	}
	export interface SveaAddProductStepsUnion {
		IfMatchRevision: string;
		InitiateStep?: Bokio.Bank.Contract.Svea.Dtos.SveaAddProductInitiateStep;
		SelectPackageStep?: Bokio.Bank.Contract.Svea.Dtos.SveaAddProductSelectPackageStep;
		SelectProductStep?: Bokio.Bank.Contract.Svea.Dtos.SveaAddProductSelectProductStep;
		AssignSignatoriesStep?: Bokio.Bank.Contract.Svea.Dtos.SveaAddProductAssignSignatoriesStep;
		SetupPackageAgreementStep?: Bokio.Bank.Contract.Svea.Dtos.SveaAddProductSetupPackageAgreementStep;
		SignPackageAgreementStep?: Bokio.Bank.Contract.Svea.Dtos.SveaAddProductSignPackageAgreementStep;
		ConfigureBankGiroProductStep?: Bokio.Bank.Contract.Svea.Dtos.SveaAddProductConfigureBankGiroProductStep;
		ConfigureMastercardDirectStep?: Bokio.Bank.Contract.Svea.Dtos.SveaAddProductConfigureMastercardDirectStep;
		ConfigureSwishStep?: Bokio.Bank.Contract.Svea.Dtos.SveaAddProductConfigureSwishStep;
		ConfigureInternationalPaymentsStep?: Bokio.Bank.Contract.Svea.Dtos.SveaAddProductConfigureInternationalPaymentsStep;
		CreditScoreStep?: Bokio.Bank.Contract.Svea.Dtos.SveaAddProductCreditScoreStep;
		ConfigureCreditProductStep?: Bokio.Bank.Contract.Svea.Dtos.SveaAddProductConfigureCreditProductStep;
		ConfigureCreditAccountStep?: Bokio.Bank.Contract.Svea.Dtos.SveaAddProductConfigureCreditAccountStep;
		AmlQuestionsStep?: Bokio.Bank.Contract.Svea.Dtos.SveaAddProductAmlQuestionsStep;
		AssignGuarantorStep?: Bokio.Bank.Contract.Svea.Dtos.SveaAddProductAssignGuarantorStep;
		SetupGuarantorAgreementStep?: Bokio.Bank.Contract.Svea.Dtos.SveaAddProductSetupGuarantorAgreementStep;
		SignGuarantorAgreementStep?: Bokio.Bank.Contract.Svea.Dtos.SveaAddProductSignGuarantorAgreementStep;
		FinalizeStep?: Bokio.Bank.Contract.Svea.Dtos.SveaAddProductFinalizeStep;
		ActiveUserPersonalId: string;
		ApplicationStatus?: Bokio.Bank.Contract.Svea.Dtos.SveaApplicationStatus;
		ApplicationId?: string;
		CannotOnboard?: boolean;
	}
	export interface SveaAmlQuestionsStep {
		State: Bokio.Bank.Contract.Svea.Dtos.SveaAmlQuestionStepStateItem[];
		Status: Bokio.Bank.Contract.Svea.Dtos.OnboardingStatus;
	}
	export interface SveaAmlQuestionStepStateItem {
		Completed: boolean;
		ProductId: string;
		ProductDefinitionId: Bokio.Bank.Contract.Svea.Dtos.SveaProductDefinitionId;
	}
	export interface SveaApplicant {
		Address?: Bokio.Bank.Contract.Dtos.AddressDto;
		FirstName?: string;
		LastName?: string;
		NationalId: string;
	}
	export interface SveaApplicantContactInformationStep {
		State?: Bokio.Bank.Contract.Svea.Dtos.SveaApplicantContactInformationStepState;
		Status: Bokio.Bank.Contract.Svea.Dtos.OnboardingStatus;
	}
	export interface SveaApplicantContactInformationStepState {
		Email?: string;
		PhoneCountryCode?: string;
		PhoneNumber?: string;
	}
	export interface SveaApplicationAndBankAccountStatus {
		ApplicationStatus: Bokio.Bank.Contract.Svea.Dtos.SveaApplicationStatus;
		HasSveaBankAccountCreated: boolean;
	}
	export interface SveaApplicationAndCreatedBankStatus {
		ApplicationStatus: Bokio.Bank.Contract.Svea.Dtos.SveaApplicationStatus;
		HasSveaBankConnectionCreated: boolean;
		HasCreatedBankConnectionFromUIAction: boolean;
	}
	export interface SveaApplicationDetails {
		OrgNumber: string;
		CompanyName?: string;
	}
	export interface SveaApplicationQuestionsState {
		Questions: string[];
	}
	export interface SveaApplicationQuestionsStep {
		State: Bokio.Bank.Contract.Svea.Dtos.SveaApplicationQuestionsState;
		Status: Bokio.Bank.Contract.Svea.Dtos.OnboardingStatus;
	}
	export interface SveaApplicationsDetails {
		Applicant?: Bokio.Bank.Contract.Svea.Dtos.SveaApplicant;
		Organization?: Bokio.Bank.Contract.Svea.Dtos.SveaOrganization;
	}
	export enum SveaApplicationStatus {
		Ongoing = "Ongoing",
		Finalizing = "Finalizing",
		Finalized = "Finalized",
		Cancelled = "Cancelled",
		OrderUnderReview = "OrderUnderReview",
	}
	export interface SveaAssignSignatoriesStep {
		State: Bokio.Bank.Contract.Svea.Dtos.SveaAssignSignatoryItem[];
		Status: Bokio.Bank.Contract.Svea.Dtos.OnboardingStatus;
	}
	export interface SveaAssignSignatoryItem {
		NationalId: string;
		FirstName: string;
		LastName: string;
		Email?: string;
	}
	export interface SveaAssignSniCodesStep {
		State?: Bokio.Bank.Contract.Svea.Dtos.SveaAssignSniCodesStepState;
		Status: Bokio.Bank.Contract.Svea.Dtos.OnboardingStatus;
	}
	export interface SveaAssignSniCodesStepState {
		SniCodes: string[];
	}
	export interface SveaAutogiroConsent {
		ConsentId: string;
		ConsentStatus: Bokio.Bank.Contract.Svea.Dtos.SveaAutogiroConsentStatus;
		Creditor: Bokio.Bank.Contract.Svea.Dtos.SveaAutogiroConsentCreditor;
		Debtor: Bokio.Bank.Contract.Svea.Dtos.SveaAutogiroConsentDebtor;
	}
	export interface SveaAutogiroConsentCreditor {
		BankGiroNumber: string;
		Name: string;
		OrganizationNumber: string;
		ShortName: string;
	}
	export interface SveaAutogiroConsentDebtor {
		AccountNumber: string;
		ClearingNumber: string;
		PayerNumber: string;
	}
	export interface SveaAutogiroConsentDto {
		Consents: Bokio.Bank.Contract.Svea.Dtos.SveaAutogiroConsent[];
		BookkeepingBankAccountName: string;
	}
	export enum SveaAutogiroConsentStatus {
		Invalid = "Invalid",
		Approved = "Approved",
		ApprovedUnderInquiry = "ApprovedUnderInquiry",
		UnderInquiry = "UnderInquiry",
		Preliminary = "Preliminary",
		Expired = "Expired",
		Cancelled = "Cancelled",
		Rejected = "Rejected",
	}
	export interface SveaBeneficialOwnerQuestionsStepV1 {
		State: Bokio.Bank.Contract.Svea.Dtos.SveaBeneficialOwnerQuestionsStepV1StateItems[];
		Status: Bokio.Bank.Contract.Svea.Dtos.OnboardingStatus;
	}
	export interface SveaBeneficialOwnerQuestionsStepV1StateItems {
		Completed: boolean;
		BeneficialOwnerQuestionKey: string;
		BeneficialOwnerQuestionKeyType: string;
		PersonKey?: string;
		QuestionIds: string[];
		CountryOfIssue?: string;
	}
	export enum SveaBeneficialOwnershipStatus {
		BeneficialOwnersExists = "BeneficialOwnersExists",
		NoBeneficialOwnersExist = "NoBeneficialOwnersExist",
		UnspecifiedOrMissingInformation = "UnspecifiedOrMissingInformation",
	}
	export interface SveaCardApplicationStatus {
		Status: Bokio.Bank.Contract.Svea.Dtos.SveaApplicationStatus;
		CardId?: string;
	}
	export interface SveaCardOrderInfoDto {
		UserBokioName: string;
		AccountMapsTo: number;
		AccountName: string;
		CardDisplayNames: string[];
		PersonalNumber: string;
		OrganizationName: string;
	}
	export interface SveaCardOrderInformationResponse {
		SveaAddProductStatus: Bokio.Bank.Contract.Svea.Dtos.SveaAddProductStatusDto;
		SveaCardOrderStatus?: Bokio.Bank.Contract.Svea.Dtos.SveaCardOrderStatus;
	}
	export interface SveaCardOrderStatus {
		Status: Bokio.Bank.Contract.Svea.Dtos.SveaApplicationStatus;
		IsSigned: boolean;
		Info?: Bokio.Bank.Contract.Svea.Dtos.SveaCardOrderInfoDto;
	}
	export interface SveaCardOrderStatusRequest {
		AccountId: string;
		UserId: string;
	}
	export interface SveaCheckConsentAndHasTransactionsInSvea {
		HasConsent: boolean;
		HasTransactionsInSveaIfNonConsent: boolean;
	}
	export interface SveaConfigureBankgiroProductStep {
		State?: Bokio.Bank.Contract.Svea.Dtos.SveaConfigureBankgiroProductStepState;
		Status: Bokio.Bank.Contract.Svea.Dtos.OnboardingStatus;
	}
	export interface SveaConfigureBankgiroProductStepState {
		ProductId: string;
		IsCreateNew: boolean;
		TransferBankgiro?: string;
	}
	export interface SveaConfigureConsentProductStep {
		State: Bokio.Bank.Contract.Svea.Dtos.SveaConfigureConsentProductStepState;
		Status: Bokio.Bank.Contract.Svea.Dtos.OnboardingStatus;
	}
	export interface SveaConfigureConsentProductStepState {
		Answer?: Bokio.Bank.Contract.Svea.Dtos.SveaConfigureDataSharingConsentStepStateAnswer;
	}
	export interface SveaConfigureCreditAccountStepState {
		ProductId: string;
		SelectedAccountId?: string;
		AvailableAccountIds: Bokio.Bank.Contract.Svea.Dtos.SveaConfigureCreditAccountStepStateAvailableAccountIdsItem[];
	}
	export interface SveaConfigureCreditAccountStepStateAvailableAccountIdsItem {
		AccountId: string;
	}
	export interface SveaConfigureCreditAccountStepStateAvailableAccountIdsItems {
		AccountId: string;
	}
	export interface SveaConfigureCreditProductStepState {
		ProductId: string;
		ChosenCreditLimit?: Bokio.Bank.Contract.Svea.Dtos.SveaCreditLimit;
	}
	export enum SveaConfigureDataSharingConsentStepStateAnswer {
		Invalid = "Invalid",
		Consent = "Consent",
		DoesNotConsent = "DoesNotConsent",
	}
	export interface SveaConfigureMastercardDirectStep {
		State?: Bokio.Bank.Contract.Svea.Dtos.SveaConfigureMastercardDirectStepState;
		Status: Bokio.Bank.Contract.Svea.Dtos.OnboardingStatus;
	}
	export interface SveaConfigureMastercardDirectStepState {
		AvailableAccountIds: Bokio.Bank.Contract.Svea.Dtos.SveaConfigureCreditAccountStepStateAvailableAccountIdsItems[];
		ProductId: string;
		SelectedAccountId?: string;
	}
	export interface SveaConfigureSwishStepState {
		AvailableAccountIds: string[];
		ProductId: string;
		SelectedAccountId?: string;
		SwishNumber?: string;
	}
	export interface SveaConfirmBeneficialOwnershipCandidate {
		FirstName: string;
		LastName: string;
		NationalId: string;
		CompanyShare: Bokio.Bank.Contract.Svea.Dtos.SveaPercentInterval;
	}
	export enum SveaConfirmBeneficialOwnershipStatus {
		Confirmed = "Confirmed",
		Declined = "Declined",
		NotCompleted = "NotCompleted",
	}
	export interface SveaConfirmBeneficialOwnershipStep {
		State?: Bokio.Bank.Contract.Svea.Dtos.SveaConfirmBeneficialOwnershipStepState;
		Status: Bokio.Bank.Contract.Svea.Dtos.OnboardingStatus;
	}
	export interface SveaConfirmBeneficialOwnershipStepState {
		Candidates: Bokio.Bank.Contract.Svea.Dtos.SveaConfirmBeneficialOwnershipCandidate[];
		Status: Bokio.Bank.Contract.Svea.Dtos.SveaConfirmBeneficialOwnershipStatus;
	}
	export interface SveaCountry {
		Alpha2Code: string;
		InternationalPayment: boolean;
		PartOfEes: boolean;
		Names: Bokio.Bank.Contract.Svea.Dtos.SveaCountryNames;
		CallingCodes: string[];
	}
	export interface SveaCountryNames {
		Sv: string;
	}
	export interface SveaCreditLimit {
		Amount: string;
		Currency: string;
	}
	export interface SveaCreditScoreAssessment {
		AssessmentResult?: string;
		Check?: Bokio.Bank.Contract.Svea.Dtos.SveaCreditScoreCheckResult;
	}
	export interface SveaCreditScoreCheckResult {
		InterestRate: string;
		MinLimit: Bokio.Bank.Contract.Svea.Dtos.SveaMoneyAmount;
		MaxLimit: Bokio.Bank.Contract.Svea.Dtos.SveaMoneyAmount;
	}
	export interface SveaCreditScoreStep {
		Status: Bokio.Bank.Contract.Svea.Dtos.OnboardingStatus;
	}
	export interface SveaFinalizeStep {
		State: Bokio.Bank.Contract.Svea.Dtos.SveaFinalizeStepState;
		Status: Bokio.Bank.Contract.Svea.Dtos.OnboardingStatus;
	}
	export interface SveaFinalizeStepState {
		ApplicationStatus: Bokio.Bank.Contract.Svea.Dtos.SveaApplicationStatus;
	}
	export interface SveaInboxAttachments {
		AttachmentId: string;
		AvailableUntil: Date;
		ContentType: string;
		Filename: string;
		IsAvailable: boolean;
	}
	export interface SveaInboxMessage {
		Attachments: Bokio.Bank.Contract.Svea.Dtos.SveaInboxAttachments[];
		Body: string;
		Header1: string;
		Header2: string;
		ContextType: Bokio.Bank.Contract.Svea.Dtos.SveaInboxMessageContextType;
		MessageId: string;
		TimeRead?: Date;
		TimeSent: Date;
		Context?: Bokio.Bank.Contract.Svea.Dtos.SveaInboxMessageContext;
	}
	export interface SveaInboxMessageContext {
		Link: string;
		UnsignedTicket: string;
	}
	export enum SveaInboxMessageContextType {
		Invalid = "Invalid",
		BankMessage = "BankMessage",
		IncomingEinvoice = "IncomingEinvoice",
		IncomingCreditNotification = "IncomingCreditNotification",
		IncomingAutogiroNotification = "IncomingAutogiroNotification",
		IncomingEDocument = "IncomingEDocument",
		AnnualStatement = "AnnualStatement",
	}
	export interface SveaInitiateStep {
		State: Bokio.Bank.Contract.Svea.Dtos.SveaInitiateStepState;
		Status: Bokio.Bank.Contract.Svea.Dtos.OnboardingStatus;
	}
	export interface SveaInitiateStepState {
		Address?: Bokio.Bank.Contract.Svea.Dtos.SveaInitiateStepStateAddress;
		OrgNr: string;
		OrganisationName?: string;
		OrganizationType: Bokio.Bank.Contract.Svea.Dtos.SveaOrganizationType;
	}
	export interface SveaInitiateStepStateAddress {
		City: string;
		Street: string;
		ZipCode: string;
	}
	export enum SveaKycApplicationStatus {
		Invalid = "Invalid",
		NoNeedToStartApplication = "NoNeedToStartApplication",
		CanStartApplication = "CanStartApplication",
		Ongoing = "Ongoing",
		UnderReview = "UnderReview",
	}
	export interface SveaKycApplicationStep {
		Name: Bokio.Bank.Contract.Svea.Dtos.SveaKycApplicationStepName;
		Completed: boolean;
		BeneficialOwnerQuestionKey?: string;
		BeneficialOwnerQuestionKeyType?: string;
		PersonKey?: string;
		ProductId?: string;
	}
	export interface SveaKycApplicationStepDto {
		StepList: Bokio.Bank.Contract.Svea.Dtos.SveaKycApplicationStep[];
		IfMatchRevision: string;
	}
	export enum SveaKycApplicationStepName {
		Initiate = "Initiate",
		AssignSniCode = "AssignSniCode",
		ConfirmBeneficialOwnership = "ConfirmBeneficialOwnership",
		AnswerApplicationQuestions = "AnswerApplicationQuestions",
		AnswerBeneficialOwnerQuestions = "AnswerBeneficialOwnerQuestions",
		AnswerAmlQuestionsForSavingsAccount = "AnswerAmlQuestionsForSavingsAccount",
		AnswerAmlQuestionsForTransactionAccount = "AnswerAmlQuestionsForTransactionAccount",
		AnswerAmlQuestionsForInternationalPayments = "AnswerAmlQuestionsForInternationalPayments",
		AnswerAmlQuestionsBusinessLoan = "AnswerAmlQuestionsBusinessLoan",
		AnswerAmlQuestionsForSwishCbase = "AnswerAmlQuestionsForSwishCbase",
		AnswerAmlQuestionsForSwishCommerce = "AnswerAmlQuestionsForSwishCommerce",
		AnswerAmlQuestionsForSwishPayout = "AnswerAmlQuestionsForSwishPayout",
		AnswerAmlQuestionsForCreditCard = "AnswerAmlQuestionsForCreditCard",
		AnswerAmlQuestionsForCheckCredit = "AnswerAmlQuestionsForCheckCredit",
		AnswerAmlQuestionsForBusinessLoanPlus = "AnswerAmlQuestionsForBusinessLoanPlus",
	}
	export interface SveaMoneyAmount {
		Amount: string;
		Currency: string;
	}
	export interface SveaOnboardingApplicationStatus {
		ApplicationStatus?: Bokio.Bank.Contract.Svea.Dtos.SveaApplicationStatus;
		IsApplicationRejected: boolean;
	}
	export interface SveaOnboardingStepsUnion {
		IfMatchRevision: string;
		InitiateStep?: Bokio.Bank.Contract.Svea.Dtos.SveaInitiateStep;
		CreditScoreStep?: Bokio.Bank.Contract.Svea.Dtos.SveaCreditScoreStep;
		ApplicantContactInformationStep?: Bokio.Bank.Contract.Svea.Dtos.SveaApplicantContactInformationStep;
		OrganizationContactInformationStep?: Bokio.Bank.Contract.Svea.Dtos.SveaOrganizationContactInformationStep;
		AssignSniCodesStep?: Bokio.Bank.Contract.Svea.Dtos.SveaAssignSniCodesStep;
		AssignSignatoriesStep?: Bokio.Bank.Contract.Svea.Dtos.SveaAssignSignatoriesStep;
		SelectPackageStep?: Bokio.Bank.Contract.Svea.Dtos.SveaSelectPackageStep;
		ConfigureConsentProductStep?: Bokio.Bank.Contract.Svea.Dtos.SveaConfigureConsentProductStep;
		SetupPackageAgreementStep?: Bokio.Bank.Contract.Svea.Dtos.SveaSetupPackageAgreementStep;
		SignPackageAgreementStep?: Bokio.Bank.Contract.Svea.Dtos.SveaSignPackageAgreementStep;
		ApplicationQuestionsStep?: Bokio.Bank.Contract.Svea.Dtos.SveaApplicationQuestionsStep;
		AmlQuestionsStep?: Bokio.Bank.Contract.Svea.Dtos.SveaAmlQuestionsStep;
		ConfirmBeneficialOwnershipStep?: Bokio.Bank.Contract.Svea.Dtos.SveaConfirmBeneficialOwnershipStep;
		BeneficialOwnerQuestionsStepV1?: Bokio.Bank.Contract.Svea.Dtos.SveaBeneficialOwnerQuestionsStepV1;
		ConfigureMastercardDirectStep?: Bokio.Bank.Contract.Svea.Dtos.SveaConfigureMastercardDirectStep;
		ConfigureBankgiroProductStep?: Bokio.Bank.Contract.Svea.Dtos.SveaConfigureBankgiroProductStep;
		FinalizeStep?: Bokio.Bank.Contract.Svea.Dtos.SveaFinalizeStep;
		ActiveUserPersonalId: string;
		OnboardingApplicationStatus?: Bokio.Bank.Contract.Svea.Dtos.SveaOnboardingApplicationStatus;
		HasActiveSveaBankConnection: boolean;
	}
	export interface SveaOrganization {
		Address?: Bokio.Bank.Contract.Dtos.AddressDto;
		OrgName?: string;
		OrgNr: string;
	}
	export interface SveaOrganizationContactInformationStep {
		State?: Bokio.Bank.Contract.Svea.Dtos.SveaOrganizationContactInformationStepState;
		Status: Bokio.Bank.Contract.Svea.Dtos.OnboardingStatus;
	}
	export interface SveaOrganizationContactInformationStepState {
		Email?: string;
		PhoneCountryCode?: string;
		PhoneNumber?: string;
	}
	export enum SveaOrganizationType {
		Ab = "Ab",
		Ef = "Ef",
		Hb = "Hb",
		Eb = "Eb",
		Ek = "Ek",
		Fi = "Fi",
		Kb = "Kb",
		Bf = "Bf",
		If = "If",
		Ov = "Ov",
		Sa = "Sa",
		Sf = "Sf",
		Sk = "Sk",
		Vp = "Vp",
	}
	export interface SveaPercentInterval {
		Max: string;
		Min: string;
	}
	export enum SveaProductDefinitionId {
		BusinessLoan = "BusinessLoan",
		CheckCredit = "CheckCredit",
		CreditCard = "CreditCard",
		TransactionAccount = "TransactionAccount",
		SavingsAccount = "SavingsAccount",
		DebitCard = "DebitCard",
		ForeignPayment = "ForeignPayment",
		Bankgiro = "Bankgiro",
		Swish = "Swish",
	}
	export enum SveaSavingsAccountOnboardingStatus {
		NotStarted = "NotStarted",
		Continue = "Continue",
		Rejected = "Rejected",
		Finalized = "Finalized",
		NotAvailable = "NotAvailable",
		ApprovedWithNoBookkeeping = "ApprovedWithNoBookkeeping",
	}
	export interface SveaSavingsAccountStatusDto {
		OnboardingStatus: Bokio.Bank.Contract.Svea.Dtos.SveaSavingsAccountOnboardingStatus;
		AddproductStatus?: Bokio.Bank.Contract.Svea.Dtos.SveaAddProductStatusDto;
	}
	export interface SveaSelectedProduct {
		Type: Bokio.Bank.Contract.Svea.Dtos.SveaProductDefinitionId;
		Id: string;
	}
	export interface SveaSelectPackageStep {
		Status: Bokio.Bank.Contract.Svea.Dtos.OnboardingStatus;
	}
	export interface SveaSetupPackageAgreementStep {
		Status: Bokio.Bank.Contract.Svea.Dtos.OnboardingStatus;
	}
	export interface SveaSigner {
		FirstName: string;
		LastName: string;
		NationalId: string;
		IsSigned: boolean;
		Token?: string;
	}
	export interface SveaSignPackageAgreementStep {
		State: Bokio.Bank.Contract.Svea.Dtos.SveaSignPackageAgreementStepState;
		Status: Bokio.Bank.Contract.Svea.Dtos.OnboardingStatus;
	}
	export interface SveaSignPackageAgreementStepState {
		IsSigned: boolean;
		Signers: Bokio.Bank.Contract.Svea.Dtos.SveaSigner[];
	}
	export interface SveaSniCodeItem {
		Description: string;
		Code: string;
	}
	export interface SveaSwishStatusResponse {
		SwishNumbers: Bokio.Bank.Contract.Svea.Dtos.SwishNumber[];
		Status: Bokio.Bank.Contract.Svea.Dtos.SveaAddProductStatusDto;
	}
	export interface SveaUserInfo {
		DelegateId: string;
		PsuId: string;
	}
	export interface SwishNumber {
		Number: string;
		BankAccountId: string;
		BankAccountLabel: string;
	}
}
export namespace Bokio.Bank.Contract.Svea.Dtos.InternationalPayments {
	export interface SettingsContentDto {
		LastSynchronized?: Date;
		Applications: Bokio.Bank.Contract.Svea.Dtos.InternationalPayments.SveaInternationalPaymentsPreregistrationApplicationDetailsDto[];
		Preregistrations: Bokio.Bank.Contract.Svea.Dtos.InternationalPayments.SveaInternationalPaymentPreregistrationDetailsDto[];
	}
	export interface SveaInternationalPaymentPreregistrationDetailsDto {
		Id: string;
		DisplayName: string;
		LastSynchronized: Date;
		TargetType: Bokio.Bank.Contract.Svea.Dtos.InternationalPayments.SveaInternationalPaymentsPreregistrationApplicationDetailsTargetType;
		TargetRole: Bokio.Bank.Contract.Svea.Dtos.InternationalPayments.SveaInternationalPaymentsPreregistrationApplicationDetailsTargetRole;
		Bic?: string;
		Iban?: string;
		Address: Entities.ExtendedAddress;
		Email: string;
	}
	export interface SveaInternationalPaymentsCreatePreregistrationApplicationRequest {
		TargetRole: Bokio.Bank.Contract.Svea.Dtos.InternationalPayments.SveaInternationalPaymentsCreatePreregistrationApplicationRequestTargetRole;
		TargetType: Bokio.Bank.Contract.Svea.Dtos.InternationalPayments.SveaInternationalPaymentsCreatePreregistrationApplicationRequestTargetType;
		Address: Entities.ExtendedAddress;
		Email: string;
		OrganizationName?: string;
		Firstname?: string;
		Lastname?: string;
		Iban?: string;
		Bic?: string;
	}
	export enum SveaInternationalPaymentsCreatePreregistrationApplicationRequestTargetRole {
		Invalid = "Invalid",
		Organization = "Organization",
		Individual = "Individual",
	}
	export enum SveaInternationalPaymentsCreatePreregistrationApplicationRequestTargetType {
		Invalid = "Invalid",
		Debtor = "Debtor",
		Creditor = "Creditor",
	}
	export interface SveaInternationalPaymentsPreregistrationApplicationDetailsDto {
		Id: string;
		Revision: string;
		DisplayName: string;
		LastSynchronized: Date;
		Status: Bokio.Bank.Contract.Svea.Dtos.InternationalPayments.SveaInternationalPaymentsPreregistrationApplicationDetailsStatus;
		TargetType: Bokio.Bank.Contract.Svea.Dtos.InternationalPayments.SveaInternationalPaymentsPreregistrationApplicationDetailsTargetType;
		TargetRole: Bokio.Bank.Contract.Svea.Dtos.InternationalPayments.SveaInternationalPaymentsPreregistrationApplicationDetailsTargetRole;
		Iban?: string;
		Bic?: string;
		Email: string;
		Address: Entities.ExtendedAddress;
		Created: Date;
		CanBeCancelled: boolean;
	}
	export interface SveaInternationalPaymentsPreregistrationApplicationDetailsFilter {
		Statuses?: Bokio.Bank.Contract.Svea.Dtos.InternationalPayments.SveaInternationalPaymentsPreregistrationApplicationDetailsStatus[];
	}
	export enum SveaInternationalPaymentsPreregistrationApplicationDetailsStatus {
		Unknown = "Unknown",
		Approved = "Approved",
		Rejected = "Rejected",
		Incomplete = "Incomplete",
		InReview = "InReview",
		Cancelled = "Cancelled",
	}
	export enum SveaInternationalPaymentsPreregistrationApplicationDetailsTargetRole {
		Debtor = "Debtor",
		Creditor = "Creditor",
	}
	export enum SveaInternationalPaymentsPreregistrationApplicationDetailsTargetType {
		Organization = "Organization",
		Individual = "Individual",
	}
	export interface SveaInternationalPaymentsPreregistrationSettingsContentFilter {
		ApplicationFilter: Bokio.Bank.Contract.Svea.Dtos.InternationalPayments.SveaInternationalPaymentsPreregistrationApplicationDetailsFilter;
	}
}
export namespace Bokio.Bank.Contract.Svea.Requests {
	export interface AssignGuarantorRequest {
		NationalId: string;
		IfMatchRevision: string;
	}
	export interface AssignSignatoriesRequest {
		Signatories: Bokio.Bank.Contract.Svea.Requests.SveaSignatoryRequestItem[];
		IfMatchRevision: string;
	}
	export interface CancelApplicationRequest {
		IfMatchRevision: string;
	}
	export interface CancelSigningRequest {
		IfMatchRevision: string;
	}
	export interface CheckCreditScoreRequest {
		IfMatchRevision: string;
	}
	export interface ConfigureBankgiroRequest {
		IsCreateNew: boolean;
		TransferExistingBankgiro: string;
	}
	export interface ConfigureCheckCreditAccountRequest {
		AccountId: string;
		ProductId: string;
		IfMatchRevision: string;
	}
	export interface ConfigureConsentRequest {
		GiveConsent: boolean;
		IfMatchRevision: string;
	}
	export interface ConfigureCreditProductRequest {
		CreditLimit: number;
		IfMatchRevision: string;
	}
	export interface ConfigureMastercardRequest {
		AccountId: string;
		ProductId: string;
		DisplayName: string;
		Email: string;
		PhoneCountryCode: string;
		PhoneNumber: string;
	}
	export interface ConfirmBeneficialOwnershipRequest {
		BeneficialOwnersConfirmed: boolean;
		IfMatchRevision: string;
	}
	export interface FinalizeApplicationRequest {
		IfMatchRevision: string;
	}
	export interface KycQuestionWithAnswersDto {
		Answers: Bokio.Bank.Contract.Svea.Dtos.KycAnswer[];
		Question: string;
		QuestionId: string;
	}
	export interface OffboardSveaSwishRequest {
		BankAccountId: string;
	}
	export interface OptionalFeaturesRequest {
		ConfigureMastercardData?: Bokio.Bank.Contract.Svea.Requests.ConfigureMastercardRequest;
		ConfigureBankgiroData?: Bokio.Bank.Contract.Svea.Requests.ConfigureBankgiroRequest;
		IfMatchRevision: string;
	}
	export interface RegisterAmlAnswersRequest {
		ProductId: string;
		Questions: Bokio.Bank.Contract.Svea.Requests.KycQuestionWithAnswersDto[];
		IfMatchRevision: string;
	}
	export interface RegisterContactInformationRequest {
		Email: string;
		PhoneCountryCode: string;
		PhoneNumber: string;
		IfMatchRevision: string;
	}
	export interface RegisterKycAmlAnswersRequest {
		ProductId: string;
		Questions: Bokio.Bank.Contract.Svea.Requests.KycQuestionWithAnswersDto[];
		IfMatchRevision: string;
	}
	export interface RegisterKycApplicationAnswersRequest {
		Questions: Bokio.Bank.Contract.Svea.Requests.KycQuestionWithAnswersDto[];
		IfMatchRevision: string;
	}
	export interface RegisterKycBeneficialOwnerAnswersRequest {
		NationalId: string;
		Questions: Bokio.Bank.Contract.Svea.Requests.KycQuestionWithAnswersDto[];
		IfMatchRevision: string;
	}
	export interface RegisterOrganizationContactInformationRequest {
		Email: string;
		PhoneCountryCode: string;
		PhoneNumber: string;
		IfMatchRevision: string;
	}
	export interface RegisterPreregistrationAmlAnswersRequest {
		ProductId: string;
		Questions: Bokio.Bank.Contract.Svea.Requests.KycQuestionWithAnswersDto[];
	}
	export interface RegisterSniCodesRequest {
		SniCodes: string[];
		IfMatchRevision: string;
	}
	export interface SelectAddonRequest {
		Addons: Bokio.Bank.Contract.Svea.Requests.SveaAddon[];
		IfMatchRevision: string;
	}
	export interface SetupGuarantorAgreementRequest {
		IfMatchRevision: string;
	}
	export interface SignPackageAgreementRequest {
		IfMatchRevision: string;
	}
	export enum SveaAddon {
		BUSINESSLOAN = "BUSINESSLOAN",
		CHECKCREDIT = "CHECKCREDIT",
		CREDITCARD = "CREDITCARD",
		TRANSACTIONACCOUNT = "TRANSACTIONACCOUNT",
		SAVINGSACCOUNT = "SAVINGSACCOUNT",
		DEBITCARD = "DEBITCARD",
		FOREIGNPAYMENT = "FOREIGNPAYMENT",
		BANKGIRO = "BANKGIRO",
		DATASHARINGCONSENT = "DATASHARINGCONSENT",
		SWISH = "SWISH",
	}
	export interface SveaChangeConsent {
		GiveConsent: boolean;
	}
	export interface SveaConfigureCardRequest {
		DisplayName: string;
		Email: string;
		PhoneCountryCode: string;
		PhoneNumber: string;
	}
	export interface SveaConfigureSwishRequest {
		ProductId: string;
		AccountId: string;
		SwishNumber?: string;
		IfMatchRevision: string;
	}
	export interface SveaCountriesFilter {
		InternationalPayment?: boolean;
		PartOfEes?: boolean;
		WithoutSweden?: boolean;
	}
	export interface SveaSignatoryRequestItem {
		NationalId: string;
		Email?: string;
	}
}
export namespace Bokio.Bank.Contract.TaxAccounts {
	export enum SetupSkatteverketAccountConnectErrorReason {
		NotSet = "NotSet",
		WrongCompanyType = "WrongCompanyType",
		WrongCountry = "WrongCountry",
		InvalidOrgNumber = "InvalidOrgNumber",
		AlreadyConnectedBookkeepingAccount = "AlreadyConnectedBookkeepingAccount",
	}
	export interface SetupSkatteverketAccountPreviewDto {
		SuggestedStartDate: Day;
		OrgNumberToConfirm: string;
		AlreadyHaveSync: boolean;
		CanConnect: boolean;
		ShowConnectOption: boolean;
		ConnectErrorReason: Bokio.Bank.Contract.TaxAccounts.SetupSkatteverketAccountConnectErrorReason;
	}
}
export namespace Bokio.Bank.Contract.Teller.Dtos {
	export interface BankIdStatusDto<T> {
		RequestStatus: Bokio.Bank.Contract.Teller.Dtos.RequestStatus;
		Data?: T;
		CollectionStatus: Bokio.Common.Contract.BankId.BankIdCollectionStatus;
		QrCode?: string;
	}
	export interface BankIdStatusDtoEmpty {
		RequestStatus: Bokio.Bank.Contract.Teller.Dtos.RequestStatus;
		Data?: Bokio.Bank.Contract.Teller.Dtos.SignEmptyData;
		CollectionStatus: Bokio.Common.Contract.BankId.BankIdCollectionStatus;
		QrCode?: string;
	}
	export interface CreateRecurringPaymentBatchDto {
		SeriesInfo: Bokio.Bank.Contract.Teller.Dtos.CreateRecurringPaymentSeriesDto;
		PaymentInfo: Bokio.Bank.Contract.Teller.Dtos.TellerPaymentInfoDto;
		PaymentDates: Date[];
		SaveRecipient: boolean;
	}
	export interface CreateRecurringPaymentBatchResponseDto {
		SeriesId: string;
		PaymentIds: string[];
	}
	export interface CreateRecurringPaymentSeriesDto {
		Interval: Entities.Teller.RecurringPaymentInterval;
		NumberOfOccurrences: number;
		StartDate: Day;
		EndDate: Day;
		Amount: number;
		Currency: string;
		RecipientReference?: string;
	}
	export interface CreditorMatchInfoDto {
		Iban: string;
		Bic: string;
	}
	export interface PaymentTypeDto {
		Type: Entities.Teller.TellerPaymentType;
		Info: Classes.Teller.TellerPaymentInformationUnion;
	}
	export enum ReceiverPayableStatus {
		Payable = "Payable",
		InternationalPaymentsNotEnabled = "InternationalPaymentsNotEnabled",
		InternationalPaymentsActivationPending = "InternationalPaymentsActivationPending",
		InternationalReceiverNotRegistered = "InternationalReceiverNotRegistered",
		InternationalReceiverInformationNotMatching = "InternationalReceiverInformationNotMatching",
		InternationalReceiverRegisterationPending = "InternationalReceiverRegisterationPending",
		InternationalReceiverRejected = "InternationalReceiverRejected",
		InternationalReceiverCancelled = "InternationalReceiverCancelled",
		InternationalReceiverRegistrationIncomplete = "InternationalReceiverRegistrationIncomplete",
		CountryNotSupported = "CountryNotSupported",
		CurrencyNotSupported = "CurrencyNotSupported",
		SepaNotSupported = "SepaNotSupported",
	}
	export enum RequestStatus {
		Pending = "Pending",
		Complete = "Complete",
		Cancelled = "Cancelled",
		Rejected = "Rejected",
		Error = "Error",
	}
	export interface SignEmptyData {
	}
	export interface SupplierMatchInfoDto {
		Id: string;
		Name: string;
		Iban?: string;
		Bic?: string;
	}
	export interface TellerPaymentForGroupInfoDto {
		RequestedAmount: number;
		RequestedCurrency: string;
		SenderReference: string;
		PaymentTypeInfo: Bokio.Bank.Contract.Teller.Dtos.PaymentTypeDto;
	}
	export interface TellerPaymentGroupInfoDto {
		RequestedPaymentDate: Day;
		BankAccountId: string;
		GroupReference: string;
	}
	export interface TellerPaymentInfoDto {
		RequestedPaymentDate: Day;
		RequestedAmount: number;
		RequestedCurrency: string;
		SenderReference: string;
		PaymentTypeInfo: Bokio.Bank.Contract.Teller.Dtos.PaymentTypeDto;
		BankAccountId: string;
	}
}
export namespace Bokio.Bank.Contract.Teller.Interfaces {
	export interface TellerBankIdSignStartResponseDto {
		BankIdToken: string;
		AutoStartToken: string;
		QrCode?: string;
	}
}
export namespace Bokio.Bank.Contract.UploadRequests {
	export interface NotifyUserModel {
		UserId: string;
		FirstName: string;
		LastName: string;
		Email?: string;
		IsCompanyOwner: boolean;
	}
	export interface NotifyUsersModel {
		Users: Bokio.Bank.Contract.UploadRequests.NotifyUserModel[];
		CallerCanSeeEmails: boolean;
	}
}
export namespace Bokio.Bank.Contract.Utils {
	export interface CountryFilter {
		Consumer: Bokio.Bank.Contract.Utils.CountryListConsumer;
	}
	export enum CountryListConsumer {
		GeneralPurpose = "GeneralPurpose",
		Payment = "Payment",
	}
	export interface PaymentsFilter {
		Pagination: Bokio.Common.Contract.Pagination.Pagination;
		SortChoice: Bokio.Common.Contract.Utils.ListSortChoice<Bokio.Bank.Contract.Utils.PaymentsSortableProperties>;
		Filter: Bokio.Bank.Contract.Utils.PaymentsSearchFilter;
	}
	export interface PaymentsSearchFilter {
		SearchTerm: string;
		ShowPaidPayments: boolean;
		ShowCancelledAndHiddenPayments?: boolean;
		FromDate?: Day;
		ToDate?: Day;
		BankAccountId?: string;
	}
	export enum PaymentsSortableProperties {
		PaymentTo = "PaymentTo",
		Date = "Date",
		Sum = "Sum",
		Status = "Status",
		Category = "Category",
		PaymentFrom = "PaymentFrom",
	}
	export interface TellerTransactionAmount {
		Amount: number;
		Currency: string;
	}
	export interface TransactionsFilter {
		Pagination: Bokio.Common.Contract.Pagination.Pagination;
		Filter: Bokio.Bank.Contract.Utils.TransactionsSearchFilter;
	}
	export interface TransactionsSearchFilter {
		SearchTerm: string;
		FromDate?: Day;
		ToDate?: Day;
		IncludeSoftDeleted?: boolean;
		State?: Bokio.Bank.Contract.Utils.TransactionsSearchFilterStateType;
		SortBy?: Bokio.Bank.Contract.Utils.TransactionsSearchFilterOrdering[];
	}
	export enum TransactionsSearchFilterOrdering {
		Default = "Default",
		PendingTransactionsFirst = "PendingTransactionsFirst",
		TransactionDateAscending = "TransactionDateAscending",
		TransactionDateDescending = "TransactionDateDescending",
	}
	export enum TransactionsSearchFilterStateType {
		Default = "Default",
		AllActive = "AllActive",
		OnlyPending = "OnlyPending",
		OnlyCompleted = "OnlyCompleted",
	}
}
export namespace Bokio.Bank.Integration.Svea {
	export enum BankIdArea {
		All = "All",
		Authentication = "Authentication",
		Signing = "Signing",
		OnboardingSign = "OnboardingSign",
		AddProductSign = "AddProductSign",
		AddProductFinalize = "AddProductFinalize",
		ConfigureSwish = "ConfigureSwish",
	}
	export enum BankIdBehavior {
		Normal = "Normal",
		MobileStartError = "MobileStartError",
		MobileCancelError = "MobileCancelError",
		InternalServerProviderError = "InternalServerProviderError",
		Unknown = "Unknown",
	}
	export interface BankIdChangeBehaviorRequest {
		Behavior: Bokio.Bank.Integration.Svea.BankIdBehavior;
		Area: Bokio.Bank.Integration.Svea.BankIdArea;
	}
	export interface CreateMockCardDto {
		CreateInBokio: boolean;
	}
	export interface GetInternationalPaymentApplicationDto {
		ApplicationId: string;
		Name: string;
		Created: Date;
		Status: Bokio.Integration.Svea.Contract.LimitedApplicationStatus;
		CanApprove: boolean;
	}
	export interface SveaMockCardDto {
		CardId: string;
		Status: Bokio.Integration.Svea.Contract.PsuPsuIdCardGetResponseItemStatus;
	}
}
export namespace Bokio.Bank.Services {
	export enum SveaOnboardingStatus {
		NotStarted = "NotStarted",
		Continue = "Continue",
		Rejected = "Rejected",
		Finalized = "Finalized",
		NotAvailable = "NotAvailable",
	}
}
export namespace Bokio.Bank.Web.Controllers {
	export enum AccessLevel {
		FullAccess = "FullAccess",
		CardHolder = "CardHolder",
		CanPrepare = "CanPrepare",
		CanApprove = "CanApprove",
		Restricted = "Restricted",
	}
	export interface AccessLevelContextEntry {
		AccountAccessLevel: Bokio.Bank.Web.Controllers.AccountAccessLevelEnum;
		BankAccountId: string;
	}
	export enum AccountAccessLevelEnum {
		CanRead = "CanRead",
		CanCreatePayment = "CanCreatePayment",
		CanApprovePayment = "CanApprovePayment",
	}
	export interface ApprovePreregisterApplicationRequest {
		ApplicationId: string;
	}
	export enum AuthenticationError {
		NoError = "NoError",
		RemoteException = "RemoteException",
		UserCancelled = "UserCancelled",
		BankIdTokenAlreadyUsed = "BankIdTokenAlreadyUsed",
		GeneralError = "GeneralError",
		TokenExpired = "TokenExpired",
		PersonalNumberMismatch = "PersonalNumberMismatch",
	}
	export interface AuthStatusResult {
		BankIdToken?: string;
		Status: Bokio.Bank.Web.Controllers.AuthStatusResultStatusEnum;
		QrCode?: string;
		Message?: string;
	}
	export enum AuthStatusResultStatusEnum {
		Initializing = "Initializing",
		PendingStart = "PendingStart",
		AwaitingAuthorization = "AwaitingAuthorization",
		Successful = "Successful",
		Failed_BankIdTokenAlreadyUsed = "Failed_BankIdTokenAlreadyUsed",
		Failed_ExpiredTransaction = "Failed_ExpiredTransaction",
		Failed_StartFailed = "Failed_StartFailed",
		Failed_UserCancelled = "Failed_UserCancelled",
		Failed_UnknownReason = "Failed_UnknownReason",
		Error = "Error",
	}
	export interface CancelResponseBody {
	}
	export interface CancelSignResponseBody {
	}
	export interface ChangeDelegateAccessLevelRequest {
		AccessLevel: string;
		AccessLevelContexts?: Bokio.Bank.Web.Controllers.AccessLevelContextEntry[];
	}
	export interface CompleteResponseBody {
		BearerToken: string;
		RefreshToken: string;
		DelegateInformation: Bokio.Bank.Web.Controllers.CompleteResponseBodyDelegateInformation;
	}
	export interface CompleteResponseBodyDelegateInformation {
		CorrespondenceName: string;
		FirstName?: string;
		LastName?: string;
		PersonalNumber: string;
		PSUs: Bokio.Bank.Web.Controllers.CompleteResponseBodyDelegateInformationPsuInformation[];
	}
	export interface CompleteResponseBodyDelegateInformationPsuInformation {
		PsuId: string;
		SveaDelegateId: string;
		AccessLevel: Bokio.Bank.Web.Controllers.CompleteResponseBodyDelegateInformationPsuInformationAccessLevelEnum;
		RestrictedAccessLevelContexts?: Bokio.Bank.Web.Controllers.CompleteResponseBodyDelegateInformationPsuInformationRestrictedAccessLevelContext[];
	}
	export enum CompleteResponseBodyDelegateInformationPsuInformationAccessLevelEnum {
		FullAccess = "FullAccess",
		Approve = "Approve",
		Prepare = "Prepare",
		CardHolder = "CardHolder",
		Restricted = "Restricted",
	}
	export interface CompleteResponseBodyDelegateInformationPsuInformationRestrictedAccessLevelContext {
		BankAccountId: string;
		AccessLevel: Bokio.Bank.Web.Controllers.CompleteResponseBodyDelegateInformationPsuInformationRestrictedAccessLevelContextAccessLevelEnum;
	}
	export enum CompleteResponseBodyDelegateInformationPsuInformationRestrictedAccessLevelContextAccessLevelEnum {
		Read = "Read",
		PreparePayment = "PreparePayment",
		ApprovePayment = "ApprovePayment",
	}
	export interface CompleteSignResponseBody {
		StatusCode: number;
		Content?: string;
	}
	export interface CreateNewDelegateRequest {
		PersonalNumber: string;
		Name?: string;
		AccessLevel: Bokio.Bank.Web.Controllers.AccessLevel;
		AccessLevelContext?: Bokio.Bank.Web.Controllers.AccessLevelContextEntry[];
	}
	export interface CreateNewDelegateResult {
		Id: string;
	}
	export enum DelegateStatus {
		Active = "Active",
		InReview = "InReview",
	}
	export interface DeleteDelegateRequest {
		DelegateId: string;
	}
	export interface DeletePreregisterApplicationRequest {
		ApplicationId: string;
	}
	export interface DemoBankDto {
		TransactionDate: Date;
		BookkeepingDate: Date;
		Text: string;
		Sum: number;
		Balance: number;
	}
	export interface DemoBankRequest {
		Account: number;
		Type: Bokio.Bank.Web.Controllers.DemoDataType;
	}
	export interface DemoBankViewModel {
		ColumnNames: string[];
		Values: string[][];
	}
	export enum DemoDataType {
		Default = "Default",
		SIBPredictionData = "SIBPredictionData",
	}
	export interface GetDelegateResult {
		AccessLevel: Bokio.Bank.Web.Controllers.AccessLevel;
		AccessLevelContext: Bokio.Bank.Web.Controllers.AccessLevelContextEntry[];
		CorrespondenceName: string;
		DelegateId: string;
		Email?: string;
		PersonKey: string;
		PhoneNumber?: Bokio.Bank.Web.Controllers.PhoneNumber;
	}
	export interface GetDelegatesResultListEntry {
		Id: string;
		Name?: string;
		AccessLevel?: Bokio.Bank.Web.Controllers.AccessLevel;
		Status: Bokio.Bank.Web.Controllers.DelegateStatus;
		DelegateId?: string;
		PersonKey?: string;
	}
	export interface LookupPersonNameRequest {
		PersonalNumber: string;
	}
	export interface LookupPersonNameResult {
		Name: string;
	}
	export interface MatchingItem {
		Transaction: Bokio.Bank.Web.Controllers.MatchingTransaction;
		Payments: Bokio.Bank.Web.Controllers.ScoredMatchingPayment[];
	}
	export interface MatchingPayment {
		Id: string;
		Date: Date;
		Currency: string;
		Amount: number;
		SenderReference: string;
		PaymentInformation?: Classes.Teller.TellerPaymentInformationUnion;
		Message: string;
		RecipientName: string;
	}
	export interface MatchingTransaction {
		Id: string;
		TransactionDate: Date;
		EffectiveDate?: Date;
		Amount: number;
		Description: string;
	}
	export interface MatchPaymentAndTransactionDto {
		PaymentId: string;
		TransactionId: string;
	}
	export interface NeedsMatchingResult {
		HasItemsToMatch: boolean;
		ItemCount: number;
	}
	export interface OngoingAuthenticationRequestBody {
		BankIdToken: string;
	}
	export interface OngoingSigninRequestBody {
		BankIdToken: string;
	}
	export interface PhoneNumber {
		CountryCode: string;
		DomesticNumber: string;
	}
	export interface RefreshTokenResponseBody {
		BearerToken: string;
	}
	export interface RequestSignBody {
		SigningToken: string;
	}
	export interface RequestSignResponseBody {
		StatusCode: number;
		Content?: string;
	}
	export interface ScoredMatchingPayment {
		Payment: Bokio.Bank.Web.Controllers.MatchingPayment;
		IsTextMatch: boolean;
		DayDiff: number;
		Score: number;
	}
	export interface SetupSkatteverketAccountDto {
		StartDate: Day;
	}
	export enum SignError {
		NoError = "NoError",
		Failed = "Failed",
		Error = "Error",
		UserCancelled = "UserCancelled",
	}
	export interface SignStatusResult {
		BankIdToken?: string;
		Status: Bokio.Bank.Web.Controllers.SignStatusResultStatusEnum;
		QrCode?: string;
		Message?: string;
	}
	export enum SignStatusResultStatusEnum {
		Initializing = "Initializing",
		PendingStart = "PendingStart",
		AwaitingAuthorization = "AwaitingAuthorization",
		Successful = "Successful",
		Failed_BankIdTokenAlreadyUsed = "Failed_BankIdTokenAlreadyUsed",
		Failed_ExpiredTransaction = "Failed_ExpiredTransaction",
		Failed_StartFailed = "Failed_StartFailed",
		Failed_UserCancelled = "Failed_UserCancelled",
		Failed_UnknownReason = "Failed_UnknownReason",
		Error = "Error",
	}
	export interface SkatteverketFetchResult {
		NeedsReconnect: boolean;
		NewRowCount: number;
		Synced: boolean;
		NoAccess: boolean;
		AlreadyInProgress: boolean;
	}
	export interface SkatteverketShouldSyncResult {
		CanSync: boolean;
		IsTimeToSync: boolean;
		LastSync?: Date;
		NeedsReconnect: boolean;
	}
	export interface SkatteverketStartFetchSessionResult {
		RedirectUrl: string;
	}
	export interface StartSignRequestBody {
		SigningToken: string;
	}
	export enum StartSkatteverketAuthSessionSource {
		TaxAccountPage = "TaxAccountPage",
		TransactionsToRecord = "TransactionsToRecord",
		EventsToRecord = "EventsToRecord",
	}
	export interface SveaInternationalPaymentsCreateApplicationResponseDto {
		ApplicationId: string;
		Revision: string;
	}
	export interface TaxAccountTransactionDto {
		Id: string;
		TransactionDate: Day;
		Description: string;
		Amount: number;
	}
}
export namespace Bokio.Bcc.Web.Contract.Request {
	export interface BccCreateOnboardingRequest {
		Email: string;
		Phone: string;
	}
	export interface BccKycRequest {
		FirstName: string;
		LastName: string;
		Email: string;
		PhoneNumber: string;
		PersonalNumber: string;
		Residency: string;
		Citizenship: string;
		PepStatus: string;
		Bank: string;
		MonthlyIncome: string;
		IncomeOrigin: Entities.BCC.IncomeOrigins[];
		IncomeOriginOther: string;
		CapitalStartOrigin: string;
		AcceptedTerms: boolean;
	}
}
export namespace Bokio.Bcc.Web.Contract.Response {
	export interface BccGetOnboardingDto {
		Email: string;
	}
	export interface BccGetOnboardingsDto {
		Onboardings: Bokio.Bcc.Web.Contract.Response.BccGetOnboardingDto[];
	}
}
export namespace Bokio.Bcc.Web.Controllers {
	export interface BccKycForm {
		Result: boolean;
	}
}
export namespace Bokio.Billing.Contract {
	export enum CostOverviewResponseErrorType {
		MissingCompanyId = "MissingCompanyId",
		NoActiveSubscription = "NoActiveSubscription",
	}
}
export namespace Bokio.Billing.Contract.Models {
	export enum BillingPlan {
		Free = "Free",
		/** @deprecated */
		Balance = "Balance",
		/** @deprecated */
		Business = "Business",
		Premium = "Premium",
		PremiumPlus = "PremiumPlus",
		Trial_2025 = "Trial_2025",
		Basic_2025 = "Basic_2025",
		Premium_2025 = "Premium_2025",
		Business_2025 = "Business_2025",
		Plus_2025 = "Plus_2025",
	}
	export interface DataFor3DSecureChallenge {
		ChangeId: string;
		PurchaseId: string;
		SubscriptionId: string;
		PaymentIntentClientSecret: string;
		PublishableKey: string;
	}
	export interface RemoveStripePaymentMethodRequest {
		CompanyId: string;
		PaymentMethodId: string;
	}
	export interface RemoveStripePaymentMethodResponse {
		Successful: boolean;
	}
	export interface SetStripePaymentMethodAsDefaultRequest {
		CompanyId: string;
		PaymentMethodId: string;
	}
	export interface SetStripePaymentMethodAsDefaultResponse {
		Successful: boolean;
	}
	export enum SubscriptionAddonType {
		Invoices = "Invoices",
		Tags = "Tags",
		BankConnection = "BankConnection",
		APIIntegrations = "APIIntegrations",
	}
}
export namespace Bokio.Billing.Contract.Models.Subscriptions {
	export interface AddonProrationDetail {
		AddonType: Bokio.Billing.Contract.Models.SubscriptionAddonType;
		AddonName: string;
		MonthlyPrice: number;
		RemainingValueExVat: number;
		StartDate: Date;
		EndDate?: Date;
	}
	export interface AddonsDto {
		Type: Bokio.Billing.Contract.Models.SubscriptionAddonType;
		InclusionType: Bokio.Billing.Contract.Models.Subscriptions.SubscriptionAddonInclusionType;
		CloseDate?: Date;
		IsTrialing: boolean;
		TrialEndDate?: Date;
	}
	export interface AddSubscriptionAddonsResponseDto {
		Status: Bokio.Billing.Contract.Models.Subscriptions.AddSubscriptionAddonStatus;
		DataFor3DSecureChallenge: Bokio.Billing.Contract.Models.DataFor3DSecureChallenge;
		ErrorMessage: string;
		ErrorType?: Bokio.Billing.Contract.Models.Subscriptions.SubscriptionAddonResponseErrorType;
		PaymentDeclineReason?: Bokio.Billing.Contract.Models.Subscriptions.PaymentDeclineReason;
	}
	export enum AddSubscriptionAddonStatus {
		BadRequest = "BadRequest",
		PreviewOnly = "PreviewOnly",
		PurchaseFailed = "PurchaseFailed",
		UpgradeRequire3DS = "UpgradeRequire3DS",
		PurchaseSucceededAddonFailed = "PurchaseSucceededAddonFailed",
		PurchaseSucceededAddonApplied = "PurchaseSucceededAddonApplied",
	}
	export interface CancelSubscriptionAddonsResponseDto {
		Status: Bokio.Billing.Contract.Models.Subscriptions.CancelSubscriptionAddonStatus;
		ErrorMessage: string;
		ErrorType?: Bokio.Billing.Contract.Models.Subscriptions.SubscriptionAddonResponseErrorType;
		RemovedAddons: Bokio.Billing.Contract.Models.Subscriptions.RemovedAddonInfo[];
	}
	export enum CancelSubscriptionAddonStatus {
		CancellationFailed = "CancellationFailed",
		CancellationSuccessful = "CancellationSuccessful",
	}
	export enum PaymentDeclineReason {
		Unknown = "Unknown",
		InsufficientFunds = "InsufficientFunds",
		ExpiredCard = "ExpiredCard",
		CardDeclined = "CardDeclined",
	}
	export enum PreviewSubscriptionMode {
		Remove = "Remove",
		Add = "Add",
	}
	export interface RemovedAddonInfo {
		AddonType: Bokio.Billing.Contract.Models.SubscriptionAddonType;
		EffectiveRemovalDate: Date;
	}
	export enum StartAddonTrialErrorType {
		GeneralFailure = "GeneralFailure",
		MissingCompanyId = "MissingCompanyId",
		NoActiveSubscription = "NoActiveSubscription",
		AddonAlreadyActive = "AddonAlreadyActive",
		TrialAlreadyUsed = "TrialAlreadyUsed",
		TrialNotAvailableForPlan = "TrialNotAvailableForPlan",
		TrialNotAvailableForAddon = "TrialNotAvailableForAddon",
	}
	export enum SubscriptionAddonInclusionType {
		DefaultWithPlan = "DefaultWithPlan",
		Purchased = "Purchased",
		CanBePurchased = "CanBePurchased",
	}
	export enum SubscriptionAddonResponseErrorType {
		GeneralFailure = "GeneralFailure",
		NoActiveSubscription = "NoActiveSubscription",
		MissingCompanyId = "MissingCompanyId",
		CustomerNotAvailableOnStripe = "CustomerNotAvailableOnStripe",
		AlreadyHasAddon = "AlreadyHasAddon",
		AddonNotFound = "AddonNotFound",
	}
	export enum SubscriptionChangeSource {
		Unknown = "Unknown",
		Purchase = "Purchase",
		StartTrial = "StartTrial",
		ManageSubscriptionModal = "ManageSubscriptionModal",
		RecommendedPlanUpgrade = "RecommendedPlanUpgrade",
		CashbackOverview = "CashbackOverview",
		StartTrialCreateCompany = "StartTrialCreateCompany",
		StartTrialAdminWeb = "StartTrialAdminWeb",
		GrantedXMonthsOfTrialCLI = "GrantedXMonthsOfTrialCLI",
		CancelPlanConfirmation = "CancelPlanConfirmation",
		CancelPlanAdminWeb = "CancelPlanAdminWeb",
		BillingProcessCancellingPlan = "BillingProcessCancellingPlan",
		UserExtendedTrial = "UserExtendedTrial",
		AssignPlanCLI = "AssignPlanCLI",
		Migration = "Migration",
		PP2022Migration = "PP2022Migration",
		PremiumPlusToPlus2025Migration = "PremiumPlusToPlus2025Migration",
		UnitedKingdomShutdown2026 = "UnitedKingdomShutdown2026",
	}
	export interface UpcomingDiscountedPayment {
		PaymentDate: Date;
		OrdinaryPlanCostExclVat: number;
		NewPlanCostExclVat: number;
		AddonCostExclVat: number;
		PlanReductionExclVat: number;
		AddonReductionExclVat: number;
		AmountToPayExclVat: number;
		AmountToPayInclVat: number;
	}
}
export namespace Bokio.Common {
	export interface CurrencyInfo {
		Code: string;
		Label: string;
	}
}
export namespace Bokio.Common.Billing {
	export interface BokioStartCampaign {
		Available: boolean;
		AvailableTo?: Date;
	}
}
export namespace Bokio.Common.Billing.Model {
	export interface AppliedCashbackCampaign {
		DepositedCapitalCashbackPercentage?: number;
		DepositedCapitalCashbackCap?: number;
		CardSpendCashbackPercentage?: number;
		ExtraCashbackPerMonthExclVat?: number;
		CampaignExpires: Day;
	}
	export interface Bill {
		Id: string;
		InvoiceNo: string;
		Status: Bokio.Common.Billing.Model.BillStatus;
		FirstDay: Day;
		LastDay: Day;
		BillingDay: Day;
		DueDate: Day;
		BilledAmountExclVat: number;
		BilledAmountInclVat: number;
		Currency: string;
		Costs: Bokio.Common.Billing.Model.Cost[];
		PaymentMethod: Bokio.Common.Billing.Model.BillPaymentMethod;
		LastPaymentFailReason?: string;
	}
	export interface BillingCompany {
		Customer: boolean;
		Issuer: boolean;
	}
	export enum BillingDeliveryMethod {
		Default = "Default",
		SupplierInvoiceDelivery = "SupplierInvoiceDelivery",
		StandardEmail = "StandardEmail",
		Card = "Card",
	}
	export interface BillingIntervalOption {
		Visibility: Bokio.Common.Billing.Model.BillingIntervalVisibility;
		CanChange: Bokio.Common.Contract.PricePlans.ChangeResult;
		PriceExclVat: number;
		Discount?: Bokio.Common.Billing.Model.IntervalDiscount;
		CashbackContract?: Bokio.Common.Billing.Model.CashbackContract;
		CashbackContractOffer?: Bokio.Common.Billing.Model.CashbackContractOffer;
		CampaignKeys: string[];
	}
	export interface BillingIntervalOptions {
		Monthly: Bokio.Common.Billing.Model.BillingIntervalOption;
		Quarterly: Bokio.Common.Billing.Model.BillingIntervalOption;
		Yearly: Bokio.Common.Billing.Model.BillingIntervalOption;
	}
	export enum BillingIntervalVisibility {
		Hidden = "Hidden",
		Disabled = "Disabled",
		Available = "Available",
	}
	export enum BillingReceiptStatus {
		Unknown = "Unknown",
		Draft = "Draft",
		Paid = "Paid",
		Failed = "Failed",
		Refunded = "Refunded",
		CurrentPeriod = "CurrentPeriod",
		Uncollectable = "Uncollectable",
		Removed = "Removed",
	}
	export enum BillingReceiptType {
		Unknown = "Unknown",
		EarlyBird = "EarlyBird",
		PricePlanPurchase = "PricePlanPurchase",
		PricePlanUpgrade = "PricePlanUpgrade",
		StandalonePurchase = "StandalonePurchase",
		MonthlyInvoice = "MonthlyInvoice",
		FullRefund = "FullRefund",
	}
	export interface BillingSettings {
		CustomerInfo: Bokio.Common.Billing.Model.CustomerInfo;
	}
	export enum BillPaymentMethod {
		Unknown = "Unknown",
		Invoice = "Invoice",
		Card = "Card",
	}
	export enum BillStatus {
		Unknown = "Unknown",
		CurrentPeriod = "CurrentPeriod",
		Pending = "Pending",
		Sent = "Sent",
		Paid = "Paid",
		Overdue = "Overdue",
		Credited = "Credited",
		Removed = "Removed",
	}
	export enum BokioUserExtendedTrialReasonCategory {
		NotSet = "NotSet",
		NoTimeToStart = "NoTimeToStart",
		NotReadyForAccountingSoftware = "NotReadyForAccountingSoftware",
		NotConvinced = "NotConvinced",
		UsingCompetitor = "UsingCompetitor",
		GotStuckOrNeededHelp = "GotStuckOrNeededHelp",
		Other = "Other",
	}
	export interface CardInfo {
		Id: string;
		Brand: string;
		LastFour: string;
		IsDefault: boolean;
		ExpiryMonth: number;
		ExpiryYear: number;
	}
	export interface CashbackContract {
		DepositedCapitalCashbackPercentage: number;
		DepositedCapitalCashbackCap?: number;
		CardSpendCashbackPercentage: number;
	}
	export interface CashbackContractOffer {
		Key: string;
		NumberOfMonths: number;
		OfferValidTo?: Day;
		DepositedCapitalCashbackPercentage?: number;
		DepositedCapitalCashbackCap?: number;
		CardSpendCashbackPercentage?: number;
		ExtraCashbackPerMonthExclVat?: number;
		DaysRemaining?: number;
		HoursRemaining?: number;
	}
	export interface CashbackDetail {
		Id: string;
		CustomerCompanyId: string;
		CustomerName: string;
		AmountExclVat: number;
		AmountInclVat: number;
		PaymentDate: Day;
		PaymentCreatedUtc: Day;
		PaymentCompletedUtc: Day;
		Status: Bokio.Common.Billing.Model.CashbackStatus;
		ReceiptId?: string;
	}
	export interface CashbackDetails {
		Summary: Bokio.Common.Billing.Model.CashbackSummary;
		Payments: Bokio.Common.Billing.Model.CashbackDetail[];
	}
	export enum CashbackStatus {
		Draft = "Draft",
		CreatingInBokio = "CreatingInBokio",
		CreatedInBokio = "CreatedInBokio",
		ApprovedInBokio = "ApprovedInBokio",
		CompletedInBokio = "CompletedInBokio",
		HasFailedPayments = "HasFailedPayments",
		NoConsentInBokio = "NoConsentInBokio",
		NoActiveBBA = "NoActiveBBA",
		InternalCompany = "InternalCompany",
		Error = "Error",
		Unknown = "Unknown",
	}
	export interface CashbackSummary {
		LastDay: Day;
		AmountExclVat: number;
		AmountInclVat: number;
		Count: number;
	}
	export interface Cost {
		Item: string;
		Notes: string;
		AmountPerItemExclVat: number;
		AmountTotalExclVat: number;
		AmountInclVat: number;
		VatRate: number;
		Currency: string;
		Quantity: number;
		Date: Day;
	}
	export interface CustomerInfo {
		ContactName: string;
		Email: string;
		PreferredDeliveryMethod: Bokio.Common.Billing.Model.BillingDeliveryMethod;
		HasFailedCardBillsPayments: boolean;
		Card: Bokio.Common.Billing.Model.CardInfo;
		AllNonDefaultPaymentMethods: Bokio.Common.Billing.Model.CardInfo[];
		HasDirtyStripeCardHistory: boolean;
		DefaultCardWarning: Bokio.Common.Billing.Model.DefaultCardWarning;
	}
	export enum DefaultCardWarning {
		NoWarning = "NoWarning",
		Expiring = "Expiring",
		Expired = "Expired",
	}
	export interface IntervalDiscount {
		DiscountedPriceExclVat?: number;
		Key: string;
		NumberOfMonths: number;
		OfferValidTo: Date;
		Partner: string;
	}
	export interface Receipt {
		ReceiptId?: string;
		Date: Date;
		AmountExclVat: number;
		AmountInclVat: number;
		Type: Bokio.Common.Billing.Model.BillingReceiptType;
		Status: Bokio.Common.Billing.Model.BillingReceiptStatus;
		ItemId: string;
		Currency: string;
	}
	export interface ReceiptsVM {
		Receipts: Bokio.Common.Billing.Model.Receipt[];
		Bills: Bokio.Common.Billing.Model.Bill[];
		DefaultCard: Bokio.Common.Billing.Model.CardInfo;
	}
	export enum SubscriptionInterval {
		Year = "Year",
		Month = "Month",
		Quarter = "Quarter",
	}
}
export namespace Bokio.Common.Broadcast {
	export enum Level {
		Information = "Information",
		Warning = "Warning",
	}
	export enum TargetCategory {
		Global = "Global",
		BBA = "BBA",
	}
}
export namespace Bokio.Common.Contract {
	export interface AmountWithCurrency {
		Amount: number;
		CurrencyIsoCode: string;
	}
	export enum LoginMethod {
		BokioAuthentication = "BokioAuthentication",
		MirAuthentication = "MirAuthentication",
		BokioPayBankIdAuthentication = "BokioPayBankIdAuthentication",
	}
}
export namespace Bokio.Common.Contract.Accounts {
	export interface ConfirmUserEmailRequest {
		UserId: string;
		ConfirmationCode: number;
		UserType: Bokio.Common.Contract.Accounts.UserType;
	}
	export enum UserType {
		Regular = "Regular",
		Accountant = "Accountant",
	}
}
export namespace Bokio.Common.Contract.BankId {
	export enum BankIdCollectionStatus {
		Invalid = "Invalid",
		Pending = "Pending",
		Complete = "Complete",
		Failed = "Failed",
	}
	export interface BankIdError {
		UserVisibleMessage: string;
	}
	export enum BankIdHintCode {
		Unknown = "Unknown",
		OutstandingTransaction = "OutstandingTransaction",
		NoClient = "NoClient",
		Started = "Started",
		UserMrtd = "UserMrtd",
		UserCallConfirm = "UserCallConfirm",
		UserSign = "UserSign",
		ExpiredTransaction = "ExpiredTransaction",
		CertificateErr = "CertificateErr",
		UserCancel = "UserCancel",
		Cancelled = "Cancelled",
		StartFailed = "StartFailed",
		UserDeclinedCall = "UserDeclinedCall",
		NotSupportedByUserApp = "NotSupportedByUserApp",
	}
}
export namespace Bokio.Common.Contract.Billing.Model {
	export interface ActivateVoucherDiscountDetails {
		ValidTo: Date;
		Title: string;
	}
	export interface ActivateVoucherResult {
		Success: boolean;
		ErrorMessage: string;
		DiscountDetails: Bokio.Common.Contract.Billing.Model.ActivateVoucherDiscountDetails;
	}
	export interface BillingVoucher {
		ActiveFrom: Date;
		ActiveTo: Date;
		CreatedUtc: Date;
		Title: string;
		Type: Bokio.Common.Contract.Billing.Model.VoucherDiscountType;
	}
	export interface CampaignDto {
		Key: string;
		EndDate: Day;
		DaysRemaining: number;
		HoursRemaining: number;
	}
	export interface Retry3DSecureData {
		PublishableStripeKey: string;
		PaymentIntentClientSecret: string;
	}
	export enum RetryFailedBillResult {
		Success = "Success",
		Failed = "Failed",
		DidNotTry = "DidNotTry",
		AlreadyPaid = "AlreadyPaid",
		Require3DS = "Require3DS",
	}
	export interface RetryFailedPaymentsResult {
		DidNotRetry: boolean;
		Require3DSecure: boolean;
		Retry3DSecureData: Bokio.Common.Contract.Billing.Model.Retry3DSecureData;
		PaymentResults: Bokio.Common.Contract.Billing.Model.RetryFailedPaymentsResultDetails[];
	}
	export interface RetryFailedPaymentsResultDetails {
		BillDate: Date;
		Sum: number;
		FailureReason: string;
		BillId: string;
		Result: Bokio.Common.Contract.Billing.Model.RetryFailedBillResult;
	}
	export enum VoucherDiscountType {
		NotSet = "NotSet",
		FreeSubscriptionXMonthsFromStart = "FreeSubscriptionXMonthsFromStart",
		AgencyPayForDigitalAnnualReport = "AgencyPayForDigitalAnnualReport",
	}
}
export namespace Bokio.Common.Contract.CompanyContactSettings {
	export enum BlockedFieldKey {
		OrgNumber = "OrgNumber",
		Name = "Name",
		CompanyType = "CompanyType",
		VatNumber = "VatNumber",
	}
	export interface FieldBlock {
		FieldKey: Bokio.Common.Contract.CompanyContactSettings.BlockedFieldKey;
		ReasonForBlock: string;
		ReadMoreUri: string;
	}
}
export namespace Bokio.Common.Contract.CompanyDrafts.Dtos {
	export interface ClientOwnershipDto {
		Email: string;
		Responsibilities: Entities.PartnerCompanyResponsibilities[];
		MembershipType: Entities.MembershipType[];
		Message: string;
	}
}
export namespace Bokio.Common.Contract.Disconnect {
	export interface DeleteCompanySubscriptionData {
		Type: Bokio.Common.Contract.Disconnect.DeleteCompanySubscriptionType;
		PartnerName: string;
	}
	export interface DeleteCompanySubscriptionRestrictionData {
		IsAllowed: boolean;
		Services: Bokio.Common.Contract.Disconnect.DeleteCompanySubscriptionData[];
		RestrictionReason: string;
	}
	export enum DeleteCompanySubscriptionType {
		PrioSupport = "PrioSupport",
		Factoring = "Factoring",
		EInvoices = "EInvoices",
		Zaver = "Zaver",
		BokioPlan = "BokioPlan",
		Plaid = "Plaid",
		Partner = "Partner",
		Stripe = "Stripe",
		EnableBanking = "EnableBanking",
	}
}
export namespace Bokio.Common.Contract.EInvoice {
	export enum EInvoiceStatus {
		InProgress = "InProgress",
		Rejected = "Rejected",
		Accepted = "Accepted",
	}
}
export namespace Bokio.Common.Contract.Inbox {
	export interface InboxEmailOwnerDto {
		Type: Bokio.Common.Contract.Inbox.InboxOwnerType;
		UserId?: string;
		Name: string;
		WhitelistItems: Entities.InboxWhitelistItem[];
	}
	export enum InboxOwnerType {
		NormalUser = "NormalUser",
		RemovedUser = "RemovedUser",
		Unconnected = "Unconnected",
		ApiUser = "ApiUser",
	}
}
export namespace Bokio.Common.Contract.Internationalization {
	export interface CountryResult {
		IsoCode3: string;
		IsoCode2: string;
		Name: string;
		IsDomestic: boolean;
		IsEU: boolean;
		Id: string;
		CountrySubdivisions: Classes.CountrySubdivision[];
		InternationalCallingCode: string;
	}
	export interface GetCountriesResult {
		Countries: Bokio.Common.Contract.Internationalization.CountryResult[];
	}
}
export namespace Bokio.Common.Contract.Metrics.Analytics.Requests {
	export enum AgencyAnalyticsEventCategory {
		Unknown = "Unknown",
		NewAgencyGuide = "NewAgencyGuide",
		CreateClientPreStep = "CreateClientPreStep",
		AgencyDropdownMenu = "AgencyDropdownMenu",
		ExportNotes = "ExportNotes",
		MoveToBokioBanner = "MoveToBokioBanner",
		MoveClientsToBokioCreateAgency = "MoveClientsToBokioCreateAgency",
		CreateAgencyPreStep = "CreateAgencyPreStep",
		LeaveAgency = "LeaveAgency",
		ImportBookkeeping = "ImportBookkeeping",
		DeleteAgency = "DeleteAgency",
		RejectQuoteRequest = "RejectQuoteRequest",
		WhatsNewCompanyOverview = "WhatsNewCompanyOverview",
		WhatsNewAgencyOverview = "WhatsNewAgencyOverview",
	}
	export interface AgencyAnalyticsRequest {
		Category: Bokio.Common.Contract.Metrics.Analytics.Requests.AgencyAnalyticsEventCategory;
		Action: string;
		Label?: string;
		Value?: number;
	}
	export enum AnalyticsEventCategory {
		Unknown = "Unknown",
		DuplicateVerifications = "DuplicateVerifications",
		DeleteReceipt = "DeleteReceipt",
		PreviewContextualBookkeepings = "PreviewContextualBookkeepings",
		AreYouAnAccountantBanner = "AreYouAnAccountantBanner",
		ContextualBankTransactions = "ContextualBankTransactions",
		SupplierInvoice = "SupplierInvoice",
		Export = "Export",
		ClosurePackageSelection = "ClosurePackageSelection",
		Bba = "Bba",
		Videos = "Videos",
		NotificationFlow = "NotificationFlow",
		BokioClosure = "BokioClosure",
		Receipt = "Receipt",
		UploadsScene = "UploadsScene",
		CompanyAgencyInvite = "CompanyAgencyInvite",
		SIEExport = "SIEExport",
		TryAgencyBanner = "TryAgencyBanner",
		BankFeed = "BankFeed",
		BokioPlans = "BokioPlans",
		EInvoiceConfiguration = "EInvoiceConfiguration",
		OffboardAgency = "OffboardAgency",
		RegisterInterest = "RegisterInterest",
		CommandPalette = "CommandPalette",
		RecordAnotherJournal = "RecordAnotherJournal",
		BbaSvea = "BbaSvea",
		AccountantPanel = "AccountantPanel",
		MathematicalExpression = "MathematicalExpression",
		NeAttachment = "NeAttachment",
		Invoicing = "Invoicing",
	}
	export interface AnalyticsRequest {
		Category: Bokio.Common.Contract.Metrics.Analytics.Requests.AnalyticsEventCategory;
		Action: string;
		Label?: string;
		Value?: number;
	}
}
export namespace Bokio.Common.Contract.Metrics.AssetsMetrics.Requests {
	export interface SaveAssetsFeedbackRequest {
		Message: string;
	}
}
export namespace Bokio.Common.Contract.Metrics.FeatureInterest.Dtos {
	export enum FeatureInterestEvent {
		Unknown = "Unknown",
		Interested = "Interested",
		InterestedDismiss = "InterestedDismiss",
		InterestedBuy = "InterestedBuy",
		InterestedFeedback = "InterestedFeedback",
		NotInterested = "NotInterested",
		NotInterestedDismiss = "NotInterestedDismiss",
		NotInterestedFeedback = "NotInterestedFeedback",
		WentToLandingPage = "WentToLandingPage",
		SawFeatureIntroduction = "SawFeatureIntroduction",
	}
	export enum FeatureInterestFeature {
		Unknown = "Unknown",
		Premium1 = "Premium1",
		Premium2 = "Premium2",
		Autopilot = "Autopilot",
		Deals = "Deals",
		BusinessAccount = "BusinessAccount",
		PlaidBankFeed = "PlaidBankFeed",
		InvoiceStripePayments = "InvoiceStripePayments",
		ECommerce = "ECommerce",
	}
	export enum FeatureInterestFeedbackOption {
		Unknown = "Unknown",
		TooExpensive = "TooExpensive",
		BadFeatures = "BadFeatures",
		NotNeeded = "NotNeeded",
		NoValueProvided = "NoValueProvided",
		Other = "Other",
		NotHaveEnoughTrust = "NotHaveEnoughTrust",
		DoNotWantToHaveAnotherBank = "DoNotWantToHaveAnotherBank",
		DoNotWantToHaveAnotherCard = "DoNotWantToHaveAnotherCard",
		WantOtherAlternative = "WantOtherAlternative",
	}
}
export namespace Bokio.Common.Contract.Metrics.FeatureInterest.Requests {
	export interface FeatureInterestRequest {
		Feature: Bokio.Common.Contract.Metrics.FeatureInterest.Dtos.FeatureInterestFeature;
		Event: Bokio.Common.Contract.Metrics.FeatureInterest.Dtos.FeatureInterestEvent;
		Value: string;
		FeedbackOptions?: Bokio.Common.Contract.Metrics.FeatureInterest.Dtos.FeatureInterestFeedbackOption[];
	}
}
export namespace Bokio.Common.Contract.Metrics.Feedback {
	export interface IntegrationsFeedbackRequest {
		Type: Bokio.Common.Contract.Metrics.Feedback.IntegrationsFeedbackType;
		Message: string;
		AdditionalInfoJson: string;
	}
	export enum IntegrationsFeedbackType {
		MessageWithSelectedIntegrations = "MessageWithSelectedIntegrations",
	}
}
export namespace Bokio.Common.Contract.Metrics.Feedback.Dtos {
	export interface AgencyRatingDto {
		Score: number;
		FeedbackText: string;
		Type: Entities.PartnerRatingType;
		AdditionalData: string;
		Cancelled: boolean;
	}
	export interface RatingDto {
		Score: number;
		FeedbackText: string;
		Type: Entities.Feedback.RatingType;
		AdditionalData: string;
		Cancelled: boolean;
	}
	export interface RatingInstructionDto {
		ShouldAskForRating: boolean;
		RatingType: Entities.Feedback.RatingType;
		RatingAdditionalData: string;
	}
}
export namespace Bokio.Common.Contract.Metrics.VacationTrackingMetrics.Requests {
	export interface VacationTrackingFeedbackRequest {
		Message: string;
	}
}
export namespace Bokio.Common.Contract.Metrics.VerificationMetric.Dtos {
	export interface VerificationMetricDto {
		VerificationId: string;
		TimeToRecord: number;
		Source: Bokio.Common.Contract.Metrics.VerificationMetric.Dtos.VerificationMetricSource;
	}
	export enum VerificationMetricSource {
		Unknown = "Unknown",
		Regular = "Regular",
		SupplierInvoice = "SupplierInvoice",
		EmployeeExpense = "EmployeeExpense",
		Transaction = "Transaction",
		ContextualTransaction = "ContextualTransaction",
		Copy = "Copy",
		ContextualTransactionWithAutomationRule = "ContextualTransactionWithAutomationRule",
	}
}
export namespace Bokio.Common.Contract.Metrics.VerificationMetric.Requests {
	export interface SaveVerificationMetricRequest {
		Metrics: Bokio.Common.Contract.Metrics.VerificationMetric.Dtos.VerificationMetricDto[];
	}
}
export namespace Bokio.Common.Contract.Metrics.YesNoFeedback.Requests {
	export enum YesNoFeedbackArea {
		Unknown = "Unknown",
		DuplicateVerifications = "DuplicateVerifications",
		BankRules = "BankRules",
	}
	export interface YesNoFeedbackRequest {
		Area: Bokio.Common.Contract.Metrics.YesNoFeedback.Requests.YesNoFeedbackArea;
		Rating: boolean;
	}
}
export namespace Bokio.Common.Contract.Pagination {
	export interface Pagination {
		PageNumber?: number;
		PageSize?: number;
		Filters?: string;
		Sorts?: string;
	}
}
export namespace Bokio.Common.Contract.PreliminaryTaxes {
	export interface PreliminaryTaxDatePaymentViewModel {
		Id: string;
		Amount: number;
		Date: Day;
		Type: Entities.Taxes.TaxDatePaymentType;
	}
	export interface PreliminaryTaxDateViewModel {
		Id: string;
		Date: Day;
		TotalSum: number;
		TotalPaid: number;
		Status: Bokio.Common.Contract.PreliminaryTaxes.PreliminaryTaxPaymentStatus;
		Payments: Bokio.Common.Contract.PreliminaryTaxes.PreliminaryTaxDatePaymentViewModel[];
	}
	export interface PreliminaryTaxesViewModel {
		Year: number;
		TaxDates: Bokio.Common.Contract.PreliminaryTaxes.PreliminaryTaxDateViewModel[];
	}
	export enum PreliminaryTaxPaymentStatus {
		Unknown = "Unknown",
		Unpaid = "Unpaid",
		NothingToPay = "NothingToPay",
		Overdue = "Overdue",
		PaymentScheduledWithBBA = "PaymentScheduledWithBBA",
		Underpaid = "Underpaid",
		PaidWithBBA = "PaidWithBBA",
		Paid = "Paid",
		Overpaid = "Overpaid",
	}
}
export namespace Bokio.Common.Contract.PricePlans {
	export interface ChangeInfo {
		OldPlan: Entities.BokioPlan;
		NewPlan: Entities.BokioPlan;
		OldInterval: Bokio.Common.Billing.Model.SubscriptionInterval;
		NewInterval: Bokio.Common.Billing.Model.SubscriptionInterval;
	}
	export interface ChangeResult {
		ChangeInfo: Bokio.Common.Contract.PricePlans.ChangeInfo;
		BlockChange: boolean;
		BlockReason: string;
		BlockReasonKey: string;
	}
}
export namespace Bokio.Common.Contract.PublicApi {
	export interface PublicApiScope {
		Identifier: string;
		Description?: string;
		DisplayName?: string;
	}
	export interface PublicApiScopeRequestInfo {
		Resource: string;
		Action: Bokio.Common.Contract.PublicApi.ScopeAction;
		DisplayName: string;
		ActionName: string;
	}
	export enum ScopeAction {
		Read = "Read",
		Write = "Write",
		ReadWrite = "ReadWrite",
	}
}
export namespace Bokio.Common.Contract.Requests.FeatureRequests {
	export interface AddFeatureRequest {
		Title: string;
		Description: string;
	}
	export interface ApproveFeatureRequest {
		FeatureRequestId: string;
	}
	export interface CategorizeFeatureRequest {
		FeatureRequestId: string;
		Category: Entities.FeatureCategory;
	}
	export interface MarkAsCompletedRequest {
		FeatureRequestId: string;
	}
	export interface MergeFeatureRequest {
		FeatureRequestIdToKeep: string;
		DuplicateFeatureRequestId: string;
	}
	export interface RejectFeatureRequest {
		FeatureRequestId: string;
	}
	export interface RemoveVoteForFeatureRequest {
		FeatureRequestId: string;
	}
	export interface VoteForFeatureRequest {
		FeatureId: string;
	}
}
export namespace Bokio.Common.Contract.Requests.Users {
	export interface CancelRequestToAgencyRequest {
		AgencyId: string;
		RequestId: string;
		InvitedUserId: string;
	}
}
export namespace Bokio.Common.Contract.Research {
	export interface AnswerResearchQuestionDto {
		CompanyId: string;
		QuestionId: string;
		SelectedAnswers?: string[];
		FreeTextAnswer?: string;
	}
	export interface ResearchQuestionAlternativeViewModel {
		Id: string;
		Order: number;
		Label: string;
	}
	export interface ResearchQuestionDto {
		CompanyId: string;
		Url: string;
	}
	export interface ResearchQuestionViewModel {
		ShowQuestion: boolean;
		QuestionId: string;
		Question: string;
		Description: string;
		Type: Entities.Research.ResearchQuestionType;
		Alternatives: Bokio.Common.Contract.Research.ResearchQuestionAlternativeViewModel[];
	}
}
export namespace Bokio.Common.Contract.Services.AiProxy {
	export enum AiFeature {
		NotSet = "NotSet",
		ExampleAssistant = "ExampleAssistant",
		TemplateSearch = "TemplateSearch",
		GenericChat = "GenericChat",
		VerificationExplanation = "VerificationExplanation",
		BookkeepingCheckReview = "BookkeepingCheckReview",
		SupportCaseSummary = "SupportCaseSummary",
	}
	export interface AiFeatureRequest {
		Feature: Bokio.Common.Contract.Services.AiProxy.AiFeature;
		ConversationHistory: Bokio.Common.Contract.Services.AiProxy.ConversationMessage[];
		ConversationId: string;
	}
	export interface AiFeedbackRequestDto {
		ConversationId: string;
		UserPrompt: string;
		AiResponse: string;
		IsPositive: boolean;
		Feature: string;
		GranualRating?: string;
		PromptRebuildContext?: string;
		UserInput?: string;
	}
	export interface AiProxyResponse {
		Content: string;
		TotalTokens: number;
		ConversationId: string;
	}
	export enum AiServiceError {
		None = "None",
		ServiceUnavailable = "ServiceUnavailable",
		RateLimitExceeded = "RateLimitExceeded",
		GeneralError = "GeneralError",
		FeatureDisabled = "FeatureDisabled",
		InvalidInput = "InvalidInput",
		InvalidResponse = "InvalidResponse",
	}
	export interface ConversationMessage {
		Role: string;
		Content: string;
	}
}
export namespace Bokio.Common.Contract.Services.UserPreferences {
	export interface AgencyUserPreferencesDto {
		MenuLoyaltyPlanCollapsedPreference?: Bokio.Common.Contract.Services.UserPreferences.MenuLoyaltyPlanCollapsedPreference;
		MoveToBokioBannerDismissedPreference?: Bokio.Common.Contract.Services.UserPreferences.MoveToBokioBannerDismissedPreference;
		HideAgencyOnboardingChecklistPreference?: Bokio.Common.Contract.Services.UserPreferences.HideAgencyOnboardingChecklistPreference;
		CustomClientColumnsPreference?: Bokio.Common.Contract.Services.UserPreferences.CustomClientColumnsPreference;
		LastReadWhatsNewDateAgencyPreference?: Bokio.Common.Contract.Services.UserPreferences.LastReadWhatsNewDateAgencyPreference;
	}
	export interface AlwaysExpandVerificationPreview {
		Value: boolean;
	}
	export interface AreYouAnAccountantBannerDismissedPreference {
		Value: boolean;
	}
	export interface AutogiroRecipientTipDismissedPreference {
		Value: Bokio.Common.Contract.Services.UserPreferences.AutogiroRecipientTipDismissedValue;
	}
	export interface AutogiroRecipientTipDismissedValue {
		DismissedBankGiroNumbers?: string[];
		DismissedHasConsentBankGiroNumbers?: string[];
	}
	export interface AutogiroTipNoticeDismissedPreference {
		Value: boolean;
	}
	export interface AutomationRulesDisplayInTransactionListUserPreference {
		Value: boolean;
	}
	export interface AutopilotFeatureInterestDismissedPreference {
		Value: boolean;
	}
	export interface BbaCloseDownNoticeDismissedPreference {
		Value: boolean;
	}
	export interface BbaKycModalDismissedPreference {
		Value: Date;
	}
	export interface BbaPopupDismissedPreference {
		Value: boolean;
	}
	export interface BbaTopBarOnboardingNoticePopoverDismissedPreference {
		Value: boolean;
	}
	export interface BbaTopBarOnboardingNotInterestedPreference {
		Value: boolean;
	}
	export interface BbaTopBarQuickAccessDismissedPreference {
		Value: boolean;
	}
	export interface BookkeepingSchoolGetStartedPreference {
		Value: Bokio.Common.Contract.Services.UserPreferences.BookkeepingSchoolGetStartedStep;
	}
	export enum BookkeepingSchoolGetStartedStep {
		Initial = "Initial",
		HowTo = "HowTo",
		SchoolPage = "SchoolPage",
		Dismissed = "Dismissed",
	}
	export interface BrandLift2025AnnouncementPopupDismissedPreference {
		Value: boolean;
	}
	export interface BusinessAccountCardCustomisationPreference {
		Value: Bokio.Common.Contract.Services.UserPreferences.CardCustomisation;
	}
	export interface BusinessAccountFeatureInterestCollapsedPreference {
		Value: boolean;
	}
	export interface BusinessAccountFeatureInterestDismissedPreference {
		Value: boolean;
	}
	export interface BusinessAccountFeatureInterestViewedPreference {
		Value: boolean;
	}
	export interface BusinessAccountPersonalBankGiroNoticeDismissedPreference {
		Value: boolean;
	}
	export interface CardCustomisation {
		ShowCompanyName?: boolean;
		CompanyName: string;
		Name: string;
	}
	export interface ClosureBannerDismissedPreference {
		Value: boolean;
	}
	export interface ClosureThingsTodoDismissed {
		Value: boolean;
	}
	export interface CompanyDataStorageSettingsNotice {
		Value: boolean;
	}
	export interface ConnectClientCompaniesDismissedPreference {
		Value: boolean;
	}
	export interface CustomClientColumnsPreference {
		Value: Entities.CustomClientColumns;
	}
	export interface CustomTemplatesTipNotice {
		Value: boolean;
	}
	export interface DailyTakingsTrailingDatesInfoDismissed {
		Value: boolean;
	}
	export interface DealsFeatureInterestDismissedPreference {
		Value: boolean;
	}
	export interface DraftVerificationDismissedPreference {
		Value: boolean;
	}
	export interface EInvoiceDiscoverabilityBannerDismissedPreference {
		Value: boolean;
	}
	export interface EinvoicePaymentMethodMovedNoticeDismissedUserPreference {
		Value: boolean;
	}
	export interface EmployeeDetailsTipNoptice {
		Value: boolean;
	}
	export interface HideAgencyOnboardingChecklistPreference {
		Value: boolean;
	}
	export interface HideCashbackBannerPreference {
		Value: Bokio.Common.Contract.Services.UserPreferences.HideCashbackBannerPreferenceValue;
	}
	export enum HideCashbackBannerPreferenceValue {
		NotSet = "NotSet",
		Collapsed = "Collapsed",
		Hidden = "Hidden",
		Shown = "Shown",
	}
	export interface HideOnboardingChecklistPreference {
		Value: Bokio.Common.Contract.Services.UserPreferences.HideOnboardingChecklistPreferenceValue;
	}
	export enum HideOnboardingChecklistPreferenceValue {
		Auto = "Auto",
		Hidden = "Hidden",
		Shown = "Shown",
	}
	export interface ImportantDatesInformationDismissedUserPreference {
		Value: boolean;
	}
	export interface ImportantDatesRunWizardNoticeDismissed {
		Value: boolean;
	}
	export interface InvoiceBusinessAccountPromoDismissedPreference {
		Value: boolean;
	}
	export interface LastReadWhatsNewDateAgencyPreference {
		Value: Date;
	}
	export interface LastReadWhatsNewDatePreference {
		Value: Date;
	}
	export interface LinkBankAccountToDomesticPayment {
		Value: boolean;
	}
	export interface MarketingSettingsPopupDismissed {
		Value: boolean;
	}
	export interface MathematicalExpressionTipNotice {
		Value: boolean;
	}
	export interface MenuCurrentPlanCollapsedPreference {
		Value: boolean;
	}
	export interface MenuLoyaltyPlanCollapsedPreference {
		Value: boolean;
	}
	export interface MoveBankAccountNoticeDismissedPreference {
		Value: boolean;
	}
	export interface MoveToBokioBannerDismissedPreference {
		Value: boolean;
	}
	export interface OrderCardThingsToDoDismissed {
		Value: boolean;
	}
	export interface PDFV3PromoDismissedPreference {
		Value: boolean;
	}
	export interface PremiumFeatureInterestDismissedPreference {
		Value: boolean;
	}
	export interface SalaryPricePlanChangesInfoDismissed {
		Value: boolean;
	}
	export interface ShowAccountBalancePreference {
		Value: boolean;
	}
	export interface ShowBookkeepingPredictionsPreference {
		Value: boolean;
	}
	export interface ShowDelightfulEffectsPreference {
		Value: boolean;
	}
	export interface ShowPricePlanChangeTopBar202309Preference {
		Value: boolean;
	}
	export interface SideMenuVisitedStates {
		AccountingServices?: boolean;
		HireAnAccountant?: boolean;
		BusinessServices?: boolean;
		BankFeed?: boolean;
		Integrations?: boolean;
		PaymentLinks?: boolean;
		Quotes?: boolean;
		VacationTracking?: boolean;
	}
	export interface SideMenuVisitedUserPreference {
		Value: Bokio.Common.Contract.Services.UserPreferences.SideMenuVisitedStates;
	}
	export interface SIEExportFeedbackSubmittedPreference {
		Value: boolean;
	}
	export interface StartBonusFeb2026BannerDismissedPreference {
		Value: boolean;
	}
	export interface StripeFeatureInterestResponsePreference {
		Value: boolean;
	}
	export interface TestCompanyBumperModalPreference {
		Value: Bokio.Common.Contract.Services.UserPreferences.TestCompanyModalAction;
	}
	export enum TestCompanyModalAction {
		None = "None",
		CreateRealCompanyClicked = "CreateRealCompanyClicked",
		DismissedModal = "DismissedModal",
	}
	export interface TodoSettingsUserPreference {
		Value: Bokio.Common.Contract.Services.UserPreferences.TodoSettingsValue;
	}
	export interface TodoSettingsValue {
		SectionOrder?: Core.Contracts.Todo.TodoSectionType[];
		CollapsedSections?: Core.Contracts.Todo.TodoSectionType[];
	}
	export interface TryAgencyBannerDismissedPreference {
		Value: boolean;
	}
	export interface UserPreferencesDto {
		ShowAccountBalancePreference?: Bokio.Common.Contract.Services.UserPreferences.ShowAccountBalancePreference;
		AlwaysExpandVerificationPreview?: Bokio.Common.Contract.Services.UserPreferences.AlwaysExpandVerificationPreview;
		AreYouAnAccountantBannerDismissed?: Bokio.Common.Contract.Services.UserPreferences.AreYouAnAccountantBannerDismissedPreference;
		AutogiroRecipientTipDismissed?: Bokio.Common.Contract.Services.UserPreferences.AutogiroRecipientTipDismissedPreference;
		AutogiroTipNoticeDismissed?: Bokio.Common.Contract.Services.UserPreferences.AutogiroTipNoticeDismissedPreference;
		AutomationRulesDisplayInTransactionList?: Bokio.Common.Contract.Services.UserPreferences.AutomationRulesDisplayInTransactionListUserPreference;
		BbaCloseDownNoticeDismissedPreference?: Bokio.Common.Contract.Services.UserPreferences.BbaCloseDownNoticeDismissedPreference;
		BbaKycModalDismissedPreference?: Bokio.Common.Contract.Services.UserPreferences.BbaKycModalDismissedPreference;
		BbaPopupDismissed?: Bokio.Common.Contract.Services.UserPreferences.BbaPopupDismissedPreference;
		BbaTopBarOnboardingNoticePopoverDismissed?: Bokio.Common.Contract.Services.UserPreferences.BbaTopBarOnboardingNoticePopoverDismissedPreference;
		BbaTopBarOnboardingNotInterested?: Bokio.Common.Contract.Services.UserPreferences.BbaTopBarOnboardingNotInterestedPreference;
		BbaTopBarQuickAccessDismissed?: Bokio.Common.Contract.Services.UserPreferences.BbaTopBarQuickAccessDismissedPreference;
		BookkeepingSchoolGetStartedPreference?: Bokio.Common.Contract.Services.UserPreferences.BookkeepingSchoolGetStartedPreference;
		BrandLift2025AnnouncementPopupDismissed?: Bokio.Common.Contract.Services.UserPreferences.BrandLift2025AnnouncementPopupDismissedPreference;
		BusinessAccountCardCustomisation?: Bokio.Common.Contract.Services.UserPreferences.BusinessAccountCardCustomisationPreference;
		BusinessAccountFeatureInterestCollapsed?: Bokio.Common.Contract.Services.UserPreferences.BusinessAccountFeatureInterestCollapsedPreference;
		BusinessAccountFeatureInterestDismissed?: Bokio.Common.Contract.Services.UserPreferences.BusinessAccountFeatureInterestDismissedPreference;
		BusinessAccountFeatureInterestViewed?: Bokio.Common.Contract.Services.UserPreferences.BusinessAccountFeatureInterestViewedPreference;
		BusinessAccountPersonalBankGiroNoticeDismissed?: Bokio.Common.Contract.Services.UserPreferences.BusinessAccountPersonalBankGiroNoticeDismissedPreference;
		ClosureBannerDismissed?: Bokio.Common.Contract.Services.UserPreferences.ClosureBannerDismissedPreference;
		ClosureThingsTodoDismissed?: Bokio.Common.Contract.Services.UserPreferences.ClosureThingsTodoDismissed;
		CompanyDataStorageSettingsNoticePreference?: Bokio.Common.Contract.Services.UserPreferences.CompanyDataStorageSettingsNotice;
		ConnectClientCompaniesDismissed?: Bokio.Common.Contract.Services.UserPreferences.ConnectClientCompaniesDismissedPreference;
		CustomTemplatesTipNoticePreference?: Bokio.Common.Contract.Services.UserPreferences.CustomTemplatesTipNotice;
		DailyTakingsTrailingDatesInfoDismissed?: Bokio.Common.Contract.Services.UserPreferences.DailyTakingsTrailingDatesInfoDismissed;
		DraftVerificationTipDismissed?: Bokio.Common.Contract.Services.UserPreferences.DraftVerificationDismissedPreference;
		EInvoiceDiscoverabilityBannerDismissedPreference?: Bokio.Common.Contract.Services.UserPreferences.EInvoiceDiscoverabilityBannerDismissedPreference;
		EinvoicePaymentMethodMovedNoticeDismissed?: Bokio.Common.Contract.Services.UserPreferences.EinvoicePaymentMethodMovedNoticeDismissedUserPreference;
		EmployeeDetailsTipNopticePreference?: Bokio.Common.Contract.Services.UserPreferences.EmployeeDetailsTipNoptice;
		HideCashbackBannerPreference?: Bokio.Common.Contract.Services.UserPreferences.HideCashbackBannerPreference;
		HideOnboardingChecklistPreference?: Bokio.Common.Contract.Services.UserPreferences.HideOnboardingChecklistPreference;
		ImportantDatesInformationDismissed?: Bokio.Common.Contract.Services.UserPreferences.ImportantDatesInformationDismissedUserPreference;
		ImportantDatesRunWizardNoticeDismissed?: Bokio.Common.Contract.Services.UserPreferences.ImportantDatesRunWizardNoticeDismissed;
		InvoiceBusinessAccountPromoDismissed?: Bokio.Common.Contract.Services.UserPreferences.InvoiceBusinessAccountPromoDismissedPreference;
		LastReadWhatsNewDatePreference?: Bokio.Common.Contract.Services.UserPreferences.LastReadWhatsNewDatePreference;
		LinkBankAccountToDomesticPaymentPopup?: Bokio.Common.Contract.Services.UserPreferences.LinkBankAccountToDomesticPayment;
		MarketingSettingsPopupDismissed?: Bokio.Common.Contract.Services.UserPreferences.MarketingSettingsPopupDismissed;
		MathematicalExpressionTipNotice?: Bokio.Common.Contract.Services.UserPreferences.MathematicalExpressionTipNotice;
		MenuCurrentPlanCollapsed?: Bokio.Common.Contract.Services.UserPreferences.MenuCurrentPlanCollapsedPreference;
		MoveBankAccountNoticeDismissed?: Bokio.Common.Contract.Services.UserPreferences.MoveBankAccountNoticeDismissedPreference;
		OrderCardThingsToDoDismissed?: Bokio.Common.Contract.Services.UserPreferences.OrderCardThingsToDoDismissed;
		PDFV3PromoDismissed?: Bokio.Common.Contract.Services.UserPreferences.PDFV3PromoDismissedPreference;
		PremiumFeatureInterestDismissed?: Bokio.Common.Contract.Services.UserPreferences.PremiumFeatureInterestDismissedPreference;
		AutopilotFeatureInterestDismissed?: Bokio.Common.Contract.Services.UserPreferences.AutopilotFeatureInterestDismissedPreference;
		DealsFeatureInterestDismissed?: Bokio.Common.Contract.Services.UserPreferences.DealsFeatureInterestDismissedPreference;
		SalaryPricePlanChangesInfoDismissed?: Bokio.Common.Contract.Services.UserPreferences.SalaryPricePlanChangesInfoDismissed;
		ShowBookkeepingPredictionsPreference?: Bokio.Common.Contract.Services.UserPreferences.ShowBookkeepingPredictionsPreference;
		ShowDelightfulEffects?: Bokio.Common.Contract.Services.UserPreferences.ShowDelightfulEffectsPreference;
		ShowPricePlanChangeTopBar202309Preference?: Bokio.Common.Contract.Services.UserPreferences.ShowPricePlanChangeTopBar202309Preference;
		SideMenuVisited?: Bokio.Common.Contract.Services.UserPreferences.SideMenuVisitedUserPreference;
		SIEExportFeedbackSubmitted?: Bokio.Common.Contract.Services.UserPreferences.SIEExportFeedbackSubmittedPreference;
		StartBonusFeb2026BannerDismissed?: Bokio.Common.Contract.Services.UserPreferences.StartBonusFeb2026BannerDismissedPreference;
		StripeFeatureInterestResponse?: Bokio.Common.Contract.Services.UserPreferences.StripeFeatureInterestResponsePreference;
		TestCompanyBumperModalPreference?: Bokio.Common.Contract.Services.UserPreferences.TestCompanyBumperModalPreference;
		TodoSettings?: Bokio.Common.Contract.Services.UserPreferences.TodoSettingsUserPreference;
		TryAgencyBannerDismissed?: Bokio.Common.Contract.Services.UserPreferences.TryAgencyBannerDismissedPreference;
		VaxaSupportAppliedThroughSkatteverketInfoDismissed?: Bokio.Common.Contract.Services.UserPreferences.VaxaSupportAppliedThroughSkatteverketInfoDismissed;
	}
	export interface VaxaSupportAppliedThroughSkatteverketInfoDismissed {
		Value: boolean;
	}
}
export namespace Bokio.Common.Contract.Utils {
	export interface ListSortChoice<TProperties> {
		Property: TProperties;
		Direction: Bokio.Common.Contract.Utils.SortDirection;
	}
	export enum SortDirection {
		Asc = "Asc",
		Desc = "Desc",
	}
	export interface SuccessResultDto {
		Success: boolean;
	}
}
export namespace Bokio.Common.Contract.ViewData {
	export interface AddCommentRequestDto {
		TopicType: Entities.TopicType;
		TopicId: string;
		Comment: string;
		MentionedUserGuids?: string[];
	}
	export interface BokioPlanDto {
		PlanInfo: Bokio.Common.Contract.ViewData.PlanInfoDto;
		PlannedChange?: Bokio.Common.Contract.ViewData.PlannedChange;
		TrialPlanInfo?: Bokio.Common.Contract.ViewData.TrialPlanInfo;
	}
	export interface CalendarSubscriptionViewModel {
		SubscriptionUrl?: string;
		CreatedUtc?: Date;
	}
	export interface CommentDto {
		CommentId: string;
		Status: Entities.CommentStatus;
		OwnedByUser: boolean;
		DisplayName: string;
		Content: string;
		LastUpdated: Date;
		CreatedAt: Date;
	}
	export interface CompanyInvoicingNumber {
		InvoiceNumberAvailableRange: Bokio.Common.Contract.ViewData.CompanyNumberRange[];
		QuoteNumberAvailableRange: Bokio.Common.Contract.ViewData.CompanyNumberRange[];
		UsedCustomerNumbers: number[];
		InvoiceNumberPrefixMaxLength: number;
		CompanyCustomerNumber: number;
		CompanyInvoiceNumber: number;
		CompanyInvoiceNumberPrefix: string;
		CompanyQuoteNumber: number;
	}
	export interface CompanyNumberRange {
		Prefix: string;
		Min: number;
		Max: number;
	}
	export interface EditCommentRequestDto {
		CommentId: string;
		NewContent: string;
	}
	export interface InAppSalesTrackRequest {
		Type: Entities.Tracking.InAppSalesTrackingEventType;
		ViewPortWidth: number;
		ViewPortHeight: number;
	}
	export interface MemberedCompanyPlanDto {
		CompanyId: string;
		CompanyName: string;
		OrgNumber: string;
		RegisteredUtc: Date;
		PlanInfo: Bokio.Common.Contract.ViewData.PlanInfoDto;
		IsInTrial: boolean;
		IsTestCompany: boolean;
		Type: Entities.MembershipType;
		CompanySecurityRestriction: Entities.Security.CompanyLoginRestrictionType;
		UserHasNotPassedSecurityRestriction: boolean;
	}
	export interface PlanInfoDto {
		Plan: Entities.BokioPlan;
		IsAgencyPlan: boolean;
		IsTrialing: boolean;
		HasBothOwnPlanAndAgencyPlan: boolean;
	}
	export interface PlannedChange {
		Date: Day;
		Plan: Entities.BokioPlan;
	}
	export interface PricePlanAddonFeatureMapping {
		AvailableAsAddonIn: Entities.BokioPlan;
		AddonType: Bokio.Common.Contract.ViewData.PricePlanAddonType;
		AddonPrice: number;
		TrialDays?: number;
	}
	export enum PricePlanAddonType {
		None = "None",
		Invoices = "Invoices",
		Tags = "Tags",
		BankConnection = "BankConnection",
		APIIntegrations = "APIIntegrations",
	}
	export interface PricePlanFeatureInfo {
		Feature: Entities.PricePlanFeature;
		Available: boolean;
		InTrial: boolean;
		AvailableInTrial: boolean;
		AvailableIn: Entities.BokioPlan[];
		AvailableAsAddonIn: Bokio.Common.Contract.ViewData.PricePlanAddonFeatureMapping[];
	}
	export interface SupportMessageActiveDto {
		Id: string;
		Subject: string;
		BodyMarkdown: string;
		CreatedAt: Date;
		DisplayMode: Entities.Support.SupportMessageDisplayMode;
		MessageType: Entities.Support.SupportMessageType;
	}
	export interface SupportMessageResolvedDto {
		ResolvedByUserId: string;
		ResolvedByUserEmail: string;
		ResolvedAt: Date;
		Id: string;
		Subject: string;
		BodyMarkdown: string;
		CreatedAt: Date;
		DisplayMode: Entities.Support.SupportMessageDisplayMode;
		MessageType: Entities.Support.SupportMessageType;
	}
	export interface TrialPlanInfo {
		Start: Day;
		End: Day;
	}
	export interface VerificationRecordingResult {
		Id: string;
		VerificationNumber: string;
	}
}
export namespace Bokio.Common.Helpers {
	export enum SveaKycAction {
		NoActionRequired = "NoActionRequired",
		InfoMessage = "InfoMessage",
		BlockPayments = "BlockPayments",
	}
	export interface SveaKycInformationDto {
		RequiredAction: Bokio.Common.Helpers.SveaKycAction;
		Date?: Date;
		CanResume: boolean;
	}
}
export namespace Bokio.Common.Services.Comments {
	export interface MentionableUserInfo {
		Id: string;
		Name: string;
	}
}
export namespace Bokio.Common.Services.CompanySearch.UcBi {
	export enum SearchError {
		Unknown = "Unknown",
		GenericError = "GenericError",
		SearchIsTooShort = "SearchIsTooShort",
		HTTP500 = "HTTP500",
		RateLimitHit = "RateLimitHit",
	}
}
export namespace Bokio.Common.Services.ImportantDates {
	export interface ImportantDatesSetupAnswerDto {
		Question: Entities.ImportantDate.ImportantDatesSetupQuestion;
		Answer: Entities.ImportantDate.ImportantDateSetupAnswer;
	}
	export interface ImportantDatesSetupDto {
		Status: Entities.ImportantDate.ImportantDatesSetupStatus;
		CurrentQuestion: Entities.ImportantDate.ImportantDatesSetupQuestion;
	}
}
export namespace Bokio.Common.Services.Notifications.Dtos {
	export interface NotificationBookkeepTransactionItemRoute {
		ReceiptId: string;
		TransactionId: string;
	}
	export interface NotificationExpenseItemRoute {
		ReceiptId: string;
		ExpenseId: string;
	}
	export interface NotificationItemRouteDto {
		Transaction?: Bokio.Common.Services.Notifications.Dtos.NotificationTransactionItemRoute;
		Payroll?: Bokio.Common.Services.Notifications.Dtos.NotificationPayrollItemRoute;
		Payslip?: Bokio.Common.Services.Notifications.Dtos.NotificationPayslipItemRoute;
		Prebookkeep?: Bokio.Common.Services.Notifications.Dtos.NotificationPreBookkeepItemRoute;
		SupplierInvoice?: Bokio.Common.Services.Notifications.Dtos.NotificationSupplierInvoiceItemRoute;
		Verification?: Bokio.Common.Services.Notifications.Dtos.NotificationVerificationItemRoute;
		Expense?: Bokio.Common.Services.Notifications.Dtos.NotificationExpenseItemRoute;
		BookkeepTransaction?: Bokio.Common.Services.Notifications.Dtos.NotificationBookkeepTransactionItemRoute;
		QuoteRequestResponseType?: Bokio.Common.Services.Notifications.Dtos.NotificationQuoteRequestResponseItemRoute;
	}
	export interface NotificationPayrollItemRoute {
		IndependentPayrollId: string;
		PayDate: Day;
	}
	export interface NotificationPayslipItemRoute {
		PayslipId: string;
		Month: number;
		Year: number;
	}
	export interface NotificationPreBookkeepItemRoute {
		ReceiptId: string;
	}
	export interface NotificationQuoteRequestResponseItemRoute {
		isQuoteRequestRejected: boolean;
	}
	export interface NotificationSupplierInvoiceItemRoute {
		ReceiptId: string;
		SupplierInvoiceId: string;
	}
	export interface NotificationTransactionItemRoute {
		TransactionId: string;
		Account: number;
		IsOnlinePurchase: boolean;
	}
	export interface NotificationVerificationItemRoute {
		VerificationId?: string;
	}
}
export namespace Bokio.Common.Services.UserFeatureToggles {
	export interface UserFeatureToggleForDevViewModel {
		FeatureKey: Entities.UserFeatures;
		Enabled: boolean;
		Description: string;
	}
	export interface UserFeatureToggleViewModel {
		FeatureKey: Entities.UserFeatures;
		Enabled: boolean;
	}
}
export namespace Bokio.Common.Types {
	export interface SecretString {
		Value: string;
	}
}
export namespace Bokio.Common.Web.Helpers {
	export interface ImageData {
		Data: string;
		Name: string;
		Type: string;
	}
}
export namespace Bokio.Integration.Billing {
	export enum MockCardExpiryState {
		Normal = "Normal",
		ExpiringSoon = "ExpiringSoon",
		Expired = "Expired",
	}
}
export namespace Bokio.Integration.BokioPay.Auth {
	export interface BankIdQrCollectResponse {
		AnimatedQrCode: string;
	}
}
export namespace Bokio.Integration.HMRC {
	export interface FraudHeaderError {
		Code: string;
		Message: string;
		Headers: string[];
	}
	export interface VATFraudHeaderTestResponse {
		Code: string;
		Message: string;
		SpecVersion: string;
		Errors: Bokio.Integration.HMRC.FraudHeaderError[];
		Warnings: Bokio.Integration.HMRC.FraudHeaderError[];
		HeadersSent: string;
	}
}
export namespace Bokio.Integration.HubSpot {
	export interface LiveChatInfo {
		HubSpotVisitorToken?: string;
	}
}
export namespace Bokio.Integration.Plaid {
	export enum AccountType {
		Investment = "Investment",
		Credit = "Credit",
		Depository = "Depository",
		Loan = "Loan",
		Other = "Other",
	}
	export interface AddBankFeedConection {
		PublicKey: string;
		Metadata: Bokio.Integration.Plaid.MetadataDto;
	}
	export interface BankFeedEventDto {
		Type: Bokio.Integration.Plaid.PlaidQueueType;
		CompanyId: string;
	}
	export interface MetadataAccountDto {
		Id: string;
		Name: string;
		Mask: string;
		Type: Bokio.Integration.Plaid.AccountType;
	}
	export interface MetadataDto {
		Institution: Bokio.Integration.Plaid.MetadataInstitutionDto;
		Accounts: Bokio.Integration.Plaid.MetadataAccountDto[];
	}
	export interface MetadataInstitutionDto {
		InstitutionId: string;
		Name: string;
	}
	export interface PlaidQueueItemDto {
		ItemId: string;
		Type: Bokio.Integration.Plaid.PlaidQueueType;
	}
	export enum PlaidQueueType {
		FirstSync = "FirstSync",
		Continuous = "Continuous",
	}
	export interface RemoveBankFeedConection {
		BankId: string;
		KeepUnrecordedTransactions: boolean;
	}
}
export namespace Bokio.Integration.Svea.Contract {
	export enum LimitedApplicationStatus {
		__BOKIO_GOT_UNKNOWN_ENUM_FROM_SVEA__ = "__BOKIO_GOT_UNKNOWN_ENUM_FROM_SVEA__",
		Ongoing = "Ongoing",
		Finalizing = "Finalizing",
		Finalized = "Finalized",
		Cancelled = "Cancelled",
		OrderUnderReview = "OrderUnderReview",
	}
	export enum PsuPsuIdCardGetResponseItemStatus {
		__BOKIO_GOT_UNKNOWN_ENUM_FROM_SVEA__ = "__BOKIO_GOT_UNKNOWN_ENUM_FROM_SVEA__",
		Active = "Active",
		Inactive = "Inactive",
		Paused = "Paused",
		Terminated = "Terminated",
	}
}
export namespace Bokio.PublicApi.Web.Models {
	export interface CreatePublicApiPrivateIntegrationDto {
		Title: string;
		Scopes: Bokio.Common.Contract.PublicApi.PublicApiScope[];
	}
	export interface EditPublicApiPrivateIntegrationDto {
		ConnectionId: string;
		IntegrationId: string;
		Title: string;
		Scopes: Bokio.Common.Contract.PublicApi.PublicApiScope[];
	}
	export interface IntegrationMarketplaceCategoryDto {
		Value: Entities.PublicApi.IntegrationMarketplaceCategory;
	}
	export interface IntegrationMarketplaceIntegrationDetailDto {
		PublishInformationId: string;
		IntegrationId: string;
		IntegrationMarketplaceName: string;
		ShortDescription: string;
		LogoUrl?: string;
		PrimaryCategory: Entities.PublicApi.IntegrationMarketplaceCategory;
		Tags: string[];
		IsConnected: boolean;
		FullDescription: string;
		PriceModel?: string;
		ScreenshotUrls: string[];
		SupportUrl?: string;
		PrivacyPolicyUrl?: string;
		TermsOfServiceUrl?: string;
		ContactEmail?: string;
		AppWebsiteUrl?: string;
		DeveloperCompanyName: string;
		ConnectUrl: string;
		DisconnectUrl: string;
		IsPreview: boolean;
	}
	export interface IntegrationMarketplaceIntegrationListItemDto {
		PublishInformationId: string;
		IntegrationId: string;
		IntegrationMarketplaceName: string;
		ShortDescription: string;
		LogoUrl?: string;
		PrimaryCategory: Entities.PublicApi.IntegrationMarketplaceCategory;
		Tags: string[];
		IsConnected: boolean;
		MarketplacePublishType: Bokio.PublicApi.Web.Models.MarketplacePublishType;
		PoweredByBokioItem?: Bokio.PublicApi.Web.Models.PoweredByBokioItem;
		IsPreview: boolean;
	}
	export enum MarketplacePublishType {
		Public = "Public",
		PoweredByBokio = "PoweredByBokio",
	}
	export interface OAuthAccessibleCompanyDto {
		CompanyId: string;
		CompanyName: string;
		OrgNumber?: string;
		CompanyType: Entities.CompanyType;
		CompanySystem: Entities.CompanySystem;
		CurrentBokioPlan: Entities.BokioPlan;
		HasCompanySettings: boolean;
	}
	export interface PoweredByBokioItem {
		Key: string;
		NavigateToRoute: string;
	}
	export interface PublicApiPrivateIntegrationDto {
		Title: string;
		ConnectionId: string;
		IntegrationId: string;
		ApiUserId: string;
		Scopes: Bokio.Common.Contract.PublicApi.PublicApiScope[];
		CompanyId: string;
		Mode: Entities.PublicApi.Mode;
		AccessToken?: string;
	}
}
export namespace Bokio.Salary.Contract.Absences.Commands {
	export interface CreateAbsence {
		Id: string;
		StartDate: Day;
		EndDate?: Day;
		Type: Entities.Salary.AbsenceType;
		State: Entities.Salary.AbsenceState;
		EmployeeId: string;
	}
	export interface EditAbsence {
		Id: string;
		StartDate: Day;
		EndDate?: Day;
		Type: Entities.Salary.AbsenceType;
		State: Entities.Salary.AbsenceState;
		EmployeeId: string;
	}
}
export namespace Bokio.Salary.Contract.Employees.Commands {
	export interface CreateSalaryValues {
		PeriodSettingId: string;
		EmployeeId: string;
		SalaryValues: Entities.Salary.SalaryValues;
	}
	export interface DeletePeriodSetting {
		EmployeeId: string;
		PeriodSettingId: string;
	}
	export interface SetLastDateOfEmployment {
		EmployeeId: string;
		LastDate?: Day;
	}
	export interface UndoDeleteEmployee {
		EmployeeId: string;
	}
}
export namespace Bokio.Salary.Contract.Employees.Dtos {
	export interface CreateEmployeeAndPeriodSettingDto {
		EmployeeData: Entities.Salary.EmployeeData;
		PeriodSetting: Bokio.Salary.Contract.Employees.Dtos.EmployeePeriodSettingDto;
		UserToConnectId?: string;
	}
	export interface CreatePeriodSettingRequest {
		EmployeeId: string;
		PeriodSettings: Bokio.Salary.Contract.Employees.Dtos.EmployeePeriodSettingDto;
	}
	export interface CreateWithDetailsRequest {
		EmployeeData: Entities.Salary.EmployeeData;
		PayslipId?: string;
		Paydate?: Day;
	}
	export interface EditEmployeeAndPeriodSettingRequest {
		EmployeeId: string;
		EmployeeData: Entities.Salary.EmployeeData;
		PeriodSetting: Bokio.Salary.Contract.Employees.Dtos.EmployeePeriodSettingDto;
		PeriodSettingId: string;
	}
	export interface EditEmployeeRequest {
		EmployeeId: string;
		EmployeeData: Entities.Salary.EmployeeData;
		PayslipId?: string;
		Paydate?: Day;
	}
	export interface EditPeriodSettingRequest {
		PeriodSetting: Bokio.Salary.Contract.Employees.Dtos.EmployeePeriodSettingDto;
		EmployeeId: string;
		PeriodSettingId: string;
	}
	export interface EditVacationSettingsRequest {
		EmployeeId: string;
		PeriodSettingId: string;
		VacationSetting: Bokio.Salary.Contract.Employees.Dtos.EmployeeVacationSettingsDto;
	}
	export interface EmployeePeriodSettingDto {
		FromDate: Day;
		ToDate?: Day;
		Type: Entities.Salary.EmployeeType;
		TaxColumn: string;
		TaxTable: string;
		SalaryPeriod: Entities.Salary.SalaryPeriod;
		Salary: number;
		Workload: Entities.Salary.Workload;
		PartTimeRate: number;
		CompensationUnit: Entities.Salary.CompensationUnit;
		HoursPerWeek: number;
		SalaryValues: Bokio.Salary.Contract.Employees.Dtos.SalaryValuesDto;
		OriginalSalaryValues: Bokio.Salary.Contract.Employees.Dtos.SalaryValuesDto;
		VacationSettings: Bokio.Salary.Contract.Employees.Dtos.EmployeeVacationSettingsDto;
		VacationTrackingEnabled: boolean;
		JobTitle: string;
		IsEligibleForVaxaSupport: boolean;
		TaxCode: string;
		CategoryLetter: string;
		SalaryFrequency: Entities.Salary.SalaryFrequency;
		NICPaymentMethod: Entities.Salary.NICPaymentMethod;
		PlaceOfEmploymentId?: string;
	}
	export interface EmployeeVacationSettingsDto {
		VacationDays: number;
		IsEligibleForPrepaidVacation: boolean;
		DaysUsedThisPeriod: number;
		SavedDaysFromPreviousPeriod: number;
		PrepaidVacationDaysUsed: number;
		PrepaidVacationDaysLeft: number;
		MaxNewSavedDays: number;
		DiscardVacationDebtDate?: Day;
	}
	export interface SalaryValuesDto {
		HourlySalary: number;
		WeeklySalary: number;
		DailySalary: number;
		MonthlyVacationRate: number;
		HourlyVacationCompensationRate: number;
		SickSalaryRate: number;
		KarensDeduction: number;
	}
}
export namespace Bokio.Salary.Contract.Employees.Requests {
	export interface AddPlaceOfEmploymentRequest {
		Address: string;
		City: string;
	}
	export interface EmployeeStatusToUpdate {
		EmployeeId: string;
		NewStatus: Entities.Salary.EmployeeStatus;
	}
	export interface UpdateEmployeeStatusRequest {
		UpdateEmployeeStatuses: Bokio.Salary.Contract.Employees.Requests.EmployeeStatusToUpdate[];
	}
}
export namespace Bokio.Salary.Contract.Hmrc.Dtos {
	export interface HmrcFullPaymentSubmissionResponse {
		Checksum: Bokio.Salary.Contract.Hmrc.Dtos.HmrcSubmissionChecksum;
		ReceiptMessage: string;
		AcceptedTime: Date;
		Errors: Bokio.Salary.Contract.Hmrc.Dtos.HmrcXmlIntegrationError[];
	}
	export interface HmrcSubmissionChecksum {
		IRmark: string;
		IRmarkBase64: string;
	}
	export interface HmrcXmlIntegrationError {
		ErrorCode: string;
		Text: string;
		Location: string;
	}
}
export namespace Bokio.Salary.Contract.Hmrc.Requests {
	export interface CompleteRequest {
		DirectorsPayrollSetupFlowId: string;
	}
	export interface CreateDirectorRequest {
		DirectorsPayrollSetupFlowId: string;
		CreatingDirectorFor: Entities.Salary.CreatingDirectorFor;
		EmployeeId?: string;
	}
	export interface SaveDirectorDetailsRequest {
		DirectorsPayrollSetupFlowId: string;
		FirstNames: string;
		LastName: string;
		DateOfBirth: Day;
		NationalInsuranceNumber: string;
		Gender: Entities.Salary.DirectorGender;
		IsUkAddress: boolean;
		AddressLine1: string;
		AddressLine2: string;
		AddressLine3: string;
		PostalCode: string;
	}
	export interface SaveEmployementDetailsRequest {
		DirectorsPayrollSetupFlowId: string;
		EmployeeNumber: string;
		EmployementStartDate: Day;
		PayrollInterval: Entities.Salary.SalaryFrequency;
		HoursWorkedCategory: Entities.Salary.HoursWorkedCategory;
	}
	export interface SaveTaxesRequest {
		DirectorsPayrollSetupFlowId: string;
		TaxCode: string;
		HasEmergencyTaxCode: boolean;
		PreviousTaxablePay: number;
		PreviousTaxPaid: number;
		TaxesStarterType: Entities.Salary.DirectorPayrollSetupFlowTaxesStarterType;
		StarterDeclaration: Entities.Salary.DirectorPayrollSetupFlowTaxesStarterDeclaration;
		StudentLoans: Bokio.Salary.Contract.Hmrc.Requests.UkStudentLoanDto[];
		EmployerPreviousNIC?: number;
		EmployeePreviousNIC?: number;
		NicPaymentMethod: Entities.Salary.NICPaymentMethod;
	}
	export interface SendFullPaymentSubmissionRequest {
		IndependentPayrollId: string;
		LateSubmissionReasonCode: string;
		IsFinalSubmission: boolean;
	}
	export interface SetupEmployerRequest {
		DirectorsPayrollSetupFlowId?: string;
		PAYEReference: string;
		AccountsOfficeReference: string;
		COTAXReference: string;
		HmrcUserId: Bokio.Common.Types.SecretString;
		HmrcPassword: Bokio.Common.Types.SecretString;
	}
	export interface UkStudentLoanDto {
		Id?: string;
		Type: Entities.Salary.UkStudentLoanType;
		FromDate: Day;
		ToDate: Day;
	}
}
export namespace Bokio.Salary.Contract.Payrolls.Commands {
	export interface BookkeepSalaries {
		Month: number;
		Year: number;
		IndependentPayrollId?: string;
		Account?: number;
		VerificationDate?: Date;
	}
	export interface LockPayroll {
		Year: number;
		Month: number;
		PayDate?: Day;
		IndependentPayrollId?: string;
		ReportId: string;
	}
	export interface SetPayrollNetAdjustments {
		Year: number;
		Month: number;
		IndependentPayrollId?: string;
		Mappings: Entities.Salary.NetAdjustmentMapping[];
	}
	export interface SetPayrollPaydate {
		Year: number;
		Month: number;
		IndependentPayrollId?: string;
		PayDate: Day;
	}
	export interface UndoBookkeepMonthSalaries {
		Month: number;
		Year: number;
		IndependentPayrollId?: string;
	}
	export interface UndoBookkeepMonthTax {
		Month: number;
		Year: number;
	}
	export interface UnlockPayroll {
		Year: number;
		Month: number;
		PayDate?: Day;
		IndependentPayrollId?: string;
	}
}
export namespace Bokio.Salary.Contract.Payrolls.Dtos {
	export interface AdvancedPayrollOnboardingViewModel {
		OnboardingStatus: Bokio.Salary.Contract.Payrolls.Dtos.AdvancedPayrollSystemOnboardingStatus;
	}
	export enum AdvancedPayrollSystemOnboardingStatus {
		NotStarted = "NotStarted",
		Pending = "Pending",
		Accepted = "Accepted",
		Rejected = "Rejected",
		Connected = "Connected",
		Offboarded = "Offboarded",
	}
	export interface AdvancedPayrollVerificationList {
		Verifications: Bokio.Salary.Contract.Payrolls.Dtos.AdvancedPayrollVerificationListItem[];
	}
	export interface AdvancedPayrollVerificationListItem {
		Id: string;
		VerificationNumber: string;
		Date: Day;
		Title: string;
	}
	export interface CreatePayslipsDto {
		Year: number;
		Month: number;
		PayDate?: Day;
		IndependentPayrollId?: string;
		EmployeeIds: string[];
	}
	export interface FullPaymentSubmissionResult {
		WasSuccessful: boolean;
		HmrcFullPaymentSubmissionResponse: Bokio.Salary.Contract.Hmrc.Dtos.HmrcFullPaymentSubmissionResponse;
		RequestTimeout: boolean;
		RequestedTime: Date;
	}
	export interface P45ViewModel {
		LastDayOfEmployment: Day;
	}
	export interface P60ViewModel {
		FromYear: string;
		ToYear: string;
		PayrollId: string;
	}
	export interface PayrollExportDto {
		CorrectedBy?: string;
		ExportDate: Day;
		IsCorrection: boolean;
		PayDate?: Day;
		VerificationDate: Day;
		VerificationId?: string;
		VerificationNumber: string;
		VerificationTitle: string;
		IsTaxVerification: boolean;
		Year: number;
		Month: number;
		IndependentPayrollId?: string;
	}
}
export namespace Bokio.Salary.Contract.Payrolls.Requests {
	export interface CreateIndependentPayrollRequest {
		PayDate: Day;
		SalaryPaymentMethod: Entities.Salary.SalaryPaymentMethod;
		PayrollTemplateId?: string;
		ParentId?: string;
		SalaryFrequency?: Entities.Salary.SalaryFrequency;
		UnlockTaxPeriod: boolean;
	}
	export interface CreateTestCompanyQuickPayrollRequest {
		EmployeeData: Entities.Salary.EmployeeData;
		PeriodSetting: Bokio.Salary.Contract.Employees.Dtos.EmployeePeriodSettingDto;
		PaymentDate: Day;
	}
	export interface GroupedPayrollPaymentRequest {
		PayslipId: string;
		RequestedAmount: number;
	}
	export interface SchedulePayrollPaymentRequest {
		IndependentPayrollId: string;
		RequestedPaymentDate: Day;
		PaymentRequests: Bokio.Salary.Contract.Payrolls.Requests.GroupedPayrollPaymentRequest[];
	}
	export interface SetPayrollPaymentDataRequest {
		Year: number;
		Month: number;
		TaxPaymentDate: Day;
		SocialFeeDiscount: number;
	}
}
export namespace Bokio.Salary.Contract.Payslips.Commands {
	export interface AddPayslipRow {
		Type: Entities.Salary.PayslipRowType;
		Category: string;
		SubCategory: string;
		PayslipId: string;
		RowId: string;
		Label: string;
		Amount?: number;
		Cost: number;
		Total: number;
		Unit: string;
		Workload?: number;
	}
	export interface AddPayslipRows {
		Rows: Bokio.Salary.Contract.Payslips.Commands.AddPayslipRow[];
	}
	export interface DeletePayslip {
		PayslipId: string;
	}
	export interface DeletePayslipRow {
		RowId: string;
	}
	export interface EditPayslipRow {
		RowId: string;
		PayslipId: string;
		Amount: number;
		Cost: number;
		OverriddenCost?: number;
		OverriddenAccrueVacation?: boolean;
		OverriddenWorkload?: number;
		Unit: string;
		Type: Entities.Salary.PayslipRowType;
		Note: string;
		CarModel: string;
		RegionCode: string;
		FromDate?: Day;
		ToDate?: Day;
	}
}
export namespace Bokio.Salary.Contract.Payslips.Dtos {
	export interface CreatePayslipsViewModel {
		PayslipIds: string[];
	}
	export enum PayslipErrorType {
		Error = "Error",
		OverridableError = "OverridableError",
		UnsupportedColumnError = "UnsupportedColumnError",
	}
}
export namespace Bokio.Salary.Contract.Payslips.Requests {
	export interface UpdateUkSalaryRowRequest {
		PayslipId: string;
		NewSalary: number;
	}
}
export namespace Bokio.Salary.Contract.Requests {
	export interface SetV1CompanyVacationSettingsRequest {
		VacationYearStartDate?: Day;
		VacationTrackingEnabled: boolean;
		DefaultEmployeeSettings: Entities.Salary.AdvancedEmployeeSettings;
	}
	export interface SetV1SalarySettingsRequest {
		Contact: Entities.ContactPerson;
		DefaultEmployeeSettings: Entities.Salary.AdvancedEmployeeSettings;
	}
}
export namespace Bokio.Salary.Contract.Vacation.Dtos {
	export interface VacationYearEndBalanceHistory {
		Rows: Bokio.Salary.Contract.Vacation.Dtos.VacationYearEndBalanceHistoryRow[];
	}
	export interface VacationYearEndBalanceHistoryRow {
		VacationType: Entities.Salary.VacationType;
		Id: string;
		Type: string;
		Description: string;
		Amount: number;
		Cost: number;
		Total: number;
		TransactionDate: Day;
		PayslipId?: string;
		PayslipDate?: Day;
	}
	export enum VacationYearEndError {
		None = "None",
		NotFound = "NotFound",
	}
}
export namespace Bokio.Salary.Contract.Vacation.Requests {
	export interface EnableVacationTrackingRequest {
		PeriodSettingId: string;
	}
}
export namespace Bokio.Salary.Services {
	export namespace PayrollSystemApplicationConstants {
		export const NmbrsProductionIntegrationId = "340a2f64-eeb4-44fc-b685-569239c7d6a8";
		export const NmbrsTestCompaniesIntegrationId = "db904276-ee95-4db5-8816-5d4c9c5b9a0d";
	}
}
export namespace Bokio.Salary.Web.Controllers {
	export enum AGIErrors {
		MonthNotLocked = "MonthNotLocked",
		AGINotSupported = "AGINotSupported",
	}
	export interface AGIViewModel {
		XML: string;
		Validation: string[];
	}
	export interface CreateEmployeeAndPeriodSettingResult {
		Employee: Bokio.Salary.Web.Viewmodels.Employees.EmployeeDetails;
		PeriodSetting: Bokio.Salary.Web.Viewmodels.Employees.EmployeePeriodSettingViewModel;
	}
	export interface EmployeesInfoForMonthViewModel {
		FirstEmployeeId?: string;
		NumberOfEmployeesWithPayslip: number;
	}
	export interface GetFirstEmployeeRequest {
		Year: number;
		Month: number;
	}
	export interface NetAdjustmentDto {
		RowId: string;
		EmployeeName: string;
		RowDescription: string;
		Account?: number;
		Total: number;
	}
	export interface NetAdjustmentViewModel {
		Dtos: Bokio.Salary.Web.Controllers.NetAdjustmentDto[];
	}
	export interface SalarySettingsViewModel {
		CompanyId: string;
		HasContact: boolean;
		Contact: Entities.ContactPerson;
		DefaultEmployeeSettings: Entities.Salary.AdvancedEmployeeSettings;
		SettingsVersion: number;
		VacationYearStartDate?: Day;
		IsDefaultSetting: boolean;
		VacationTrackingEnabled: boolean;
	}
	export interface SetupCompanyForSalariesDto {
		NextSalaryDay: Day;
		CreateEmployeeResult: Bokio.Salary.Web.Controllers.CreateEmployeeAndPeriodSettingResult;
	}
	export interface YearlySummaryResult {
		PaidVacationDays: number;
		SavedVacationDays: number;
		Gross: number;
		Benefits: number;
		IncomeTax: number;
	}
}
export namespace Bokio.Salary.Web.Viewmodels {
	export interface BookkeepTaxRequest {
		Month: number;
		Year: number;
		Account?: number;
	}
	export interface CompanyViewModel {
		Id: string;
		SenderData: Entities.InvoiceSenderData;
		Payday: number;
	}
}
export namespace Bokio.Salary.Web.Viewmodels.Absences {
	export interface AbsenceDetails {
		Id: string;
		StartDate: Day;
		EndDate?: Day;
		Type: Entities.Salary.AbsenceType;
		State: Entities.Salary.AbsenceState;
		EmployeeId: string;
		EmployeeName: string;
		Days: Bokio.Salary.Web.Viewmodels.Absences.AbsenceDetailsDay[];
	}
	export interface AbsenceDetailsDay {
		Id: string;
		AbsenceFactor: number;
		Date: Day;
	}
	export interface AbsenceForList {
		Id: string;
		StartDate: Day;
		EndDate?: Day;
		Type: Entities.Salary.AbsenceType;
		State: Entities.Salary.AbsenceState;
		EmployeeId: string;
		EmployeeName: string;
		AffectedDays: number;
	}
}
export namespace Bokio.Salary.Web.Viewmodels.Ads {
	export interface PensionCalloutMetadataViewModel {
		CompanyId: string;
		UserId: string;
		Status: Entities.Salary.CalloutStatus;
		Type: Entities.Salary.CalloutType;
	}
}
export namespace Bokio.Salary.Web.Viewmodels.Employees {
	export interface CompanyEmployee {
		UserId?: string;
		User: Bokio.Salary.Web.Viewmodels.Employees.CompanyUser;
		Id: string;
		InvitationPending: boolean;
		FirstName: string;
		LastName: string;
		Email: string;
	}
	export interface CompanyUser {
		Id: string;
		FirstName: string;
		LastName: string;
		Email: string;
		AccessLevel: Bokio.Salary.Web.Viewmodels.Employees.MembershipAccessLevel;
	}
	export interface CreateDraftEmployeeDto {
		EmployeeData: Entities.Salary.EmployeeData;
		UserToConnectId?: string;
	}
	export interface EmployeeBillingPlanViewModel {
		PlanName: string;
		NrOfFreeSeats: number;
		PricePerExtraSeat?: number;
		NrOfActiveEmployees: number;
		FreeSeatOverrideValidUntil?: Day;
		IsSalaryAvailable: boolean;
		MaxNrOfSeats: number;
	}
	export interface EmployeeDetails {
		UserId?: string;
		Id: string;
		EmployeeData: Entities.Salary.EmployeeData;
		IsDeleted: boolean;
		InvitationPending: boolean;
		UserName: string;
		CompanyId: string;
		HasVactionSetting: boolean;
		IsEmployeeFormComplete: boolean;
		IsContractFormComplete: boolean;
		IsOwner: boolean;
		IsInvalidContract: boolean;
		HasPayslips: boolean;
		Status: Entities.Salary.EmployeeStatus;
		EmployeePeriodSetting: Entities.Salary.EmployeePeriodSetting;
	}
	export interface EmployeeForList {
		FirstName: string;
		LastName: string;
		Id: string;
		UserId?: string;
	}
	export interface EmployeePeriodSettingsOperationsViewModel {
		IsEditAllowed: boolean;
		IsDeleteAllowed: boolean;
	}
	export interface EmployeePeriodSettingViewModel {
		Id: string;
		EmployeeId: string;
		Employee: Entities.Salary.Employee;
		FromDate: Day;
		ToDate?: Day;
		Type: Entities.Salary.EmployeeType;
		TaxColumn: string;
		TaxTable: string;
		SalaryPeriod: Entities.Salary.SalaryPeriod;
		Salary: number;
		Workload: Entities.Salary.Workload;
		PartTimeRate: number;
		CompensationUnit: Entities.Salary.CompensationUnit;
		HoursPerWeek: number;
		SalaryValues: Entities.Salary.SalaryValues;
		OriginalSalaryValues: Entities.Salary.SalaryValues;
		VacationSettings: Entities.Salary.EmployeeVacationSettings;
		JobTitle: string;
		HasSocialSecurityNumber: boolean;
		IsEligibleForVaxaSupport: boolean;
		IsEmployeeFormComplete: boolean;
		IsDeleted: boolean;
		VacationTrackingEnabled: boolean;
		IsInvalidContract: boolean;
		TaxCode: string;
		CategoryLetter: string;
		SalaryFrequency: Entities.Salary.SalaryFrequency;
		NICPaymentMethod: Entities.Salary.NICPaymentMethod;
		PlaceOfEmploymentId?: string;
		PlaceOfEmployment?: Bokio.Salary.Web.Viewmodels.Employees.PlaceOfEmploymentViewModel;
	}
	export interface EmployeeWithPeriodSettings {
		UserId?: string;
		Id: string;
		EmployeeData: Entities.Salary.EmployeeData;
		IsDeleted: boolean;
		InvitationPending: boolean;
		UserName: string;
		CompanyId: string;
		HasVactionSetting: boolean;
		IsEmployeeFormComplete: boolean;
		CurrentPeriodSetting: Bokio.Salary.Web.Viewmodels.Employees.EmployeePeriodSettingViewModel;
		IsInvalidContract: boolean;
		IsContractFormComplete: boolean;
		Status: Entities.Salary.EmployeeStatus;
		IsDeactivationAllowed: boolean;
		EmployeeNo: string;
		EmployeePeriodSettings: Bokio.Salary.Web.Viewmodels.Employees.EmployeePeriodSettingViewModel[];
		VacationBalance: Bokio.Salary.Web.Viewmodels.Vacation.VacationBalanceDetail;
	}
	export interface ExpenseEmployees {
		Employees: Bokio.Salary.Web.Viewmodels.Employees.CompanyEmployee[];
		Users: Bokio.Salary.Web.Viewmodels.Employees.CompanyUser[];
	}
	export interface JobTitleList {
		JobTitle: string;
	}
	export interface MembershipAccessLevel {
		ViewBookkeeping: boolean;
		Bookkeep: boolean;
		UploadReceipt: boolean;
		UploadBank: boolean;
		Closures: boolean;
		Partner: boolean;
		Reports: boolean;
		SupportUser: boolean;
		Attest: boolean;
		Disbursements: boolean;
		UploadExpense: boolean;
		Salaries: boolean;
		Invoices: boolean;
		AccountingSettings: boolean;
		InvoiceSettings: boolean;
		SalarySettings: boolean;
		CompanySettings: boolean;
		Inbox: boolean;
		AdminUsers: boolean;
		InquiryAssign: boolean;
		SupplierInvoices: boolean;
		BbaAccess: boolean;
	}
	export interface PlaceOfEmploymentViewModel {
		Id: string;
		Address: string;
		City: string;
	}
	export interface RequiredDataForEmployeeActivationViewModel {
		OrganisationNumber: string;
		CompanyName: string;
		City: string;
		PostalCode: string;
		Street1: string;
		ContactName: string;
		Email: string;
		SalaryEmail: string;
		SalaryFirstName: string;
		SalaryLastName: string;
		SalaryTelephoneNumber: string;
	}
}
export namespace Bokio.Salary.Web.Viewmodels.Hmrc {
	export interface DirectorsPayrollEmployeeData {
		EmployeeId?: string;
		Email: string;
		IsConnectedToUser: boolean;
		UserId?: string;
		InvitationStatus?: Entities.CompanyInvitationStatus;
	}
	export interface DirectorsPayrollSetupFlowDto {
		Id: string;
		CompanyId: string;
		Status: Entities.Salary.DirectorsPayrollSetupFlowStatus;
		CreatingDirectorFor?: Entities.Salary.CreatingDirectorFor;
		EmployeeData: Bokio.Salary.Web.Viewmodels.Hmrc.DirectorsPayrollEmployeeData;
		EmployerPAYEReference: string;
		AccountsOfficeReference: string;
		COTAXReference: string;
		HasSavedHmrcCredentials: boolean;
		FirstNames: string;
		LastName: string;
		DateOfBirth?: Day;
		NationalInsuranceNumber: string;
		Gender?: Entities.Salary.DirectorGender;
		IsUkAddress?: boolean;
		AddressLine1: string;
		AddressLine2: string;
		AddressLine3: string;
		PostalCode: string;
		EmployementNumber: string;
		EmployementStartDate?: Day;
		PayrollInterval?: Entities.Salary.SalaryFrequency;
		HoursWorkedCategory?: Entities.Salary.HoursWorkedCategory;
		TaxesStarterType?: Entities.Salary.DirectorPayrollSetupFlowTaxesStarterType;
		StarterDeclaration?: Entities.Salary.DirectorPayrollSetupFlowTaxesStarterDeclaration;
		TaxCode: string;
		EmergencyTaxCode?: Entities.Salary.EmergencyTaxCode;
		PreviousTaxablePay?: number;
		PreviousTaxPaid?: number;
		StudentLoans: Bokio.Salary.Web.Viewmodels.StudentLoans.UkStudentLoanViewModel[];
		HmrcUserId: Bokio.Common.Types.SecretString;
		HmrcPassword: Bokio.Common.Types.SecretString;
		PeriodSettingsId?: string;
		HasEmergencyTaxCode: boolean;
		EmployerPreviousNIC?: number;
		EmployeePreviousNIC?: number;
		NicPaymentMethod: Entities.Salary.NICPaymentMethod;
	}
}
export namespace Bokio.Salary.Web.Viewmodels.Payrolls {
	export interface CategoryViewModel {
		Name: string;
		Type: string;
		Rule: string;
		Sub: Bokio.Salary.Web.Viewmodels.Payrolls.SubCategoryViewModel[];
		Key: string;
		Translation: string;
		IgnoreOnCopyToNext: boolean;
		CostOverridable: boolean;
		ShouldShow: boolean;
	}
	export interface DeleteIndependentPayrollRequest {
		IndependentPayrollId: string;
	}
	export interface EmailPayslipsRequest {
		PayDate?: Day;
		IndependentPayrollId?: string;
		SendFiles: boolean;
	}
	export interface EmployeeSummaryRow {
		Year: number;
		Month: number;
		PeriodFrom: Day;
		PeriodTo: Day;
		Id: string;
		Firstname: string;
		Lastname: string;
		SocialSecurityNumber: string;
		IsLocked: boolean;
		Gross: number;
		Net: number;
		Tax: number;
		SocialTax: number;
		Total: number;
		BankIdentifier: string;
		BankAccount: string;
		ExemptFromLoweredSocialTaxDueToCovid: boolean;
		PayDate: Day;
		HasUser: boolean;
		IndependentPayrollId?: string;
		HasBookkeepableRows: boolean;
		TellerTransactionStatus: Entities.Teller.TellerTransactionStatus;
		EmployeeId: string;
		VacationTrackingEnabled: boolean;
		HasValidBankDetails: boolean;
		TellerPaymentStatus: Entities.Teller.TellerPaymentStatus;
		StudentLoanDeductionsUK: number;
		EmployeeNationalInsuranceContributionUK: number;
		LastDayOfEmployment?: Day;
	}
	export enum FullPaymentSubmissionHmrcStatus {
		Successful = "Successful",
		Pending = "Pending",
		Timeout = "Timeout",
		Blocked = "Blocked",
		NotSent = "NotSent",
	}
	export interface GroupedPayrollPaymentViewModel {
		PayslipId: string;
		PaymentInfo: Bokio.Bank.Contract.Teller.Dtos.TellerPaymentForGroupInfoDto;
	}
	export interface LockPayrollErrorItem {
		PropertyName: string;
		Message: string;
	}
	export interface LockPayrollResult {
		FaultyPayslips: { [key: string]: Bokio.Salary.Web.Viewmodels.Payrolls.LockPayrollErrorItem[]; };
		Success: boolean;
		Payslips: Bokio.Salary.Web.Viewmodels.Payslips.PayslipViewModel[];
	}
	export interface ManuallyRecordPayrollRequest {
		IsManuallyRecorded: boolean;
		IndependentPayrollId?: string;
	}
	export interface ManuallyRecordTaxrollRequest {
		IsManuallyRecorded: boolean;
	}
	export enum PayrollPaymentStatus {
		None = "None",
		AwaitingApproval = "AwaitingApproval",
		Signed = "Signed",
		Completed = "Completed",
		Canceled = "Canceled",
		Rejected = "Rejected",
	}
	export interface PayrollTellerPaymentViewModel {
		IndependentPayrollId?: string;
		GroupInfo: Bokio.Bank.Contract.Teller.Dtos.TellerPaymentGroupInfoDto;
		Payments: Bokio.Salary.Web.Viewmodels.Payrolls.GroupedPayrollPaymentViewModel[];
	}
	export interface SetExemptFromLoweredSocialTaxDueToCovidRequest {
		PayslipId: string;
		ExemptFromLoweredSocialTaxDueToCovid: boolean;
	}
	export interface SetIndependentPayrollIntervalRequest {
		IndependentPayrollId: string;
		PayrollInterval: Entities.Salary.SalaryFrequency;
	}
	export interface SetIndependentPayrollPaymentMethodRequest {
		IndependentPayrollId: string;
		PaymentMethod: Entities.Salary.SalaryPaymentMethod;
	}
	export interface SubCategoryViewModel {
		Name: string;
		Slug: string;
		Key: string;
		Rule: string;
		Translation: string;
		IgnoreOnCopyToNext: boolean;
		CostOverridable: boolean;
		AccrueVacationOverridable: boolean;
		AccrueVacationByDefault: boolean;
		ShouldShow: boolean;
	}
	export interface SummaryRow {
		Id: string;
		Firstname: string;
		Lastname: string;
		SocialSecurityNumber: string;
		IsLocked: boolean;
		Gross: number;
		Net: number;
		Tax: number;
		SocialTax: number;
		Total: number;
		BankIdentifier: string;
		BankAccount: string;
		ExemptFromLoweredSocialTaxDueToCovid: boolean;
		PayDate: Day;
		HasUser: boolean;
		IndependentPayrollId?: string;
		HasBookkeepableRows: boolean;
		TellerTransactionStatus: Entities.Teller.TellerTransactionStatus;
		EmployeeId: string;
		VacationTrackingEnabled: boolean;
		HasValidBankDetails: boolean;
		TellerPaymentStatus: Entities.Teller.TellerPaymentStatus;
		StudentLoanDeductionsUK: number;
		EmployeeNationalInsuranceContributionUK: number;
		LastDayOfEmployment?: Day;
	}
	export interface SummaryViewModel {
		TotalNet: number;
		TotalTax: number;
		TotalSocialTax: number;
		Total: number;
		Payslips: Bokio.Salary.Web.Viewmodels.Payrolls.SummaryRow[];
		TotalGross: number;
		PayDate: Day;
		IndependentPayrollId?: string;
		SalaryPaymentMethod: Entities.Salary.SalaryPaymentMethod;
		IsLocked: boolean;
		IsSalaryTaxPeriodLocked: boolean;
		IsRecorded: boolean;
		IsTaxRecorded: boolean;
		IsPaid: boolean;
		IsDefaultPayroll: boolean;
		TaxDate: Day;
		TaxPaymentDate: Day;
		SocialFeeDiscount: number;
		NetAdjustmentMappings: Entities.Salary.NetAdjustmentMapping[];
		ReportSystem: Classes.SystemName;
		IsNetAdjustmentBlocked: boolean;
		BookkeepingExport: Bokio.Salary.Contract.Payrolls.Dtos.PayrollExportDto;
		TaxBookkeeping: Bokio.Salary.Contract.Payrolls.Dtos.PayrollExportDto;
		NeedToSetSalarySettings: boolean;
		PublishBlockReason: string;
		PayrollPaymentStatus: Bokio.Salary.Web.Viewmodels.Payrolls.PayrollPaymentStatus;
		PayrollInterval: Entities.Salary.SalaryFrequency;
		IndependentPayrollParentId?: string;
		IsPayrollManuallyRecorded: boolean;
		IsTaxrollManuallyRecorded: boolean;
		IsLatestPayroll: boolean;
		IsFinalSubmissionUk: boolean;
		MaxAllowedPayDate?: Day;
		FpsSubmissionStatus: Bokio.Salary.Web.Viewmodels.Payrolls.FullPaymentSubmissionHmrcStatus;
		PayslipsEmailedAt?: Day;
	}
}
export namespace Bokio.Salary.Web.Viewmodels.Payslips {
	export interface CalculationResultViewModel {
		Errors: Core.Salary.Calculations.PayslipError[];
		Gross: number;
		Net: number;
		TaxBenefit: number;
		TaxFree: number;
		Incometax: number;
		Deductions: number;
		SocialTax: number;
		RoundingDiff: number;
		RowResults: { [key: string]: Bokio.Salary.Web.Viewmodels.Payslips.PayslipRowViewModel; };
	}
	export interface PayslipRowViewModel {
		Id: string;
		Category: string;
		SubCategory: string;
		Label: string;
		PayslipId: string;
		Type: Entities.Salary.PayslipRowType;
		Note: string;
		Rule: string;
		Amount: number;
		Cost: number;
		OverriddenCost?: number;
		OverriddenAccrueVacation?: boolean;
		OverriddenWorkload?: number;
		Total: number;
		Unit: string;
		IsValid: boolean;
		Errors: string[];
		CarModel: string;
		CarName: string;
		RegionCode: string;
		Warning: boolean;
		FromDate?: Day;
		ToDate?: Day;
		DefaultAmount: number;
		DefaultCost: number;
		DefaultTotal: number;
	}
	export interface PayslipViewModel {
		Id: string;
		EmployeeData: Entities.Salary.EmployeeData;
		PeriodFrom: Day;
		PeriodTo: Day;
		PayDate: Day;
		Year: number;
		Month: number;
		Locked: boolean;
		TaxTotal: number;
		SocialTaxRate: number;
		SocialTaxTotal: number;
		GrossIncome: number;
		NetTotal: number;
		SenderData: Entities.InvoiceSenderData;
		Rows: Bokio.Salary.Web.Viewmodels.Payslips.PayslipRowViewModel[];
		EmployeeId: string;
		EmployeePeriodSettingId?: string;
		IndependentPayrollId?: string;
		EmployeeType: Entities.Salary.EmployeeType;
		VacationBalanceDetail: Bokio.Salary.Web.Viewmodels.Vacation.VacationBalanceDetail;
	}
}
export namespace Bokio.Salary.Web.Viewmodels.Reports {
	export interface GroupedEmployeesViewModel {
		Permanent: Bokio.Salary.Web.Viewmodels.Employees.EmployeeForList[];
		Hourly: Bokio.Salary.Web.Viewmodels.Employees.EmployeeForList[];
	}
	export interface HourlyPaidRow {
		SalaryHours: number;
		SalaryTotal: number;
		OvertimeTotal: number;
		OddHourTotal: number;
		HazardPayTotal: number;
		EmployeeId: string;
		EmployeeName: string;
		PayslipId: string;
		PayslipDate: Day;
	}
	export interface HourlyPaidViewModel {
		Rows: Bokio.Salary.Web.Viewmodels.Reports.HourlyPaidRow[];
		DateRange: Bokio.Salary.Web.Viewmodels.Reports.ReportDateRange;
		EmployeeNames: string[];
	}
	export interface ReportDateRange {
		From: Day;
		To: Day;
	}
	export interface SalaryReportRequest {
		EmployeeIds: string[];
		JobTitles: string[];
		From?: Day;
		To?: Day;
	}
	export interface SalaryTotalRow {
		GrossIncome: number;
		NetIncome: number;
		Benefits: number;
		IncomeTax: number;
		SocialTaxTotal: number;
		JobTitle: string;
		EmployeeId: string;
		EmployeeName: string;
		PayslipId: string;
		PayslipDate: Day;
	}
	export interface SalaryTotalViewModel {
		Rows: Bokio.Salary.Web.Viewmodels.Reports.SalaryTotalRow[];
		DateRange: Bokio.Salary.Web.Viewmodels.Reports.ReportDateRange;
		EmployeeNames: string[];
	}
	export interface SickDayPayslipRow {
		SickLeavePosts: number;
		ReducedSalaryDays: number;
		HasQualifyDay: boolean;
		ReducedSalaryHours: number;
		EmployeeId: string;
		EmployeeName: string;
		PayslipId: string;
		PayslipDate: Day;
	}
	export interface SickDayRow {
		SickDays: number;
		SickHours: number;
		EmployeeId: string;
		EmployeeName: string;
		PayslipId: string;
		PayslipDate: Day;
	}
	export interface SickDaysViewModel {
		Rows: Bokio.Salary.Web.Viewmodels.Reports.SickDayRow[];
		DateRange: Bokio.Salary.Web.Viewmodels.Reports.ReportDateRange;
		EmployeeNames: string[];
	}
	export interface SocialFeeBirthYearBracket {
		BirthYearIntervalStart?: number;
		BirthYearIntervalEnd?: number;
		SocialFeeRate: number;
	}
	export interface VacationDebtReportRequest {
		JobTitles: string[];
		DebtAt?: Day;
	}
	export interface VacationDebtReportRow {
		EmployeeId: string;
		EmployeeName: string;
		JobTitle: string;
		BirthYear: number;
		AccruedDays: number;
		AccruedDaysValue: number;
		AccruedCompensationValue: number;
		PaidDays: number;
		PaidDaysValue: number;
		SavedDays: number;
		SavedDaysValue: number;
		UnpaidCompensationValue: number;
		PrepaidDays: number;
		PrepaidDaysDebtValue: number;
	}
	export interface VacationDebtReportViewModel {
		CompanyName: string;
		PrintDate: Day;
		Rows: Bokio.Salary.Web.Viewmodels.Reports.VacationDebtReportRow[];
		SocialFeeRateByBirthYears: Bokio.Salary.Web.Viewmodels.Reports.SocialFeeBirthYearBracket[];
		AccrualFromDate: Day;
		AccrualToDate: Day;
		UsageFromDate: Day;
		UsageToDate: Day;
		VacationDayRate: number;
		VacationCompensationRate: number;
	}
	export interface VacationSummaryRow {
		VacationDays: number;
		HolidayExtraPay: number;
		HourlyHolidayPay: number;
		EmployeeId: string;
		EmployeeName: string;
		PayslipId: string;
		PayslipDate: Day;
	}
	export interface VacationSummaryViewModel {
		Rows: Bokio.Salary.Web.Viewmodels.Reports.VacationSummaryRow[];
		DateRange: Bokio.Salary.Web.Viewmodels.Reports.ReportDateRange;
		EmployeeNames: string[];
	}
}
export namespace Bokio.Salary.Web.Viewmodels.SalaryTaxPeriods {
	export interface MatchPayslipWithTransactionDto {
		AutoVerificationRowId: string;
		PayslipId: string;
		RowVersion: string;
	}
	export interface PayrollForList {
		Id: string;
		PayDate: Day;
		PayslipCount: number;
		Net: number;
		Gross: number;
		SocialFees: number;
		SalaryTax: number;
		IsLocked: boolean;
		IsPaid: boolean;
		IsBBAPaymentScheduled: boolean;
		HadUnlockedPayslips: boolean;
		HasUnmappedNetAdjustments: boolean;
		Status: Bokio.Salary.Web.Viewmodels.SalaryTaxPeriods.PayrollForListStatus;
	}
	export enum PayrollForListStatus {
		InProgress = "InProgress",
		Locked = "Locked",
		Paid = "Paid",
	}
	export interface RecordIncomeTaxesFromTransactionDto {
		AutoVerificationRowId: string;
		RowVersion: string;
	}
	export interface RecordSocialFeesFromTransactionDto {
		AutoVerificationRowId: string;
		RowVersion: string;
	}
	export interface RecordTaxesDto {
		TaxDate: Day;
	}
	export enum RecordTaxesFromBankRowError {
		Unknown = "Unknown",
		TypeIsAlreadyRecorded = "TypeIsAlreadyRecorded",
		PeriodIsNotMarkedAsReady = "PeriodIsNotMarkedAsReady",
		PeriodIsAlreadyDone = "PeriodIsAlreadyDone",
		SumIsIncorrect = "SumIsIncorrect",
		VerificationValidationFailed = "VerificationValidationFailed",
		ItemHasBeenChanged = "ItemHasBeenChanged",
	}
	export interface SalaryTaxPeriodActions {
		CanAddPayrolls: boolean;
		S1_PayrollsStepAction: Bokio.Salary.Web.Viewmodels.SalaryTaxPeriods.SalaryTaxPeriodStepAction;
		S2_DeclarationStepAction: Bokio.Salary.Web.Viewmodels.SalaryTaxPeriods.SalaryTaxPeriodStepAction;
		S3_PaymentStepAction: Bokio.Salary.Web.Viewmodels.SalaryTaxPeriods.SalaryTaxPeriodStepAction;
		S3_CanUseBBA: boolean;
		S4_RecordingStepAction: Bokio.Salary.Web.Viewmodels.SalaryTaxPeriods.SalaryTaxPeriodStepAction;
	}
	export interface SalaryTaxPeriodForList {
		Id?: string;
		Status: Bokio.Salary.Web.Viewmodels.SalaryTaxPeriods.SalaryTaxPeriodStatus;
		TaxDeadline: Day;
		Year: number;
		Month: number;
		CurrentStep: number;
		PayslipCount: number;
		IsLocked: boolean;
		TaxDeclarationStatus: Entities.Salary.TaxDeclarationStatus;
		TaxPaymentStatus: Entities.Salary.TaxPaymentStatus;
		TaxRecordingStatus: Entities.Salary.TaxRecordingStatus;
		HasTaxAccountSync: boolean;
		MissingAnyPayrollRecordings: boolean;
	}
	export interface SalaryTaxPeriodForView {
		Id: string;
		Payrolls: Bokio.Salary.Web.Viewmodels.SalaryTaxPeriods.PayrollForList[];
		IsLocked: boolean;
		TaxDeclarationStatus: Entities.Salary.TaxDeclarationStatus;
		TaxDeclarationAudit: LimitedAuditInfo;
		TaxPaymentStatus: Entities.Salary.TaxPaymentStatus;
		TaxPaymentAudit: LimitedAuditInfo;
		TaxRecordingStatus: Entities.Salary.TaxRecordingStatus;
		TaxWasManuallyRecorded: boolean;
		TaxVerifications: Bokio.Salary.Web.Viewmodels.SalaryTaxPeriods.VerificationInfo[];
		TaxDeadline: Day;
		Month: number;
		Year: number;
		HasTaxAccountSync: boolean;
		TaxPaymentAccountNumber: string;
		TaxPaymentIdentifier: string;
		TaxesToPay?: number;
		Actions: Bokio.Salary.Web.Viewmodels.SalaryTaxPeriods.SalaryTaxPeriodActions;
		TaxWasRecordedV1Way: boolean;
		EligableForTaxAccountSync: boolean;
		SocialFeeDiscount: number;
		SuggestedTaxPaymentDate?: Day;
		ScheduledPayments: Bokio.Salary.Web.Viewmodels.SalaryTaxPeriods.ScheduledPaymentDto[];
		ScheduledPaymentsSum: number;
		InvalidOrgNumber: boolean;
		RequiresManualAgiAdjustment: boolean;
	}
	export enum SalaryTaxPeriodStatus {
		NotStarted = "NotStarted",
		Started = "Started",
		PayrollsDone = "PayrollsDone",
		DeclarationsDone = "DeclarationsDone",
		PaymentDone = "PaymentDone",
		WaitingForMatchesFromTaxAccountSync = "WaitingForMatchesFromTaxAccountSync",
		Completed = "Completed",
	}
	export enum SalaryTaxPeriodStepAction {
		NotOpenYet = "NotOpenYet",
		CanComplete = "CanComplete",
		CanUndo = "CanUndo",
		BlockedByLaterStep = "BlockedByLaterStep",
		StepRequirementsNotMet = "StepRequirementsNotMet",
	}
	export interface ScheduledPaymentDto {
		TaxPeriodId: string;
		RequestedAmount: number;
		Status: Entities.Teller.TellerPaymentStatus;
		VerificationId?: string;
		RequestedDate: Day;
	}
	export interface ScheduleSalaryTaxPaymentRequest {
		Date: Day;
		Amount: number;
	}
	export enum ScheduleTaxPaymentError {
		PaymentAlreadyExists = "PaymentAlreadyExists",
	}
	export interface SetSocialFeeDiscountDto {
		SocialFeeDiscount: number;
	}
	export interface VerificationInfo {
		VerificationId?: string;
		Title: string;
		VerificationNumber: string;
		VerificationDate: Day;
	}
}
export namespace Bokio.Salary.Web.Viewmodels.StudentLoans {
	export interface UkStudentLoanViewModel {
		Id?: string;
		Type: Entities.Salary.UkStudentLoanType;
		FromDate: Day;
		ToDate: Day;
	}
}
export namespace Bokio.Salary.Web.Viewmodels.Vacation {
	export interface BookkeepVacationYearEndRequest {
		VacationYearEndId: string;
	}
	export interface ConfirmVacationYearEndEmployeeRequest {
		VacationYearEndEmployeeId: string;
	}
	export interface ConfirmVacationYearEndRequest {
		VacationYearEndId: string;
	}
	export interface CreateVacationYearEndEmployeeRequest {
		VacationYearEndId: string;
		EmployeeId: string;
	}
	export interface EmployeePeriodSettingDataForExample {
		VacationDays: number;
		Salary: number;
		DailySalary: number;
		VacationPay: number;
		MonthlyVacationRate: number;
		HourlyVacationCompensationRate: number;
		WorkloadData: Bokio.Salary.Web.Viewmodels.Vacation.WorkloadDataForExample[];
	}
	export interface SavedDays {
		Year: number;
		Amount: number;
	}
	export interface StartVacationYearEndRequest {
		VacationYearStartDate: Day;
	}
	export interface UpdateVacationYearEndEmployeeRequest {
		VacationYearEndEmployeeId: string;
		BalanceForNextYear: Bokio.Salary.Web.Viewmodels.Vacation.VacationBalanceViewModel;
		VacationPay?: number;
	}
	export interface VacationAccrualTransactionViewModel {
		Id: string;
		CompanyId: string;
		EmployeeId: string;
		PayslipId?: string;
		Type: Entities.Salary.VacationType;
		Amount: number;
		Description: string;
		TransactionDate: Day;
		IsDeleted: boolean;
		UserId?: string;
		UserName: string;
		PayDate?: Day;
	}
	export interface VacationBalanceAndAccrualForList {
		EmployeeId: string;
		EmployeeName: string;
		IsDraftEmployee: boolean;
		EmployeeType: Entities.Salary.EmployeeType;
		Salary: number;
		VacationTrackingEnabled: boolean;
		DiscardVacationDebtDate: Day;
		PrepaidBalance: number;
		PrepaidDaysUsed: number;
		PrepaidTotalDebt: number;
		UnpaidBalance: number;
		PaidBalance: number;
		SavedBalance: number;
		CompensationBalance: number;
		PaidAccrual: number;
		FirstContractStartDate: Day;
		VacationDayPay: number;
		VacationDayPayForSavedDays: number;
		VacationDayPayForPaidDays: number;
		VacationDayPayRate: number;
		VacationCompensationRate: number;
		BirthYear: number;
	}
	export interface VacationBalanceAndAccrualOnBoardingViewModel {
		EmployeeId: string;
		VacationDays: number;
		PaidBalance: number;
		PaidAccrual: number;
		VacationYearStartDate: Day;
		VacationEndCalculationDate: Day;
		EstimatedPaidAccrual: number;
		CompensationBalance: number;
		UnpaidBalance: number;
		SavedDays: Bokio.Salary.Web.Viewmodels.Vacation.SavedDays[];
		PrepaidVacationDaysUsed: number;
		TotalPrepaidDebt: number;
		PrepaidBalance: number;
		DiscardVacationDebtDate: Day;
		VacationTrackingEnabled: boolean;
		EmployeeType: Entities.Salary.EmployeeType;
		Salary: number;
		CurrentContractStartDate: Day;
		FirstContractStartDate: Day;
	}
	export interface VacationBalanceDetail {
		EmployeeId: string;
		EmployeeName: string;
		EmployeeType: Entities.Salary.EmployeeType;
		Prepaid: number;
		PrepaidDaysUsed: number;
		PrepaidTotalDebt: number;
		Unpaid: number;
		Paid: number;
		Saved: number;
		Compensation: number;
		PaidAccrual: number;
		Transactions: Bokio.Salary.Web.Viewmodels.Vacation.VacationTransactionViewModel[];
		AccrualTransactions: Bokio.Salary.Web.Viewmodels.Vacation.VacationAccrualTransactionViewModel[];
	}
	export interface VacationBalanceForList {
		EmployeeId: string;
		EmployeeName: string;
		Prepaid: number;
		Unpaid: number;
		Paid: number;
		Saved: number;
		Compensation: number;
	}
	export interface VacationBalanceUpdate {
		EmployeeId: string;
		PrepaidBalance: number;
		PrepaidReason: string;
		PrepaidDaysUsed: number;
		PrepaidDaysUsedReason: string;
		PrepaidTotalDebt: number;
		PrepaidTotalDebtReason: string;
		UnpaidBalance: number;
		UnpaidReason: string;
		PaidBalance: number;
		PaidReason: string;
		SavedBalance: number;
		SavedReason: string;
		CompensationBalance: number;
		CompensationReason: string;
		PaidAccrual: number;
		PaidAccrualReason: string;
		DiscardVacationDebtDate: Day;
		FirstContractStartDate: Day;
	}
	export interface VacationBalanceViewModel {
		Prepaid: number;
		PrepaidUsed: number;
		PrepaidDebt: number;
		Unpaid: number;
		Paid: number;
		Saved: number;
		Compensation: number;
		Accrued: number;
		Workload: number;
	}
	export interface VacationTransactionViewModel {
		Id: string;
		CompanyId: string;
		EmployeeId: string;
		PayslipId?: string;
		PayDate?: Day;
		Type: Entities.Salary.VacationType;
		FromDate?: Day;
		ToDate?: Day;
		Amount: number;
		Cost: number;
		Total: number;
		CurrentStatus: Entities.Salary.VacationStatus;
		Description: string;
		TransactionDate: Day;
		IsDeleted: boolean;
		UserId?: string;
		UserName: string;
		VacationYearEndId?: string;
	}
	export interface VacationYearEndEmployeeDetail {
		Id: string;
		VacationYearEndId: string;
		EmployeeId: string;
		Status: Entities.Salary.VacationYearEndEmployeeStatus;
		FirstName: string;
		LastName: string;
		ThisYearStartDate: Day;
		ThisYearEndDate: Day;
		NextYearStartDate: Day;
		NextYearEndDate: Day;
		BalanceForThisYear: Bokio.Salary.Web.Viewmodels.Vacation.VacationBalanceViewModel;
		OriginalBalanceForNextYear: Bokio.Salary.Web.Viewmodels.Vacation.VacationBalanceViewModel;
		BalanceForNextYear: Bokio.Salary.Web.Viewmodels.Vacation.VacationBalanceViewModel;
		EmployeePeriodSettingDataForExample: Bokio.Salary.Web.Viewmodels.Vacation.EmployeePeriodSettingDataForExample;
	}
	export interface VacationYearEndEmployeeForList {
		Id?: string;
		Status: Entities.Salary.VacationYearEndEmployeeStatus;
		EmployeeId: string;
		EmployeeFirstname: string;
		EmployeeLastname: string;
		EmployeeTypes: Entities.Salary.EmployeeType[];
		EmployeeWorkloadInPercent: number;
	}
	export interface VacationYearEndMetaData {
		EligibleForVacationYearEnd: boolean;
		VacationYearStartDate?: Day;
		Status?: Entities.Salary.VacationYearEndStatus;
		TotalEmployees?: number;
		NrOfEmployeesCompleted?: number;
		ShouldShowPrompt: boolean;
	}
	export interface VacationYearEndVerifications {
		VacationYearEndId: string;
		ResetVerification: Core.ViewData.VerificationForList;
		UpdatedVacationVerification: Core.ViewData.VerificationForList;
	}
	export interface VacationYearEndViewModel {
		Id: string;
		VacationYearStartDate: Day;
		Status: Entities.Salary.VacationYearEndStatus;
		VacationYearEndEmployees: Bokio.Salary.Web.Viewmodels.Vacation.VacationYearEndEmployeeForList[];
	}
	export interface WorkloadDataForExample {
		WorkloadRate: number;
		Type: Entities.Salary.EmployeeType;
		FromDate: Day;
		ToDate?: Day;
	}
}
export namespace Bokio.Sales.Web.ViewModels {
	export interface AddArticleDto {
		ProductCode?: string;
		Description?: string;
		UnitPrice: number;
		VAT: number;
		Kind: Entities.Invoices.InvoiceRowKind;
		UnitType: Entities.Invoices.InvoiceRowUnitType;
		IsTextRow: boolean;
		TemplateName?: string;
		ImportId?: string;
		BookkeepingAccountNumber?: number;
	}
	export interface ConnectInvoiceToAutoverificationRowPreviewDto {
		InvoiceId: string;
		InvoiceNumber: string;
		PaymentReference: string;
		CustomerId: string;
		CustomerName: string;
		PaymentAmount: Bokio.Common.Contract.AmountWithCurrency;
		PaymentDate: Date;
		RemainingAmountBeforePayment: Bokio.Common.Contract.AmountWithCurrency;
		ReceivedAmount: Bokio.Common.Contract.AmountWithCurrency;
		InvoiceAmount: Bokio.Common.Contract.AmountWithCurrency;
		InvoiceAmountInInvoiceCurrency: Bokio.Common.Contract.AmountWithCurrency;
		InvoiceDate: Date;
		InvoiceDueDate: Date;
		BookkeepingAccount: number;
		IsForeignCurrency: boolean;
		RemainingAmountAfterPayment: Bokio.Common.Contract.AmountWithCurrency;
		WillClose: boolean;
		WillRegisterPayment: boolean;
		SettlementAmount?: Bokio.Common.Contract.AmountWithCurrency;
		CanAutoRecord: boolean;
		SettlementType?: Entities.Invoices.InvoiceSettlementType;
		AccountingType: Entities.AccountingType;
		InvoiceType: Entities.Invoices.InvoiceType;
		AvailableSettlementTypes: Entities.Invoices.InvoiceSettlementType[];
		ShouldPeriodiseForCashMethod: boolean;
	}
	export interface ConnectToAutoVerificationRowRequest {
		InvoiceId: string;
		AutoVerificationRowId: string;
		SettlementType?: Entities.Invoices.InvoiceSettlementType;
		VatScheme?: Entities.Invoices.InvoiceSettlementVatScheme;
		PreviousSumReceived?: number;
		RowVersion: string;
	}
	export interface ConnectToAutoVerificationRowResult {
		SettlementVerificationId?: string;
		SettlementVerificationNumber?: string;
		PaymentVerificationId?: string;
		PaymentVerificationNumber?: string;
	}
	export interface InvoiceDetails {
		AmountIncVat: number;
		InvoiceId: string;
		InvoicePrefix: string;
		InvoiceNumber: number;
		InvoiceState: Entities.Invoices.InvoiceState;
		Currency: string;
	}
	export interface RecurringInvoiceDetailsForList {
		Id: string;
		InvoiceNumber: string;
		CreatedOrPublishedDate?: Date;
		TotalAmountDueDomestic: number;
		TotalAmount: number;
		InvoiceState: Entities.Invoices.InvoiceState;
		PublishStamp?: Date;
		IsDeleted: boolean;
	}
	export interface RecurringInvoiceDetailsView {
		RecurringInvoiceNumber: number;
		Id: string;
		InvoiceId: string;
		State: Entities.Invoices.RecurringInvoiceStatus;
		CustomerName: string;
		CustomerId: string;
		InvoiceAmount: number;
		RecurringInvoiceScheduling: Entities.Invoices.RecurringInvoiceScheduling;
		TotalAmountBilled: number;
		TotalAmountDue: number;
		DueDays?: string;
		RecurringInvoiceList: Bokio.Sales.Web.ViewModels.RecurringInvoiceDetailsForList[];
		CreatedDate: Day;
		NextScheduledInvoiceDate: Day;
		LastUpdatedInvoiceDate?: Date;
		TemplateInvoiceId?: string;
		Currency: string;
		Version: Entities.Invoices.RecurringInvoiceVersion;
		OriginalAncestorId: string;
	}
	export interface RecurringInvoiceEvent {
		RecurringInvoiceNumber: number;
		Type: Bokio.Sales.Web.ViewModels.RecurringInvoiceEventType;
		Date: Date;
		AdditionalDetails?: Bokio.Sales.Web.ViewModels.InvoiceDetails;
	}
	export enum RecurringInvoiceEventType {
		Unknown = "Unknown",
		Started = "Started",
		Edited = "Edited",
		Stopped = "Stopped",
		NextInvoiceDate = "NextInvoiceDate",
		GeneratedDraft = "GeneratedDraft",
		InvoicePublished = "InvoicePublished",
		DeletedDraft = "DeletedDraft",
	}
	export interface RecurringInvoiceForList {
		Id: string;
		Status: Entities.Invoices.RecurringInvoiceStatus;
		RecurringInvoiceNumber: number;
		OccurranceType: Entities.Invoices.OccurranceType;
		Amount: number;
		CustomerName: string;
		LastSentDate?: Date;
		NextSentDate?: Date;
		Currency: string;
		InvoiceId?: string;
	}
	export interface RecurringInvoiceForView {
		Id: string;
		Created: Date;
		Updated?: Date;
		RecurringInvoiceScheduling: Entities.Invoices.RecurringInvoiceScheduling;
		TemplateInvoiceId?: string;
		OriginalAncestorId: string;
	}
	export interface ToggleEnableStripePaymentsResults {
		Enabled: boolean;
	}
}
export namespace Bokio.Sales.Web.ViewModels.InvoiceBatch {
	export interface AddInvoiceBatchItemRequest {
		ArticleId: string;
		InvoiceBatchId: string;
		Items: Bokio.Sales.Web.ViewModels.InvoiceBatch.AddInvoiceBatchItemRequestItem[];
		MatchField: Entities.Invoices.InvoiceBatchCustomerMatchField;
	}
	export interface AddInvoiceBatchItemRequestItem {
		MatchValue: string;
		Units: number;
	}
	export interface CreateInvoiceBatchRequest {
		Name: string;
		InvoiceDate: Day;
		Deadline: Day;
	}
	export interface GenerateInvoicesBatchRequest {
		InvoiceBatchId: string;
	}
	export enum InvoiceBatchAction {
		GenerateInvoices = "GenerateInvoices",
		TryMatchCustomers = "TryMatchCustomers",
		AddItems = "AddItems",
		EditItems = "EditItems",
		DeleteItems = "DeleteItems",
	}
	export interface InvoiceBatchCustomerGroupDto {
		CustomerId?: string;
		CustomerName?: string;
		MatchValue: string;
		MatchField: Entities.Invoices.InvoiceBatchCustomerMatchField;
		MatchResult: Entities.Invoices.InvoiceBatchCustomerMatchResult;
		Items: Bokio.Sales.Web.ViewModels.InvoiceBatch.InvoiceBatchItemDto[];
		TotalSumExVat: number;
		TotalSumIncVat: number;
		InvoiceId?: string;
		InvoiceState?: Entities.Invoices.InvoiceState;
		InvoiceNumber?: number;
	}
	export interface InvoiceBatchForViewDto {
		Id: string;
		Name: string;
		InvoiceDate: Day;
		Deadline: Day;
		State: Entities.Invoices.InvoiceBatchState;
		CustomerGroups: Bokio.Sales.Web.ViewModels.InvoiceBatch.InvoiceBatchCustomerGroupDto[];
		TotalSumExVat: number;
		TotalSumIncVat: number;
		AvailableActions: Bokio.Sales.Web.ViewModels.InvoiceBatch.InvoiceBatchAction[];
	}
	export interface InvoiceBatchItemDto {
		Id: string;
		ArticleId: string;
		ArticleDescription: string;
		Units: number;
		UnitPrice: number;
		TotalAmountExVat: number;
		VatRate: number;
	}
	export interface InvoiceBatchListDto {
		Id: string;
		Name: string;
		InvoiceDate: Day;
		Deadline: Day;
		State: Entities.Invoices.InvoiceBatchState;
		ItemCount: number;
	}
}
export namespace Bokio.Services.Account {
	export enum AcceptInvitationResponse {
		InvitationNotFound = "InvitationNotFound",
		InvitationAlreadyAccepted = "InvitationAlreadyAccepted",
		UserAddedToCompany = "UserAddedToCompany",
		UserAccountRegistrationNotComplete = "UserAccountRegistrationNotComplete",
		InvitationExpired = "InvitationExpired",
	}
	export enum ChangePasswordError {
		CurrentPasswordRequired = "CurrentPasswordRequired",
		WrongUser = "WrongUser",
		PasswordsDoNotMatch = "PasswordsDoNotMatch",
		ErrorWhenChangingPassword = "ErrorWhenChangingPassword",
	}
	export interface CompanyInfo {
		Id: string;
		Name: string;
	}
	export interface ConfirmEmailError {
		Status: Bokio.Services.Account.ConfirmEmailErrorCode;
		User: Bokio.Services.Account.UserToBeConfirmedDto;
	}
	export enum ConfirmEmailErrorCode {
		AlreadyConfirmed = "AlreadyConfirmed",
		IncorrectCode = "IncorrectCode",
	}
	export enum CreateUserToBeConfirmedError {
		UnknownError = "UnknownError",
		UserAlreadyExists = "UserAlreadyExists",
		EmailIsNotInWhiteList = "EmailIsNotInWhiteList",
		InvalidPersonalIdentifier = "InvalidPersonalIdentifier",
		EmailDomainIsBlacklisted = "EmailDomainIsBlacklisted",
	}
	export enum DeleteUserAccountErrors {
		HasCompanyMemberships = "HasCompanyMemberships",
		HasPartnerMemberships = "HasPartnerMemberships",
	}
	export enum EnableTotpErrorType {
		AlreadyActivated = "AlreadyActivated",
		InvalidCode = "InvalidCode",
		InvalidPassword = "InvalidPassword",
		GenericError = "GenericError",
	}
	export interface InvitationDetails {
		Company: Bokio.Services.Account.CompanyInfo;
		Invitee: Bokio.Services.Account.UserInfo;
		Inviter: Bokio.Services.Account.UserInfo;
	}
	export interface JoinByInvitationParameters {
		InviteId: string;
		SecretToken?: string;
		FirstName: string;
		LastName: string;
		Password: string;
		TermsVersion: number;
	}
	export enum LoginError {
		GeneralError = "GeneralError",
		LockedOut = "LockedOut",
		RequiresVerification = "RequiresVerification",
		UserNotFound = "UserNotFound",
		InvalidPassword = "InvalidPassword",
		InvalidCode = "InvalidCode",
		LinkInvalid = "LinkInvalid",
		InvalidLoginMethod = "InvalidLoginMethod",
		BlockedPassword = "BlockedPassword",
	}
	export interface LoginUserResult {
		CompanyIds: string[];
		UserName: string;
	}
	export enum PreUserABVariant {
		A = "A",
		B = "B",
	}
	export interface PreUserABVariantDto {
		Country: string;
		PreUserABVariant: Bokio.Services.Account.PreUserABVariant;
	}
	export enum ResetPasswordError {
		NoSuchUser = "NoSuchUser",
		CodeInvalidOrUsed = "CodeInvalidOrUsed",
		LockedOut = "LockedOut",
		RequiresVerification = "RequiresVerification",
		RequiresExternalLogin = "RequiresExternalLogin",
	}
	export interface TOTPDisableCommand {
		Password: Bokio.Common.Types.SecretString;
		Code: Bokio.Common.Types.SecretString;
	}
	export interface TOTPEnableCommand {
		SecretKey: Bokio.Common.Types.SecretString;
		Password: Bokio.Common.Types.SecretString;
		Code: Bokio.Common.Types.SecretString;
	}
	export interface TOTPEnableViewModel {
		SecretKey: Bokio.Common.Types.SecretString;
		BarcodeUrl: Bokio.Common.Types.SecretString;
		QrCodeSrc: string;
		EncryptedSecret: string;
	}
	export interface UserInfo {
		FirstName: string;
		LastName: string;
		FullName: string;
		Email: string;
	}
	export interface UserToBeConfirmedDto {
		Id: string;
		FirstName: string;
		LastName: string;
		Email: string;
		AcceptedTermsVersion: number;
		SignupType: Entities.UserSignupType;
		ClientSecret: string;
	}
}
export namespace Bokio.Services.Companies {
	export interface CompanyInfo {
		Id: string;
		Name: string;
		Vertical: string;
		StartedAt?: Date;
	}
}
export namespace Bokio.Services.CompanySearch {
	export interface CompanySearchFetchResult {
		Name: string;
		OrgNumber: string;
		Address: Entities.Address;
		VatNumber: string;
		Phone: string;
		CompanyType: Entities.CompanyType;
		StartedAt?: Date;
		Vertical: string;
		VerticalCodes: string[];
		ActiveFiscal?: Bokio.Services.CompanySearch.FiscalYearInfoDto;
	}
	export interface FetchInfoRequest {
		OrgNumber: string;
	}
	export interface FiscalYearInfoDto {
		StartDate: Day;
		EndDate: Day;
		IsFirstFiscalYear: boolean;
		IsCurrentFiscalYear: boolean;
	}
	export interface SearchRequest {
		Name: string;
		UcBasicInfo: boolean;
	}
	export interface SearchResult {
		Name: string;
		OrgNumber: string;
		Address: Entities.Address;
		Vertical: string;
	}
}
export namespace Bokio.Services.Experiments {
	export interface ExperimentDto {
		Id: string;
		Name: string;
		Enabled: boolean;
		Variants: Bokio.Services.Experiments.VariantDto[];
		Hypothesis: string;
	}
	export interface VariantDto {
		Id?: string;
		Name: string;
		Enabled: boolean;
		Index: number;
	}
}
export namespace Bokio.Services.FiscalYears {
	export interface CanCloseFiscalYear {
		SettingId: string;
		CanCloseYear: boolean;
		Error: Bokio.Accounting.Contract.FiscalYears.Errors.ClosureError;
		ErrorMessage: string;
	}
	export interface CanDeleteFiscalYearValidation {
		CanDelete: boolean;
		Errors: Bokio.Services.FiscalYears.FiscalYearValidationError[];
	}
	export enum CreateFiscalMode {
		Next = "Next",
		Previous = "Previous",
	}
	export interface FiscalYearDto {
		AccountingForm: Entities.AccountingType;
		EndDate: Day;
		ExpectedTurnover: number;
		Org: string;
		StartDate: Day;
		HasIncomingBalances: boolean;
		ToYearAndMonthString: string;
		CanDeleteValidation: Bokio.Services.FiscalYears.CanDeleteFiscalYearValidation;
		IsClosed: boolean;
		NeedsReview: boolean;
		YearId: string;
		IsFirstOpen: boolean;
		VatSetting: Entities.VatSetting;
	}
	export interface FiscalYearsDto {
		NextYear: Core.ViewData.FiscalYearViewModel;
		PreviousYear: Core.ViewData.FiscalYearViewModel;
		Years: Core.ViewData.CompanySettingsForView[];
		Messages: Message[];
	}
	export enum FiscalYearValidationError {
		IsOnlyYear = "IsOnlyYear",
		IsNotFirstFiscalYear = "IsNotFirstFiscalYear",
		IsCurrentYear = "IsCurrentYear",
		HasVerifications = "HasVerifications",
		HasNonZeroIncomingBalances = "HasNonZeroIncomingBalances",
	}
}
export namespace Bokio.Services.Inboxes {
	export interface InboxDto {
		Id: string;
		Name: string;
		Domain: string;
		Whitelist: Entities.InboxWhitelistItem[];
		OwnerGroupedWhiteList: Bokio.Common.Contract.Inbox.InboxEmailOwnerDto[];
	}
	export interface InboxStateDto {
		Inbox: Bokio.Services.Inboxes.InboxDto;
	}
	export enum UpdateInboxError {
		Unknown = "Unknown",
		AddressAlreadyInUse = "AddressAlreadyInUse",
	}
}
export namespace Bokio.Services.Subscriptions {
	export interface SubscriptionDto {
		Info: Entities.SubscriptionInfo;
		Item: Bokio.Services.Subscriptions.SubscriptionItemDto;
		Subscribed: boolean;
	}
	export interface SubscriptionItemDto {
		Started: Date;
		ExtraData: Entities.SubscriptionExtraData;
		SubscriptionId: string;
	}
}
export namespace Bokio.Utils {
	export interface RecentLoginProtectedResult<T> {
		Data: T;
		RequireNewLogin: boolean;
	}
}
export namespace Bokio.Web.Controllers {
	export interface PageEventRequest {
		Category: string;
		Action: string;
		Label: string;
		Timestamp: Date;
	}
	export interface SetMarketingSettingRequest {
		AllowMarketing: boolean;
	}
	export interface SignedTermsResponse {
		ReturnUrl: string;
	}
	export interface SignTermsRequest {
		Version: number;
		AlsoAllowMarketing: boolean;
	}
	export interface SingleTermViewModel {
		Url: string;
		Body: string;
		Next?: Bokio.Web.Controllers.SingleTermViewModel;
	}
	export interface TermsInfo {
		Version: number;
		EulaUrl: string;
		DpaUrl: string;
		StorageUrl: string;
		HasDpa: boolean;
		HasStorage: boolean;
		ValidFromDate?: string;
		Next?: Bokio.Web.Controllers.TermsInfo;
	}
	export interface TermsViewModel {
		Version: number;
		EulaUrl: string;
		DpaUrl: string;
		Message: string;
		HasDpa: boolean;
	}
	export interface UserApprovalsViewModel {
		SignedEulaVersion: number;
		AllowMarketing: boolean;
		AllowCookies: boolean;
	}
}
export namespace Bokio.WebInfrastructure.InteractiveRequest {
	export interface InteractiveResult<TResult> {
	}
}
export namespace Classes {
	export interface Account {
		IsMainAccount: boolean;
		SubCategoryId: number;
		Id: number;
		Text: string;
	}
	export interface AccountBase {
		Id: number;
		Text: string;
	}
	export interface AccountCategory {
		Id: number;
		Text: string;
		SubCategories: Classes.AccountSubCategory[];
	}
	export interface AccountSubCategory {
		Id: number;
		Text: string;
		ParentId: number;
		Accounts: Classes.AccountBase[];
	}
	export interface Country {
		IsoCode2: string;
		IsoCode3: string;
		IsoNum: string;
		InternationalCallingCode: string;
		Name: string;
		EUMembershipHistory: Classes.EUMembership[];
		CountrySubdivision?: Classes.CountrySubdivision;
	}
	export interface CountryMetadata {
		CountryCode: CountryCode;
		Currency: string;
		DefaultVatRate: number;
		AccountPlanKey: string;
		DisableRounding: boolean;
		PopularCurrencies: string[];
		VatPercentages: Classes.VATPercentage[];
		VatReportingPeriods: Entities.VatSetting[];
		SupportedCompanyTypes: Entities.CompanyType[];
		RulesByCompanyTypeAndVatSetting: Classes.RulesByCompanyTypeAndVatSetting[];
		RulesByCompanyType: Classes.RulesByCompanyType[];
		PayablesAccount: number;
		EmployeeExpensesAccount: number;
		AvailableCountrySubdivision: string[];
		MinResultAccountNumber: number;
	}
	export interface CountrySubdivision {
		Code: string;
		Name: string;
		EUMembershipHistory: Classes.EUMembership[];
	}
	export interface DateRange {
		Start: Day;
		End: Day;
	}
	export interface DeleteVerificationValidationError {
		Type: Classes.DeleteVerificationValidationErrorType;
	}
	export enum DeleteVerificationValidationErrorType {
		GenericDeleteVerifcationValidationError = "GenericDeleteVerifcationValidationError",
		HardDeleteNotAllowed = "HardDeleteNotAllowed",
	}
	export interface EUMembership {
		Entry: Date;
		Exit?: Date;
	}
	export enum FiscalYearMainRule {
		MustEndDec31 = "MustEndDec31",
		CanEndAnyMonth = "CanEndAnyMonth",
		CanEndAnyDate = "CanEndAnyDate",
	}
	export enum InboundEmailResultAttachmentStatus {
		RefusedMimetype = "RefusedMimetype",
		RefusedMd5Checksum = "RefusedMd5Checksum",
		Accepted = "Accepted",
		Pending = "Pending",
	}
	export enum InboundEmailResultStatus {
		RefusedNoFiles = "RefusedNoFiles",
		RefusedInbox = "RefusedInbox",
		RefusedWhitelist = "RefusedWhitelist",
		Accepted = "Accepted",
		RefusedInvalidInboxName = "RefusedInvalidInboxName",
		RefusedInvalidEmail = "RefusedInvalidEmail",
	}
	export enum InboundSystem {
		/** @deprecated Deprecated. Keeping as it can be stored in the DB */
		Mailgun = "Mailgun",
		PostmarkV1 = "PostmarkV1",
		PostmarkV2 = "PostmarkV2",
		/** @deprecated Used in some experiment feature for personal inbox which is not there anymore */
		Gmail = "Gmail",
	}
	export interface InvoiceValidationError {
		RowId?: number;
		Type: Classes.InvoiceValidationErrorType;
		RotRut?: Classes.RotRutData;
		PropertyName?: string;
		Message?: string;
	}
	export enum InvoiceValidationErrorType {
		UnspecifiedRowKind = "UnspecifiedRowKind",
		GenericPublishError = "GenericPublishError",
		NotApproved = "NotApproved",
		NoActiveCustomerSettingsForInvoiceDate = "NoActiveCustomerSettingsForInvoiceDate",
		PaymentMethodNotSet = "PaymentMethodNotSet",
		ForeignPaymentMethodNotSet = "ForeignPaymentMethodNotSet",
		FactoringOrgNumberDoesNotMatchSubscription = "FactoringOrgNumberDoesNotMatchSubscription",
		InvoiceDateForFactoringInvoiceIsSetToFuture = "InvoiceDateForFactoringInvoiceIsSetToFuture",
		CompanyOrgNumberMissing = "CompanyOrgNumberMissing",
		PersonalNumberMissing = "PersonalNumberMissing",
		VatSpecifiedForInvoiceToForeignCompany = "VatSpecifiedForInvoiceToForeignCompany",
		RotRutCurrencyMustBeInSEK = "RotRutCurrencyMustBeInSEK",
		ZeroSumInvoiceShouldHaveRowGreaterThanZero = "ZeroSumInvoiceShouldHaveRowGreaterThanZero",
		InvoiceDeadlineIsBeforeInvoiceDate = "InvoiceDeadlineIsBeforeInvoiceDate",
		RotRutInvoiceMustNotHaveNegativeRows = "RotRutInvoiceMustNotHaveNegativeRows",
		ReverseChargeOnForeignCustomer = "ReverseChargeOnForeignCustomer",
		CompanyMissingCountrySubdivision = "CompanyMissingCountrySubdivision",
		FreePlanBokioBankgiroPaymentMethodCannotBeSet = "FreePlanBokioBankgiroPaymentMethodCannotBeSet",
		RotRutInvoiceDeductionAmountExceedsMaximum = "RotRutInvoiceDeductionAmountExceedsMaximum",
		InvoiceAmountLowStripeNotSupported = "InvoiceAmountLowStripeNotSupported",
		PersonalMessageIncludesInvalidExternalLink = "PersonalMessageIncludesInvalidExternalLink",
		ForeignCustomerAndReversedVATRows = "ForeignCustomerAndReversedVATRows",
		CreditsNotAllowedInvoiceState = "CreditsNotAllowedInvoiceState",
		BbaInternationalPaymentCountryNotAllowed = "BbaInternationalPaymentCountryNotAllowed",
		BbaInternationalPaymentCurrencyNotAllowed = "BbaInternationalPaymentCurrencyNotAllowed",
		BbaIbanNotAllowedForDomesticPayment = "BbaIbanNotAllowedForDomesticPayment",
		BbaInternationalPaymentsNotEnabled = "BbaInternationalPaymentsNotEnabled",
		BbaInternationalPaymentCompanyNotOnboarded = "BbaInternationalPaymentCompanyNotOnboarded",
		RotRutDeductionPersonInvalidPersonalNumber = "RotRutDeductionPersonInvalidPersonalNumber",
		CurrencyRateValueMustBePositive = "CurrencyRateValueMustBePositive",
		CustomerNotSelected = "CustomerNotSelected",
		EInvoiceAttachmentsNotSupported = "EInvoiceAttachmentsNotSupported",
		Uncategoryized = "Uncategoryized",
		SenderCompanyMissing = "SenderCompanyMissing",
		SenderCompanyNameMissing = "SenderCompanyNameMissing",
		SenderEmailInvalid = "SenderEmailInvalid",
		SenderAddressIncomplete = "SenderAddressIncomplete",
		SenderPaymentMethodMissing = "SenderPaymentMethodMissing",
		SenderOrgNumberMissing = "SenderOrgNumberMissing",
		SenderOrgNumberInvalid = "SenderOrgNumberInvalid",
		SenderVatNumberInvalid = "SenderVatNumberInvalid",
		SenderPhoneMissing = "SenderPhoneMissing",
		SenderReferenceNameMissing = "SenderReferenceNameMissing",
		SenderPaymentMethodInvalid = "SenderPaymentMethodInvalid",
		SenderIsTaxRegisteredMissing = "SenderIsTaxRegisteredMissing",
		SenderForeignPaymentMethodDeprecatedBic = "SenderForeignPaymentMethodDeprecatedBic",
		CustomerNameMissing = "CustomerNameMissing",
		CustomerOrgNumberMissing = "CustomerOrgNumberMissing",
		CustomerOrgNumberInvalid = "CustomerOrgNumberInvalid",
		CustomerVatNumberInvalid = "CustomerVatNumberInvalid",
		CustomerNumberTooLarge = "CustomerNumberTooLarge",
		CustomerSubdivisionMissing = "CustomerSubdivisionMissing",
		CustomerPersonalNumberInvalid = "CustomerPersonalNumberInvalid",
		CustomerAddressIncomplete = "CustomerAddressIncomplete",
		RowsMissing = "RowsMissing",
		RowDescriptionMissing = "RowDescriptionMissing",
		RowDescriptionTooLong = "RowDescriptionTooLong",
		RowQuantityInvalid = "RowQuantityInvalid",
		RowPriceMissing = "RowPriceMissing",
		RowVatNotAllowed = "RowVatNotAllowed",
		RowReversedVatNotAllowed = "RowReversedVatNotAllowed",
		RowRotRutNonNegativeQuantity = "RowRotRutNonNegativeQuantity",
		RowRotRutNonNegativePrice = "RowRotRutNonNegativePrice",
		RowRotRutTypeMissing = "RowRotRutTypeMissing",
		RowRotRutMaterialTypeMissing = "RowRotRutMaterialTypeMissing",
		RowRotRutServiceHasUnitTypeInvalid = "RowRotRutServiceHasUnitTypeInvalid",
		RowRotRutVatServiceInvalid = "RowRotRutVatServiceInvalid",
		RecurringStartDateInvalid = "RecurringStartDateInvalid",
		ExchangeRateFetchFailed = "ExchangeRateFetchFailed",
		FutureDateForeignCurrency = "FutureDateForeignCurrency",
	}
	export interface QuoteValidationError {
		RowId?: number;
		Type: Classes.QuoteValidationErrorType;
	}
	export enum QuoteValidationErrorType {
		UnspecifiedRowKind = "UnspecifiedRowKind",
		GenericPublishError = "GenericPublishError",
		VatSpecifiedForUnregisteredCompany = "VatSpecifiedForUnregisteredCompany",
		NoActiveCustomerSettingsForQuoteValidFromDate = "NoActiveCustomerSettingsForQuoteValidFromDate",
		PaymentMethodNotSet = "PaymentMethodNotSet",
		ForeignPaymentMethodNotSet = "ForeignPaymentMethodNotSet",
		CompanyOrgNumberMissing = "CompanyOrgNumberMissing",
		PersonalNumberMissing = "PersonalNumberMissing",
		VatSpecifiedForInvoiceToForeignCompany = "VatSpecifiedForInvoiceToForeignCompany",
		RotRutCurrencyMustBeInSEK = "RotRutCurrencyMustBeInSEK",
		CustomerAddressMissingInformation = "CustomerAddressMissingInformation",
		CompanyAddressMissingInformation = "CompanyAddressMissingInformation",
		ZeroSumInvoiceShouldHaveRowGreaterThanZero = "ZeroSumInvoiceShouldHaveRowGreaterThanZero",
		ValidFromIsBeforeValidToDate = "ValidFromIsBeforeValidToDate",
		RotRutInvoiceMustNotHaveNegativeRows = "RotRutInvoiceMustNotHaveNegativeRows",
		NoSelectedCustomer = "NoSelectedCustomer",
		ExceedQuota = "ExceedQuota",
		SenderIsTaxRegisteredMissing = "SenderIsTaxRegisteredMissing",
	}
	export interface RotRutData {
		MaxDeductionAmount: number;
		Type?: Entities.Invoices.RotRutType;
		DeductionPersonPersonalNumber?: string;
	}
	export interface RotRutValidationError {
		Type: Classes.RotRutValidationErrorType;
	}
	export enum RotRutValidationErrorType {
		UnknownError = "UnknownError",
		RotRutNotSet = "RotRutNotSet",
		RotRutCurrencyMustBeInSEK = "RotRutCurrencyMustBeInSEK",
		InvalidStateChanged = "InvalidStateChanged",
		CannotMoveToStatusReadyToSubmit = "CannotMoveToStatusReadyToSubmit",
	}
	export interface RulesByCompanyType {
		FiscalYearMainRule: Classes.FiscalYearMainRule;
		MaxLengthOfFiscalYear: number;
		AppliesToCompanyType: Entities.CompanyType[];
	}
	export interface RulesByCompanyTypeAndVatSetting {
		PermittedAccountingTypes: Entities.AccountingType[];
		AppliesToCompanyType: Entities.CompanyType[];
		AppliesToVatSetting: Entities.VatSetting[];
	}
	export interface SystemName {
		SystemKey: string;
		Version: string;
	}
	export interface UserDto {
		Id: string;
		Email: string;
		Name: string;
		ShortName: string;
		IsApiUser: boolean;
	}
	export interface VATPercentage {
		Rate: number;
		Label: string;
	}
}
export namespace Classes.AI {
	export interface BoundingBox {
		Left: number;
		Top: number;
		Width: number;
		Height: number;
	}
	export interface DateMatch {
		Value: Day;
		BoundingBox: Classes.AI.BoundingBox;
		Score: number;
	}
	export interface InvalidSize {
		Width: number;
		Height: number;
	}
	export interface NumericMatch {
		Value: number;
		BoundingBox: Classes.AI.BoundingBox;
		Score: number;
	}
	export interface PaymentDetailsMatch {
		PaymentDetailsMatchData: Classes.AI.PaymentDetailsMatchData;
		BoundingBox: Classes.AI.BoundingBox;
		Score: number;
	}
	export interface PaymentDetailsMatchData {
		Source: Classes.AI.PaymentDetailSource;
		Type: Classes.AI.PaymentDetailType;
		AccountNumber: string;
		VendorName?: string;
		VendorCountryCode?: string;
		VendorOrgNumber?: string;
		Amount?: Bokio.Common.Contract.AmountWithCurrency;
		Date?: Date;
		DueDate?: Date;
		Reference?: string;
	}
	export enum PaymentDetailSource {
		Unknown = "Unknown",
		QRCode = "QRCode",
		OCRSlip = "OCRSlip",
	}
	export enum PaymentDetailType {
		Unknown = "Unknown",
		Bankgiro = "Bankgiro",
		Plusgiro = "Plusgiro",
	}
	export interface ReceiptFieldsPrediction {
		DocumentType: Classes.Ocr.OcrImageType;
		TotalSums: Classes.AI.NumericMatch[];
		VatSums: Classes.AI.NumericMatch[];
		Vats: Classes.AI.NumericMatch[];
		Dates: Classes.AI.DateMatch[];
		PaymentDates: Classes.AI.DateMatch[];
		DueDates: Classes.AI.DateMatch[];
		PaymentReferences: Classes.AI.TextMatch[];
		VendorTaxId?: Classes.AI.TextMatch;
		VendorOrgNumber?: Classes.AI.TextMatch;
		VendorName?: Classes.AI.TextMatch;
		VendorCountry?: Classes.AI.TextMatch;
		CustomerTaxId?: Classes.AI.TextMatch;
		CustomerName?: Classes.AI.TextMatch;
		ModelName: string;
		PredictedAt: Day;
		SizeViolation?: Classes.AI.InvalidSize;
		UserEnteredPaymentDate?: Day;
		UserEnteredSum?: number;
		UserEnteredCurrency?: string;
		Rotation: number;
		Orientation: number;
		PaymentInformation?: Classes.AI.PaymentDetailsMatch;
		SupplierSuggestion?: Classes.AI.SupplierSuggestionDto;
		CurrencyISO?: Classes.AI.TextMatch;
	}
	export interface SupplierSuggestionDto {
		Type: Classes.AI.SupplierSuggestionDtoResultType;
		SupplierInfo: Classes.AI.SupplierSuggestionDtoSupplierInfo;
	}
	export enum SupplierSuggestionDtoResultType {
		Unknown = "Unknown",
		SuggestUsingExistingSupplier = "SuggestUsingExistingSupplier",
		SuggestCreatingSupplier = "SuggestCreatingSupplier",
	}
	export interface SupplierSuggestionDtoSupplierInfo {
		TaxRegistrationNumber?: string;
		Id?: string;
		Name?: string;
		OrgNumber?: string;
		CountryISO2?: string;
		CurrencyCode?: string;
		Type: Classes.AI.PaymentDetailType;
		AccountNumber?: string;
	}
	export interface TextMatch {
		Value: string;
		BoundingBox: Classes.AI.BoundingBox;
		Score: number;
	}
}
export namespace Classes.Ocr {
	export enum OcrImageType {
		Invoice = "Invoice",
		Receipt = "Receipt",
	}
}
export namespace Classes.Payments {
	export interface ExternalPaymentFileSpecification {
		ExternalPaymentMessageId: string;
		PaymentFileType: Classes.Payments.ExternalPaymentFileType;
		SenderOrgNumber: string;
		SenderName: string;
		FileName: string;
		Sum: number;
		SenderBankgiro: string;
		SenderCustomerNo: string;
		SenderAccountNo: string;
		Payments: Classes.Payments.ExternalPaymentSpecification[];
		InvalidBankgiro: boolean;
	}
	export enum ExternalPaymentFileType {
		Unknown = "Unknown",
		BgSalaryFile = "BgSalaryFile",
		BgFile = "BgFile",
		PainFile = "PainFile",
	}
	export interface ExternalPaymentSpecification {
		Sum: number;
		ReceiverName: string;
		ReceiverIdentifer: string;
		Date: Day;
		ClearingNumber: string;
		AccountNumber: string;
		Message: string;
		IsSalary: boolean;
		FailedToParseBankAccount: boolean;
	}
}
export namespace Classes.Teller {
	export interface BankAccountCapabilities {
		InternationalPayments: boolean;
	}
	export interface BankgiroBankAccountInformation {
		BankgiroNumber: string;
		/** @deprecated Shared Bankgiro is not supported anymore */
		Shared: boolean;
	}
	export interface BankgiroPaymentInformation {
		BankgiroNumber: string;
		RecipientName: string;
		Ocr?: string;
		Message?: string;
	}
	export interface CurrencyAmount {
		Amount: number;
		Currency: string;
	}
	export interface EnableBankingAccountInformation {
		AccountIdentificationHash: string;
		ShouldRemindKlarnaMigrationMightMissTransactions?: boolean;
	}
	export interface OwnAccountPaymentInformation {
		ExternalBankAccountId: string;
		ClearingNumber: string;
		AccountNumber: string;
		RecipientName: string;
		Message: string;
	}
	export interface PlusgiroBankAccountInformation {
		PlusgiroNumber: string;
	}
	export interface PlusgiroPaymentInformation {
		PlusgiroNumber: string;
		RecipientName: string;
		Ocr?: string;
		Message?: string;
	}
	export interface SekClearingBankAccountInformation {
		ClearingNumber: string;
		AccountNumber: string;
	}
	export interface SekClearingPaymentInformation {
		ClearingNumber: string;
		AccountNumber: string;
		RecipientName: string;
		Message: string;
	}
	export interface SepaBankAccountInformation {
		AccountNumber: string;
	}
	export interface SepaPaymentInformation {
		RecipientAddress: Entities.ExtendedAddress;
		AccountNumber: string;
		RecipientName: string;
		Message: string;
		PaymentReasonCodeForSenderCountry?: string;
	}
	export interface SwiftBankAccountInformation {
		AccountNumber: string;
		BicCode: string;
		Shared: boolean;
	}
	export interface SwiftPaymentInformation {
		RecipientAddress: Entities.ExtendedAddress;
		BicCode: string;
		AccountNumber: string;
		RecipientName: string;
		Message: string;
		PaymentReasonCodeForSenderCountry?: string;
	}
	export interface TellerBankAccountInformationUnion {
		BankgiroBankAccountInfo?: Classes.Teller.BankgiroBankAccountInformation;
		PlusgiroBankAccountInfo?: Classes.Teller.PlusgiroBankAccountInformation;
		SepaBankAccountInformation?: Classes.Teller.SepaBankAccountInformation;
		SekClearingBankAccountInformation?: Classes.Teller.SekClearingBankAccountInformation;
		SwiftBankAccountInformation?: Classes.Teller.SwiftBankAccountInformation;
		SwishBankAccountInformation?: Classes.Teller.BankAccountInformation.SwishBankAccountInformation;
		Capabilities?: Classes.Teller.BankAccountCapabilities;
		EnableBankingAccountInformation?: Classes.Teller.EnableBankingAccountInformation;
	}
	export interface TellerPaymentInformationUnion {
		BankgiroPaymentInfo?: Classes.Teller.BankgiroPaymentInformation;
		PlusgiroPaymentInfo?: Classes.Teller.PlusgiroPaymentInformation;
		SwiftPaymentInfo?: Classes.Teller.SwiftPaymentInformation;
		SepaPaymentInformation?: Classes.Teller.SepaPaymentInformation;
		SekClearingPaymentInformation?: Classes.Teller.SekClearingPaymentInformation;
		OwnAccountPaymentInformation?: Classes.Teller.OwnAccountPaymentInformation;
	}
}
export namespace Classes.Teller.BankAccountInformation {
	export interface SwishBankAccountInformation {
		SwishNumber: string;
		EnrollmentId: string;
	}
}
export namespace Classes.Todo {
	export interface AnnualReportSubmissionTodoData {
		SettingId: string;
		StartDate: Day;
		EndDate: Day;
		DueDate: Day;
	}
	export interface BbaPermissionReviewTodoData {
		UserDisplayName: string;
		AffectedUserId: string;
	}
	export interface CheckMissingTransactionsTodoData {
		BookkeepingAccount: number;
		StartDate: Day;
		EndDate: Day;
	}
	export interface ClosureTodoData {
		StartDate: string;
		EndDate: string;
		SettingId: string;
		ClosureId?: string;
	}
	export interface CustomTodoData {
		Title: string;
		DueDate?: Day;
		Frequency?: Entities.Todo.Frequency;
		StartDate?: Day;
	}
	export interface TodoItemStoredData {
		ClosureTodoData?: Classes.Todo.ClosureTodoData;
		CustomTodoData?: Classes.Todo.CustomTodoData;
		CheckMissingTransactionsTodoData?: Classes.Todo.CheckMissingTransactionsTodoData;
		AnnualReportSubmissionTodoData?: Classes.Todo.AnnualReportSubmissionTodoData;
		BbaPermissionReviewTodoData?: Classes.Todo.BbaPermissionReviewTodoData;
	}
}
export namespace Common.Controllers {
	export interface AddCheckTypeDto {
		CheckType: Entities.Accounting.Reconciliations.BookkeepingCheckType;
	}
	export interface AddManualTaxPaymentDto {
		TaxDateId: string;
		Sum: number;
		Date: Day;
	}
	export interface AddPreliminaryTaxesDto {
		Year: number;
		MonthlyAmount: number;
	}
	export interface BalanceListItem {
		Date: Day;
		Sum: number;
		Title: string;
		SupplierInvoiceId?: string;
		ExpenseId?: string;
		ExpensePaymentId?: string;
		VerificationId?: string;
		VerificationNumber?: string;
	}
	export interface BookkeepingCheckDetailsDto {
		Id: string;
		CreatedUtc: Date;
		FromDate: Day;
		ToDate: Day;
		Status: Entities.Accounting.Reconciliations.BookkeepingCheckStatus;
		HasBookkeepingChanges: boolean;
		Items: Common.Controllers.BookkeepingCheckItemDto[];
	}
	export interface BookkeepingCheckForListDto {
		Id: string;
		CreatedUtc: Date;
		FromDate: Day;
		ToDate: Day;
		Status: Entities.Accounting.Reconciliations.BookkeepingCheckStatus;
		SequenceNumber: number;
	}
	export interface BookkeepingCheckItemDto {
		Id: string;
		VerificationId: string;
		Date: Day;
		Title: string;
		VerificationNumber: string;
		ReceiptId?: string;
		BankTransactionId?: string;
		IsProcessing: boolean;
		Results: Common.Controllers.BookkeepingCheckItemResultDto[];
	}
	export interface BookkeepingCheckItemResultDto {
		Id: string;
		CheckType: Entities.Accounting.Reconciliations.BookkeepingCheckType;
		Status: Entities.Accounting.Reconciliations.BookkeepingCheckResultStatus;
		SkipReason: string;
		AgentType: Entities.Accounting.Reconciliations.BookkeepingCheckAgentType;
		Confidence?: number;
		CostEstimate?: number;
		Reasoning: string;
		FindingCode?: Entities.Accounting.Reconciliations.BookkeepingCheckFindingCode;
		FindingSeverity?: Entities.Accounting.Reconciliations.BookkeepingCheckFindingSeverity;
		FindingTitle: string;
		FindingDescription: string;
		SuggestedResolutionJson: string;
		Resolution: Common.Controllers.BookkeepingCheckItemResultResolutionDto;
	}
	export interface BookkeepingCheckItemResultResolutionDto {
		Type: Entities.Accounting.Reconciliations.BookkeepingCheckResolutionType;
		Note: string;
	}
	export interface BookkeepingCheckTestSetupResult {
		FromDate: Date;
		ToDate: Date;
		VerificationCount: number;
	}
	export interface BulkResolveBookkeepingCheckResultsDto {
		BookkeepingCheckItemResultIds: string[];
		Type: Entities.Accounting.Reconciliations.BookkeepingCheckResolutionType;
		Note: string;
	}
	export interface CheckVerificationGroup {
		Verifications: Common.Controllers.CheckVerificationVerification[];
		Key: string;
	}
	export interface CheckVerificationPatternAccount {
		Account: number;
		AccountName: string;
		Sum: number;
		Ratio: number;
		RatioBeforeVat: number;
	}
	export interface CheckVerificationsViewModel {
		Groups: Common.Controllers.CheckVerificationGroup[];
	}
	export interface CheckVerificationVerification {
		Verification: Core.ViewData.VerificationForList;
		TransactionGroups: Common.Controllers.CheckVerificationPatternAccount[];
	}
	export interface CreateCustomTodoItemRequest {
		Data: Classes.Todo.CustomTodoData;
	}
	export interface CreateRecurringCustomTodoRequest {
		Title: string;
		StartDate: Day;
		FirstDueDate?: Day;
	}
	export interface EnableBankingTransactionListResponse {
		Items: Common.Controllers.BalanceListItem[];
		DeletedItems: Common.Controllers.BalanceListItem[];
		ManuallyImportedItems: Common.Controllers.BalanceListItem[];
	}
	export interface ErrorDataVersion1 {
		Message: string;
		MessageParametersJson: string;
		MessageTypeName: string;
	}
	export interface InjectFakeLlmPassResultsDto {
		BookkeepingCheckId: string;
		InjectForAllItems: boolean;
		FalseAlarmConfidence?: number;
		FalseAlarmReasoning: string;
	}
	export interface LedgerRenconcileOptionsDto {
		ShowExpenses: boolean;
		ShowFileImport: boolean;
		ShowCopyAndPaste: boolean;
		ShowTaxAccount: boolean;
		ShowBBA: boolean;
		ShowEnableBanking: boolean;
		ShowSupplierInvoices: boolean;
	}
	export interface ListImportantDateErrorInfo {
		ErrorType: Common.Controllers.ListImportantDateErrorInfoType;
		CompanyType: Entities.CompanyType;
		StartDate: Day;
		EndDate: Day;
		ExpectedTurnover: number;
		VatSetting: Entities.VatSetting;
		EndMonth: number;
		FiscalYearId?: string;
		CurrentDate: Day;
	}
	export enum ListImportantDateErrorInfoType {
		Unknown = "Unknown",
		FiscalYearMissing = "FiscalYearMissing",
		NoMatch = "NoMatch",
	}
	export interface ParseFileAccountStatementViewModel {
		DataAsSemicolonCsv: string;
	}
	export interface PreviewBookkeepingCheckDto {
		VerificationCount: number;
	}
	export interface ReceiptCheckDetailsDto {
		Id: string;
		CreatedUtc: Date;
		FromDate: Day;
		ToDate: Day;
		Status: Entities.Accounting.Reconciliations.RecordingCheckStatus;
		Data: Entities.Accounting.Reconciliations.RecordingCheckStorageData;
		Findings: Common.Controllers.ReceiptCheckErrorDto[];
	}
	export interface ReceiptCheckErrorDto {
		VerificationId: string;
		ErrorCode: Entities.Accounting.Reconciliations.ErrorCodeEnum;
		Resolution: Common.Controllers.ReceiptCheckErrorResolutionDto;
		Id: string;
		FindingId: string;
		Severity: Common.Controllers.RecordingCheckErrorSeverityForView;
		Data: Common.Controllers.ErrorDataVersion1;
	}
	export interface ReceiptCheckErrorResolutionDto {
		Id: string;
		Note: string;
		VerificationId: string;
		Type: Entities.Accounting.Reconciliations.RecordingCheckResolutionType;
		Audit: AuditInfo;
	}
	export interface ReceiptCheckForListDto {
		Id: string;
		CreatedUtc: Date;
		FromDate: Day;
		ToDate: Day;
		Status: Entities.Accounting.Reconciliations.RecordingCheckStatus;
		SequenceNumber: number;
	}
	export interface RecheckVerificationDto {
		BookkeepingCheckId: string;
		VerificationId: string;
	}
	export interface RecheckVerificationResultDto {
		Id: string;
		VerificationId: string;
	}
	export enum RecordingCheckErrorSeverityForView {
		High = "High",
		Low = "Low",
	}
	export interface ResolveBookkeepingCheckResultDto {
		BookkeepingCheckItemResultId: string;
		Type: Entities.Accounting.Reconciliations.BookkeepingCheckResolutionType;
		Note: string;
	}
	export interface ResolveRecordingCheckErrorDto {
		RecordingCheckId: string;
		VerificationId: string;
		Type: Entities.Accounting.Reconciliations.RecordingCheckResolutionType;
		Note: string;
		ErrorType: Entities.Accounting.Reconciliations.ErrorCodeEnum;
	}
	export interface SetPreferenceRequest {
		Type: Entities.UserPreferenceType;
		IsCompanySpecific: boolean;
		Value: Bokio.Common.Contract.Services.UserPreferences.UserPreferencesDto;
	}
	export interface StartBookkeepingCheckDto {
		FromDate: Day;
		ToDate: Day;
	}
	export interface StartRecordingCheckDto {
		FromDate: Day;
		ToDate: Day;
	}
	export interface UpdateTaxDateDto {
		Id: string;
		Amount: number;
	}
	export interface UpdateTaxPaymentsDto {
		TaxDatesToUpdate: Common.Controllers.UpdateTaxDateDto[];
	}
}
export namespace Common.ViewModels {
	export interface InboxHistoryFilter {
		Pagination: Bokio.Common.Contract.Pagination.Pagination;
		SortChoice: Bokio.Common.Contract.Utils.ListSortChoice<Common.ViewModels.InboxSortableProperties>;
	}
	export interface InboxHistoryViewModel {
		Filter: Common.ViewModels.InboxHistoryFilter;
		Items: Common.ViewModels.InboxMessageForListWithActionInfo[];
		Page: number;
		PageSize: number;
		TotalItems: number;
	}
	export interface InboxMessageAttachmentViewModel {
		Name: string;
		Status: Classes.InboundEmailResultAttachmentStatus;
		ReceiptId?: string;
		Id: string;
	}
	export interface InboxMessageDetailsViewModel {
		Id: string;
		TimeStamp: Date;
		From: string;
		Sender: string;
		FraudCheckResult: Entities.InboxFraudCheckResult;
		SystemAction: Entities.Inboxes.InboxMessageState;
		UserAction?: Entities.Inboxes.InboxMessageState;
		ActiveAction: Entities.Inboxes.InboxMessageState;
		ResultStatus: Classes.InboundEmailResultStatus;
		Attachments: Common.ViewModels.InboxMessageAttachmentViewModel[];
		FraudChecks: Common.ViewModels.InboxMessageFraudCheckViewModel[];
		PositiveFraudChecks: Common.ViewModels.InboxMessageFraudCheckViewModel[];
		SuspiciosFraudChecks: Common.ViewModels.InboxMessageFraudCheckViewModel[];
		FailingFraudChecks: Common.ViewModels.InboxMessageFraudCheckViewModel[];
		CanApprove: boolean;
		CanReject: boolean;
		TextBody: string;
		Subject: string;
		System: Classes.InboundSystem;
	}
	export interface InboxMessageForList {
		Id: string;
		TimeStamp: Date;
		From: string;
		Sender: string;
		FraudCheckResult: Entities.InboxFraudCheckResult;
		SystemAction: Entities.Inboxes.InboxMessageState;
		UserAction?: Entities.Inboxes.InboxMessageState;
		ActiveAction: Entities.Inboxes.InboxMessageState;
		ResultStatus: Classes.InboundEmailResultStatus;
		AttachmentCount: number;
	}
	export interface InboxMessageForListWithActionInfo {
		Message: Common.ViewModels.InboxMessageForList;
		CanApprove: boolean;
		CanReject: boolean;
	}
	export interface InboxMessageFraudCheckViewModel {
		Id: number;
		Check: Entities.Inboxes.FraudCheckType;
		WarningLevel: Entities.InboxFraudCheckResult;
	}
	export enum InboxSortableProperties {
		Timestap = "Timestap",
		Sender = "Sender",
		State = "State",
	}
	export interface ToDoCountViewModel {
		ToDoTotalCount: number;
		ToDoCount: number;
		ImportantDatesCount: number;
		MaximumTodoCountReached: boolean;
	}
}
export namespace Config {
	export interface FeatureAvailabilityConfig {
		Country: string;
		RotRut: boolean;
		Salary: boolean;
		VatCheck: boolean;
		ReversedVAT: boolean;
		InvoiceRounding: boolean;
		SIE: boolean;
		ImportantDates: boolean;
		TrialBalance: boolean;
		PartnerServiceK10: boolean;
		YearEndClosureSE: boolean;
		PrioSupport: boolean;
		FindAnAccountant: boolean;
		Billing: boolean;
		Plans: boolean;
		Cashback: boolean;
		BGFiles: boolean;
		NoMoneyTemplates: boolean;
		RequireCountrySubdivisionForBookkeeping: boolean;
		Stripe: boolean;
		Factoring: boolean;
		BokioBusinessAccount: boolean;
		SalaryFullPaymentSubmissions: boolean;
		EInvoice: boolean;
		BookkeepingSupport: boolean;
		Drilldown: boolean;
		SkatteverketSync: boolean;
		PublicApi: boolean;
		PublicApiIntegrationMarketplace: boolean;
		AiFeatures: boolean;
		AllowNewSignups: boolean;
		CreateCustomAccounts: boolean;
		Plaid: boolean;
		Klarna: boolean;
		EnableBanking: boolean;
	}
}
export namespace Contracts {
	export enum CallTimePreference {
		SoonAsPossible = "SoonAsPossible",
		Morning = "Morning",
		Afternoon = "Afternoon",
	}
	export interface GetSupportCategoriesRequest {
		Url?: string;
	}
	export interface HelpRequest {
		Name: string;
		Email: string;
		Subject: string;
		Area: Contracts.SupportFormArea;
		CallTimePreference?: Contracts.CallTimePreference;
		Category: Contracts.SupportFormCategory;
		SubCategory: Contracts.SupportFormSubCategory;
		Message: string;
		FrontendRoute: string;
		ExactUrl: string;
		IsCurrentPageRelevant: boolean;
		Type?: Contracts.HelpType;
		ReferenceId: string;
		PhoneNumber: string;
		IsCallBackRequest?: boolean;
		DoesCompanyHavePhoneNumber?: boolean;
	}
	export enum HelpType {
		NotSet = "NotSet",
		Question = "Question",
		Technincal = "Technincal",
		Feedback = "Feedback",
	}
	export interface SupportArea {
		Label: string;
		Key: Contracts.SupportFormArea;
		UrlPatterns: string[];
		SupportCategories: Contracts.SupportCategory[];
	}
	export interface SupportCategory {
		Label: string;
		Key: Contracts.SupportFormCategory;
		SubCategories: Contracts.SupportSubCategory[];
	}
	export enum SupportFormArea {
		NotSet = "NotSet",
		RecordingAndClosure = "RecordingAndClosure",
		SuppliersAndPurchases = "SuppliersAndPurchases",
		Bank = "Bank",
		InvoiceCustomers = "InvoiceCustomers",
		Expenses = "Expenses",
		Reports = "Reports",
		EmployeesAndSalaries = "EmployeesAndSalaries",
		AdditionalServices = "AdditionalServices",
		PricePlans = "PricePlans",
		ImportSie = "ImportSie",
		OpenApi = "OpenApi",
		BackOffice = "BackOffice",
		Overview = "Overview",
		Todo = "Todo",
		Settings = "Settings",
		Accounting = "Accounting",
		Closure = "Closure",
		Agencies = "Agencies",
		Other = "Other",
	}
	export enum SupportFormCategory {
		NotSet = "NotSet",
		JournalEntries = "JournalEntries",
		Templates = "Templates",
		ManualRecording = "ManualRecording",
		Closure = "Closure",
		FixedAssets = "FixedAssets",
		RecordingAndClosureOther = "RecordingAndClosureOther",
		SupplierInvoices = "SupplierInvoices",
		Suppliers = "Suppliers",
		SupplierAndPurchasesCreditInvoice = "SupplierAndPurchasesCreditInvoice",
		SupplierAndPurchasesPayment = "SupplierAndPurchasesPayment",
		SuppliersAndPurchasesOther = "SuppliersAndPurchasesOther",
		Bba = "Bba",
		AutomaticBankImport = "AutomaticBankImport",
		ManualImport = "ManualImport",
		BankRules = "BankRules",
		Swish = "Swish",
		InternationalPayments = "InternationalPayments",
		OutgoingInternationalPayments = "OutgoingInternationalPayments",
		TransactionsToRecord = "TransactionsToRecord",
		BankOther = "BankOther",
		Invoice = "Invoice",
		CashInvoice = "CashInvoice",
		CreditInvoice = "CreditInvoice",
		EInvoice = "EInvoice",
		Quotes = "Quotes",
		RotRut = "RotRut",
		Customers = "Customers",
		Articles = "Articles",
		Factoring = "Factoring",
		RecurringInvoices = "RecurringInvoices",
		InvoicesOther = "InvoicesOther",
		Create = "Create",
		Payments = "Payments",
		Setup = "Setup",
		EditOrDelete = "EditOrDelete",
		Permissions = "Permissions",
		ExpensesOther = "ExpensesOther",
		ProfitAndLossReport = "ProfitAndLossReport",
		GeneralLedger = "GeneralLedger",
		BalanceReport = "BalanceReport",
		VatReturns = "VatReturns",
		InvoicesReport = "InvoicesReport",
		AgedDebtors = "AgedDebtors",
		SalaryReports = "SalaryReports",
		ResultAnalysis = "ResultAnalysis",
		TagReport = "TagReport",
		AccountsPayable = "AccountsPayable",
		ReportsOther = "ReportsOther",
		Salary = "Salary",
		Employees = "Employees",
		Vacation = "Vacation",
		ApplicationforAdvancedPayroll = "ApplicationforAdvancedPayroll",
		EmployeesAndSalariesOther = "EmployeesAndSalariesOther",
		HireAccountant = "HireAccountant",
		Integrations = "Integrations",
		Offerings = "Offerings",
		Zettle = "Zettle",
		Stripe = "Stripe",
		BokioApi = "BokioApi",
		ChangePlan = "ChangePlan",
		Payment = "Payment",
		Guidance = "Guidance",
		Upgrade = "Upgrade",
		Downgrade = "Downgrade",
		Membership = "Membership",
		Receipts = "Receipts",
		ExpressionOfInterest = "ExpressionOfInterest",
		PricePlansOther = "PricePlansOther",
		Overview = "Overview",
		Todo = "Todo",
		ReceiptInbox = "ReceiptInbox",
		OtherOther = "OtherOther",
		LoyaltyProgram = "LoyaltyProgram",
		MoveToBokio = "MoveToBokio",
		GraphsAndCharts = "GraphsAndCharts",
		AccountingDetails = "AccountingDetails",
		TodoList = "TodoList",
		ImportantDates = "ImportantDates",
		Uploads = "Uploads",
		GetStartedImport = "GetStartedImport",
		CloseAccountExport = "CloseAccountExport",
		FiscalYears = "FiscalYears",
		ChartOfAccounts = "ChartOfAccounts",
		CustomTemplates = "CustomTemplates",
		Ã…rsredovisningOnline = "Ã…rsredovisningOnline",
		ManualClosure = "ManualClosure",
		NEAttachment = "NEAttachment",
	}
	export enum SupportFormSubCategory {
		NotSet = "NotSet",
		SendingPayment = "SendingPayment",
		RecevingPayment = "RecevingPayment",
		GetBba = "GetBba",
		Card = "Card",
		BbaOther = "BbaOther",
		InvoiceCreate = "InvoiceCreate",
		InvoiceRecord = "InvoiceRecord",
		InvoiceEdit = "InvoiceEdit",
		InvoiceOther = "InvoiceOther",
		CashInvoiceCreate = "CashInvoiceCreate",
		CashInvoiceRecord = "CashInvoiceRecord",
		CashInvoiceEdit = "CashInvoiceEdit",
		CashInvoiceOther = "CashInvoiceOther",
		CreditInvoiceCreate = "CreditInvoiceCreate",
		CreditInvoiceRecord = "CreditInvoiceRecord",
		CreditInvoiceEdit = "CreditInvoiceEdit",
		CreditInvoiceOther = "CreditInvoiceOther",
		EInvoiceCreate = "EInvoiceCreate",
		EInvoiceRecord = "EInvoiceRecord",
		EInvoiceEdit = "EInvoiceEdit",
		EInvoiceOther = "EInvoiceOther",
		CustomersCreate = "CustomersCreate",
		CustomersImportExport = "CustomersImportExport",
		CustomersEdit = "CustomersEdit",
		CustomersOther = "CustomersOther",
		ArticlesCreate = "ArticlesCreate",
		ArticlesImportExport = "ArticlesImportExport",
		ArticlesEdit = "ArticlesEdit",
		ArticlesOther = "ArticlesOther",
		CreateSalary = "CreateSalary",
		RecordSalary = "RecordSalary",
		Agi = "Agi",
		SalaryOther = "SalaryOther",
		CreateEmployee = "CreateEmployee",
		Contract = "Contract",
		Vacation = "Vacation",
		EmployeesOther = "EmployeesOther",
		IntegrationsFactoring = "IntegrationsFactoring",
		Zettle = "Zettle",
		IntegrationsOther = "IntegrationsOther",
		LoyaltyProgramEnquiry = "LoyaltyProgramEnquiry",
		MoveToBokioEnquiry = "MoveToBokioEnquiry",
	}
	export interface SupportMessageCategories {
		DefaultArea: Contracts.SupportFormArea;
		SupportAreas: Contracts.SupportArea[];
	}
	export interface SupportSubCategory {
		Label: string;
		Key: Contracts.SupportFormSubCategory;
	}
}
export namespace Contracts.FeatureRequests {
	export interface FeatureRequestDto {
		Id: string;
		Title: string;
		Description: string;
		Votes: number;
		Status: Entities.FeatureRequestStatus;
		UserHasVoted: boolean;
		CreatedAtDate: Day;
		DuplicateOf?: Contracts.FeatureRequests.FeatureRequestDto;
	}
	export interface FeatureRequestForAdminDto {
		Id: string;
		Title: string;
		Description: string;
		Votes: number;
		Status: Entities.FeatureRequestStatus;
		CreatedByUserId?: string;
		CreatedAtDate: Day;
		Category: Entities.FeatureCategory;
	}
}
export namespace Contracts.Invoices {
	export interface InvoiceItemToBookkeep {
		Type: Contracts.Invoices.InvoiceItemToBookkeepType;
		ItemId: string;
		InvoiceNumberWithPrefix: string;
		Date: Day;
		Sum: number;
		InvoiceId: string;
		AccountingType?: Entities.AccountingType;
		Currency?: string;
	}
	export enum InvoiceItemToBookkeepType {
		Invoice = "Invoice",
		Payment = "Payment",
		Reminder = "Reminder",
		Financing = "Financing",
		Settlement = "Settlement",
	}
}
export namespace Core {
	export interface ActiveBankConnection {
		ExternalSystem: Entities.Bank.ExternalSystem;
		BankAccountId: string;
		BankAccountName?: string;
		BookkeepingAccount: number;
		BankConfiguration: Bokio.Bank.Contract.Dtos.BankConfiguration;
		HasConsent: boolean;
		PrimaryAccountPaymentType?: Entities.Teller.TellerPaymentType;
		BankAccountType: Entities.Bank.BankAccountType;
		KycInformation?: Bokio.Common.Helpers.SveaKycInformationDto;
	}
	export enum Features {
		Unknown = "Unknown",
		BokioBusinessAccountPricingExperiment = "BokioBusinessAccountPricingExperiment",
		UnderDevelopment = "UnderDevelopment",
		AOAnnualReport = "AOAnnualReport",
		InvoicePdfGeneratorV3 = "InvoicePdfGeneratorV3",
		StripeIntegration = "StripeIntegration",
		UkCustomTemplates = "UkCustomTemplates",
		ReceivingEInvoices = "ReceivingEInvoices",
		OldBusinessChat = "OldBusinessChat",
		LegacyBokioBusinessAccount = "LegacyBokioBusinessAccount",
		SveaInternationalPayments = "SveaInternationalPayments",
		MirCloseDown = "MirCloseDown",
		BypassMirCloseDown = "BypassMirCloseDown",
		MultipleBokioBusinessAccountBankAccounts = "MultipleBokioBusinessAccountBankAccounts",
		MirCloseDownFinal = "MirCloseDownFinal",
		ForceBankAccountCreationFromSveaAsyncEvents = "ForceBankAccountCreationFromSveaAsyncEvents",
		ForceBankAccountCreationFromSveaUI = "ForceBankAccountCreationFromSveaUI",
		V2VatFlow = "V2VatFlow",
		RecurringInvoiceVersion3 = "RecurringInvoiceVersion3",
		EnableBanking = "EnableBanking",
		NewFactoringAPI = "NewFactoringAPI",
		SveaInternationalPaymentsV2 = "SveaInternationalPaymentsV2",
		EventsToRecord = "EventsToRecord",
		RecordingChecks = "RecordingChecks",
		FiscalYearDuration2024To2025 = "FiscalYearDuration2024To2025",
		PayDividendsWithBba = "PayDividendsWithBba",
		BankAccountModel = "BankAccountModel",
		FeatureRequests = "FeatureRequests",
		EventsToRecordUK = "EventsToRecordUK",
		ArsredovisningOnlineNE = "ArsredovisningOnlineNE",
		AiFeedback = "AiFeedback",
		ExpensesInEventsToRecord = "ExpensesInEventsToRecord",
		GraniteNet10 = "GraniteNet10",
		Friskvard = "Friskvard",
		BbaOverdraft = "BbaOverdraft",
		AIVerificationExplanation = "AIVerificationExplanation",
		SveaDelegates = "SveaDelegates",
		AutoReceiptRequirement = "AutoReceiptRequirement",
		AttestationFlow = "AttestationFlow",
		BookkeepingChecks_AI = "BookkeepingChecks_AI",
		SupplierInvoiceAttestation = "SupplierInvoiceAttestation",
	}
	export interface FeatureState {
		Key: Core.Features;
		Active: boolean;
	}
	export enum FiscalYearStatus {
		HasActiveFiscal = "HasActiveFiscal",
		NoActiveYear = "NoActiveYear",
		PromptToCreateNextYear = "PromptToCreateNextYear",
	}
	export interface PartnerStatus {
		PartnerId: string;
		PartnerName: string;
		PartnerType?: Entities.PartnerType;
		PartnerCompanyType?: Entities.PartnerCompanyType;
		PartnerCompanyStatus: Entities.PartnerCompanyStatus;
	}
}
export namespace Core.Closures {
	export interface ConnectToAORequest {
		FiscalId: string;
		RedirectTo: string;
	}
}
export namespace Core.Contracts.Todo {
	export interface AutoVerificationMatchData {
		Title: string;
		Name: string;
		Date: Day;
		Sum: number;
		UniquePaymentReference: string;
	}
	export interface AutoVerificationMatchRowData {
		Account: number;
		Amount: number;
		Text: string;
		Date: Day;
		RowVersion: string;
	}
	export enum MatchType {
		Invoice = "Invoice",
		SupplierInvoice = "SupplierInvoice",
		Verification = "Verification",
		SalaryIncomeTax = "SalaryIncomeTax",
		SalarySocialFees = "SalarySocialFees",
		VatTaxes = "VatTaxes",
		Payslip = "Payslip",
		Disbursement = "Disbursement",
	}
	export enum ReceiptCategoryType {
		uncategorized = "uncategorized",
		expense = "expense",
		income = "income",
		supplier = "supplier",
		other = "other",
		billing = "billing",
		transactionReceipt = "transactionReceipt",
	}
	export interface TodoAutoVerificationMatch {
		AutoVerificationRowId?: string;
		Text: string;
		Amount: number;
		Date: Day;
		AccuracyScore: number;
		Type: Core.Contracts.Todo.MatchType;
		SupplierInvoiceId?: string;
		InvoiceId?: string;
		VerificationId?: string;
		Data: Core.Contracts.Todo.AutoVerificationMatchData;
		Account: number;
		SalaryTaxPeriodId?: string;
		DisbursementId?: string;
		RowVersion: string;
	}
	export enum TodoGroupType {
		None = "None",
		Material = "Material",
		Expenses = "Expenses",
		Invoices = "Invoices",
		SupplierInvoice = "SupplierInvoice",
		Salary = "Salary",
		Bank = "Bank",
		Savings = "Savings",
		Vat = "Vat",
		Inbox = "Inbox",
		DraftVerifications = "DraftVerifications",
		DailyTakings = "DailyTakings",
		ConnectToMoneyAccount = "ConnectToMoneyAccount",
		OrderCard = "OrderCard",
		ActivateCard = "ActivateCard",
		CompanyOnboardingManagePayments = "CompanyOnboardingManagePayments",
		CompanyOnboardingEasyToUseAccounting = "CompanyOnboardingEasyToUseAccounting",
		CompanyOnboardingSendProfessionalInvoices = "CompanyOnboardingSendProfessionalInvoices",
		CompanyOnboardingTrackAllYourBills = "CompanyOnboardingTrackAllYourBills",
		CompanyOnboardingManageSalaries = "CompanyOnboardingManageSalaries",
		CompanyOnboardingManageExpenses = "CompanyOnboardingManageExpenses",
		CompanyOnboardingGetHelpFromAccountant = "CompanyOnboardingGetHelpFromAccountant",
		DepositMoney = "DepositMoney",
		Payments = "Payments",
		ContinueSveaOnboarding = "ContinueSveaOnboarding",
		ECommerce = "ECommerce",
		StartBbaKycApplication = "StartBbaKycApplication",
		ContinueBbaKycApplication = "ContinueBbaKycApplication",
		CompanySettings = "CompanySettings",
		Vacation = "Vacation",
		CheckMissingTransactionsWhenMigratingFromKlarna = "CheckMissingTransactionsWhenMigratingFromKlarna",
		ContinueSwishOnboarding = "ContinueSwishOnboarding",
		ContinueSavingsAccountOnboarding = "ContinueSavingsAccountOnboarding",
		ConnectBookkeepingSavingsAccountOnboarding = "ConnectBookkeepingSavingsAccountOnboarding",
		DeclinedSavingsAccountOnboarding = "DeclinedSavingsAccountOnboarding",
		AssetDepreciation = "AssetDepreciation",
		ReviewBankAccessNewUser = "ReviewBankAccessNewUser",
		ReviewBankAccessRemovedUser = "ReviewBankAccessRemovedUser",
	}
	export interface TodoItemDto {
		Id?: string;
		ReceiptId?: string;
		ReceiptCategory?: Core.Contracts.Todo.ReceiptCategoryType;
		ItemId: string;
		Title: string;
		Sum?: number;
		Date: Day;
		Account?: number;
		Users: Classes.UserDto[];
		Data: string;
		TypedData?: Classes.Todo.TodoItemStoredData;
		ProviderKey: string;
		DoNow: boolean;
		HasSupport: boolean;
		SupportWaitingFor: Core.Contracts.Todo.TodoSupportState;
		Section: Core.Contracts.Todo.TodoSectionType;
		Group: Core.Contracts.Todo.TodoGroupType;
		WaitingForSomeoneElse: boolean;
		Matches: Core.Contracts.Todo.TodoAutoVerificationMatch[];
		HasAccess: boolean;
		CanBeSplit: boolean;
		DisableMatching: boolean;
		Description?: string;
		CanBeModified: boolean;
		TaskStatus?: Entities.Partners.WorkStatusType;
		DueDate?: Date;
		Count: number;
	}
	export enum TodoSectionType {
		Approve = "Approve",
		Bookkeep = "Bookkeep",
		Pay = "Pay",
		BookkeepPayment = "BookkeepPayment",
		GetPayment = "GetPayment",
		SchedulePayment = "SchedulePayment",
		Promotions = "Promotions",
		SupportMessages = "SupportMessages",
		BankConnection = "BankConnection",
		CompanyOnboarding = "CompanyOnboarding",
		CompleteClosure = "CompleteClosure",
		Review = "Review",
		CompleteTasks = "CompleteTasks",
		NewPaymentMethods = "NewPaymentMethods",
		CustomTodo = "CustomTodo",
		BokioBusinessAccount = "BokioBusinessAccount",
	}
	export enum TodoSupportState {
		None = "None",
		Company = "Company",
		Partner = "Partner",
	}
}
export namespace Core.Culture {
	export interface CultureChoice {
		Name: string;
		DisplayName: string;
		EnglishName: string;
	}
}
export namespace Core.Invoices {
	export interface InvoicePaymentMethodTemplate {
		CanEditLabels: boolean;
		Heading: string;
		HasNoTemplate: boolean;
		HasSecondaryInfo: boolean;
		HasThirdInfo: boolean;
		IsDisabled: boolean;
		IsDomestic: boolean;
		IsForeign: boolean;
		Key: Entities.Invoices.InvoicePaymentMethodKey;
		PrimaryLabel?: string;
		PrimaryValue?: string;
		SecondaryLabel?: string;
		SecondaryValue?: string;
		ThirdLabel?: string;
		ThirdValue?: string;
	}
}
export namespace Core.Manifest {
	export interface ServerManifest {
		PrimaryCulture: string;
		SupportedCultures: string[];
		Sites: Core.Manifest.Site[];
		Copyright: string;
		LegalSystem: string;
		ReleaseVersion: string;
		ReleaseDate: Date;
		ReleaseDateString: string;
	}
	export interface Site {
		Country: string;
		Domain: string;
	}
}
export namespace Core.Metrics.DigitalAnnualReportMetrics.Requests {
	export interface DigitalAnnualReportFeedbackRequest {
		Message: string;
	}
}
export namespace Core.Metrics.Feedback {
	export interface AgencyFeedbackRequest {
		Topic: string;
		Message: string;
	}
	export interface GenericFeedbackRequest {
		Topic: string;
		Subject: string;
		Message: string;
	}
}
export namespace Core.Queries.Todo {
	export interface CompanyOnboardingTodoData {
		Type: Core.Queries.Todo.CompanyOnboardingTodoType;
	}
	export enum CompanyOnboardingTodoType {
		Guide_ActivateBokioBusinessAccount = "Guide_ActivateBokioBusinessAccount",
		ActivateBokioBusinessAccount = "ActivateBokioBusinessAccount",
		Guide_LearnAccounting = "Guide_LearnAccounting",
		BeforeYouStart_ImportPreviousBookkeeping = "BeforeYouStart_ImportPreviousBookkeeping",
		BeforeYouStart_EnsureBalancesMatch = "BeforeYouStart_EnsureBalancesMatch",
		BeforeYouStart_CheckVatPeriod = "BeforeYouStart_CheckVatPeriod",
		ImportTransactionsFromOldBank = "ImportTransactionsFromOldBank",
		RecordFirstTransaction = "RecordFirstTransaction",
		Guide_LearnSales = "Guide_LearnSales",
		BeforeYouStart_InvoiceLayout = "BeforeYouStart_InvoiceLayout",
		SendFirstInvoice = "SendFirstInvoice",
		Guide_LearnSuppliersAndPurchases = "Guide_LearnSuppliersAndPurchases",
		UploadFirstBill = "UploadFirstBill",
		Guide_LearnSalaries = "Guide_LearnSalaries",
		BeforeYouStart_AddFirstEmployee = "BeforeYouStart_AddFirstEmployee",
		DoFirstPayroll = "DoFirstPayroll",
		Guide_LearnExpenses = "Guide_LearnExpenses",
		BeforeYouStart_AddPersonalAccountDetails = "BeforeYouStart_AddPersonalAccountDetails",
		UploadFirstExpense = "UploadFirstExpense",
		Guide_LearnHowToWorkWithAccountant = "Guide_LearnHowToWorkWithAccountant",
		ReachOutToAccountant = "ReachOutToAccountant",
	}
	export interface SupplierInvoiceTodoData {
		HasScheduledPayment: boolean;
		ShouldSchedulePayment: boolean;
	}
}
export namespace Core.Recipes {
	export enum FailReason {
		DuplicateDetected = "DuplicateDetected",
		SumDoesNotAddUp = "SumDoesNotAddUp",
		VerificationWasNotFinished = "VerificationWasNotFinished",
		FutureDate = "FutureDate",
		YearClosed = "YearClosed",
		YearDoesntExist = "YearDoesntExist",
		PaymentBeforeInvoiceDate = "PaymentBeforeInvoiceDate",
		InvalidAccount = "InvalidAccount",
		ReceiptAlreadyBookkept = "ReceiptAlreadyBookkept",
		VatPeriodClosed = "VatPeriodClosed",
		VatPeriodStarted = "VatPeriodStarted",
		HasLaterConversionBalances = "HasLaterConversionBalances",
		InvalidTransactionsForConnectedEntity = "InvalidTransactionsForConnectedEntity",
		InvalidDateForConnectedEntity = "InvalidDateForConnectedEntity",
		IsAnyAutoVerificationRowsPendingOrInconsistent = "IsAnyAutoVerificationRowsPendingOrInconsistent",
		ReachedMaximumVerificationsLimitForTestCompany = "ReachedMaximumVerificationsLimitForTestCompany",
		AccountBalanceLimitExceeded = "AccountBalanceLimitExceeded",
		ReceiptIsDeleted = "ReceiptIsDeleted",
		PeriodIsLocked = "PeriodIsLocked",
		InvalidBookkeepingForSupplierInvoice = "InvalidBookkeepingForSupplierInvoice",
		RecipeNotSupportedForVatFree = "RecipeNotSupportedForVatFree",
		VatSettingFromFrontendDoesNotMatchWithCompanyVatSetting = "VatSettingFromFrontendDoesNotMatchWithCompanyVatSetting",
		HasBankRowMatches = "HasBankRowMatches",
		ItemHasBeenChanged = "ItemHasBeenChanged",
		RecipeNotFound = "RecipeNotFound",
		FutureDateWithLimit = "FutureDateWithLimit",
	}
	export interface RecipeInputDefinition {
		Variables: Core.Recipes.Variable[];
		DescriptionExpression: string;
		MoneyAccountSetting: Bokio.Bank.Contract.MoneyAccount.MoneyAccountSettingsForView;
		AccountingForm: Entities.AccountingType;
		Description: string;
		Name: string;
		FixedName: string;
		Id: string;
	}
	export interface RegisteredRecipeResult {
		Success: boolean;
		VerificationNumber: string;
		FailReasonMessage: string;
		FailReason: Core.Recipes.FailReason;
		VerificationId: string;
		RecordingWasPrepared: boolean;
	}
	export interface Variable {
		Key: string;
		Label: string;
		Description: string;
		DataType: string;
		VariableType: Core.Recipes.VariableType;
		IsSystemVariable: boolean;
		Optional: boolean;
		IsFixedAssetTemplate: boolean;
		Options: Core.Recipes.VariableOption[];
		DefinitionOptions: Core.Recipes.VariableOption[];
	}
	export interface VariableOption {
		Label: string;
		Value: string;
	}
	export enum VariableType {
		Unknown = "Unknown",
		MoneyType = "MoneyType",
		Money0Type = "Money0Type",
		DateType = "DateType",
		PaymentDateType = "PaymentDateType",
		TextType = "TextType",
		NumberType = "NumberType",
		AccountType = "AccountType",
		DropdownType = "DropdownType",
		AssetDropdownType = "AssetDropdownType",
	}
}
export namespace Core.Recipes.Dtos {
	export interface BookkeepingForms {
		GeneralForms: Core.Recipes.Dtos.FormItem[];
		RecipeForms: Core.Recipes.Dtos.RecipeForm[];
	}
	export interface FormItem {
		Key: string;
		VariableType: Core.Recipes.VariableType;
		Label: string;
		Options: Core.Recipes.VariableOption[];
		IsFixedAssetTemplate: boolean;
	}
	export interface RecipeForm {
		RecipeId: string;
		Name: string;
		FixedName: string;
		Description: string;
		VatPercentage?: number;
		FormItems: Core.Recipes.Dtos.FormItem[];
		PaymentDirection: Entities.PaymentDirection;
		IsVATFree: boolean;
		IsCustom: boolean;
	}
}
export namespace Core.Recipes.Requests {
	export interface AdvancedCustomRecipePreviewRequest {
		CustomRecipe: Bokio.Accounting.Contract.Recipes.Dtos.AdvancedCustomRecipeDto;
		Amount: number;
	}
	export interface CustomRecipeShareRequest {
		CustomRecipeId: string;
		IsShared: boolean;
	}
	export interface PreviewCostOrIncomeRecipeDto {
		CustomRecipe: Bokio.Accounting.Contract.Recipes.Dtos.CostOrIncomeRecipeDto;
		PaymentAccount?: number;
		VATArea: string;
	}
	export interface PreviewTransferRecipeDto {
		CustomRecipe: Bokio.Accounting.Contract.Recipes.Dtos.TransferRecipeDto;
		PaymentAccount?: number;
		VATArea: string;
	}
}
export namespace Core.Reports {
	export interface CashflowGroupItem {
		Id: string;
		Title: string;
		Date: Date;
		Sum: number;
	}
	export enum CashflowGroupItemType {
		Invoice = "Invoice",
		SupplierInvoice = "SupplierInvoice",
		Disbursement = "Disbursement",
		SalaryPayment = "SalaryPayment",
	}
	export enum CashflowGroupType {
		Income = "Income",
		Cost = "Cost",
	}
	export interface CashFlowItemGroup {
		ItemType: Core.Reports.CashflowGroupItemType;
		GroupType: Core.Reports.CashflowGroupType;
		Items: Core.Reports.CashflowGroupItem[];
		Total: number;
		Title: string;
	}
	export interface PrognosisExplanation {
		Included: string[];
		NotIncluded: string[];
	}
	export interface ResultReportPeriod {
		FromDate: Day;
		ToDate: Day;
		PeriodText: string;
	}
	export interface VerificationForReport {
		Date: Day;
		Account: number;
		Sum: number;
		Debet: number;
		Credit: number;
		VerificationNumber: string;
		Title: string;
		Id: string;
		IsInactive: boolean;
	}
}
export namespace Core.Reports.VAT {
	export enum VerificationRemapperResultState {
		NotNeeded = "NotNeeded",
		Remapped = "Remapped",
		Failed = "Failed",
	}
}
export namespace Core.Salary.Calculations {
	export interface PayslipError {
		Type: string;
	}
}
export namespace Core.Salary.Calculations.PopulationData {
	export interface PopulationRegion {
		Name: string;
		Population: number;
		Code: number;
	}
}
export namespace Core.Salary.Calculations.Taxreports {
	export interface ReportStructureBase {
		Blocks: Core.Salary.Calculations.Taxreports.TaxReportBlock[];
	}
	export interface TaxReportBlock {
		Title: string;
		Type: string;
		Rows: Core.Salary.Calculations.Taxreports.TaxReportRow[];
	}
	export interface TaxReportResult {
		Sum: number;
		Fields: { [key: number]: number; };
		Structure: Core.Salary.Calculations.Taxreports.ReportStructureBase;
	}
	export interface TaxReportRow {
		Title: string;
		RowType: string;
		Cells: number[];
	}
}
export namespace Core.Services.Closures {
	export interface ClosureForListDto {
		SettingsId: string;
		FiscalYear: Core.ViewData.FiscalYearViewModel;
		Finished: boolean;
		TotalStep: number;
		CurrentStep: number;
		ClosureFlow: Bokio.Accounting.Contract.AnnualReport.Dtos.ClosureFlow;
	}
}
export namespace Core.Services.CompanyDrafts {
	export interface CompanyDraftForView {
		Id: string;
		CurrentStep: Entities.CompanyDraftStepKey;
		Name: string;
		Address: Entities.Address;
		OrgNumber: string;
		Type: Entities.CompanyDraftType;
		Source: Entities.CompanyDraftSource;
		CompanyType: Entities.CompanyType;
		StartDate?: Day;
		EndDate?: Day;
		StartedAt?: Day;
		UsesOfficialDetails: boolean;
		VatSetting: Entities.VatSetting;
		AccountingType: Entities.AccountingType;
		ActiveFiscalFromSearch?: Bokio.Services.CompanySearch.FiscalYearInfoDto;
		ClientOwnership?: Bokio.Common.Contract.CompanyDrafts.Dtos.ClientOwnershipDto;
		AgencyId?: string;
		VoucherCodeToActivate: string;
		PhoneNumber: string;
	}
}
export namespace Core.Services.FeatureToggles {
	export interface FeatureToggleViewModel {
		Name: string;
		Description: string;
		ReadMoreLink: string;
		Key: string;
		Enabled: boolean;
		Constraints: string[];
		AlwaysEnabledFromDateTimeUtc?: Date;
		CantDisable: boolean;
	}
	export interface ToggleFeatureDto {
		Enabled: boolean;
		FeatureKey: string;
		Feedback: string;
	}
}
export namespace Core.Services.FiscalYears {
	export interface FiscalYearRangeDto {
		StartDate: Day;
		EndDate: Day;
	}
}
export namespace Core.Services.ManualMatch {
	export interface BankRowPossibleMatch {
		Matches: Core.Contracts.Todo.TodoAutoVerificationMatch[];
	}
}
export namespace Core.Services.Notes {
	export interface AgencyCommentDto {
		Id: string;
		State: Core.Services.Notes.CommentsStateDto;
		Author: Classes.UserDto;
		TimeCreated: Date;
		NotificationStatus: Core.Services.Notes.NotificationStatusDto;
		UpdateInfo: Core.Services.Notes.UpdateInfo;
		CompanyId: string;
		CompanyName: string;
	}
	export interface CommentsStateDto {
		Text: string;
		MentionedAgencyGuids: string[];
		MentionedCompanyGuids: string[];
		QuoteRequestId?: string;
	}
	export interface NotificationStatusDto {
		Status: Entities.Notifications.NotificationStatusTypes;
		StatusUpdateDateTime: Date;
	}
	export interface TasksStateDto {
		Text: string;
		TaskStatus: Entities.Partners.WorkStatusType;
		Assignee?: Classes.UserDto;
		DueDate?: Day;
		IsClientAssignee: boolean;
		QuoteRequestId?: string;
		Title: string;
		Priority: Entities.Priority;
		EditAccess: Entities.EditAccess;
	}
	export interface UpdateInfo {
		NoteUpdateDateTime: Date;
		UserName: string;
	}
}
export namespace Core.Services.Notifications.Dtos {
	export interface AgencyNotificationSettingDto {
		Name: string;
		NotificationArea: Entities.Notifications.NotificationArea;
		NotificationAreaType: Entities.Notifications.NotificationAreaType;
		Enabled: boolean;
		NotificationTargets: Core.Services.Notifications.Dtos.AgencyNotificationTargetSettingDto[];
	}
	export interface AgencyNotificationSettingGroupByAreaDto {
		Name: string;
		NotificationArea: Entities.Notifications.NotificationArea;
		Settings: Core.Services.Notifications.Dtos.AgencyNotificationSettingDto[];
	}
	export interface AgencyNotificationTargetSettingDto {
		NotificationTarget: Entities.Notifications.NotificationTarget;
		Enabled: boolean;
	}
	export interface NotificationDto {
		Id: string;
		Status: Entities.Notifications.NotificationStatusTypes;
		Timestamp: Date;
		Message: string;
		Area: Entities.Notifications.NotificationArea;
		AreaType: Entities.Notifications.NotificationAreaType;
		ItemId?: string;
		ItemType?: Entities.Notifications.NotificationItemType;
		LinkTo: string;
	}
	export interface NotificationSettingDto {
		Name: string;
		NotificationArea: Entities.Notifications.NotificationArea;
		NotificationAreaType: Entities.Notifications.NotificationAreaType;
		Enabled: boolean;
		NotificationTargets: Core.Services.Notifications.Dtos.NotificationTargetSettingDto[];
	}
	export interface NotificationSettingGroupByAreaDto {
		Name: string;
		NotificationArea: Entities.Notifications.NotificationArea;
		Settings: Core.Services.Notifications.Dtos.NotificationSettingDto[];
	}
	export interface NotificationTargetSettingDto {
		NotificationTarget: Entities.Notifications.NotificationTarget;
		Enabled: boolean;
	}
	export interface NotificationWebActivityDto {
		AreaType: Entities.Notifications.NotificationAreaType;
		BadgeCount: number;
	}
	export interface NotificationWebRefreshPingJobDto {
		ReceipientUserId: string;
		AreaType: Entities.Notifications.NotificationAreaType;
		BadgeCount: number;
	}
	export interface PushNotificationDataDto {
		CompanyId: string;
		NotificationId: string;
		Area: Entities.Notifications.NotificationArea;
		ItemId?: string;
		ItemType?: Entities.Notifications.NotificationItemType;
		TransactionIsInStorePurchase?: boolean;
		TransactionAutoVerificationRowId?: string;
	}
}
export namespace Core.Services.VAT {
	export enum SeVatReportState {
		Unknown = "Unknown",
		Reconcile = "Reconcile",
		LockReport = "LockReport",
		DownloadReport = "DownloadReport",
		DeclareVat = "DeclareVat",
		CompletedReport = "CompletedReport",
		ManuallyMarkedAsComplete = "ManuallyMarkedAsComplete",
		ActivePeriod = "ActivePeriod",
		PayVat = "PayVat",
	}
	export interface VatReportListDto {
		ActiveFiscalYearRange: Core.Services.FiscalYears.FiscalYearRangeDto;
		ActiveVatSetting: Entities.VatSetting;
		Periods: Core.Services.VAT.VatReportPeriodDto[];
	}
	export interface VatReportPeriodDto {
		FromDate: Day;
		ToDate: Day;
		ReportState: Core.Services.VAT.SeVatReportState;
		Year: number;
		Period: number;
		VatAmount?: number;
		ReportId?: string;
		Changed?: Date;
		DefaultVatTaxDate?: Day;
		VatTaxDate?: Day;
		NonEUTradeVatTaxDate?: Day;
	}
	export enum VatServiceError {
		NoError = "NoError",
		FiscalYearsDamaged = "FiscalYearsDamaged",
		OtherError = "OtherError",
		VatSettingsNotCoveringPeriod = "VatSettingsNotCoveringPeriod",
		VatReportBeforeFirstFiscalYear = "VatReportBeforeFirstFiscalYear",
	}
}
export namespace Core.ViewData {
	export interface AlienDebt {
		Receivables: number;
		Payables: number;
	}
	export enum AlienInvoiceError {
		InvoiceNumberConflict = "InvoiceNumberConflict",
		InvoiceNumberAheadOfInvoiceNumberCounter = "InvoiceNumberAheadOfInvoiceNumberCounter",
		TotalAlienInvoiceSumExceedsIncomingReceivables = "TotalAlienInvoiceSumExceedsIncomingReceivables",
		TotalAlienInvoiceSumExceedsIncomingPayables = "TotalAlienInvoiceSumExceedsIncomingPayables",
	}
	export interface BalanceReportRowDto {
		SummaryName: string;
		Name: string;
		Date?: Day;
		Key: string;
		SubRows: Core.ViewData.BalanceReportRowDto[];
		HadTransactions: boolean;
		Incoming: number;
		Result: number;
		Outgoing: number;
		Id?: string;
		ShowOnlySummary: boolean;
		IsInactive: boolean;
	}
	export interface BatchMailResponseDto {
		Success: boolean;
		Responses: Core.ViewData.MailResponseDto[];
	}
	export interface ClosureForView {
		Id: string;
		SettingsId: string;
		VerificationId?: string;
		Finished: boolean;
		CurrentStep: number;
		TotalStep: number;
		StartPart: Entities.Accounting.StartPart;
		DepreciationPart: Entities.Accounting.DepreciationsPart;
		PeriodisationPart: Entities.Accounting.PeriodisationPart;
		ProvisionPart: Entities.Accounting.ProvisionPart;
		ChecklistPart: Entities.Accounting.ChecklistPart;
		TaxPart: Entities.Accounting.TaxPart;
		AccountingPart: Entities.Accounting.AccountingPart;
		ArsredovisningOnlinePart: Entities.Accounting.ArsredovisningOnlinePart;
		ResultPart: Entities.Accounting.ResultPart;
		Inquiry: Entities.Inquiry;
		Document: Entities.Accounting.Document;
		FiscalYear: Core.ViewData.FiscalYearViewModel;
		IsAssignedToClosure: boolean;
		LockableState: Core.ViewData.LockableState;
		VatSettings: Entities.VatSetting[];
		TransferEquityVerificationId?: string;
		TransferResultPart: Entities.Accounting.TransferResultPart;
		TransferBalancedResultPart: Entities.Accounting.TransferBalancedResultPart;
		DividendsDecisionPart: Entities.Accounting.DividendsDecisionPart;
		PayDividendsPart: Entities.Accounting.PayDividendsPart;
		AnnualGeneralMeetingDate?: Day;
		DividendsAmount?: number;
		Shareholders: Core.ViewData.ShareholderForView[];
		UnhandledEvents: Bokio.Accounting.Contract.UnhandledEvents.UnhandledEventDto[];
	}
	export interface CompanySettingsForView {
		Id: string;
		AccountingForm: Entities.AccountingType;
		BasePlanKey: string;
		FiscalYear: Core.ViewData.FiscalYearViewModel;
		CompanyId: string;
		LatestVerificationNumber: string;
		IsClosed: boolean;
		NeedsReview: boolean;
		ValidationStatus: Core.ViewData.ValidationStatus;
	}
	export interface CompanyVatSettingDto {
		Id: string;
		CompanyId: string;
		StartDate: Day;
		EndDate?: Day;
		VatSetting: Entities.VatSetting;
	}
	export interface CustomAccountForView {
		Id: number;
		Text: string;
		ConnectedTo?: number;
	}
	export interface EmailActivityDto {
		Type: Core.ViewData.VisibleEmailActivityType;
		TimeUtc: Date;
		ItemId: string;
		MessageId?: string;
		SentTo: string;
		TypeOrderIndex: number;
		Message: string;
	}
	export interface FiscalYearSettingValidationResult {
		Valid: boolean;
		ExpectedTurnover: number;
		VatSetting: Entities.VatSetting;
	}
	export interface FiscalYearViewModel {
		StartDate: Day;
		EndDate: Day;
		Key: string;
		HasValue: boolean;
		YearString: string;
	}
	export enum ImportantDateStatus {
		None = "None",
		Started = "Started",
		Completed = "Completed",
		Upcoming = "Upcoming",
		Overdue = "Overdue",
	}
	export interface ImportantDateViewModel {
		Id: string;
		Date: Day;
		Status: Core.ViewData.ImportantDateStatus;
		Title: string;
		Description: string;
		CategoryId: string;
		HiddenCategory: boolean;
		HiddenDate: boolean;
		State: Entities.ImportantDate.ImportantDateState;
		Link: string;
		PeriodStart?: Day;
		PeriodEnd?: Day;
	}
	export enum LockableState {
		Lockable = "Lockable",
		MustLockPreviousYearsFirst = "MustLockPreviousYearsFirst",
		MustWaitUntilEnoughBankDaysHavePassed = "MustWaitUntilEnoughBankDaysHavePassed",
	}
	export interface MailResponseDto {
		Success: boolean;
		MessageId: string;
		Subject: string;
		Sent: Date;
		From: string;
		To: string;
		Id: string;
	}
	export interface PeriodlyValue {
		PeriodIndex: number;
		Value: number;
	}
	export enum PreviewTemplate {
		FictionalVat = "FictionalVat",
		FictionalVatMultiple = "FictionalVatMultiple",
		Vat = "Vat",
		VatMultiple = "VatMultiple",
		SingleAccount = "SingleAccount",
		Unknown = "Unknown",
	}
	export interface ReceiptPredictionActivityDto {
		CompanyId: string;
		ReceiptId: string;
		IsSuccessful: boolean;
	}
	export interface RegisteredVerificationResult {
		Verification: Core.ViewData.VerificationForList;
		Success: boolean;
		VerificationNumber: string;
		FailReasonMessage: string;
		FailReason: Core.Recipes.FailReason;
		VerificationId: string;
		RecordingWasPrepared: boolean;
	}
	export interface RegisterSupplierInvoiceDto {
		SupplierInvoiceId: string;
		Date: Day;
		Title: string;
		Transactions: Core.ViewData.TransactionDto[];
		IgnoreDuplicateCheck: boolean;
		RecieptId?: string;
		SupplierId?: string;
		ExpectPaymentAt?: Day;
		PaymentVerificationFor?: string;
		UserIdForTesting?: string;
		CopyOfVerificationId?: string;
		Comment?: string;
		FailReasonsToBypass?: Core.Recipes.FailReason[];
	}
	export interface RegisterViewModel {
		Date: Day;
		Title: string;
		Transactions: Core.ViewData.TransactionDto[];
		IgnoreDuplicateCheck: boolean;
		RecieptId?: string;
		SupplierId?: string;
		ExpectPaymentAt?: Day;
		PaymentVerificationFor?: string;
		UserIdForTesting?: string;
		CopyOfVerificationId?: string;
		Comment?: string;
		FailReasonsToBypass?: Core.Recipes.FailReason[];
	}
	export interface ReportPeriodViewModel {
		FromDate: Day;
		ToDate: Day;
		Year: number;
		Period: number;
		ReportId?: string;
		Setting: Core.ViewData.CompanySettingsForView;
		DefaultVatTaxDate?: Day;
		VatTaxDate?: Day;
		NonEUTradeVatTaxDate?: Day;
	}
	export interface ResultReportRowDto {
		SummaryName: string;
		Name: string;
		Key: string;
		Values: Core.ViewData.PeriodlyValue[];
		SubRows: Core.ViewData.ResultReportRowDto[];
		HadTransactions: boolean;
		Account?: number;
		IsBreakdownRow: boolean;
	}
	export interface SaveRecipesVerificationForSupplierInvoice {
		SupplierInvoiceId: string;
		SaveFromRecipesCommand: Bokio.Accounting.Contract.Verifications.Requests.SaveVerificationFromMultipleRecipesRequest;
	}
	export interface ShareholderForView {
		Id: string;
		Name: string;
		BankAccount: string;
		ClearingNumber: string;
		NumberOfShares?: number;
		DividendPayoutStatus?: Entities.Teller.TellerPaymentStatus;
	}
	export interface SupplierInvoiceErrorsDto {
		HasErrors: boolean;
		PreparedBookkeepingIncorrect: boolean;
	}
	export enum SupplierInvoiceExternalSystem {
		None = "None",
		EInvoice = "EInvoice",
		BokioBilling = "BokioBilling",
	}
	export interface SupplierInvoiceForView {
		Id: string;
		SupplierId: string;
		SupplierName: string;
		Type: Entities.Payment.SupplierInvoiceType;
		Deadline: Day;
		Date: Day;
		Sum: number;
		RemainingSum: number;
		ReferenceNumber: string;
		Title: string;
		HasScheduledPayment: boolean;
		VerificationId?: string;
		HasPrefillData: boolean;
		InvoiceSystem: Entities.Payment.SupplierInvoiceSystem;
		Statuses: Core.ViewData.SupplierInvoiceStatus[];
		HasExternalPayments: boolean;
		ExternalSystem: Core.ViewData.SupplierInvoiceExternalSystem;
		CurrencyCode: string;
		SumInInvoiceCurrency?: Bokio.Common.Contract.AmountWithCurrency;
		CreditedSumInInvoiceCurrency?: Bokio.Common.Contract.AmountWithCurrency;
		CreditedSum: Bokio.Common.Contract.AmountWithCurrency;
		InvoiceAccountingType: Entities.AccountingType;
		IsConnectedCreditInvoice: boolean;
		AttestationStatus?: Entities.AttestationFlow.AttestationRequestStatus;
		InvoiceErrors: Core.ViewData.SupplierInvoiceErrorsDto;
	}
	export enum SupplierInvoiceStatus {
		Unpaid = "Unpaid",
		ReadyToSign = "ReadyToSign",
		Scheduled = "Scheduled",
		Paid = "Paid",
		UnderPaid = "UnderPaid",
		OverPaid = "OverPaid",
		NotRecorded = "NotRecorded",
		Overdue = "Overdue",
		Rejected = "Rejected",
		CreditNote = "CreditNote",
		Periodised = "Periodised",
	}
	export interface TagForList {
		FullTag: string;
		AllowedValueId: string;
	}
	export interface TransactionDto {
		Account: number;
		Debet: number;
		Credit: number;
	}
	export interface TransactionForList {
		Account: number;
		AccountName: string;
		Debet: number;
		Credit: number;
		Id: number;
	}
	export enum ValidationError {
		ImbalancedOutgoingBalances = "ImbalancedOutgoingBalances",
		OutgoingIngoingBalanceDiff = "OutgoingIngoingBalanceDiff",
		BalanceDiffWithoutTransactions = "BalanceDiffWithoutTransactions",
	}
	export enum ValidationState {
		NotValidated = "NotValidated",
		Valid = "Valid",
		Invalid = "Invalid",
	}
	export interface ValidationStatus {
		State: Core.ViewData.ValidationState;
		Errors: Core.ViewData.ValidationError[];
	}
	export interface VATReportForView {
		Id: string;
		VerificationId?: string;
		Verification?: Core.ViewData.VerificationForList;
	}
	export interface VerificationForList {
		Id: string;
		VerificationNumber: string;
		Date: Day;
		Title: string;
		Transactions: Core.ViewData.TransactionForList[];
		AllDistinctTags: Core.ViewData.TagForList[];
		HasDepreciation: boolean;
		ExpectPaymentAt?: Day;
		PlannedPaymentAccount?: number;
		ReceiptIds: string[];
		CreatedBy?: string;
		CreatedUtc: Date;
		VerificationsThatShouldHaveComeBefore: string[];
		NumberSortIndex: number;
		DateSortIndex: number;
		HasDigitalRecipt: boolean;
		CanRegisterPayment?: boolean;
		ParentRelations: Core.ViewData.VerificationRelationForList[];
		Sum?: number;
		IsDeleted: boolean;
		UserEmail: string;
		IsInactive?: boolean;
		Source: Entities.Source;
	}
	export interface VerificationPreview {
		Template: Core.ViewData.PreviewTemplate;
		VatSum: number;
		Sum: number;
		Account: number;
		AccountName: string;
	}
	export interface VerificationRelationForList {
		ParentVerificationId: string;
		ChildVerificationId: string;
		Type: Entities.RelationType;
	}
	export enum VisibleEmailActivityType {
		Processed = "Processed",
		Delivered = "Delivered",
		Opened = "Opened",
		Clicked = "Clicked",
		Bounced = "Bounced",
		Failed = "Failed",
	}
}
export namespace Entities {
	export enum AccountingType {
		Cash = "Cash",
		Invoice = "Invoice",
		InvoiceWithCashVAT = "InvoiceWithCashVAT",
		NotSet = "NotSet",
	}
	export interface AcquisitionCampaignData {
		CampaignId: string;
		Source: string;
		Medium: string;
		Name: string;
		Term: string;
		Content: string;
	}
	export interface Address {
		Street1?: string;
		Street2?: string;
		City?: string;
		PostalCode?: string;
		Country?: string;
		AddressString: string;
	}
	export enum AgencyDraftSource {
		NotSet = "NotSet",
		SignUp = "SignUp",
		ExistingUser = "ExistingUser",
	}
	export interface AgencyMetadata {
		OrgNumber?: string;
		ContractStatus: Entities.ContractStatus;
		CompanyType: Entities.CompanyType;
		BusinessDescription?: string;
		Address?: Entities.Address;
		PhoneNumber?: string;
	}
	export enum AgencyUserPreferenceType {
		MenuLoyaltyPlanCollapsedPreference = "MenuLoyaltyPlanCollapsedPreference",
		MoveToBokioBannerDismissedPreference = "MoveToBokioBannerDismissedPreference",
		HideAgencyOnboardingChecklistPreference = "HideAgencyOnboardingChecklistPreference",
		CustomClientColumnsPreference = "CustomClientColumnsPreference",
		LastReadWhatsNewDateAgency = "LastReadWhatsNewDateAgency",
	}
	export interface Attestation {
		IsDone: boolean;
		IsDenied: boolean;
	}
	export enum AutomaticCheckingEnum {
		Unspecified = "Unspecified",
		Enabled = "Enabled",
		Disabled = "Disabled",
	}
	export enum BillingSubscriptionPaymentState {
		OK = "OK",
		PastDue = "PastDue",
		BlockedDueToMissingPayment = "BlockedDueToMissingPayment",
		PaidByAgency = "PaidByAgency",
		PaidByAgencyAndHaveOwnPlan = "PaidByAgencyAndHaveOwnPlan",
	}
	export enum BillingSubscriptionState {
		Activated = "Activated",
		Downgrading = "Downgrading",
		Trialing = "Trialing",
	}
	export enum BokioPlan {
		Invalid = "Invalid",
		Free = "Free",
		/** @deprecated */
		Balance = "Balance",
		/** @deprecated */
		Business = "Business",
		Premium = "Premium",
		Pro = "Pro",
		Trial_2025 = "Trial_2025",
		Basic_2025 = "Basic_2025",
		Premium_2025 = "Premium_2025",
		Business_2025 = "Business_2025",
		Plus_2025 = "Plus_2025",
		/** @deprecated */
		Beta = "Beta",
		/** @deprecated */
		FreeShared = "FreeShared",
	}
	export interface BokioPlanData {
		Plan: Entities.BokioPlan;
	}
	export enum BookkeepingImportSteps {
		Start = "Start",
		PickPreviousSystem = "PickPreviousSystem",
		HowToImport = "HowToImport",
		AccountantStep = "AccountantStep",
		SelectImportMethodWithoutWizard = "SelectImportMethodWithoutWizard",
		Completed = "Completed",
		Skipped = "Skipped",
		NotTracking = "NotTracking",
	}
	export enum BookkeepingTools {
		NotSet = "NotSet",
		AnalogueBooks = "AnalogueBooks",
		Excel = "Excel",
		Other = "Other",
		NoBookkeeping = "NoBookkeeping",
		BLBokforing = "BLBokforing",
		Edison = "Edison",
		Fortnox = "Fortnox",
		HogiaSmallOffice = "HogiaSmallOffice",
		PromikBook = "PromikBook",
		Speedledger = "Speedledger",
		VismaCompact500 = "VismaCompact500",
		VismaEnskildFirma = "VismaEnskildFirma",
		VismaSPCS = "VismaSPCS",
		Zenconomy = "Zenconomy",
		Zervant = "Zervant",
		RedFlag = "RedFlag",
		FreeAgent = "FreeAgent",
		Kashflow = "Kashflow",
		Pandle = "Pandle",
		Quickbooks = "Quickbooks",
		Quickfile = "Quickfile",
		Sage = "Sage",
		VT = "VT",
		Wave = "Wave",
		Xero = "Xero",
	}
	export interface CellData {
		Name: string;
		Value: number;
		ManualValue: number;
	}
	export enum CommentStatus {
		Unknown = "Unknown",
		Active = "Active",
		Edited = "Edited",
		Removed = "Removed",
	}
	export enum CompanyAddressPosition {
		Right = "Right",
		Left = "Left",
	}
	export enum CompanyAuthenticationState {
		NotAuthenticated = "NotAuthenticated",
		Authenticated = "Authenticated",
	}
	export enum CompanyDraftSource {
		NotSet = "NotSet",
		SignUp = "SignUp",
		ExistingUser = "ExistingUser",
		MobileSignup = "MobileSignup",
		TestCompanyBanner = "TestCompanyBanner",
		AgencyCreated = "AgencyCreated",
		RFMigration = "RFMigration",
		SignUpYearEnd = "SignUpYearEnd",
		Resumed = "Resumed",
		TestCompanyModal = "TestCompanyModal",
		TestCompanyPortal_Invoices = "TestCompanyPortal_Invoices",
		TestCompanyPortal_TransactionToRecord = "TestCompanyPortal_TransactionToRecord",
		TestCompanyPortal_Journals = "TestCompanyPortal_Journals",
		TestCompanyPortal_Todo = "TestCompanyPortal_Todo",
		CompanyList_CreateTestCompany = "CompanyList_CreateTestCompany",
		TestCompanyPortal_EventsToRecord = "TestCompanyPortal_EventsToRecord",
		Onboarding_Wizard = "Onboarding_Wizard",
	}
	export enum CompanyDraftStepKey {
		PickType = "PickType",
		PickCompany = "PickCompany",
		Details = "Details",
		FiscalDetails = "FiscalDetails",
		Completed = "Completed",
		CompanyOwnership = "CompanyOwnership",
		/** @deprecated Used in A/B test. Kept so we know the values stored in DB */
		PickBusinessStructure = "PickBusinessStructure",
		/** @deprecated Used in A/B test. Kept so we know the values stored in DB */
		SetupTestCompany = "SetupTestCompany",
		/** @deprecated Used in A/B test. Kept so we know the values stored in DB */
		ImportCompanySelectTool = "ImportCompanySelectTool",
		/** @deprecated Used in A/B test. Kept so we know the values stored in DB */
		ImportCompanySelectMethod = "ImportCompanySelectMethod",
		OnboardingWizard = "OnboardingWizard",
	}
	export enum CompanyDraftType {
		NotSet = "NotSet",
		RealCompany = "RealCompany",
		TestCompany = "TestCompany",
		AgencyClientCompany = "AgencyClientCompany",
	}
	export interface CompanyImage {
		Mimetype: string;
		Length: number;
		Version: number;
	}
	export enum CompanyImportMethod {
		NotSet = "NotSet",
		ImportSie = "ImportSie",
		SetOpeningBalances = "SetOpeningBalances",
		BookkeepManually = "BookkeepManually",
		WontBookkeep = "WontBookkeep",
		ImportCsv = "ImportCsv",
	}
	export enum CompanyInvitationStatus {
		Pending = "Pending",
		Canceled = "Canceled",
		Accepted = "Accepted",
		NotSent = "NotSent",
	}
	export enum CompanyInvitationType {
		General = "General",
		Expenses = "Expenses",
		Accountant = "Accountant",
	}
	export interface CompanyInvoiceData {
		PaymentTerms: string;
		DeliveryTerms: string;
		DelayInterest: string;
		DisableRounding?: boolean;
		ValidDays: number;
	}
	export interface CompanyPlan {
		CompanyId: string;
		Plan: Entities.BokioPlan;
		ChangeDate?: Date;
		UpcomingPlan?: Entities.BokioPlan;
		PaymentState: Entities.BillingSubscriptionPaymentState;
		SubscriptionState: Entities.BillingSubscriptionState;
		AuditUtc: Date;
	}
	export enum CompanySystem {
		Default = "Default",
		DemoCompany = "DemoCompany",
		DevSupportImport = "DevSupportImport",
		TestCompany = "TestCompany",
	}
	export enum CompanyType {
		Proprietorship = "Proprietorship",
		LimitedCompany = "LimitedCompany",
		LimitedPartnership = "LimitedPartnership",
		Partnership = "Partnership",
		Cooperative = "Cooperative",
		NonProfitAssociation = "NonProfitAssociation",
		CommunityAssociation = "CommunityAssociation",
		ReligiousCommunity = "ReligiousCommunity",
		NotSet = "NotSet",
	}
	export enum CompanyUserRoleType {
		Invalid = "Invalid",
		AppCompanyOwner = "AppCompanyOwner",
	}
	export interface ContactPerson {
		FirstName: string;
		LastName: string;
		PhoneNumber: string;
		Email: string;
	}
	export enum ContractStatus {
		NotSigned = "NotSigned",
		Signed = "Signed",
		Pending = "Pending",
	}
	export enum CreationSource {
		UserCreated = "UserCreated",
		BokioCreated = "BokioCreated",
	}
	export enum CustomClientColumns {
		None = "None",
		OrgNumber = "OrgNumber",
		CompanyType = "CompanyType",
		AssignedAccountants = "AssignedAccountants",
		PricePlanCurrentPlan = "PricePlanCurrentPlan",
		FiscalYearEnd = "FiscalYearEnd",
		ConnectionDate = "ConnectionDate",
		Email = "Email",
		CreatedByAgency = "CreatedByAgency",
		PlanEndDate = "PlanEndDate",
	}
	export enum CustomerType {
		Company = "Company",
		Private = "Private",
	}
	export interface DecimalRange {
		From: number;
		To: number;
	}
	export interface DeliveryInformation {
		Name: string;
		Address: Entities.Address;
	}
	export enum DisbursementPaymentType {
		Manual = "Manual",
		Teller = "Teller",
	}
	export enum DisbursementStatus {
		Planned = "Planned",
		Paid = "Paid",
		MarkedAsManuallyRecorded = "MarkedAsManuallyRecorded",
	}
	export enum EditAccess {
		NotSet = "NotSet",
		OnlyMe = "OnlyMe",
		Anyone = "Anyone",
	}
	export interface ExchangeRate {
		Currency: string;
		CounterCurrency: string;
		Value: number;
		Date: Day;
	}
	export enum ExpenseType {
		Standard = "Standard",
		Friskvard = "Friskvard",
		Mileage = "Mileage",
		PerDiem = "PerDiem",
	}
	export enum ExportReasonType {
		ChangingSystem = "ChangingSystem",
		Other = "Other",
	}
	export interface ExtendedAddress {
		Co?: string;
		AdditionalLines?: string[];
		CountryCode?: string;
		AddressString: string;
		Street1?: string;
		Street2?: string;
		City?: string;
		PostalCode?: string;
		Country?: string;
	}
	export interface ExternalId {
		System: string;
		Id: string;
	}
	export enum FeatureCategory {
		None = "None",
		Recording = "Recording",
		Closure = "Closure",
		Salary = "Salary",
		Expense = "Expense",
		Uploads = "Uploads",
		Agency = "Agency",
		Reports = "Reports",
		Invoice = "Invoice",
		BBA = "BBA",
		BankImport = "BankImport",
		Suppliers = "Suppliers",
		AdditionalServices = "AdditionalServices",
		Todo = "Todo",
		MobileApp = "MobileApp",
		Other = "Other",
	}
	export enum FeatureRequestStatus {
		Pending = "Pending",
		Approved = "Approved",
		Rejected = "Rejected",
		Completed = "Completed",
		Duplicate = "Duplicate",
	}
	export enum ImportOptions {
		Close = "Close",
		CloseVat = "CloseVat",
		CloseClosure = "CloseClosure",
	}
	export enum ImportState {
		NotSet = "NotSet",
		Created = "Created",
		ImportedCompanyInfo = "ImportedCompanyInfo",
		ImportedMissingAccounts = "ImportedMissingAccounts",
		ImportedTagTypesAndValues = "ImportedTagTypesAndValues",
		ErrorWarning = "ErrorWarning",
		ErrorFatal = "ErrorFatal",
		Forced = "Forced",
		Verified = "Verified",
		ImportedYears = "ImportedYears",
		Abandoned = "Abandoned",
		Crashed = "Crashed",
	}
	export enum InboxFraudCheckResult {
		Trusted = "Trusted",
		Suspicious = "Suspicious",
		Fail = "Fail",
	}
	export interface InboxWhitelistItem {
		Email: string;
		UserId?: string;
		Timestamp: Date;
		AcceptableLevel?: Entities.InboxFraudCheckResult;
	}
	export enum InfoFetchState {
		None = "None",
		Started = "Started",
		NotFound = "NotFound",
		Finished = "Finished",
		Failed = "Failed",
		Ignored = "Ignored",
	}
	export interface Inquiry {
		Id: string;
		State: Entities.InquiryState;
		Type: Entities.InquiryType;
		Contact: Entities.InquiryContactInfo;
		Data: string;
		Key: string;
		AssigneeId?: string;
		AgencyId?: string;
		Agency: Entities.Partner;
	}
	export interface InquiryContactInfo {
		Email: string;
		Phone: string;
	}
	export enum InquiryState {
		Waiting = "Waiting",
		Notified = "Notified",
		Assigned = "Assigned",
		Closed = "Closed",
		Finished = "Finished",
	}
	export enum InquiryType {
		Offer = "Offer",
		FixedPrice = "FixedPrice",
		BokioFixedPrice = "BokioFixedPrice",
		K1 = "K1",
		K2 = "K2",
		K3 = "K3",
	}
	export interface InvoiceReceiverData {
		Type: Entities.CustomerType;
		Name?: string;
		CustomerNumber: number;
		OrgNumber: string;
		TaxRegistrationNumber: string;
		Address: Entities.Address;
		ContactName: string;
		Email: string;
		Phone: string;
		ValidDays: number;
		PaymentTerms: string;
		DeliveryTerms: string;
		DelayInterest: string;
		CountryIso2: string;
		CountrySubdivision: string;
		IsForeign: boolean;
		IsReversedVATEnabled: boolean;
		Language: string;
		EInvoiceExternalId?: Entities.ExternalId;
	}
	export interface InvoiceSenderData {
		CompanyName: string;
		Address: Entities.Address;
		OrgNumber: string;
		TaxRegistrationNumber: string;
		Email: string;
		Phone: string;
		ReferenceName: string;
		CountrySubdivision?: CountrySubdivision;
		/** @deprecated Use PaymentMethods instead */
		Bankgiro: string;
		/** @deprecated Use PaymentMethods instead */
		Postgiro: string;
		/** @deprecated Use PaymentMethods instead */
		BIC: string;
		/** @deprecated Use PaymentMethods instead */
		IBAN: string;
		/** @deprecated Use PaymentMethods instead */
		BankAccount: string;
		PaymentMethod: Entities.Invoices.InvoicePaymentMethod;
		ForeignPaymentMethod: Entities.Invoices.InvoicePaymentMethod;
		AddUniqueReferenceNumber: boolean;
		IsTaxRegistered?: boolean;
	}
	export enum MembershipType {
		HasUser = "HasUser",
		ViewBookkeeping = "ViewBookkeeping",
		Bookkeep = "Bookkeep",
		UploadReceipt = "UploadReceipt",
		UploadBank = "UploadBank",
		Closures = "Closures",
		Partner = "Partner",
		Reports = "Reports",
		SupportUser = "SupportUser",
		Attest = "Attest",
		ImportantDates = "ImportantDates",
		BbaAccess = "BbaAccess",
		Disbursements = "Disbursements",
		UploadExpense = "UploadExpense",
		Salaries = "Salaries",
		Invoices = "Invoices",
		SupplierInvoices = "SupplierInvoices",
		AccountingSettings = "AccountingSettings",
		InvoiceSettings = "InvoiceSettings",
		SalarySettings = "SalarySettings",
		CompanySettings = "CompanySettings",
		Inbox = "Inbox",
		AdminUsers = "AdminUsers",
		InquiryAssign = "InquiryAssign",
	}
	export enum NoteKind {
		Comment = "Comment",
		Task = "Task",
	}
	export interface NumberRange {
		From: number;
		To: number;
	}
	export interface Partner {
		Id: string;
		Name?: string;
		Metadata?: Entities.AgencyMetadata;
		Type?: Entities.PartnerType;
		Audit: AuditInfo;
		SupportResponsible: boolean;
		ClosureResponsible: boolean;
		RootAccountingFirm: boolean;
		/** @deprecated Helpscout is not used as a helpdesk system anymore */
		HelpscoutMailboxId?: string;
		PartnershipKind: Entities.PartnershipKind;
		Deleted: boolean;
		DeleteUserId?: string;
	}
	export enum PartnerCompanyResponsibilities {
		ConnectedToAgency = "ConnectedToAgency",
		TaxAdvice = "TaxAdvice",
		Bookkeeping = "Bookkeeping",
		Reconciliation = "Reconciliation",
		ReviewAndCorrectionOfBookkeeping = "ReviewAndCorrectionOfBookkeeping",
		VatReturns = "VatReturns",
		YearEnd = "YearEnd",
		Payroll = "Payroll",
		TaxReturn = "TaxReturn",
		ForecastingAndBudgeting = "ForecastingAndBudgeting",
		ManagementAccounts = "ManagementAccounts",
	}
	export enum PartnerCompanyStatus {
		Requested = "Requested",
		Active = "Active",
		Inactive = "Inactive",
	}
	export enum PartnerCompanyType {
		None = "None",
		FullPartner = "FullPartner",
		Closure = "Closure",
		Consulting = "Consulting",
		AgencyClient = "AgencyClient",
		AgencyTestClient = "AgencyTestClient",
	}
	export enum PartnerMembershipType {
		Viewer = "Viewer",
		ManageCompanies = "ManageCompanies",
		ManageUsers = "ManageUsers",
		ClosureSupport = "ClosureSupport",
		BookkeepingSupport = "BookkeepingSupport",
		PartnerSettings = "PartnerSettings",
		SelfAssign = "SelfAssign",
		Partner = "Partner",
		AnswerSupportTicket = "AnswerSupportTicket",
		SupportUser = "SupportUser",
		ManageQuoteRequests = "ManageQuoteRequests",
		FeatureRequests = "FeatureRequests",
	}
	export enum PartnerRatingType {
		Unknown = "Unknown",
		CreateClientCompany = "CreateClientCompany",
		CreateNote = "CreateNote",
		QuoteRequest = "QuoteRequest",
		CustomClientColumns = "CustomClientColumns",
	}
	export enum PartnershipKind {
		Regular = "Regular",
		CanPayForTheClient = "CanPayForTheClient",
		CanOwnCompanies = "CanOwnCompanies",
	}
	export enum PartnerType {
		Fortner = "Fortner",
		Bokio = "Bokio",
		Agency = "Agency",
		AgencyPartner = "AgencyPartner",
	}
	export enum PaymentDirection {
		Unknown = "Unknown",
		In = "In",
		Out = "Out",
		InShowAll = "InShowAll",
		OutShowAll = "OutShowAll",
		NoDirection = "NoDirection",
	}
	export enum PreviousBookkepingMethod {
		NotSet = "NotSet",
		ExcelOrSimilar = "ExcelOrSimilar",
		PenAndPaper = "PenAndPaper",
		OtherSoftware = "OtherSoftware",
		Accountant = "Accountant",
		NoPreviousBookkeeping = "NoPreviousBookkeeping",
	}
	export enum PricePlanFeature {
		Tags = "Tags",
		AssetManagement = "AssetManagement",
		ProprietorshipClosure = "ProprietorshipClosure",
		NeAttatchmentIncluded = "NeAttatchmentIncluded",
		PowerFunctions = "PowerFunctions",
		Invoicing = "Invoicing",
		Sales_CustomInvoiceEmailMessage = "Sales_CustomInvoiceEmailMessage",
		Salary = "Salary",
		VacationTracking = "VacationTracking",
		Expenses = "Expenses",
		AutomaticBankImport = "AutomaticBankImport",
		EInvoice = "EInvoice",
		PublicApi = "PublicApi",
		Zettle = "Zettle",
		AdvancedSalary = "AdvancedSalary",
		TaxAccountSync = "TaxAccountSync",
		PrivateApi = "PrivateApi",
		StartBokioBusinessAccountOnboarding = "StartBokioBusinessAccountOnboarding",
		TelephoneSupport = "TelephoneSupport",
		BookkeepingSupport = "BookkeepingSupport",
		AccessAlreadyOnboardedBokioBusinessAccount = "AccessAlreadyOnboardedBokioBusinessAccount",
	}
	export enum Priority {
		NotSet = "NotSet",
		Low = "Low",
		Medium = "Medium",
		High = "High",
	}
	export enum ProgressStatus {
		Empty = "Empty",
		Loading = "Loading",
		Completed = "Completed",
	}
	export enum ReceiptClass {
		Normal = "Normal",
		OtherItem = "OtherItem",
		FortnerBookkeep = "FortnerBookkeep",
		Bank = "Bank",
		Salary = "Salary",
		CompanyInfo = "CompanyInfo",
	}
	export enum ReceiptType {
		Upload = "Upload",
		Invoice = "Invoice",
		Salary = "Salary",
		SalaryTaxReport = "SalaryTaxReport",
		MileageExpense = "MileageExpense",
		PerDiemExpense = "PerDiemExpense",
		FortnerBookkeepInvoice = "FortnerBookkeepInvoice",
		FortnerBookkeepPayment = "FortnerBookkeepPayment",
		FortnerBookkeepReminder = "FortnerBookkeepReminder",
	}
	export enum ReceiptWaitingStatus {
		WaitingForManager = "WaitingForManager",
		WaitingForEmployee = "WaitingForEmployee",
		None = "None",
	}
	export enum RecipeUsageArea {
		General = "General",
		TaxAccount = "TaxAccount",
	}
	export enum RelationType {
		NotSet = "NotSet",
		Cancels = "Cancels",
		ChildIsCorrectedByParent = "ChildIsCorrectedByParent",
		PaymentFor = "PaymentFor",
		ReminderFor = "ReminderFor",
		RelatedByInvoiceFinancing = "RelatedByInvoiceFinancing",
		SettlementFor = "SettlementFor",
		ChildDepreciatesParent = "ChildDepreciatesParent",
		PeriodisationReverse = "PeriodisationReverse",
		PeriodisationAdjustment = "PeriodisationAdjustment",
		PeriodisationPost = "PeriodisationPost",
	}
	export enum Source {
		NotSet = "NotSet",
		Manual = "Manual",
		Recipe = "Recipe",
		AutoVerification = "AutoVerification",
		VATReport = "VATReport",
		Reminder = "Reminder",
		Invoice = "Invoice",
		Import = "Import",
		InvoiceMehtod = "InvoiceMehtod",
		Cancel = "Cancel",
		Depreciation = "Depreciation",
		Salary = "Salary",
		Closure = "Closure",
		SIImport = "SIImport",
		Api = "Api",
		InvoiceReminder = "InvoiceReminder",
		SupplierInvoice = "SupplierInvoice",
		Disbursement = "Disbursement",
		Conversion = "Conversion",
		Copy = "Copy",
		VacationOnboarding = "VacationOnboarding",
		VacationAdjustment = "VacationAdjustment",
		Periodisation = "Periodisation",
		AssetControl = "AssetControl",
		VacationYearEnd = "VacationYearEnd",
		CashbackPayment = "CashbackPayment",
		EmployeeExpense = "EmployeeExpense",
	}
	export interface SubscriptionExtraData {
		BokioBusinessAccount?: Entities.BokioPlanData;
	}
	export interface SubscriptionInfo {
		CostPerMonth?: number;
		Description: string;
		Key: Entities.SubscriptionKey;
		MonthsBetweenPayment: number;
		Name: string;
		ThirdParty: boolean;
	}
	export enum SubscriptionKey {
		PrioSupport = "PrioSupport",
		Factoring = "Factoring",
		EInvoices = "EInvoices",
		Zaver = "Zaver",
		/** @deprecated Not used anymore. CompanyPlan and billing is used instead */
		BokioPlan = "BokioPlan",
		Stripe = "Stripe",
	}
	export enum TopicType {
		Unknown = "Unknown",
		Verification = "Verification",
		DraftVerification = "DraftVerification",
		Invoice = "Invoice",
		Payslip = "Payslip",
		Payroll = "Payroll",
		SupplierInvoice = "SupplierInvoice",
		RecordingPeriodisation = "RecordingPeriodisation",
	}
	export interface Transaction {
		Id: number;
		VerificationId: string;
		Account: number;
		Sum: number;
		Debet: number;
		Credit: number;
	}
	export enum UserFeatures {
		Unknown = "Unknown",
		ShowGetStartedBoard = "ShowGetStartedBoard",
		DemoCompany = "DemoCompany",
	}
	export enum UserPreferenceType {
		ImportantDatesInformationDismissed = "ImportantDatesInformationDismissed",
		TodoSettings = "TodoSettings",
		SideMenuVisited = "SideMenuVisited",
		DraftVerificationTipDismissed = "DraftVerificationTipDismissed",
		PremiumFeatureInterestDismissed = "PremiumFeatureInterestDismissed",
		AutopilotFeatureInterestDismissed = "AutopilotFeatureInterestDismissed",
		DealsFeatureInterestDismissed = "DealsFeatureInterestDismissed",
		BusinessAccountFeatureInterestDismissed = "BusinessAccountFeatureInterestDismissed",
		BusinessAccountFeatureInterestCollapsed = "BusinessAccountFeatureInterestCollapsed",
		AreYouAnAccountantBannerDismissed = "AreYouAnAccountantBannerDismissed",
		LinkBankAccountToDomesticPaymentPopup = "LinkBankAccountToDomesticPaymentPopup",
		BusinessAccountPersonalBankGiroNoticeDismissed = "BusinessAccountPersonalBankGiroNoticeDismissed",
		BusinessAccountCardCustomisation = "BusinessAccountCardCustomisation",
		BusinessAccountFeatureInterestViewed = "BusinessAccountFeatureInterestViewed",
		InvoiceBusinessAccountPromoDismissed = "InvoiceBusinessAccountPromoDismissed",
		MenuCurrentPlanCollapsed = "MenuCurrentPlanCollapsed",
		PDFV3PromoDismissed = "PDFV3PromoDismissed",
		BbaPopupDismissed = "BbaPopupDismissed",
		ClosureBannerDismissed = "ClosureBannerDismissed",
		ConnectClientCompaniesDismissed = "ConnectClientCompaniesDismissed",
		StripeFeatureInterestResponse = "StripeFeatureInterestResponse",
		SIEExportFeedbackSubmitted = "SIEExportFeedbackSubmitted",
		TryAgencyBannerDismissed = "TryAgencyBannerDismissed",
		BbaTopBarQuickAccessDismissed = "BbaTopBarQuickAccessDismissed",
		BbaTopBarOnboardingNotInterested = "BbaTopBarOnboardingNotInterested",
		BbaTopBarOnboardingNoticePopoverDismissed = "BbaTopBarOnboardingNoticePopoverDismissed",
		BbaCardCustomisedCompanyName = "BbaCardCustomisedCompanyName",
		EinvoicePaymentMethodMovedNoticeDismissedUserPreference = "EinvoicePaymentMethodMovedNoticeDismissedUserPreference",
		AutomationRulesDisplayInTransactionList = "AutomationRulesDisplayInTransactionList",
		LastReadWhatsNewDate = "LastReadWhatsNewDate",
		EInvoiceDiscoverabilityBannerDismissed = "EInvoiceDiscoverabilityBannerDismissed",
		BookkeepingSchoolGetStartedPreference = "BookkeepingSchoolGetStartedPreference",
		ExperimentalOnboardingChecklist = "ExperimentalOnboardingChecklist",
		TestCompanyBumperModal = "TestCompanyBumperModal",
		HideOnboardingChecklist = "HideOnboardingChecklist",
		MathematicalExpressionTipNotice = "MathematicalExpressionTipNotice",
		ShowPricePlanChangeTopBar202309 = "ShowPricePlanChangeTopBar202309",
		ShowAccountBalancePreference = "ShowAccountBalancePreference",
		BbaCloseDownNoticeDismissed = "BbaCloseDownNoticeDismissed",
		ShowBookkeepingPredictions = "ShowBookkeepingPredictions",
		HideCashbackBannerPreference = "HideCashbackBannerPreference",
		BbaKycModalDismissed = "BbaKycModalDismissed",
		CustomTemplatesTipNotice = "CustomTemplatesTipNotice",
		EmployeeDetailsTipNoptice = "EmployeeDetailsTipNoptice",
		ShowCompanyDataStorageSettingsNotice = "ShowCompanyDataStorageSettingsNotice",
		OrderCardThingsToDoDismissed = "OrderCardThingsToDoDismissed",
		ClosureThingsTodoDismissed = "ClosureThingsTodoDismissed",
		MarketingSettingsPopupDismissed = "MarketingSettingsPopupDismissed",
		SalaryPricePlanChangesInfoDismissed = "SalaryPricePlanChangesInfoDismissed",
		DailyTakingsTrailingDatesInfoDismissed = "DailyTakingsTrailingDatesInfoDismissed",
		MoveBankAccountNoticeDismissed = "MoveBankAccountNoticeDismissed",
		ImportantDatesRunWizardNoticeDismissed = "ImportantDatesRunWizardNoticeDismissed",
		AlwaysExpandVerificationPreview = "AlwaysExpandVerificationPreview",
		VaxaSupportAppliedThroughSkatteverketInfoDismissed = "VaxaSupportAppliedThroughSkatteverketInfoDismissed",
		BrandLift2025AnnouncementPopupDismissed = "BrandLift2025AnnouncementPopupDismissed",
		StartBonusFeb2026BannerDismissed = "StartBonusFeb2026BannerDismissed",
		ShowDelightfulEffects = "ShowDelightfulEffects",
		AutogiroTipNoticeDismissed = "AutogiroTipNoticeDismissed",
		AutogiroRecipientTipDismissed = "AutogiroRecipientTipDismissed",
	}
	export interface UserReferralSource {
		ReferrerId?: string;
		Campaign: string;
		/** @deprecated Use AcquisitionCampaign instead */
		Source: string;
	}
	export enum UserSignupType {
		NotSet = "NotSet",
		RegularSignup = "RegularSignup",
		DigitalYearEndSignup = "DigitalYearEndSignup",
		AgencySignup = "AgencySignup",
		ExtraUserInvite = "ExtraUserInvite",
		InvitedAsOwnerByAgency = "InvitedAsOwnerByAgency",
		BankIdSignup = "BankIdSignup",
		DeveloperSignup = "DeveloperSignup",
	}
	export enum VATPeriodStatus {
		Open = "Open",
		Submitted = "Submitted",
		Completed = "Completed",
	}
	export enum VatReportStateHMRC {
		Unknown = "Unknown",
		Completed = "Completed",
	}
	export enum VatSetting {
		Yearly = "Yearly",
		Quarterly = "Quarterly",
		Monthly = "Monthly",
		NotSet = "NotSet",
		ExternalVatProvider = "ExternalVatProvider",
		NotRegisteredForVat = "NotRegisteredForVat",
	}
	export enum VehicleType {
		Invalid = "Invalid",
		PrivateCar = "PrivateCar",
		ServiceCarFuel = "ServiceCarFuel",
		ServiceCarElectric = "ServiceCarElectric",
	}
	export interface VoucherIntent {
		Id: string;
		VoucherCode: string;
		Audit: AuditInfo;
		VoucherValidTo: Date;
		Title: string;
		CreatedSource: Entities.VoucherIntentSource;
	}
	export enum VoucherIntentSource {
		NotSet = "NotSet",
		CreateCompany = "CreateCompany",
		CreateUser = "CreateUser",
	}
}
export namespace Entities.Accounting {
	export interface AccountingPart {
		SkippedByUser: boolean;
		SkippedBySystem: boolean;
		Finished?: boolean;
	}
	export interface ArsredovisningOnlinePart {
		UseArsredovisningOnlineChoice?: boolean;
		AoReportId: string;
		AoVerificationIds: string;
		AoReportUrl: string;
		UserIdThatIsConnected?: string;
		AnnualGeneralMeetingDate?: Day;
		DividendAmount?: number;
		SkippedByUser: boolean;
		SkippedBySystem: boolean;
		Finished?: boolean;
	}
	export enum AssetStatus {
		Unknown = "Unknown",
		Active = "Active",
		Archived = "Archived",
		FullyDepreciated = "FullyDepreciated",
	}
	export interface ChecklistPart {
		SkippedByUser: boolean;
		SkippedBySystem: boolean;
		Finished?: boolean;
	}
	export enum ClosureSubState {
		Unstarted = "Unstarted",
		Open = "Open",
		Confirmed = "Confirmed",
	}
	export enum DepreciationFrequency {
		Annual = "Annual",
		Monthly = "Monthly",
	}
	export interface DepreciationsPart {
		VerificationIds: string;
		RelevantInformation: string;
		SkippedByUser: boolean;
		SkippedBySystem: boolean;
		Finished?: boolean;
	}
	export interface DividendsDecisionPart {
		VerificationId?: string;
		NotPayingDividends: boolean;
		SkippedByUser: boolean;
		SkippedBySystem: boolean;
		Finished?: boolean;
	}
	export interface Document {
		Finish: boolean;
	}
	export enum EntityType {
		None = "None",
		BankTransaction = "BankTransaction",
	}
	export enum HighligtItems {
		None = "None",
		Menu_Todo = "Menu_Todo",
	}
	export interface MoneyAccount {
		MapsTo: number;
		IsDefault: boolean;
		IsSalaryAccount: boolean;
		IsInvoiceAccount: boolean;
		Pinned: boolean;
	}
	export interface MoneyAccountSettings {
		Accounts: Entities.Accounting.MoneyAccount[];
	}
	export interface PayDividendsPart {
		TotalNumberOfShares?: number;
		SkippedByUser: boolean;
		SkippedBySystem: boolean;
		Finished?: boolean;
	}
	export interface PeriodisationPart {
		PeriodisationsJson: string;
		PeriodisationsDto: Entities.Accounting.PeriodisationsDto;
		PeriodisationVerificationIds: string;
		SkippedByUser: boolean;
		SkippedBySystem: boolean;
		Finished?: boolean;
	}
	export interface PeriodisationsDto {
		OutstandingSales?: number;
		RecievedAdvances?: number;
		PrepaidInterest?: number;
		OutstandingInterest?: number;
		GoodsOutstandingExpenses?: number;
		GoodsPrepaidExpenses?: number;
		GoodsInventory?: number;
		OtherOutstandingExpenses?: number;
		OtherPrepaidExpenses?: number;
		OtherClaimsAndDebts?: number;
		PrepaidSalaries?: number;
		UnpaidSocials?: number;
		PrepaidInterestLosses?: number;
		OutstandingInterestLosses?: number;
	}
	export interface ProvisionPart {
		RelevantInformation: string;
		SkippedByUser: boolean;
		SkippedBySystem: boolean;
		Finished?: boolean;
	}
	export enum ReceiptRequestStatus {
		None = "None",
		Required = "Required",
		Uploaded = "Uploaded",
		PoorQuality = "PoorQuality",
		Incorrect = "Incorrect",
		NotNeeded = "NotNeeded",
	}
	export enum RecordingPeriodisationStatus {
		Active = "Active",
		Reversed = "Reversed",
		Finished = "Finished",
	}
	export interface ResultPart {
		SkippedByUser: boolean;
		SkippedBySystem: boolean;
		Finished?: boolean;
	}
	export interface StartPart {
		BookkeepingIncomeAndExpenses: Entities.Accounting.ClosureSubState;
		CompleteVATReport: Entities.Accounting.ClosureSubState;
		InquiryId?: string;
		SkippedByUser: boolean;
		SkippedBySystem: boolean;
		Finished?: boolean;
	}
	export interface TaxPart {
		Tax: number;
		TaxVerificationId?: string;
		SkippedByUser: boolean;
		SkippedBySystem: boolean;
		Finished?: boolean;
	}
	export interface TransferBalancedResultPart {
		VerificationId?: string;
		SkippedByUser: boolean;
		SkippedBySystem: boolean;
		Finished?: boolean;
	}
	export interface TransferResultPart {
		SkippedByUser: boolean;
		SkippedBySystem: boolean;
		Finished?: boolean;
	}
	export enum VerificationAttributeType {
		HiddenFromPrerecordingCheck = "HiddenFromPrerecordingCheck",
	}
}
export namespace Entities.Accounting.Predictions {
	export enum SharedBookkeepingPredictionRuleType {
		Unknown = "Unknown",
		Supplier = "Supplier",
		SupplierSkatteverket = "SupplierSkatteverket",
		TextMatch = "TextMatch",
		Ignored = "Ignored",
	}
}
export namespace Entities.Accounting.Reconciliations {
	export enum BookkeepingCheckAgentType {
		RuleBased = "RuleBased",
		LLM = "LLM",
	}
	export enum BookkeepingCheckFindingCode {
		None = "None",
		VatError = "VatError",
		MissingReceipt = "MissingReceipt",
		VerificationAmountDiff = "VerificationAmountDiff",
		LlmGeneralFinding = "LlmGeneralFinding",
	}
	export enum BookkeepingCheckFindingSeverity {
		None = "None",
		High = "High",
		Mid = "Mid",
		Low = "Low",
	}
	export enum BookkeepingCheckResolutionType {
		Unknown = "Unknown",
		FalseError = "FalseError",
		NonImportantError = "NonImportantError",
		Fixed = "Fixed",
		VerifiedFixed = "VerifiedFixed",
	}
	export enum BookkeepingCheckResultStatus {
		Passed = "Passed",
		Failed = "Failed",
		Skipped = "Skipped",
	}
	export enum BookkeepingCheckStatus {
		Running = "Running",
		ReadyForUser = "ReadyForUser",
		CompletedByUser = "CompletedByUser",
	}
	export enum BookkeepingCheckType {
		Unknown = "Unknown",
		VatSum = "VatSum",
		TotalSum = "TotalSum",
		SwedishVatIdForeignVat = "SwedishVatIdForeignVat",
		ForeignCountrySwedishVat = "ForeignCountrySwedishVat",
		HasReceipt = "HasReceipt",
		LlmGeneralReview = "LlmGeneralReview",
	}
	export enum ErrorCodeEnum {
		General = "General",
		VatError = "VatError",
		BankDateMismatch = "BankDateMismatch",
		BankAmountDiff = "BankAmountDiff",
		VerificationDateMismatch = "VerificationDateMismatch",
		VerificationAmountDiff = "VerificationAmountDiff",
		Pending = "Pending",
		Failed = "Failed",
	}
	export interface RecordingCheckBankTransaction {
		Id: string;
		Date: Day;
		Amount: number;
		Account: number;
		Title: string;
	}
	export interface RecordingCheckReceipt {
		Id: string;
		PageCount: number;
		Extension: string;
		Mimetype: string;
		Data: string;
		DataUrl: string;
		DataAccessToken: string;
		Type: Entities.ReceiptType;
	}
	export enum RecordingCheckResolutionType {
		Unknown = "Unknown",
		FalseError = "FalseError",
		NonImportantError = "NonImportantError",
		Fixed = "Fixed",
	}
	export enum RecordingCheckStatus {
		Running = "Running",
		ReadyForUser = "ReadyForUser",
		CompletedByUser = "CompletedByUser",
	}
	export interface RecordingCheckStorageData {
		Verifications: Entities.Accounting.Reconciliations.RecordingCheckVerification[];
		BankTransactions: Entities.Accounting.Reconciliations.RecordingCheckBankTransaction[];
		Receipts: Entities.Accounting.Reconciliations.RecordingCheckReceipt[];
		AccountMap: { [key: number]: string; };
	}
	export interface RecordingCheckTransaction {
		Account: number;
		Sum: number;
	}
	export interface RecordingCheckVerification {
		Id: string;
		Date: Day;
		VerificationNumber: string;
		Title: string;
		Transactions: Entities.Accounting.Reconciliations.RecordingCheckTransaction[];
		ReceiptId?: string;
		BankTransactionId?: string;
	}
}
export namespace Entities.AttestationFlow {
	export enum AttestableEntityType {
		Invalid = "Invalid",
		SupplierInvoice = "SupplierInvoice",
		Expense = "Expense",
	}
	export namespace AttestationConstants {
		export const UnlimitedApprovalLimit = -1;
	}
	export enum AttestationRequestStatus {
		Invalid = "Invalid",
		AwaitingAssignment = "AwaitingAssignment",
		Pending = "Pending",
		Approved = "Approved",
		Denied = "Denied",
		Cancelled = "Cancelled",
		Reassigned = "Reassigned",
		OrgTreeChanged = "OrgTreeChanged",
	}
	export enum AttestationStepStatus {
		Invalid = "Invalid",
		Pending = "Pending",
		Active = "Active",
		Approved = "Approved",
		Denied = "Denied",
		Skipped = "Skipped",
		Escalated = "Escalated",
	}
}
export namespace Entities.AutomationRules {
	export enum AutomationRuleActionType {
		NoAction = "NoAction",
		RecordWithRecipe = "RecordWithRecipe",
	}
	export enum AutomationRuleConstraintField {
		NoField = "NoField",
		Amount = "Amount",
		Message = "Message",
		AccountNumber = "AccountNumber",
		SupplierInvoiceSupplierName = "SupplierInvoiceSupplierName",
		ReceiptVendorName = "ReceiptVendorName",
		ReceiptVendorOrgNumber = "ReceiptVendorOrgNumber",
		ReceiptVendorVatNumber = "ReceiptVendorVatNumber",
	}
	export enum AutomationRuleConstraintType {
		NoConstraint = "NoConstraint",
		EqualTo = "EqualTo",
		LessThan = "LessThan",
		GreaterThan = "GreaterThan",
		Contains = "Contains",
		StartsWith = "StartsWith",
		EndsWith = "EndsWith",
		ConstraintGroup = "ConstraintGroup",
	}
	export enum AutomationRuleDirection {
		Unknown = "Unknown",
		Cost = "Cost",
		Income = "Income",
	}
	export enum AutomationRuleLogicOperator {
		And = "And",
		Or = "Or",
	}
	export enum AutomationRuleSource {
		UserDefined = "UserDefined",
		QuickCreated = "QuickCreated",
		FromTaxAccount = "FromTaxAccount",
	}
	export enum AutomationRuleStatus {
		Draft = "Draft",
		Active = "Active",
		Inactive = "Inactive",
		Deleted = "Deleted",
	}
}
export namespace Entities.Bank {
	export enum BankAccountType {
		NotSet = "NotSet",
		Investment = "Investment",
		Credit = "Credit",
		Depository = "Depository",
		Loan = "Loan",
		Other = "Other",
		Saving = "Saving",
		Depot = "Depot",
		TaxAccount = "TaxAccount",
	}
	export enum DataProvider {
		Unknown = "Unknown",
	}
	export enum ExternalSystem {
		Manual = "Manual",
		Plaid = "Plaid",
		Mir = "Mir",
		Klarna = "Klarna",
		Svea = "Svea",
		EnableBanking = "EnableBanking",
		SkatteverketTaxAccount = "SkatteverketTaxAccount",
	}
	export enum MetadataKey {
	}
}
export namespace Entities.BCC {
	export enum IncomeOrigins {
		Salary = "Salary",
		Pension = "Pension",
		SocialBenefit = "SocialBenefit",
		SoleProprietorship = "SoleProprietorship",
		Capital = "Capital",
		StudentGrant = "StudentGrant",
		NoIncome = "NoIncome",
		Other = "Other",
	}
}
export namespace Entities.Feedback {
	export enum DisconnectType {
		Unknown = "Unknown",
		DeleteCompany = "DeleteCompany",
		LeaveCompany = "LeaveCompany",
		ChangingPlan = "ChangingPlan",
	}
	export enum FeatureInterestKey {
		Unkown = "Unkown",
		BankCard = "BankCard",
	}
	export enum FeedbackOption {
		Unknown = "Unknown",
		DoesNotSupportNeeds = "DoesNotSupportNeeds",
		SwitchSoftware = "SwitchSoftware",
		ClosedCompany = "ClosedCompany",
		AccountantTakover = "AccountantTakover",
		TestCompany = "TestCompany",
		Other = "Other",
		NoLongerActive = "NoLongerActive",
		MissingFeatures = "MissingFeatures",
		NoBBASupport = "NoBBASupport",
		MovingToAnotherProduct = "MovingToAnotherProduct",
		AccountantTakingOver = "AccountantTakingOver",
		UnhappyWithCustomerSupport = "UnhappyWithCustomerSupport",
		ClosingDownCompany = "ClosingDownCompany",
	}
	export enum RatingType {
		Unknown = "Unknown",
		RegularBookkeeping = "RegularBookkeeping",
		BankTransactionBookkeeping = "BankTransactionBookkeeping",
		RegularInvoicing = "RegularInvoicing",
		DigitalYearEndClosure = "DigitalYearEndClosure",
		VacationYearEnd = "VacationYearEnd",
		RegularQuote = "RegularQuote",
		ReceivingEInvoice = "ReceivingEInvoice",
		DirectorsPayroll = "DirectorsPayroll",
		BankRules = "BankRules",
		InviteAccountant = "InviteAccountant",
		EcommerceFirstBookkeeping = "EcommerceFirstBookkeeping",
		CustomTodo = "CustomTodo",
		CustomTemplate = "CustomTemplate",
		Salary = "Salary",
		Closure = "Closure",
		EventsToRecord = "EventsToRecord",
		AddPayment = "AddPayment",
		OnboardingChecklist = "OnboardingChecklist",
		CreateBookkeepAndPay = "CreateBookkeepAndPay",
	}
}
export namespace Entities.ImportantDate {
	export enum ImportantDateSetupAnswer {
		Invalid = "Invalid",
		Yes = "Yes",
		No = "No",
	}
	export enum ImportantDatesSetupQuestion {
		NotStarted = "NotStarted",
		SkatteverketEService = "SkatteverketEService",
		Employees = "Employees",
		RealEstate = "RealEstate",
		CustomersInOtherEUCountries = "CustomersInOtherEUCountries",
		TradeWithOtherCompaniesInEU = "TradeWithOtherCompaniesInEU",
		SellGoodsFromEUToIndividuals = "SellGoodsFromEUToIndividuals",
		SellGoodsFromOutsideEUToIndividuals = "SellGoodsFromOutsideEUToIndividuals",
		Completed = "Completed",
	}
	export enum ImportantDatesSetupStatus {
		Unknown = "Unknown",
		Created = "Created",
		InProgress = "InProgress",
		Completed = "Completed",
	}
	export enum ImportantDateState {
		None = "None",
		Started = "Started",
		Completed = "Completed",
	}
}
export namespace Entities.Inboxes {
	export enum FraudCheckType {
		DKIM_Fail = "DKIM_Fail",
		DKIM_Missing = "DKIM_Missing",
		DKIM_Pass = "DKIM_Pass",
		SPF_Fail = "SPF_Fail",
		SPF_Missing = "SPF_Missing",
		SPF_Pass = "SPF_Pass",
		ForgedHeaders = "ForgedHeaders",
		SpamTestsMissing = "SpamTestsMissing",
		BccInbox = "BccInbox",
	}
	export enum InboxMessageState {
		Imported = "Imported",
		Sandboxed = "Sandboxed",
		Rejected = "Rejected",
		BlockedByInboxAccess = "BlockedByInboxAccess",
	}
}
export namespace Entities.Integration {
	export enum IntegrationActivationState {
		None = "None",
		Initiated = "Initiated",
		AccessCode = "AccessCode",
		Token = "Token",
		Activated = "Activated",
		Deactivated = "Deactivated",
	}
}
export namespace Entities.Invoices {
	export interface Article {
		CompanyId: string;
		Id: string;
		ProductCode?: string;
		Description?: string;
		UnitPrice: number;
		UnitType: Entities.Invoices.InvoiceRowUnitType;
		Tax: number;
		Kind: Entities.Invoices.InvoiceRowKind;
		AccountNbr?: number;
		Deleted: boolean;
		RotRutRow?: Entities.Invoices.RotRutRow;
		RotRutRowId?: string;
		IsTextRow: boolean;
		TemplateName?: string;
		ImportId?: string;
		CreatedUtc: Date;
		Source: Entities.Invoices.ArticleSource;
	}
	export enum ArticleSource {
		App = "App",
		Api = "Api",
	}
	export interface Customer {
		Id: string;
		/** @deprecated Deprecated in favour of DefaultInvoiceReceiverData */
		CustomerNumber: number;
		CompanyId: string;
		DefaultInvoiceReciverData: Entities.InvoiceReceiverData;
		DefaultInvoiceSenderData: Entities.InvoiceSenderData;
		SendToEmails?: string;
		Deleted: boolean;
		IsCreatedByImport: boolean;
	}
	export enum DeliveryStatusState {
		Unknown = "Unknown",
		Processing = "Processing",
		Rejected = "Rejected",
		Accepted = "Accepted",
		Sent = "Sent",
		BillingSupplierInvoiceDelivered = "BillingSupplierInvoiceDelivered",
	}
	export interface EmailInvoiceDeliveryData {
		DeliveryType?: Entities.Invoices.EmailInvoiceDeliveryType;
		Recipient?: string;
		BatchId?: string;
	}
	export enum EmailInvoiceDeliveryType {
		LinkAndPdf = "LinkAndPdf",
		Link = "Link",
	}
	export enum EmailQuoteDeliveryType {
		LinkAndPdf = "LinkAndPdf",
		Link = "Link",
	}
	export enum FactoringInvoiceEvent {
		AwaitingDetermination = "AwaitingDetermination",
		Settled = "Settled",
		Rejected = "Rejected",
	}
	export interface FactoringOnboardingModel {
		OrgNumber?: string;
		CompanyName?: string;
		Email?: string;
		PhoneNumber?: string;
		FirstName?: string;
		LastName?: string;
	}
	export interface Invoice {
		Type: Entities.Invoices.InvoiceType;
		Id: string;
		Deadline: Day;
		InvoiceDate: Day;
		InvoiceNumber: number;
		InvoiceNumberPrefix?: string;
		CompanyInvoiceCounter: number;
		UniquePaymentReference?: string;
		SystemName?: string;
		SystemVersion: number;
		InvoiceSystem: Entities.Invoices.InvoiceSystem;
		HasPlaceholderVerification: boolean;
		ReceiverData: Entities.InvoiceReceiverData;
		SenderData: Entities.InvoiceSenderData;
		Currency?: string;
		CurrencyRateValue?: number;
		Sum: number;
		SumSEK: number;
		TaxRate: number;
		Tax: number;
		TaxSEK: number;
		TotalSum: number;
		TotalSumSEK: number;
		InvoiceFee: number;
		Rounding: number;
		SumReceived: number;
		State: Entities.Invoices.InvoiceState;
		/** @deprecated HB 2018-01-31: Seems unused */
		DecimalRounding: number;
		CompanyId: string;
		Created?: Date;
		IsReplacingId?: string;
		DisableBookkeeping: boolean;
		AccountingType?: Entities.AccountingType;
		AccountingVersion: Entities.Invoices.InvoiceAccountingVersion;
		DisableRounding: boolean;
		HasVatFreeMessage?: boolean;
		PublishStamp?: Date;
		ExternalId?: string;
		IsConnectedCreditInvoice: boolean;
		IsStandaloneCreditInvoice: boolean;
		IsCreditInvoice: boolean;
		RotRut?: Entities.Invoices.RotRut;
		RotRutId?: string;
		Quote?: Entities.Invoices.Quote;
		QuoteId?: string;
		IsRotRutInvoice: boolean;
		DeductionSum: number;
		InvoicePeriod?: Entities.Invoices.InvoicePeriod;
		ContractReference?: string;
		ProjectReference?: string;
		OrderReference?: string;
		BuyerReference?: string;
		DeliveryInformation: Entities.DeliveryInformation;
		PaymentLink?: Entities.Invoices.PaymentLink;
		PaymentLinkId?: string;
		SourceKey?: Entities.ExternalId;
		InvoiceSettings: Entities.Invoices.InvoiceSettings;
		AuditInfo: AuditInfo;
		IsRecurringInvoiceTemplate: boolean;
		RecurringInvoiceId?: string;
		RowVersion?: string;
	}
	export enum InvoiceAccountingVersion {
		V1 = "V1",
		V2 = "V2",
	}
	export enum InvoiceBatchCustomerMatchField {
		Unknown = "Unknown",
		Id = "Id",
		Email = "Email",
		OrganizationNumber = "OrganizationNumber",
		PersonalNumber = "PersonalNumber",
	}
	export enum InvoiceBatchCustomerMatchResult {
		Unknown = "Unknown",
		Ok = "Ok",
		DuplicateCustomerFound = "DuplicateCustomerFound",
		NoCustomerFound = "NoCustomerFound",
	}
	export enum InvoiceBatchState {
		Draft = "Draft",
		Generated = "Generated",
		Deleted = "Deleted",
	}
	export interface InvoiceDelivery {
		Id: string;
		InvoiceId: string;
		Method: Entities.Invoices.InvoiceDeliveryMethod;
		Status: Entities.Invoices.OldInvoiceDeliveryStatus;
		ReminderId?: string;
		TimestampUtc: Date;
		TrackingId?: string;
	}
	export interface InvoiceDeliveryData {
	}
	export enum InvoiceDeliveryMethod {
		Email = "Email",
		Post = "Post",
		Download = "Download",
		EInvoice = "EInvoice",
		BillingEmail = "BillingEmail",
	}
	export interface InvoiceDeliveryStatus {
		Id: string;
		InvoiceDeliveryId: string;
		InvoiceDelivery: Entities.Invoices.InvoiceDelivery;
		Message?: string;
		State: Entities.Invoices.DeliveryStatusState;
		Time: Date;
	}
	export enum InvoiceFinancingType {
		FactoringWithRecourse = "FactoringWithRecourse",
		CreditFactoringWithRecourse = "CreditFactoringWithRecourse",
		PaymentFromFactoringProvider = "PaymentFromFactoringProvider",
		RemainingPaymentFromFactoringProvider = "RemainingPaymentFromFactoringProvider",
	}
	export enum InvoicePaymentIntentStatus {
		Created = "Created",
		Sent = "Sent",
		Processing = "Processing",
		Completed = "Completed",
		Failed = "Failed",
		Cancel = "Cancel",
	}
	export interface InvoicePaymentMethod {
		Key: Entities.Invoices.InvoicePaymentMethodKey;
		PrimaryLabel?: string;
		PrimaryValue?: string;
		SecondaryLabel?: string;
		SecondaryValue?: string;
		ThirdLabel?: string;
		ThirdValue?: string;
	}
	export enum InvoicePaymentMethodKey {
		Bankgiro = "Bankgiro",
		Postgiro = "Postgiro",
		BankAccount = "BankAccount",
		Swish = "Swish",
		BankTransfer = "BankTransfer",
		NotSet = "NotSet",
		Custom = "Custom",
		Paypal = "Paypal",
		IBAN = "IBAN",
		/** @deprecated BBA 1.0 payment method - no longer supported for new invoices */
		Bokio_Bankgiro = "Bokio_Bankgiro",
		/** @deprecated BBA 1.0 shared IBAN - no longer supported for new invoices */
		Bokio_Shared_IBAN = "Bokio_Shared_IBAN",
		Bokio_IBAN = "Bokio_IBAN",
	}
	export enum InvoicePaymentSystem {
		Bokio = "Bokio",
		Teller = "Teller",
		Stripe = "Stripe",
	}
	export enum InvoicePdfGeneratorVersion {
		Invalid = "Invalid",
		/** @deprecated Doesn't support V1 anymore, should use V3 instead */
		V1 = "V1",
		V2 = "V2",
		V3 = "V3",
	}
	export interface InvoicePeriod {
		StartDate?: Day;
		EndDate?: Day;
	}
	export interface InvoiceRow {
		DiscountsId?: number;
		InvoiceId: string;
		Type: Entities.Invoices.InvoiceRowType;
		Id: number;
		Index?: number;
		ProductCode?: string;
		Description?: string;
		Units: number;
		MaxUnits?: number;
		UnitPrice?: number;
		UnitType: Entities.Invoices.InvoiceRowUnitType;
		Tax: number;
		Kind: Entities.Invoices.InvoiceRowKind;
		AccountNbr?: number;
		ReversedVAT?: Entities.Invoices.ReversedVAT;
		TaxWithReversedVAT: number;
		IsTextRow: boolean;
		ArticleId?: string;
		RotRutRow?: Entities.Invoices.RotRutRow;
		RotRutRowId?: string;
		CreditsRowId?: number;
	}
	export enum InvoiceRowKind {
		Unspecified = "Unspecified",
		Goods = "Goods",
		Services = "Services",
	}
	export enum InvoiceRowType {
		Normal = "Normal",
		RowDiscountAbsolute = "RowDiscountAbsolute",
		RowDiscountPercentage = "RowDiscountPercentage",
		TotalDiscountAbsolute = "TotalDiscountAbsolute",
		TotalDiscountPercentage = "TotalDiscountPercentage",
		ReminderFee = "ReminderFee",
	}
	export enum InvoiceRowUnitType {
		Unspecified = "Unspecified",
		Piece = "Piece",
		Hour = "Hour",
		Day = "Day",
		Month = "Month",
		Kilogram = "Kilogram",
		Gram = "Gram",
		Liter = "Liter",
		Meter = "Meter",
		Centimeter = "Centimeter",
		Millimeter = "Millimeter",
		MeterSquared = "MeterSquared",
		MeterCubic = "MeterCubic",
		Mile = "Mile",
		Kilometer = "Kilometer",
		Gigabyte = "Gigabyte",
		Hectar = "Hectar",
		Words = "Words",
		Year = "Year",
		Week = "Week",
		Minute = "Minute",
		Megabyte = "Megabyte",
		Ton = "Ton",
	}
	export interface InvoiceSettings {
		InvoicePdfGeneratorVersion: Entities.Invoices.InvoicePdfGeneratorVersion;
		IsVatIncludedInRowTotal: boolean;
		StripePaymentsEnabled: boolean;
		PortalEnabled: boolean;
	}
	export enum InvoiceSettlementType {
		RoundedOffCurrency = "RoundedOffCurrency",
		BadDebt = "BadDebt",
		BankFee = "BankFee",
		StripeFee = "StripeFee",
		InvoiceBalanceBugFix = "InvoiceBalanceBugFix",
		PaymentServiceFee = "PaymentServiceFee",
	}
	export enum InvoiceSettlementVatScheme {
		Domestic = "Domestic",
		Eu = "Eu",
		NonEu = "NonEu",
		VatExempt = "VatExempt",
	}
	export enum InvoiceState {
		Draft = "Draft",
		Published = "Published",
		Paid = "Paid",
		Delayed = "Delayed",
		UnderPaid = "UnderPaid",
		OverPaid = "OverPaid",
		Deleted = "Deleted",
		Credit = "Credit",
		Edit = "Edit",
		Edited = "Edited",
	}
	export enum InvoiceStatus {
		Unknown = "Unknown",
		Closed = "Closed",
		Sent = "Sent",
		Reminder = "Reminder",
		FinalNotice = "FinalNotice",
		Dispute = "Dispute",
		DebtCollection = "DebtCollection",
		Ebv = "Ebv",
		Recalled = "Recalled",
		Rejected = "Rejected",
		RejectedByRecipient = "RejectedByRecipient",
		Approved = "Approved",
		ApprovedForDelivery = "ApprovedForDelivery",
		Clearing = "Clearing",
		PendingRepurchasing = "PendingRepurchasing",
	}
	export enum InvoiceSystem {
		Bokio = "Bokio",
		Inkassogram = "Inkassogram",
		Ativo = "Ativo",
		EInvoiceCrediflow = "EInvoiceCrediflow",
		Alien = "Alien",
	}
	export enum InvoiceType {
		Invoice = "Invoice",
		CashInvoice = "CashInvoice",
		CreditInvoice = "CreditInvoice",
	}
	export enum OccurranceType {
		Monthly = "Monthly",
		MonthlyLastDay = "MonthlyLastDay",
		Weekly = "Weekly",
		Daily = "Daily",
		Annually = "Annually",
		Quarterly = "Quarterly",
		Custom = "Custom",
	}
	export enum OldInvoiceDeliveryStatus {
		Sent = "Sent",
		Failed = "Failed",
		Acknowledged = "Acknowledged",
	}
	export interface PaymentLink {
		Id: string;
		CompanyId: string;
		ReferenceNumber?: string;
		Title?: string;
		Description?: string;
		PublishStamp?: Date;
		ExpiryDate?: Date;
		State: Entities.Invoices.PaymentLinkState;
		ExternalPaymentLinkReference?: string;
		PaymentUrl?: string;
		Sum: number;
		SumSEK: number;
		TaxRate: number;
		Tax: number;
		TaxSEK: number;
		TotalSum: number;
		TotalSumSEK: number;
		Rounding: number;
		DisableRounding: boolean;
		Currency?: string;
		CurrencyRateValue?: number;
		DeductionSum: number;
		InvoiceFee: number;
		SumReceived: number;
		Created: Date;
		CustomerId?: string;
		Customer?: Entities.Invoices.Customer;
		SenderData: Entities.Invoices.PaymentLinkSenderData;
		ReceiverData: Entities.Invoices.PaymentLinkReceiverData;
		Language?: string;
	}
	export interface PaymentLinkReceiverData {
		Type: Entities.CustomerType;
		Name?: string;
		CustomerNumber: number;
		Email?: string;
		PhoneNumber?: string;
		CountryIso2?: string;
		TaxRegistrationNumber?: string;
	}
	export interface PaymentLinkSenderData {
		CompanyName?: string;
		Address?: Entities.Address;
		OrgNumber?: string;
		TaxRegistrationNumber?: string;
		Email?: string;
		Phone?: string;
		ReferenceName?: string;
	}
	export enum PaymentLinkState {
		Draft = "Draft",
		Published = "Published",
		Paid = "Paid",
		Cancelled = "Cancelled",
		Refunded = "Refunded",
		Error = "Error",
		Expired = "Expired",
		Edit = "Edit",
		Edited = "Edited",
	}
	export enum PropertyType {
		RealEstate = "RealEstate",
		HousingDesignation = "HousingDesignation",
	}
	export interface Quote {
		Id: string;
		ValidToDate: Day;
		ValidFromDate: Day;
		QuoteNumber: number;
		CustomerId?: string;
		Customer?: Entities.Invoices.Customer;
		CustomerContactDetailId?: string;
		ReceiverData: Entities.InvoiceReceiverData;
		SenderData: Entities.InvoiceSenderData;
		Currency?: string;
		IsReplacingId?: string;
		CurrencyRateValue?: number;
		Sum: number;
		SumSEK: number;
		TaxRate: number;
		Tax: number;
		TaxSEK: number;
		TotalSum: number;
		TotalSumSEK: number;
		Rounding: number;
		SumReceived: number;
		State: Entities.Invoices.QuoteState;
		CompanyId: string;
		Created?: Date;
		DisableRounding: boolean;
		PublishStamp?: Date;
		InvoiceFee: number;
		DeductionSum: number;
		RotRut?: Entities.Invoices.RotRut;
		RotRutId?: string;
		IsRotRutQuote: boolean;
		InvoicePeriod?: Entities.Invoices.InvoicePeriod;
		ContractReference?: string;
		ProjectReference?: string;
		OrderReference?: string;
		BuyerReference?: string;
		DeliveryInformation: Entities.DeliveryInformation;
		QuoteSettings: Entities.Invoices.QuoteSettings;
	}
	export enum QuoteActivityType {
		Approved = "Approved",
		Edited = "Edited",
		Declined = "Declined",
		ToInvoice = "ToInvoice",
		DisconnectInvoice = "DisconnectInvoice",
	}
	export enum QuoteDeliveryMethod {
		Email = "Email",
		Post = "Post",
		Download = "Download",
	}
	export enum QuotePdfGeneratorVersion {
		Invalid = "Invalid",
		/** @deprecated Doesn't support V1 anymore, should use V3 instead */
		V1 = "V1",
		V2 = "V2",
		V3 = "V3",
	}
	export interface QuoteSettings {
		QuotePdfGeneratorVersion: Entities.Invoices.QuotePdfGeneratorVersion;
		IsVatIncludedInRowTotal: boolean;
	}
	export enum QuoteState {
		Draft = "Draft",
		Published = "Published",
		Closed = "Closed",
		Approved = "Approved",
		Declined = "Declined",
		Expired = "Expired",
		Deleted = "Deleted",
		Edit = "Edit",
		Edited = "Edited",
	}
	export interface RecurringInvoiceScheduling {
		StartDate: Day;
		Occurrance: Entities.Invoices.OccurranceType;
		NumberOfOccurrances: number;
		CreateDaysBeforePublish: number;
	}
	export enum RecurringInvoiceStatus {
		Draft = "Draft",
		Active = "Active",
		Archived = "Archived",
		Edit = "Edit",
		Edited = "Edited",
		Deleted = "Deleted",
		Inactive = "Inactive",
	}
	export enum RecurringInvoiceVersion {
		V1 = "V1",
		V2 = "V2",
		V3 = "V3",
	}
	export enum ReversedVAT {
		ConstructionVAT = "ConstructionVAT",
	}
	export interface RotRut {
		Id: string;
		CompanyId: string;
		PersonalNumber?: string;
		DeductionSum: number;
		Type: Entities.Invoices.RotRutType;
		Description?: string;
		Status: Entities.Invoices.RotRutStatus;
		PropertyType: Entities.Invoices.PropertyType;
		RealEstateNumber?: string;
		OrganisationalNumberOfTenant?: string;
		ApartmentNumber?: string;
		Invoice?: Entities.Invoices.Invoice;
		Quotes?: Entities.Invoices.Quote;
	}
	export interface RotRutDeductionPerson {
		Id: string;
		PersonalNumber?: string;
		DeductionSum: number;
	}
	export enum RotRutMaterialType {
		Rot_Contruction = "Rot_Contruction",
		Rot_Electricity = "Rot_Electricity",
		Rot_GlassPlate = "Rot_GlassPlate",
		Rot_SoilWork = "Rot_SoilWork",
		Rot_Sweeping = "Rot_Sweeping",
		Rot_Painting = "Rot_Painting",
		Rot_Plumbing = "Rot_Plumbing",
		Rut_ChildServices = "Rut_ChildServices",
		Rut_DataITServices = "Rut_DataITServices",
		Rut_RemovalServices = "Rut_RemovalServices",
		Rut_ClothingCare = "Rut_ClothingCare",
		Rut_PersonalHelpCare = "Rut_PersonalHelpCare",
		Rut_Repair = "Rut_Repair",
		Rut_Snow = "Rut_Snow",
		Rut_Cleaning = "Rut_Cleaning",
		Rut_Gardening = "Rut_Gardening",
		Rut_WaterWashingOfTextiles = "Rut_WaterWashingOfTextiles",
		Rut_Furnishing = "Rut_Furnishing",
		Rut_TransportOfHouseholdGoods = "Rut_TransportOfHouseholdGoods",
		Rut_HousingSupervision = "Rut_HousingSupervision",
	}
	export interface RotRutRow {
		Id: string;
		Type: Entities.Invoices.RotRutType;
		MaterialType: Entities.Invoices.RotRutMaterialType;
	}
	export enum RotRutStatus {
		Draft = "Draft",
		AwaitingPayment = "AwaitingPayment",
		ReadyToSubmit = "ReadyToSubmit",
		Submitted = "Submitted",
		RotRutErrandRemoved = "RotRutErrandRemoved",
		Completed = "Completed",
	}
	export enum RotRutType {
		Rot = "Rot",
		Rut = "Rut",
	}
	export interface SalesSettings {
		Id: string;
		CompanyId: string;
		InvoiceSettings: Entities.Invoices.InvoiceSettings;
		QuoteSettings: Entities.Invoices.QuoteSettings;
	}
	export enum SourceSystem {
		TOGGL = "TOGGL",
	}
	export interface TimeTrackingAccount {
		Id: string;
		CompanyId: string;
		System: Entities.Invoices.SourceSystem;
		Name?: string;
		AuthJson?: string;
	}
}
export namespace Entities.KnowYourCustomers {
	export interface FactoringKnowYouCustomerAnswersVersion2 {
		PurposeOfBusiness: string[];
		MajorityOwners: Entities.KnowYourCustomers.NameSSNPercentCountry[];
		PartialOwners: Entities.KnowYourCustomers.NameAndSSN[];
		PepPersons: Entities.KnowYourCustomers.NameAndSSN[];
	}
	export interface NameAndSSN {
		Name?: string;
		SocialSecurityNumber?: string;
	}
	export interface NameSSNPercentCountry {
		OwnerPercent?: number;
		Country?: string;
		Name?: string;
		SocialSecurityNumber?: string;
	}
}
export namespace Entities.Notifications {
	export enum NotificationArea {
		None = "None",
		DummyNotification = "DummyNotification",
		Expense = "Expense",
		BokioBusinessAccount = "BokioBusinessAccount",
		Invoice = "Invoice",
		Other = "Other",
		System = "System",
		Salary = "Salary",
		SupplerInvoice = "SupplerInvoice",
		Users = "Users",
		Tasks = "Tasks",
		BookkeepingSupport = "BookkeepingSupport",
		Mention = "Mention",
		Plans = "Plans",
		Ecommerce = "Ecommerce",
		NotifyInboxEmailResult = "NotifyInboxEmailResult",
		CompanySecurityEvent = "CompanySecurityEvent",
		UserSecurityEvent = "UserSecurityEvent",
		BankFeed = "BankFeed",
		Todo = "Todo",
		Attestation = "Attestation",
	}
	export enum NotificationAreaType {
		None = "None",
		OtherInbox = "OtherInbox",
		FeatureRequests = "FeatureRequests",
		ExpenseApproved = "ExpenseApproved",
		ExpenseDenied = "ExpenseDenied",
		ExpenseAdjusted = "ExpenseAdjusted",
		BankPaymentFailed = "BankPaymentFailed",
		BankCardTransaction = "BankCardTransaction",
		BankBusinessAccountSetup = "BankBusinessAccountSetup",
		BankBokioBusinessAccountApplication = "BankBokioBusinessAccountApplication",
		BankBokioBusinessAccountKycApplication = "BankBokioBusinessAccountKycApplication",
		BankBokioBusinessSavingsAccountApplication = "BankBokioBusinessSavingsAccountApplication",
		BankCheckCreditApplication = "BankCheckCreditApplication",
		InvoicePaymentUpdates = "InvoicePaymentUpdates",
		RecurringInvoiceCreated = "RecurringInvoiceCreated",
		EInvoiceDisconnected = "EInvoiceDisconnected",
		FullPaymentSubmissionUpdates = "FullPaymentSubmissionUpdates",
		IncomingEInvoice = "IncomingEInvoice",
		SupplierInvoiceFailedToCreateForNonExistentFiscalYear = "SupplierInvoiceFailedToCreateForNonExistentFiscalYear",
		AgencyRespondsToInvitation = "AgencyRespondsToInvitation",
		AgencyRemovedConnection = "AgencyRemovedConnection",
		ClientCompanyInvitationRequest = "ClientCompanyInvitationRequest",
		ClientRemovedConnection = "ClientRemovedConnection",
		ClientCompanyQuoteRequest = "ClientCompanyQuoteRequest",
		PartnerRespondsToQuoteRequest = "PartnerRespondsToQuoteRequest",
		CompanyOwnerAcceptsInvitation = "CompanyOwnerAcceptsInvitation",
		TaskAssigned = "TaskAssigned",
		BookkeepingSupport = "BookkeepingSupport",
		MentionMessage = "MentionMessage",
		MentionJournalEntry = "MentionJournalEntry",
		MentionInvoice = "MentionInvoice",
		MentionPayslip = "MentionPayslip",
		MentionPayroll = "MentionPayroll",
		CashbackReceived = "CashbackReceived",
		EcommerceNewPaymentMethods = "EcommerceNewPaymentMethods",
		InboxEmailConfirmation = "InboxEmailConfirmation",
		BankConnectionLost = "BankConnectionLost",
		ReceiptRequested = "ReceiptRequested",
		ReceiptUploaded = "ReceiptUploaded",
		AttestationStepAssigned = "AttestationStepAssigned",
		AttestationRequestDenied = "AttestationRequestDenied",
		AttestationCostOwnerAssigned = "AttestationCostOwnerAssigned",
		AttestationTreeNeedsReview = "AttestationTreeNeedsReview",
		Default = "Default",
	}
	export enum NotificationGroupStatus {
		None = "None",
		Pending = "Pending",
		GroupedRoot = "GroupedRoot",
		GroupedChild = "GroupedChild",
	}
	export enum NotificationItemType {
		Payment = "Payment",
		Transaction = "Transaction",
		Expense = "Expense",
		Invoice = "Invoice",
		Markdown = "Markdown",
		Payroll = "Payroll",
		SupplierInvoice = "SupplierInvoice",
		Memberships = "Memberships",
		Tasks = "Tasks",
		BookkeepingSupportResponse = "BookkeepingSupportResponse",
		MentionComment = "MentionComment",
		MentionJournalEntry = "MentionJournalEntry",
		MentionInvoice = "MentionInvoice",
		CashbackPayment = "CashbackPayment",
		BbaNormalOnboarding = "BbaNormalOnboarding",
		BbaUpgrade = "BbaUpgrade",
		EcommerceNewPaymentMethods = "EcommerceNewPaymentMethods",
		MentionCommentQuoteRequest = "MentionCommentQuoteRequest",
		TasksQuoteRequest = "TasksQuoteRequest",
		BbaKycApplication = "BbaKycApplication",
		MentionPayslip = "MentionPayslip",
		MentionPayroll = "MentionPayroll",
		FeatureRequest = "FeatureRequest",
		CompanySecurityEvent = "CompanySecurityEvent",
		SavingsAccountOnboarding = "SavingsAccountOnboarding",
		UserSecurityEvent = "UserSecurityEvent",
		BankConnection = "BankConnection",
		CheckCreditOnboarding = "CheckCreditOnboarding",
	}
	export enum NotificationItemTypeVariant {
		Default = "Default",
		TransactionCardOnline = "TransactionCardOnline",
		TransactionCardInStore = "TransactionCardInStore",
		InvoicePaid = "InvoicePaid",
		InvoiceUnderpaid = "InvoiceUnderpaid",
		InvoiceOverdue = "InvoiceOverdue",
		InvoiceOverpaid = "InvoiceOverpaid",
		FullPaymentSubmissionSucceeded = "FullPaymentSubmissionSucceeded",
		FullPaymentSubmissionFailed = "FullPaymentSubmissionFailed",
		InvoicePaidThroughStripe = "InvoicePaidThroughStripe",
		AgencyRejectsInvitation = "AgencyRejectsInvitation",
		AgencyAcceptsInvitation = "AgencyAcceptsInvitation",
		PartnerAcceptsQuoteRequest = "PartnerAcceptsQuoteRequest",
		PartnerRejectsQuoteRequest = "PartnerRejectsQuoteRequest",
		BbaUpgradeStatusUpdate = "BbaUpgradeStatusUpdate",
		BbaNormalOnboardingStatusUpdate = "BbaNormalOnboardingStatusUpdate",
		PartnerRejectsQuoteRequestWithMessage = "PartnerRejectsQuoteRequestWithMessage",
		MentionedClientInComment = "MentionedClientInComment",
		MentionedAccountantInComment = "MentionedAccountantInComment",
		BbaKycApplicationDueDateUpdate = "BbaKycApplicationDueDateUpdate",
		FeatureRequestApproved = "FeatureRequestApproved",
		FeatureRequestDenied = "FeatureRequestDenied",
		FeatureRequestCompleted = "FeatureRequestCompleted",
		FeatureRequestMerged = "FeatureRequestMerged",
		CompanyPaymentDetailsChanged = "CompanyPaymentDetailsChanged",
		SupplierPaymentDetailsChanged = "SupplierPaymentDetailsChanged",
		SavingsAccountApplicationApproved = "SavingsAccountApplicationApproved",
		SavingsAccountApplicationRejected = "SavingsAccountApplicationRejected",
		PasswordChanged = "PasswordChanged",
		EmailChanged = "EmailChanged",
		TwoFactorEnabled = "TwoFactorEnabled",
		TwoFactorDisabled = "TwoFactorDisabled",
		InvoicePortalPaymentDetailsChanged = "InvoicePortalPaymentDetailsChanged",
		CheckCreditApplicationApproved = "CheckCreditApplicationApproved",
		CheckCreditApplicationRejected = "CheckCreditApplicationRejected",
	}
	export enum NotificationStatusTypes {
		None = "None",
		New = "New",
		Seen = "Seen",
		Read = "Read",
		Dismissed = "Dismissed",
	}
	export enum NotificationTarget {
		None = "None",
		Mobile = "Mobile",
		Email = "Email",
		WebApp = "WebApp",
	}
}
export namespace Entities.Onboarding {
	export enum ConnectWithType {
		None = "None",
		BBA = "BBA",
		OtherBank = "OtherBank",
	}
	export interface OnboardingChecklist {
		Id: string;
		CompanyId: string;
		Status: Entities.Onboarding.OnboardingChecklistStatus;
		Completed: AuditInfo;
	}
	export enum OnboardingChecklistItemName {
		Invalid = "Invalid",
		CreateNewCompany = "CreateNewCompany",
		ConnectToBank = "ConnectToBank",
		ImportPreviousBookkeeping = "ImportPreviousBookkeeping",
		DownloadMobileApp = "DownloadMobileApp",
		GetStartedWithImportantDates = "GetStartedWithImportantDates",
		ActivateBBA = "ActivateBBA",
		RecordAReceiptOrExpense = "RecordAReceiptOrExpense",
		CreateAnInvoice = "CreateAnInvoice",
		CreateAPayroll = "CreateAPayroll",
		ConnectToSkatteverket = "ConnectToSkatteverket",
		SetOpeningBalances = "SetOpeningBalances",
		InviteAccountant = "InviteAccountant",
		SetFiscalYear = "SetFiscalYear",
	}
	export enum OnboardingChecklistItemStatus {
		Invalid = "Invalid",
		Active = "Active",
		InProgress = "InProgress",
		Pending = "Pending",
		Completed = "Completed",
		Removed = "Removed",
	}
	export enum OnboardingChecklistStatus {
		NotCreated = "NotCreated",
		Created = "Created",
		Overdue = "Overdue",
		Completed = "Completed",
	}
	export enum OnboardingExtraExperienceType {
		None = "None",
		Test = "Test",
		Undefined = "Undefined",
	}
	export interface OnboardingWizardResponse {
		CompanyId: string;
		StartWith: Entities.Onboarding.StartWithType;
		ConnectWith: Entities.Onboarding.ConnectWithType;
		CreatedUtc: Date;
		LastUpdated: AuditInfo;
		CurrentStep: Entities.Onboarding.OnboardingWizardStep;
		WantExtraExperience: Entities.Onboarding.OnboardingExtraExperienceType;
		UserDiscoverySource: Entities.Onboarding.UserDiscoverySourceType;
		UserDiscoverySourceOtherText?: string;
	}
	export enum OnboardingWizardStep {
		Undefined = "Undefined",
		CompanyInformationConfirmation = "CompanyInformationConfirmation",
		AccountingDetails = "AccountingDetails",
		StartWith = "StartWith",
		DiscoverySource = "DiscoverySource",
		ConnectWith = "ConnectWith",
		Done = "Done",
		Completed = "Completed",
	}
	export enum StartWithType {
		None = "None",
		Bookkeeping = "Bookkeeping",
		SendInvoice = "SendInvoice",
		Salary = "Salary",
		InviteAccountant = "InviteAccountant",
	}
	export enum UserDiscoverySourceType {
		Undefined = "Undefined",
		SearchEngine = "SearchEngine",
		SocialMediaInstagramFacebook = "SocialMediaInstagramFacebook",
		LinkedIn = "LinkedIn",
		YouTube = "YouTube",
		TvOrRadio = "TvOrRadio",
		AiSearch = "AiSearch",
		FriendOrColleague = "FriendOrColleague",
		AccountantOrAgency = "AccountantOrAgency",
		NewsOrBlogpost = "NewsOrBlogpost",
		AnotherWebsite = "AnotherWebsite",
		Other = "Other",
	}
}
export namespace Entities.Partners {
	export enum ApplicationStatus {
		Error = "Error",
		Submitted = "Submitted",
		HandledByPartner = "HandledByPartner",
	}
	export enum OnboardingQueueStatus {
		New = "New",
		Contacted = "Contacted",
		ConsultationInProgress = "ConsultationInProgress",
		ConsultationReady = "ConsultationReady",
		OnboardingInProgress = "OnboardingInProgress",
		OnboardingComplete = "OnboardingComplete",
		Incomplete = "Incomplete",
		ContractSigned = "ContractSigned",
		ContractSent = "ContractSent",
		Archived = "Archived",
		ClosedOtherAgencySelected = "ClosedOtherAgencySelected",
		Removed = "Removed",
	}
	export enum WorkStatusType {
		Waiting = "Waiting",
		New = "New",
		Overdue = "Overdue",
		Ongoing = "Ongoing",
		Incomplete = "Incomplete",
		Completed = "Completed",
		Archived = "Archived",
	}
}
export namespace Entities.Partners.AgencyOnboarding {
	export enum AgencyOnboardingChecklistItemName {
		Invalid = "Invalid",
		CreateNewAgency = "CreateNewAgency",
		ImportCustomers = "ImportCustomers",
		BookConsultation = "BookConsultation",
		CreateCompany = "CreateCompany",
		AddAccountant = "AddAccountant",
		CreateTestClient = "CreateTestClient",
	}
	export enum AgencyOnboardingChecklistItemStatus {
		Invalid = "Invalid",
		Active = "Active",
		Completed = "Completed",
		Removed = "Removed",
	}
	export enum AgencyOnboardingChecklistStatus {
		NotCreated = "NotCreated",
		Created = "Created",
		Completed = "Completed",
	}
}
export namespace Entities.Payment {
	export enum PaymentMessageType {
		Unknown = "Unknown",
		OCR = "OCR",
		Text = "Text",
	}
	export enum PaymentMethodStatus {
		Added = "Added",
		InProgress = "InProgress",
		Accepted = "Accepted",
		Invalid = "Invalid",
		Deleted = "Deleted",
	}
	export enum PaymentType {
		Manual = "Manual",
		Bankgiro = "Bankgiro",
		Autogiro = "Autogiro",
		Card = "Card",
	}
	export interface PreVerificationData {
		RecipeForms: Bokio.Accounting.Contract.Verifications.DTOs.RecipeInfo[];
		GeneralForms: { [key: string]: string; };
		ManualForms: { [key: number]: number; };
	}
	export enum SupplierInvoiceSystem {
		Bokio = "Bokio",
		Alien = "Alien",
	}
	export enum SupplierInvoiceType {
		Invalid = "Invalid",
		Invoice = "Invoice",
		CreditInvoice = "CreditInvoice",
	}
}
export namespace Entities.PublicApi {
	export enum IntegrationMarketplaceCategory {
		PaymentProcessing = "PaymentProcessing",
		AccountingAndBookkeeping = "AccountingAndBookkeeping",
		BankingAndFinance = "BankingAndFinance",
		TimeTrackingAndHR = "TimeTrackingAndHR",
		ECommerce = "ECommerce",
		ProductivityAndAutomation = "ProductivityAndAutomation",
		InvoicingAndBilling = "InvoicingAndBilling",
	}
	export enum Mode {
		Test = "Test",
		Production = "Production",
	}
}
export namespace Entities.Research {
	export enum ResearchQuestionType {
		NotSet = "NotSet",
		FreeText = "FreeText",
		SingleSelect = "SingleSelect",
		MultiSelect = "MultiSelect",
	}
}
export namespace Entities.Salary {
	export enum AbsenceState {
		Reported = "Reported",
		PreApproved = "PreApproved",
		Approved = "Approved",
		Handled = "Handled",
		Rejected = "Rejected",
	}
	export enum AbsenceType {
		Sick = "Sick",
		Vab = "Vab",
		Vacation = "Vacation",
		Parentalleave = "Parentalleave",
		Leave = "Leave",
	}
	export interface AdvancedEmployeeSettings {
		HourlyEmployeeVacationRate?: number;
		MontlyEmployeeVacationRate?: number;
		DailySalaryPercentage?: number;
		SalaryPeriod: Entities.Salary.SalaryPeriod;
		SavedVacationDays: number;
		VacationDays: number;
	}
	export enum CalloutStatus {
		Seen = "Seen",
		Clicked = "Clicked",
		Dismissed = "Dismissed",
	}
	export enum CalloutType {
		SoloNoPension = "SoloNoPension",
		SoloWithPension = "SoloWithPension",
		Employees = "Employees",
	}
	export enum CompensationUnit {
		Month = "Month",
		Year = "Year",
		Hour = "Hour",
	}
	export enum CreatingDirectorFor {
		Myself = "Myself",
		ExistingEmployee = "ExistingEmployee",
		NewDirector = "NewDirector",
	}
	export enum DirectorGender {
		Female = "Female",
		Male = "Male",
	}
	export enum DirectorPayrollSetupFlowTaxesStarterDeclaration {
		FirstJobSinceStartOfTaxYear = "FirstJobSinceStartOfTaxYear",
		CurrentlyOnlyJob = "CurrentlyOnlyJob",
		HaveAnotherJobOrPension = "HaveAnotherJobOrPension",
	}
	export enum DirectorPayrollSetupFlowTaxesStarterType {
		NewEmployeeWithP45 = "NewEmployeeWithP45",
		NewEmployeeWithoutP45 = "NewEmployeeWithoutP45",
		ExistingEmployee = "ExistingEmployee",
	}
	export enum DirectorsPayrollSetupFlowStatus {
		EmployerInformationStep = "EmployerInformationStep",
		CreateDirectorStep = "CreateDirectorStep",
		DirectorDetailsStep = "DirectorDetailsStep",
		EmployementDetailsStep = "EmployementDetailsStep",
		TaxesStep = "TaxesStep",
		AddDirectorStep = "AddDirectorStep",
		Completed = "Completed",
	}
	export enum EmergencyTaxCode {
		W1 = "W1",
		M1 = "M1",
	}
	export interface Employee {
		Id: string;
		EmployeeData: Entities.Salary.EmployeeData;
		IsDeleted: boolean;
		EmployedSinceUTC: Date;
		CreatedUTC: Date;
		CompanyId: string;
		UserId?: string;
		Status: Entities.Salary.EmployeeStatus;
		NationalInsuranceNumber?: string;
		DateOfBirth?: Day;
		Gender: Entities.Salary.Gender;
		EmployeeNo?: string;
		HoursWorkedCategory?: Entities.Salary.HoursWorkedCategory;
		GrossIncomeBeforeOnboarding: number;
		TaxesPaidBeforeOnboarding: number;
		OnboardingDateUtc?: Date;
		TaxesStarterType?: Entities.Salary.DirectorPayrollSetupFlowTaxesStarterType;
		StarterDeclaration?: Entities.Salary.DirectorPayrollSetupFlowTaxesStarterDeclaration;
		EmployerNICBeforeOnboarding: number;
		EmployeeNICBeforeOnboarding: number;
	}
	export interface EmployeeData {
		Firstname?: string;
		Lastname?: string;
		Address?: Entities.Address;
		Email?: string;
		Phone?: string;
		SocialSecurityNumber?: string;
		BankIdentifier?: string;
		BankAccount?: string;
		Type: Entities.Salary.EmployeeType;
		TaxColumn?: string;
		TaxTable?: string;
		AdvancedSettings: Entities.Salary.AdvancedEmployeeSettings;
		Language?: string;
	}
	export enum EmployeeExpenseAccountType {
		PrivateCard = "PrivateCard",
		CompanyCreditCard = "CompanyCreditCard",
	}
	export interface EmployeePeriodSetting {
		Id: string;
		EmployeeId: string;
		Employee: Entities.Salary.Employee;
		FromDate: Day;
		ToDate?: Day;
		Type: Entities.Salary.EmployeeType;
		TaxColumn?: string;
		TaxTable?: string;
		SalaryPeriod: Entities.Salary.SalaryPeriod;
		Salary: number;
		Workload: Entities.Salary.Workload;
		PartTimeRate: number;
		CompensationUnit: Entities.Salary.CompensationUnit;
		HoursPerWeek: number;
		SalaryValues: Entities.Salary.SalaryValues;
		OriginalSalaryValues: Entities.Salary.SalaryValues;
		VacationSettings: Entities.Salary.EmployeeVacationSettings;
		VacationTrackingEnabled: boolean;
		JobTitle?: string;
		IsEligibleForVaxaSupport: boolean;
		IsDeleted: boolean;
		TaxCode?: string;
		CategoryLetter?: string;
		SalaryFrequency: Entities.Salary.SalaryFrequency;
		NICPaymentMethod: Entities.Salary.NICPaymentMethod;
		PlaceOfEmployment?: Entities.Salary.PlaceOfEmployment;
		PlaceOfEmploymentId?: string;
	}
	export enum EmployeeStatus {
		Inactive = "Inactive",
		Active = "Active",
	}
	export enum EmployeeType {
		Permanent = "Permanent",
		Hourly = "Hourly",
	}
	export interface EmployeeVacationSettings {
		VacationDays: number;
		IsEligibleForPrepaidVacation: boolean;
		/** @deprecated PrepaidVacationDaysLeft is used only. Old values are left in db */
		PrepaidDaysLeftThisYear: number;
		DaysUsedThisPeriod: number;
		SavedDaysFromPreviousPeriod: number;
		PrepaidVacationDaysUsed: number;
		PrepaidVacationDaysLeft: number;
		MaxNewSavedDays: number;
		DiscardVacationDebtDate?: Day;
	}
	export enum Gender {
		Unknowm = "Unknowm",
		Male = "Male",
		Female = "Female",
	}
	export enum HoursWorkedCategory {
		A = "A",
		B = "B",
		C = "C",
		D = "D",
		E = "E",
	}
	export interface NetAdjustmentMapping {
		RowId: string;
		Account?: number;
	}
	export enum NICPaymentMethod {
		Annually = "Annually",
		Monthly = "Monthly",
		Weekly = "Weekly",
	}
	export enum PayslipRowType {
		Inc = "Inc",
		Dec = "Dec",
	}
	export interface PlaceOfEmployment {
		Id: string;
		CompanyId: string;
		Address: string;
		City: string;
		IsDeleted: boolean;
	}
	export enum SalaryFrequency {
		Annually = "Annually",
		Monthly = "Monthly",
	}
	export enum SalaryPaymentMethod {
		Unknown = "Unknown",
		Cash = "Cash",
		ManualBankTransfer = "ManualBankTransfer",
		AutomaticBankTransfer = "AutomaticBankTransfer",
	}
	export enum SalaryPeriod {
		Advance = "Advance",
		Arreas = "Arreas",
	}
	export interface SalaryValues {
		HourlySalary: number;
		WeeklySalary: number;
		DailySalary: number;
		MonthlyVacationRate: number;
		HourlyVacationCompensationRate: number;
		SickSalaryRate: number;
		KarensDeduction: number;
	}
	export enum TaxDeclarationStatus {
		NotDone = "NotDone",
		MarkedAsDoneManually = "MarkedAsDoneManually",
	}
	export enum TaxPaymentStatus {
		NotDone = "NotDone",
		MarkedAsDoneManually = "MarkedAsDoneManually",
	}
	export enum TaxRecordingStatus {
		NotDone = "NotDone",
		Done = "Done",
	}
	export enum UkStudentLoanType {
		Postgraduate = "Postgraduate",
		Plan1 = "Plan1",
		Plan2 = "Plan2",
		Plan4 = "Plan4",
	}
	export enum VacationStatus {
		Locked = "Locked",
		Recorded = "Recorded",
		Pending = "Pending",
	}
	export enum VacationType {
		Prepaid = "Prepaid",
		Unpaid = "Unpaid",
		Paid = "Paid",
		Saved = "Saved",
		Compensation = "Compensation",
	}
	export enum VacationYearEndEmployeeStatus {
		NotStarted = "NotStarted",
		InProgress = "InProgress",
		Done = "Done",
	}
	export enum VacationYearEndStatus {
		InProgress = "InProgress",
		Confirmed = "Confirmed",
		Recorded = "Recorded",
	}
	export enum Workload {
		Fulltime = "Fulltime",
		PartTime = "PartTime",
		NA = "NA",
	}
}
export namespace Entities.Sales {
	export enum DailyTakingsStatus {
		None = "None",
		OK = "OK",
		FixedByUser = "FixedByUser",
		Error = "Error",
		UnsupportPaymentMethodUnknownMethod = "UnsupportPaymentMethodUnknownMethod",
		UnsupportedEventTypeUnknownEvent = "UnsupportedEventTypeUnknownEvent",
		UnsupportedEventTypeFrozenFunds = "UnsupportedEventTypeFrozenFunds",
		UnsupportedEventTypeAdjustment = "UnsupportedEventTypeAdjustment",
		UnsupportedEventTypeFeeDiscountRevocation = "UnsupportedEventTypeFeeDiscountRevocation",
		UnsupportedEventTypeEmoneyTransfer = "UnsupportedEventTypeEmoneyTransfer",
		UnsupportedEventTypeVoucherActivation = "UnsupportedEventTypeVoucherActivation",
		UnsupportedEventTypeMissingCounterpart = "UnsupportedEventTypeMissingCounterpart",
		ECommercePurchasesOmitted = "ECommercePurchasesOmitted",
		ShouldReprocess = "ShouldReprocess",
	}
	export enum DailyTakingsVerificationRelationType {
		NotSet = "NotSet",
		DailyTakings = "DailyTakings",
		BankFees = "BankFees",
		Payouts = "Payouts",
		Other = "Other",
		Cancelled = "Cancelled",
	}
}
export namespace Entities.Security {
	export enum CompanyLoginRestrictionType {
		NotSet = "NotSet",
		Require2FA = "Require2FA",
		RequireBokioPayBankId = "RequireBokioPayBankId",
	}
	export interface CompanySecurityRequirement {
		CompanyId: string;
		RequiredLoginType: Entities.Security.CompanyLoginRestrictionType;
		ModifiedDateTime: Date;
	}
}
export namespace Entities.Support {
	export enum CloseReason {
		NotSet = "NotSet",
		TooComplex = "TooComplex",
		SupportQuestion = "SupportQuestion",
		NoResponse = "NoResponse",
	}
	export enum SupportMessageDisplayMode {
		TodoOnly = "TodoOnly",
		BlockingModal = "BlockingModal",
	}
	export enum SupportMessageType {
		Informational = "Informational",
		BlockingApproval = "BlockingApproval",
		SupportSign = "SupportSign",
		TrialOver = "TrialOver",
		SummerCampaign = "SummerCampaign",
		BbaNotAvailableInFreePlan = "BbaNotAvailableInFreePlan",
		TrialExtended = "TrialExtended",
		CleanUpUsers = "CleanUpUsers",
		TrialToPaidPlan = "TrialToPaidPlan",
		FreeToPaidPlan = "FreeToPaidPlan",
		PremiumToBba = "PremiumToBba",
		BbaToPremiumPlus = "BbaToPremiumPlus",
		LowDepositFree = "LowDepositFree",
		HighDepositFree = "HighDepositFree",
		BbaInactivityFee = "BbaInactivityFee",
		BbaNonConsentInactivityFee = "BbaNonConsentInactivityFee",
	}
	export enum SupportTicketRole {
		Company = "Company",
		Partner = "Partner",
	}
	export enum SupportTicketStatus {
		Pending = "Pending",
		InProgress = "InProgress",
		Resolved = "Resolved",
		Invalid = "Invalid",
		Closed = "Closed",
		MarkedForBilling = "MarkedForBilling",
	}
}
export namespace Entities.Taxes {
	export enum TaxDatePaymentType {
		ManualPayment = "ManualPayment",
		TellerPayment = "TellerPayment",
		UseMoneyOnTaxAccount = "UseMoneyOnTaxAccount",
	}
}
export namespace Entities.Teller {
	export enum RecurringPaymentInterval {
		Invalid = "Invalid",
		Weekly = "Weekly",
		Monthly = "Monthly",
	}
	export enum TellerConsumer {
		Invalid = "Invalid",
		ManualPayment = "ManualPayment",
		SupplierInvoice = "SupplierInvoice",
		Expenses = "Expenses",
		Invoice = "Invoice",
		Payroll = "Payroll",
		CardTransaction = "CardTransaction",
		Billing = "Billing",
		BbaMigration = "BbaMigration",
		SalaryTax = "SalaryTax",
		VATTax = "VATTax",
	}
	export interface TellerPaymentPrefilledInformation {
		GiroOcr?: string;
		GiroMessage?: string;
		ReferenceForSender?: string;
	}
	export enum TellerPaymentStatus {
		Invalid = "Invalid",
		AwaitingApproval = "AwaitingApproval",
		CancelledByUser = "CancelledByUser",
		DraftInExternalSystem = "DraftInExternalSystem",
		WaitingForAuthorization = "WaitingForAuthorization",
		InComplianceReview = "InComplianceReview",
		Scheduled = "Scheduled",
		Transfering = "Transfering",
		RejectedByBank = "RejectedByBank",
		PaymentComplete = "PaymentComplete",
		WaitingForStatus = "WaitingForStatus",
	}
	export enum TellerPaymentType {
		Invalid = "Invalid",
		SeBankgiro = "SeBankgiro",
		SePlusgiro = "SePlusgiro",
		SeClearingAccount = "SeClearingAccount",
		OwnAccount = "OwnAccount",
		EuSepa = "EuSepa",
		SwiftBic = "SwiftBic",
	}
	export enum TellerTransactionStatus {
		Invalid = "Invalid",
		Pending = "Pending",
		Completed = "Completed",
		Removed = "Removed",
		HiddenProcessing = "HiddenProcessing",
		HiddenCompleted = "HiddenCompleted",
	}
	export enum TellerTransactionType {
		Invalid = "Invalid",
		SeBankgiro = "SeBankgiro",
		SePlusgiro = "SePlusgiro",
		SeClearingAccount = "SeClearingAccount",
		SeBban = "SeBban",
		OwnBankAccount = "OwnBankAccount",
		EuSepa = "EuSepa",
		SwiftBic = "SwiftBic",
		IntBban = "IntBban",
		IntTransfer = "IntTransfer",
		IbanCredit = "IbanCredit",
		IntBbanWithMissingContext = "IntBbanWithMissingContext",
		Card = "Card",
		SwishDebit = "SwishDebit",
		SwishCredit = "SwishCredit",
		SwishReturnDebit = "SwishReturnDebit",
		SwishReturnCredit = "SwishReturnCredit",
		SwishCommerceDebit = "SwishCommerceDebit",
		SwishCommerceRefundCredit = "SwishCommerceRefundCredit",
		AutogiroDebit = "AutogiroDebit",
		Correction = "Correction",
		Charge = "Charge",
		Unknown = "Unknown",
		SveaBankgiroCredit = "SveaBankgiroCredit",
		OwnBankAccountCredit = "OwnBankAccountCredit",
		SwedishBankAccountCredit = "SwedishBankAccountCredit",
	}
}
export namespace Entities.Todo {
	export enum Frequency {
		Monthly = "Monthly",
	}
}
export namespace Entities.Tracking {
	export enum InAppSalesTrackingEventType {
		NotSet = "NotSet",
		ViewCampaignModal_Covid19_1 = "ViewCampaignModal_Covid19_1",
		DissmissCampaignModal_Covid19_1 = "DissmissCampaignModal_Covid19_1",
		ClickCTA_FactoringReadMore_Covid19_1 = "ClickCTA_FactoringReadMore_Covid19_1",
		ClickCTA_BlogReadMore_Covid19_1 = "ClickCTA_BlogReadMore_Covid19_1",
	}
}
export namespace Feedback.Controllers {
	export enum SetRatingErrors {
		OutsideOneDay = "OutsideOneDay",
	}
	export enum SurveyError {
		Default = "Default",
		AlreadyResponded = "AlreadyResponded",
	}
}
export namespace Feedback.Models {
	export interface ShowInterestDto {
		FeatureInterestKey: Entities.Feedback.FeatureInterestKey;
		Comment?: string;
	}
	export interface SignUpSurveyDto {
		UseCase: Feedback.Models.UseCaseQuestion;
		BusinessActivity?: boolean;
		SwitchingSoftware?: boolean;
		UsingAnAccountant?: boolean;
		NewToAccounting?: boolean;
		HaveEmployees?: boolean;
		IsAccountant?: boolean;
		BookkeepingInOtherSoftware?: boolean;
	}
	export interface UseCaseQuestion {
		UseCases: Feedback.Models.UseCases[];
		ShortAwnswer?: string;
	}
	export enum UseCases {
		Unknown = "Unknown",
		Bookkeeping = "Bookkeeping",
		Invoices = "Invoices",
		Salary = "Salary",
		Closures = "Closures",
		Vat = "Vat",
		JustLooking = "JustLooking",
	}
}
export namespace Invoices.Contract {
	export enum ConsumerType {
		InApp = "InApp",
		PublicApi = "PublicApi",
		All = "All",
	}
	export interface DailyTakingsActivationStatusResult {
		ActivationStatus: Entities.Integration.IntegrationActivationState;
		SyncFromDate?: Day;
	}
	export interface InvoiceCorrectionAction {
		Key: string;
		Disabled: Invoices.Contract.InvoiceCorrectionActionBlocker;
	}
	export interface InvoiceCorrectionActionBlocker {
		IsBlocked: boolean;
		Message: string;
	}
	export enum iZettleAuthError {
		UserActivationUrlFailed = "UserActivationUrlFailed",
		UserTokenCouldNotBeReturned = "UserTokenCouldNotBeReturned",
		UserActivationStatusCouldNotBeReturned = "UserActivationStatusCouldNotBeReturned",
		GraniteConnectionFailed = "GraniteConnectionFailed",
		TestCompanyNotAllowed = "TestCompanyNotAllowed",
	}
	export interface iZettleAuthUrlState {
		Url: string;
		State: string;
	}
}
export namespace Invoices.Contract.Commands.Articles {
	export interface DeleteArticle {
		ArticleId: string;
	}
	export interface UpdateArticle {
		ArticleId: string;
		ProductCode?: string;
		Description?: string;
		UnitPrice: number;
		VAT: number;
		Kind: Entities.Invoices.InvoiceRowKind;
		UnitType: Entities.Invoices.InvoiceRowUnitType;
		IsTextRow: boolean;
		TemplateName?: string;
		BookkeepingAccountNumber?: number;
	}
}
export namespace Invoices.Contract.Commands.Attachments {
	export interface DeleteInvoiceAttachment {
		InvoiceId: string;
		InvoiceAttachmentId: string;
	}
	export interface DeleteInvoiceAttachments {
		InvoiceId: string;
	}
}
export namespace Invoices.Contract.Commands.BookkeepCommands {
	export interface BookkeepInvoiceCommand {
		InvoiceId: string;
	}
	export interface BookkeepInvoiceFinancing {
		InvoiceFinancingId: string;
	}
	export interface BookkeepPaymentCommand {
		PaymentId: string;
	}
	export interface BookkeepReminderCommand {
		ReminderId: string;
	}
	export interface DeleteInvoiceBookkeeping {
		InvoiceId: string;
	}
}
export namespace Invoices.Contract.Commands.CompanyCommands {
	export interface SetCompanyAddressPosition {
		AddressPosition: Entities.CompanyAddressPosition;
	}
	export interface SetCompanyColor {
		CompanyColor: string;
	}
	export interface SetCompanyInvoiceData {
		PaymentTerms: string;
		DeliveryTerms: string;
		DelayInterest: string;
		DisableRounding: boolean;
		ValidDays: number;
	}
	export interface SetCompanyInvoiceNumber {
		InvoiceNumber: number;
		InvoiceNumberPrefix?: string;
	}
	export interface SetCompanyQuoteNumber {
		QuoteNumber: number;
	}
	export interface SetStartingNumbers {
		CustomerNumber: number;
		InvoiceNumber: number;
		QuoteNumber: number;
		InvoiceNumberPrefix: string;
	}
	export interface UpdateAutomaticChecking {
		AutomaticChecking: boolean;
	}
}
export namespace Invoices.Contract.Commands.CreditInvoices {
	export interface ConnectCreditInvoiceCommand {
		InvoiceId: string;
		CreditsInvoiceId?: string;
	}
	export interface ToggleStandaloneCreditNoteInAgeDebtorsCommand {
		InvoiceId: string;
	}
}
export namespace Invoices.Contract.Commands.CustomerCommands {
	export interface CreateCustomer {
		CustomerId: string;
		CustomerNumber?: number;
		IsCreatedByImport?: boolean;
	}
	export interface CreateOrUpdateCustomerContactDetails {
		Id?: string;
		ContactName: string;
		Email?: string;
		Phone: string;
		IsPrimary: boolean;
	}
	export interface DeleteCustomer {
		CustomerId: string;
	}
	export interface EditFullReceiverData {
		CustomerId: string;
		ReceiverData: Entities.InvoiceReceiverData;
		ContactDetails: Invoices.Contract.Commands.CustomerCommands.CreateOrUpdateCustomerContactDetails[];
		IsImport: boolean;
	}
	export interface ViewCustomerContactDetails {
		Id: string;
		ContactName: string;
		Email?: string;
		Phone: string;
		IsPrimary: boolean;
	}
}
export namespace Invoices.Contract.Commands.Factoring {
	export interface DeletePaymentFromCustomerToFactoringProvider {
		InvoiceFinancingId: string;
	}
	export interface RegisterPaymentFromCustomerToFactoringProvider {
		InvoiceId: string;
		Sum: number;
		PreviousSumReceived?: number;
		Date: Day;
		AccountNbr?: number;
		/** @deprecated Legacy version of settle invoice that should not be used */
		SettleInvoice: boolean;
		PaymentId: string;
		/** @deprecated Seems unused */
		ReceiptId: string;
		/** @deprecated Seems unused */
		AutoVerificationRowId?: string;
		VerificationId?: string;
		ExternalId: string;
	}
	export interface RegisterPaymentFromFactoringProvider {
		Type: Entities.Invoices.InvoiceFinancingType;
		AccountNbr?: number;
		InvoiceId: string;
		Sum: number;
		Cost?: number;
		Date: Day;
	}
	export interface RequestFactoringQuote {
		InvoiceId: string;
	}
}
export namespace Invoices.Contract.Commands.InvoiceCommands {
	export interface AddReminder {
		ReminderFee: number;
		Message: string;
	}
	export interface AddRotRutRow {
		Type: Entities.Invoices.RotRutType;
		MaterialType: Entities.Invoices.RotRutMaterialType;
	}
	export interface AddRow {
		InvoiceId: string;
		Description?: string;
		Units: number;
		UnitPrice?: number;
		UnitType: Entities.Invoices.InvoiceRowUnitType;
		VAT?: number;
		IsTextRow: boolean;
		ProductCode?: string;
		ArticleId?: string;
		Kind: Entities.Invoices.InvoiceRowKind;
		RotRutRow?: Invoices.Contract.Commands.InvoiceCommands.AddRotRutRow;
		ReversedVAT?: Entities.Invoices.ReversedVAT;
	}
	export interface CopyInvoice {
		InvoiceId: string;
		OldInvoiceId: string;
		CustomerId?: string;
		Rows: Entities.Invoices.InvoiceRow[];
	}
	export interface CreateAlienInvoiceCommand {
		InvoiceId: string;
		CustomerId: string;
		InvoiceNumber: number;
		InvoiceDate: Day;
		DueDate: Day;
		RemainingSumDomestic: number;
		Notes: string;
	}
	export interface CreateInvoice {
		Type?: Entities.Invoices.InvoiceType;
		Deadline?: Day;
		InvoiceDate?: Day;
		CustomerId?: string;
		InvoiceFee: number;
		RecurringInvoiceEnabled?: boolean;
	}
	export interface DeleteAlienInvoiceCommand {
		InvoiceId: string;
	}
	export interface DeleteInvoice {
		InvoiceId: string;
		Date?: Day;
	}
	export interface DeleteRow {
		InvoiceId: string;
		RowId: number;
	}
	export interface EditAlienInvoiceCommand {
		InvoiceId: string;
		CustomerId: string;
		InvoiceNumber: number;
		InvoiceDate: Day;
		DueDate: Day;
		RemainingSumDomestic: number;
		Notes: string;
	}
	export interface EditInvoiceDates {
		InvoiceId: string;
		PropertyName: string;
		OldValue?: Day;
		NewValue: Day;
	}
	export interface EditInvoiceHasVatFreeMessage {
		InvoiceId: string;
		HasVatFreeMessage?: boolean;
	}
	export interface EditInvoiceRow {
		Id: number;
		Description: string;
		Units: number;
		UnitPrice?: number;
		UnitType: Entities.Invoices.InvoiceRowUnitType;
		VAT: number;
		Kind: Entities.Invoices.InvoiceRowKind;
		ProductCode: string;
		/** @deprecated Seems unused */
		InvoiceId: string;
		ArticleId?: string;
		RotRutRow?: Invoices.Contract.Commands.InvoiceCommands.UpdateRotRutRow;
		ReversedVAT?: Entities.Invoices.ReversedVAT;
	}
	export interface EditPublishedInvoice {
		InvoiceId: string;
		NewInvoiceId: string;
	}
	export interface PublishInvoice {
		InvoiceId: string;
		ReceiptId?: string;
		InvoiceSystem: Entities.Invoices.InvoiceSystem;
		PersonalMessage?: string;
		EscalateSoftBlockToHardBlock?: boolean;
	}
	export interface SaveEditInvoice {
		InvoiceId: string;
	}
	export interface SetCurrency {
		InvoiceId: string;
		Currency: string;
		/** @deprecated Should not set. Except for PAPI */
		CurrencyRateValue?: number;
	}
	export interface SetCurrencyResult {
		Success: boolean;
	}
	export interface SetCustomer {
		InvoiceId: string;
		CustomerId?: string;
		CustomerContactId?: string;
	}
	export interface SetCustomerResult {
		Success: boolean;
	}
	export interface SetRowOrder {
		InvoiceId: string;
		OrderedRowIds: number[];
	}
	export interface ToggleEnableStripePayments {
		InvoiceId: string;
		Enable: boolean;
	}
	export interface ToggleInvoicePortal {
		InvoiceId: string;
		Enable: boolean;
	}
	export interface UndoPublishInvoice {
		InvoiceId: string;
	}
	export interface UpdateRotRutRow {
		Id?: string;
		Type: Entities.Invoices.RotRutType;
		MaterialType: Entities.Invoices.RotRutMaterialType;
	}
}
export namespace Invoices.Contract.Commands.InvoiceDeliveryCommands {
	export interface SendFactoringRequestDelivery {
		SenderEmail: string;
		InvoiceId: string;
	}
	export interface SendInvoiceDelivery {
		InvoiceId: string;
		Method: Entities.Invoices.InvoiceDeliveryMethod;
		ReminderId?: string;
		Email: string;
		Emails: string[];
		PersonalMessage?: string;
		DataJson: string;
	}
}
export namespace Invoices.Contract.Commands.Payments {
	export interface DeletePayment {
		PaymentId: string;
	}
	export interface RegisterInvoiceSettlement {
		InvoiceId: string;
		PaymentId?: string;
		VerificationId?: string;
		InvoiceSettlement: Invoices.Contract.ViewData.RegisterInvoiceSettlementDto;
	}
	export interface RemoveInvoiceSettlement {
		InvoiceId: string;
		SettlementId: string;
	}
	export interface UpdatePaymentIntentStatusCommand {
		PaymentIntentId: string;
		Status: Entities.Invoices.InvoicePaymentIntentStatus;
	}
}
export namespace Invoices.Contract.Commands.QuoteAttachments {
	export interface DeleteQuoteAttachment {
		QuoteId: string;
		QuoteAttachmentId: string;
	}
	export interface DeleteQuoteAttachments {
		QuoteId: string;
	}
}
export namespace Invoices.Contract.Commands.Quotes {
	export interface AddQuoteRow {
		QuoteId: string;
		Description?: string;
		Units: number;
		UnitPrice?: number;
		UnitType: Entities.Invoices.InvoiceRowUnitType;
		VAT?: number;
		IsTextRow: boolean;
		ProductCode?: string;
		AccountNbr?: number;
		ArticleId?: string;
		Kind: Entities.Invoices.InvoiceRowKind;
		RotRutRow?: Invoices.Contract.Commands.InvoiceCommands.AddRotRutRow;
		ReversedVAT?: Entities.Invoices.ReversedVAT;
	}
	export interface ConvertToInvoice {
		QuoteId: string;
	}
	export interface CopyQuote {
		QuoteId: string;
	}
	export interface CreateQuoteCommand {
		ValidFromDate?: Day;
		ValidToDate?: Day;
		CustomerId?: string;
		QuoteFee: number;
	}
	export interface CreateQuoteRotRut {
		QuoteId: string;
		Type: Entities.Invoices.RotRutType;
		Description: string;
		PropertyType: Entities.Invoices.PropertyType;
		RealEstateNumber: string;
		OrganisationalNumberOfTenant: string;
		ApartmentNumber: string;
	}
	export interface DeleteQuote {
		QuoteId: string;
	}
	export interface DeleteQuoteRotRut {
		QuoteId: string;
		RotRutId: string;
	}
	export interface DeleteQuoteRow {
		QuoteId: string;
		RowId: number;
	}
	export interface EditQuote {
		QuoteId: string;
	}
	export interface EditQuoteDate {
		QuoteId: string;
		ValidFromDate: Day;
		ValidToDate: Day;
	}
	export interface EditQuoteRotRut {
		QuoteId: string;
		RotRutId: string;
		Type: Entities.Invoices.RotRutType;
		Description: string;
		PropertyType: Entities.Invoices.PropertyType;
		RealEstateNumber: string;
		OrganisationalNumberOfTenant: string;
		ApartmentNumber: string;
	}
	export interface EditQuoteRow {
		QuoteId: string;
		Id: number;
		Description: string;
		Units: number;
		UnitPrice?: number;
		UnitType: Entities.Invoices.InvoiceRowUnitType;
		VAT: number;
		Kind: Entities.Invoices.InvoiceRowKind;
		ProductCode: string;
		ArticleId?: string;
		RotRutRow?: Invoices.Contract.Commands.InvoiceCommands.UpdateRotRutRow;
		ReversedVAT?: Entities.Invoices.ReversedVAT;
	}
	export interface EditQuoteState {
		QuoteId: string;
		State: Entities.Invoices.QuoteState;
	}
	export interface PublishQuote {
		QuoteId: string;
	}
	export interface SaveEditQuote {
		QuoteId: string;
	}
	export interface SendQuoteDelivery {
		QuoteId: string;
		Method: Entities.Invoices.QuoteDeliveryMethod;
		Email: string;
		PersonalMessage?: string;
		DataJson: string;
	}
	export interface SetQuoteCurrency {
		QuoteId: string;
		Currency: string;
	}
	export interface SetQuoteCustomer {
		QuoteId: string;
		CustomerId?: string;
		CustomerContactId?: string;
	}
	export interface SetQuoteRowOrder {
		QuoteId: string;
		OrderedRowIds: number[];
	}
	export interface ToggleQuoteRounding {
		QuoteId: string;
		DisableRounding: boolean;
	}
	export interface ToggleQuoteShowVAT {
		QuoteId: string;
		IsVatIncludedInRowTotal: boolean;
	}
}
export namespace Invoices.Contract.Commands.RecurringInvoiceCommands {
	export interface ActivateRecurringInvoice {
		RecurringInvoiceId: string;
	}
	export interface CopyRecurringInvoice {
		RecurringInvoiceId: string;
		TemplateInvoiceId: string;
	}
	export interface CreateRecurringInvoice {
		TemplateInvoiceId: string;
		RecurringInvoiceScheduling: Entities.Invoices.RecurringInvoiceScheduling;
	}
	export interface DeleteRecurringInvoice {
		RecurringInvoiceId: string;
	}
	export interface EditRecurringInvoice {
		InvoiceId: string;
		RecurringInvoiceId: string;
	}
	export interface PublishRecurringInvoice {
		RecurringInvoiceId: string;
	}
	export interface SaveEditedRecurringInvoice {
		RecurringInvoiceId: string;
	}
	export interface StopRecurringInvoice {
		RecurringInvoiceId: string;
	}
	export interface UpdateRecurringInvoiceSettings {
		RecurringInvoiceId: string;
		TemplateInvoiceId?: string;
		RecurringInvoiceScheduling: Entities.Invoices.RecurringInvoiceScheduling;
	}
}
export namespace Invoices.Contract.Commands.RotRuts {
	export interface ClaimRotRut {
		InvoiceId: string;
		RotRutId: string;
		Amount: number;
	}
	export interface CreateRotRut {
		InvoiceId: string;
		Type: Entities.Invoices.RotRutType;
		Description: string;
		PropertyType: Entities.Invoices.PropertyType;
		RealEstateNumber: string;
		OrganisationalNumberOfTenant: string;
		ApartmentNumber: string;
	}
	export interface DeleteRotRut {
		InvoiceId: string;
		RotRutId: string;
	}
	export interface EditRotRut {
		InvoiceId: string;
		RotRutId: string;
		Type: Entities.Invoices.RotRutType;
		Description: string;
		PropertyType: Entities.Invoices.PropertyType;
		RealEstateNumber: string;
		OrganisationalNumberOfTenant: string;
		ApartmentNumber: string;
	}
	export interface SetRotRutStatus {
		InvoiceId: string;
		RotRutId: string;
		RotRutStatus: Entities.Invoices.RotRutStatus;
	}
}
export namespace Invoices.Contract.Commands.Stripe {
	export enum SignupState {
		NotStarted = "NotStarted",
		Created = "Created",
		Verifying = "Verifying",
		Completed = "Completed",
		Error = "Error",
		Rejected = "Rejected",
		Disconnecting = "Disconnecting",
	}
	export interface StripeCompanyStatus {
		Status: Invoices.Contract.Commands.Stripe.SignupState;
		SignupUrl: string;
	}
}
export namespace Invoices.Contract.Commands.TimeTrackingCommands {
	export interface CreateTimeTrackingAccount {
		Account: Entities.Invoices.TimeTrackingAccount;
	}
	export interface CreateTimeTrackingImport {
		Id: string;
		TimeTrackingAccountId: string;
		ExternalClientId: string;
		ExternalProjectId: string;
		FromDate: Day;
		ToDate: Day;
		Units: number;
		Price: number;
		InvoiceId: string;
		InvoiceRowId: number;
	}
	export interface DeleteTimeTrackingAccount {
		AccountId: string;
	}
}
export namespace Invoices.Contract.CustomerInvoices {
	export enum ToggleCustomerInvoicePeriodisationBlockReason {
		NoBlocker = "NoBlocker",
		IsConnectedCreditInvoice = "IsConnectedCreditInvoice",
		IsRecorded = "IsRecorded",
		HasRecordedCreditInvoices = "HasRecordedCreditInvoices",
	}
	export interface ToggleCustomerInvoicePeriodisationResult {
		IsPeriodised: boolean;
		CanPeriodise: boolean;
		ShowPeriodiseOption: boolean;
		BlockReason?: Invoices.Contract.CustomerInvoices.ToggleCustomerInvoicePeriodisationBlockReason;
		Warnings: Invoices.Contract.CustomerInvoices.ToggleCustomerInvoicePeriodisationWarning[];
	}
	export enum ToggleCustomerInvoicePeriodisationWarning {
		NoWarning = "NoWarning",
		IsRotRutInvoice = "IsRotRutInvoice",
	}
}
export namespace Invoices.Contract.DTOs {
	export interface AddInvoicePortalPaymentMethodRequestDto {
		Key: Entities.Invoices.InvoicePaymentMethodKey;
		PrimaryLabel: string;
		PrimaryValue?: string;
		SecondaryLabel?: string;
		SecondaryValue?: string;
		ThirdLabel?: string;
		ThirdValue?: string;
	}
	export interface InvoicePortalPaidMarkDto {
		Id: string;
		IsPaid: boolean;
		MarkedByEmail?: string;
	}
	export interface InvoicePortalPaymentMethodDto {
		Id: string;
		Key: Entities.Invoices.InvoicePaymentMethodKey;
		PrimaryLabel: string;
		PrimaryValue?: string;
		SecondaryLabel?: string;
		SecondaryValue?: string;
		ThirdLabel?: string;
		ThirdValue?: string;
		Enabled: boolean;
	}
	export interface InvoicePortalSettingsDto {
		PortalEnabled: boolean;
		PaymentMethods: Invoices.Contract.DTOs.InvoicePortalPaymentMethodDto[];
		StripeStatus: Invoices.Contract.Commands.Stripe.StripeCompanyStatus;
	}
	export interface MarkInvoiceAsPaidRequestDto {
		IsPaid: boolean;
		Email?: string;
	}
	export interface RemoveInvoicePortalPaymentMethodRequestDto {
		ItemId: string;
	}
	export interface SetPortalEnabledRequestDto {
		Enabled: boolean;
	}
	export interface UpdateInvoicePortalPaymentMethodRequestDto {
		ItemId: string;
		Key: Entities.Invoices.InvoicePaymentMethodKey;
		PrimaryLabel: string;
		PrimaryValue?: string;
		SecondaryLabel?: string;
		SecondaryValue?: string;
		ThirdLabel?: string;
		ThirdValue?: string;
		Enabled: boolean;
	}
}
export namespace Invoices.Contract.EInvoice {
	export enum Compliance {
		DoesNotAllow = "DoesNotAllow",
		Permits = "Permits",
		Prefer = "Prefer",
	}
	export enum EInvoiceInviteServiceType {
		Invalid = "Invalid",
		InviteSupplier = "InviteSupplier",
		InviteReceiver = "InviteReceiver",
	}
	export enum EInvoiceInviteStatusCode {
		Invalid = "Invalid",
		Sent = "Sent",
		Approved = "Approved",
		Denied = "Denied",
		InsufficientInformation = "InsufficientInformation",
		Expired = "Expired",
		NotSent = "NotSent",
	}
	export interface EInvoiceParty {
		OrgNumber: string;
		VAT: string;
		CountryCode: string;
		ID: number;
		Name: string;
		Address1: string;
		Address2: string;
		ZipCode: string;
		City: string;
		Phone: string;
		ContactName: string;
		Fax: string;
		Email: string;
		Notes: Invoices.Contract.EInvoice.EInvoicePartyNote[];
		ReceiveInvoicePreference?: Invoices.Contract.EInvoice.EInvoicePartyPreference;
		SenderInvoicePreference?: Invoices.Contract.EInvoice.EInvoicePartyPreference;
		GLN: string;
	}
	export interface EInvoicePartyInfo {
		ReceiveInvoicePreference?: Invoices.Contract.EInvoice.EInvoicePartyPreference;
		SenderInvoicePreference?: Invoices.Contract.EInvoice.EInvoicePartyPreference;
		GLN: string;
	}
	export interface EInvoicePartyInviteStatus {
		InviteId: number;
		ServiceType: Invoices.Contract.EInvoice.EInvoiceInviteServiceType;
		InvitingPartyId: number;
		InvitedPartyId: number;
		InviteResipientEmail: string;
		StatusCode: Invoices.Contract.EInvoice.EInvoiceInviteStatusCode;
		LatestStatusTime: Date;
	}
	export interface EInvoicePartyNote {
		Severity: Invoices.Contract.EInvoice.NoteSeverity;
		Type: Invoices.Contract.EInvoice.NoteType;
	}
	export interface EInvoicePartyPreference {
		Compliance: Invoices.Contract.EInvoice.Compliance;
		Instructions: string;
		RegistrationStatus: Invoices.Contract.EInvoice.ServiceRegistrationStatus;
	}
	export interface GetEInvoicePartyDto {
		Party?: Invoices.Contract.EInvoice.EInvoiceParty;
		IsCompanyAuthenticated: boolean;
		NeedsCrediFlowKyc: boolean;
		IsDisconnected: boolean;
	}
	export enum NoteSeverity {
		Invalid = "Invalid",
		Info = "Info",
		Warning = "Warning",
	}
	export enum NoteType {
		Invalid = "Invalid",
		PartyMissingEmail = "PartyMissingEmail",
	}
	export enum PartyRegisterError {
		Unknown = "Unknown",
		AlreadyRegistered = "AlreadyRegistered",
		NotRegistered = "NotRegistered",
		OrgNumberAlreadyOnboardedAnotherBokioCompany = "OrgNumberAlreadyOnboardedAnotherBokioCompany",
		PartyIdAlreadyConnectedToAnotherBokioCompany = "PartyIdAlreadyConnectedToAnotherBokioCompany",
		AlreadyConnected = "AlreadyConnected",
		NotConnected = "NotConnected",
		PartyHasUncollectedInvoices = "PartyHasUncollectedInvoices",
		UpdateFailed = "UpdateFailed",
		CommunicationError = "CommunicationError",
		ValidationError = "ValidationError",
		VATNumberDoesNotMatchUc = "VATNumberDoesNotMatchUc",
	}
	export enum ServiceRegistrationStatus {
		Unregistered = "Unregistered",
		RegisteredWithBokio = "RegisteredWithBokio",
		RegisteredExternal = "RegisteredExternal",
	}
}
export namespace Invoices.Contract.Factoring {
	export enum FactoringCompanyStatus {
		Unknown = "Unknown",
		Active = "Active",
		NotActive = "NotActive",
		CannotActivateFactoring = "CannotActivateFactoring",
		OnboardingIncomplete = "OnboardingIncomplete",
		IncompleteCompanyTasks = "IncompleteCompanyTasks",
		MissingOnboarding = "MissingOnboarding",
	}
}
export namespace Invoices.Contract.InvoiceLog {
	export interface InvoiceLogEntryDto {
		Id: string;
		InvoiceId: string;
		InvoiceNumberWithPrefix: string;
		CustomerId?: string;
		CustomerName: string;
		EventType: Invoices.Contract.InvoiceLog.InvoiceLogEventType;
		Date: Day;
		RegisteredUtc: Date;
		Label: string;
		Amount?: number;
		VerificationId?: string;
		VerificationNumber?: string;
	}
	export enum InvoiceLogEventType {
		InvoiceCreated = "InvoiceCreated",
		Payment = "Payment",
		ReminderFee = "ReminderFee",
		Credit = "Credit",
		Settlement = "Settlement",
		FactoringSettled = "FactoringSettled",
	}
	export interface InvoiceLogFilterDto {
		DateFrom?: Day;
		DateTo?: Day;
		EventTypes?: Invoices.Contract.InvoiceLog.InvoiceLogEventType[];
		CustomerId?: string;
	}
	export interface InvoiceLogResultDto {
		Items: Invoices.Contract.InvoiceLog.InvoiceLogEntryDto[];
	}
}
export namespace Invoices.Contract.OnlinePayments {
	export interface StripePaymentIntentPaymentMethod {
		Brand: string;
		Last4: string;
	}
}
export namespace Invoices.Contract.RotRuts {
	export interface DeductionRule {
		Type: Entities.Invoices.RotRutType;
		EffectiveFrom: Day;
		EffectiveTo: Day;
		MaxPercentage: number;
		ErrorMessage: string;
	}
}
export namespace Invoices.Contract.Sales {
	export interface CanFetchFromDto {
		Day: Day;
		LimitReason: Invoices.Contract.Sales.CanFetchFromEarlierLimitReason;
		HasExistingData: boolean;
	}
	export enum CanFetchFromEarlierLimitReason {
		None = "None",
		ClosedOrNonExistingFiscalYear = "ClosedOrNonExistingFiscalYear",
		ClosedVatPeriod = "ClosedVatPeriod",
		LockedPeriod = "LockedPeriod",
		TimeLimit = "TimeLimit",
	}
}
export namespace Invoices.Contract.TimeTracking {
	export interface TrackingAccountRangeRequest {
		WorkspaceId: number;
		Start: Day;
		End: Day;
		TrackingAccountId: string;
	}
	export interface TrackingAccountRequest {
		TrackingAccountId: string;
	}
}
export namespace Invoices.Contract.ViewData {
	export interface AccountsReceivableResult {
		AllCustomersDue: number;
		TotalNumberOfInvoices: number;
		Customers: Invoices.Contract.ViewData.CustomerDue[];
	}
	export interface AlienInvoiceForView {
		Id: string;
		CustomerId?: string;
		CustomerContactDetailId?: string;
		CustomerName: string;
		AmountSEK: number;
		RemainingSum: number;
		InvoiceDate: Date;
		InvoiceNumber: number;
		Deadline: Date;
		Notes: string;
		ReceiverData: Entities.InvoiceReceiverData;
	}
	export interface CustomerDue {
		Id: string;
		Due: number;
		TotalInvoiceAmountEver: number;
		Name: string;
		CustomerNumber: number;
		Invoices: Invoices.Contract.ViewData.InvoiceWithBalance[];
	}
	export interface FactoringData {
		IsSold: boolean;
		ExternalId: Entities.ExternalId;
		FactoringInvoiceStatus?: Entities.Invoices.FactoringInvoiceEvent;
	}
	export interface FactoringOnboardingPayload {
		KYCId?: string;
		SubscriptionId?: string;
		ServiceOnboardingId: string;
		ExpectedTurnover?: number;
		OnboardingCompanyInfo: Entities.Invoices.FactoringOnboardingModel;
		KYC: Entities.KnowYourCustomers.FactoringKnowYouCustomerAnswersVersion2;
	}
	export interface InvoiceActions {
		CanSendReminder: boolean;
	}
	export interface InvoiceBody {
		Type: Entities.Invoices.InvoiceType;
		Deadline: Day;
		InvoiceDate: Day;
		InvoiceNumberWithPrefix: string;
		PaymentReference: string;
		PaymentLinkId?: string;
		PaymentLinkReference: string;
		CustomerId?: string;
		CustomerNumber: number;
		CustomerContactDetailId?: string;
		CreditsId?: string;
		CreditedById?: string;
		ReceiverData: Entities.InvoiceReceiverData;
		SenderData: Entities.InvoiceSenderData;
		Sum: number;
		SumSek: number;
		InvoiceFee: number;
		Rounding: number;
		TotalSum: number;
		TotalSumSek: number;
		SumReceived: number;
		RemainingSum: number;
		Tax: number;
		TaxSek: number;
		DeductionSum: number;
		State: Entities.Invoices.InvoiceState;
		Rows: Invoices.Contract.ViewData.InvoiceRowForView[];
		Totals: Invoices.Contract.ViewData.InvoiceTotalsRow[];
		CompanyId: string;
		Currency: string;
		AccountingType?: Entities.AccountingType;
		Created?: Date;
		DisableBookkeeping: boolean;
		DisableRounding: boolean;
		HasVatFreeMessage?: boolean;
		IsVatIncludedInRowTotal: boolean;
		CreditsNumber?: number;
		CreditsNumberWithPrefix: string;
		CreditsType?: Entities.Invoices.InvoiceType;
		CurrencyRateValue?: number;
		InvoiceSystem: Entities.Invoices.InvoiceSystem;
		ExternalId: string;
		PlaceholderVerificationId?: string;
		FactoringData: Invoices.Contract.ViewData.FactoringData;
		RotRutId?: string;
		RotRut?: Invoices.Contract.ViewData.RotRutForView;
		QuoteId?: string;
		QuoteReference: string;
		CreditedRotRutId?: string;
		ClaimedInvoiceId?: string;
		ClaimInvoiceId?: string;
		RecurringInvoiceId?: string;
		InvoicePeriod: Entities.Invoices.InvoicePeriod;
		ContractReference: string;
		ProjectReference: string;
		OrderReference: string;
		BuyerReference: string;
		DeliveryInformation: Entities.DeliveryInformation;
		LastEditedBy: string;
		StripePaymentsEnabled: boolean;
		PortalEnabled: boolean;
		DefaultEmailDeliveryType?: Entities.Invoices.EmailInvoiceDeliveryType;
		TemplateRecurringInvoice?: Invoices.Contract.ViewData.TemplateRecurringInvoiceForInvoiceBody;
	}
	export interface InvoiceDeliveryDto {
		Id: string;
		Method: Entities.Invoices.InvoiceDeliveryMethod;
		EmailActivity?: Core.ViewData.EmailActivityDto;
		TimestampUtc: Date;
		EmailDeliveryType?: Entities.Invoices.EmailInvoiceDeliveryType;
		DeliveryStatus: Invoices.Contract.ViewData.InvoiceDeliveryStatusDto;
		EmailInvoiceDeliveryData?: Entities.Invoices.EmailInvoiceDeliveryData;
		IsReminder: boolean;
	}
	export interface InvoiceDeliveryStatusDto {
		Message: string;
		State: Entities.Invoices.DeliveryStatusState;
		Time: Date;
	}
	export interface InvoiceForQuote {
		Id: string;
		State: Entities.Invoices.InvoiceState;
		InvoiceNumber: string;
	}
	export interface InvoiceForTodoView {
		Id: string;
		CompanyId: string;
		InvoiceNumberWithPrefix: string;
		Currency: string;
		AccountingType?: Entities.AccountingType;
		PlaceholderVerificationId?: string;
		State: Entities.Invoices.InvoiceState;
		SenderCompanyName: string;
		ReceiverEmail: string;
	}
	export interface InvoiceForView {
		Id: string;
		InvoicePortalUrl: string;
		Actions: Invoices.Contract.ViewData.InvoiceActions;
		CustomerDataDiffs: Invoices.Contract.ViewData.ReceiverDataFieldDiff[];
		Type: Entities.Invoices.InvoiceType;
		Deadline: Day;
		InvoiceDate: Day;
		InvoiceNumberWithPrefix: string;
		PaymentReference: string;
		PaymentLinkId?: string;
		PaymentLinkReference: string;
		CustomerId?: string;
		CustomerNumber: number;
		CustomerContactDetailId?: string;
		CreditsId?: string;
		CreditedById?: string;
		ReceiverData: Entities.InvoiceReceiverData;
		SenderData: Entities.InvoiceSenderData;
		Sum: number;
		SumSek: number;
		InvoiceFee: number;
		Rounding: number;
		TotalSum: number;
		TotalSumSek: number;
		SumReceived: number;
		RemainingSum: number;
		Tax: number;
		TaxSek: number;
		DeductionSum: number;
		State: Entities.Invoices.InvoiceState;
		Rows: Invoices.Contract.ViewData.InvoiceRowForView[];
		Totals: Invoices.Contract.ViewData.InvoiceTotalsRow[];
		CompanyId: string;
		Currency: string;
		AccountingType?: Entities.AccountingType;
		Created?: Date;
		DisableBookkeeping: boolean;
		DisableRounding: boolean;
		HasVatFreeMessage?: boolean;
		IsVatIncludedInRowTotal: boolean;
		CreditsNumber?: number;
		CreditsNumberWithPrefix: string;
		CreditsType?: Entities.Invoices.InvoiceType;
		CurrencyRateValue?: number;
		InvoiceSystem: Entities.Invoices.InvoiceSystem;
		ExternalId: string;
		PlaceholderVerificationId?: string;
		FactoringData: Invoices.Contract.ViewData.FactoringData;
		RotRutId?: string;
		RotRut?: Invoices.Contract.ViewData.RotRutForView;
		QuoteId?: string;
		QuoteReference: string;
		CreditedRotRutId?: string;
		ClaimedInvoiceId?: string;
		ClaimInvoiceId?: string;
		RecurringInvoiceId?: string;
		InvoicePeriod: Entities.Invoices.InvoicePeriod;
		ContractReference: string;
		ProjectReference: string;
		OrderReference: string;
		BuyerReference: string;
		DeliveryInformation: Entities.DeliveryInformation;
		LastEditedBy: string;
		StripePaymentsEnabled: boolean;
		PortalEnabled: boolean;
		DefaultEmailDeliveryType?: Entities.Invoices.EmailInvoiceDeliveryType;
		TemplateRecurringInvoice?: Invoices.Contract.ViewData.TemplateRecurringInvoiceForInvoiceBody;
	}
	export interface InvoiceReminderForView {
		Id: string;
		InvoiceId: string;
		VerificationId?: string;
		Fee: number;
	}
	export interface InvoiceRowForView {
		Id: number;
		ProductCode: string;
		Description: string;
		Units: number;
		MaxUnits?: number;
		UnitPrice: number;
		Tax: number;
		Kind: Entities.Invoices.InvoiceRowKind;
		AccountNbr?: number;
		ArticleId?: string;
		IsTextRow: boolean;
		InvoiceId: string;
		CreditsRowId?: number;
		UnitType: Entities.Invoices.InvoiceRowUnitType;
		IsReminderRow: boolean;
		Index: number;
		RotRutRow?: Invoices.Contract.ViewData.RotRutRowForView;
		RotRutRowId?: string;
		ReversedVAT?: Entities.Invoices.ReversedVAT;
	}
	export interface InvoicesStats {
		OverPaidAmount: number;
		OverdueAmount: number;
		OutstandingAmount: number;
		NumberOfActiveInvoices: number;
		NumberOfRecurringInvoice: number;
		NumberOfInvoices: number;
		States: Entities.Invoices.InvoiceState[];
		Types: Entities.Invoices.InvoiceType[];
	}
	export interface InvoicesSumByPeriod {
		Periods: Invoices.Contract.ViewData.InvoicesSumDataPoint[];
		UniqueCustomers: number;
	}
	export interface InvoicesSumDataPoint {
		Year: number;
		Month: number;
		Sum: number;
		SumExcludeVAT: number;
		CreditSum: number;
		NumberOfInvoices: number;
	}
	export interface InvoiceTotalsRow {
		Label: string;
		Sum: number;
		Type: Invoices.Contract.ViewData.RowType;
		Currency: string;
	}
	export interface InvoiceWithBalance {
		Id: string;
		Due: number;
		InvoiceNumberWithPrefix: string;
		InvoiceDate: Day;
		Deadline: Day;
		DaysOverDue: number;
		Type: Entities.Invoices.InvoiceType;
		TotalSumSEK: number;
		VatSEK: number;
	}
	export interface QuoteBody {
		ValidFromDate: Day;
		ValidToDate: Day;
		QuoteNumber: number;
		CustomerId?: string;
		CustomerNumber: number;
		CustomerContactDetailId?: string;
		ReceiverData: Entities.InvoiceReceiverData;
		SenderData: Entities.InvoiceSenderData;
		Sum: number;
		SumSek: number;
		InvoiceFee: number;
		Rounding: number;
		TotalSum: number;
		TotalSumSek: number;
		SumReceived: number;
		Tax: number;
		TaxSek: number;
		DeductionSum: number;
		State: Entities.Invoices.QuoteState;
		IsVatIncludedInRowTotal: boolean;
		Rows: Invoices.Contract.ViewData.QuoteRowForView[];
		Totals: Invoices.Contract.ViewData.InvoiceTotalsRow[];
		CompanyId: string;
		Currency: string;
		Created?: Date;
		DisableBookkeeping: boolean;
		DisableRounding: boolean;
		CurrencyRateValue?: number;
		RotRutId?: string;
		RotRut?: Invoices.Contract.ViewData.RotRutForView;
		Invoices: Invoices.Contract.ViewData.InvoiceForQuote[];
		InvoicePeriod: Entities.Invoices.InvoicePeriod;
		ContractReference: string;
		ProjectReference: string;
		OrderReference: string;
		BuyerReference: string;
		DeliveryInformation: Entities.DeliveryInformation;
	}
	export interface QuoteDeliveryDto {
		Id: string;
		Method: Entities.Invoices.QuoteDeliveryMethod;
		EmailActivity?: Core.ViewData.EmailActivityDto;
		TimestampUtc: Date;
		EmailDeliveryType?: Entities.Invoices.EmailQuoteDeliveryType;
	}
	export interface QuoteForView {
		Id: string;
		ValidFromDate: Day;
		ValidToDate: Day;
		QuoteNumber: number;
		CustomerId?: string;
		CustomerNumber: number;
		CustomerContactDetailId?: string;
		ReceiverData: Entities.InvoiceReceiverData;
		SenderData: Entities.InvoiceSenderData;
		Sum: number;
		SumSek: number;
		InvoiceFee: number;
		Rounding: number;
		TotalSum: number;
		TotalSumSek: number;
		SumReceived: number;
		Tax: number;
		TaxSek: number;
		DeductionSum: number;
		State: Entities.Invoices.QuoteState;
		IsVatIncludedInRowTotal: boolean;
		Rows: Invoices.Contract.ViewData.QuoteRowForView[];
		Totals: Invoices.Contract.ViewData.InvoiceTotalsRow[];
		CompanyId: string;
		Currency: string;
		Created?: Date;
		DisableBookkeeping: boolean;
		DisableRounding: boolean;
		CurrencyRateValue?: number;
		RotRutId?: string;
		RotRut?: Invoices.Contract.ViewData.RotRutForView;
		Invoices: Invoices.Contract.ViewData.InvoiceForQuote[];
		InvoicePeriod: Entities.Invoices.InvoicePeriod;
		ContractReference: string;
		ProjectReference: string;
		OrderReference: string;
		BuyerReference: string;
		DeliveryInformation: Entities.DeliveryInformation;
	}
	export interface QuoteRowForView {
		Id: number;
		ProductCode: string;
		Description: string;
		Units: number;
		MaxUnits?: number;
		UnitPrice: number;
		Tax: number;
		Kind: Entities.Invoices.InvoiceRowKind;
		AccountNbr?: number;
		ArticleId?: string;
		IsTextRow: boolean;
		QuoteId: string;
		UnitType: Entities.Invoices.InvoiceRowUnitType;
		Index: number;
		RotRutRow?: Invoices.Contract.ViewData.RotRutRowForView;
		RotRutRowId?: string;
		ReversedVAT?: Entities.Invoices.ReversedVAT;
	}
	export interface QuotesStats {
		DraftAmount: number;
		PublishedAmount: number;
		ApprovedAmount: number;
		CompanyCurrency: string;
		EstimatedDraftAmount: number;
		EstimatedPublishedAmount: number;
		EstimatedApprovedAmount: number;
		ExchangeRates: { [key: string]: number; };
		NumberOfActiveQuotes: number;
		NumberOfQuotes: number;
		States: Entities.Invoices.QuoteState[];
	}
	export enum ReceiverDataField {
		Name = "Name",
		OrgNumber = "OrgNumber",
		VatNumber = "VatNumber",
		ContactName = "ContactName",
		Email = "Email",
		Phone = "Phone",
		Street = "Street",
		Street2 = "Street2",
		PostalCode = "PostalCode",
		City = "City",
		Country = "Country",
	}
	export interface ReceiverDataFieldDiff {
		FieldName: Invoices.Contract.ViewData.ReceiverDataField;
		InvoiceValue: string;
		CurrentValue: string;
	}
	export interface RegisterInvoiceSettlementDto {
		Date: Day;
		Type: Entities.Invoices.InvoiceSettlementType;
		Sum: number;
		PreviousSumReceived?: number;
		VatScheme?: Entities.Invoices.InvoiceSettlementVatScheme;
	}
	export interface RegisterPaymentDto {
		PaymentId: string;
		PaymentVerificationId?: string;
		SettlementVerificationId?: string;
	}
	export interface RegisterPaymentViewModel {
		InvoiceId: string;
		Sum: number;
		Date: Day;
		AccountNbr?: number;
		ExtrernalId?: string;
		PreviousSumReceived?: number;
		VerificationId?: string;
		Settlement?: Invoices.Contract.ViewData.RegisterInvoiceSettlementDto;
	}
	export interface RotRutForList {
		InvoiceNumberWithPrefix: string;
		Id: string;
		Type: Entities.Invoices.RotRutType;
		DeductionSum: number;
		Status: Entities.Invoices.RotRutStatus;
		RotRutDeductionPeople: Entities.Invoices.RotRutDeductionPerson[];
		InvoiceId: string;
		InvoiceDueDate: Day;
		CustomerNumber: string;
		HasPayments: boolean;
		PaymentDate?: Day;
	}
	export interface RotRutForView {
		Id: string;
		Type: Entities.Invoices.RotRutType;
		Description: string;
		PropertyType: Entities.Invoices.PropertyType;
		RealEstateNumber: string;
		OrganisationalNumberOfTenant: string;
		ApartmentNumber: string;
		Status: Entities.Invoices.RotRutStatus;
		PublishedClaimInvoiceId?: string;
		PublishedClaimDate?: Date;
		RotRutDeductionPeople: Entities.Invoices.RotRutDeductionPerson[];
	}
	export interface RotRutRowForView {
		Id: string;
		Type: Entities.Invoices.RotRutType;
		MaterialType: Entities.Invoices.RotRutMaterialType;
	}
	export enum RowType {
		Sum = "Sum",
		InvoiceFee = "InvoiceFee",
		Rounding = "Rounding",
		VAT = "VAT",
		Deduction = "Deduction",
		ReversedVAT = "ReversedVAT",
		VATWithConversion = "VATWithConversion",
	}
	export interface TemplateRecurringInvoiceForInvoiceBody {
		Id?: string;
		StartedDate: Day;
		Occurrance: Entities.Invoices.OccurranceType;
	}
	export interface TopArticleDto {
		Amount: number;
		ArticleName: string;
	}
	export interface TopCustomerDto {
		CustomerName: string;
		Amount: number;
	}
}
export namespace Invoices.Controllers {
	export interface ArticleForBatchInvoicing {
		Article: Invoices.ViewModels.ArticleForList;
		State: Invoices.Controllers.BatchInvoicingArticleState;
	}
	export interface ArticleImportDto {
		ImportId?: string;
		ImportDate: Date;
		ArticleCount: number;
	}
	export enum BatchInvoicingArticleState {
		Valid = "Valid",
		Invalid = "Invalid",
	}
	export interface CustomerBasicDetailsListViewModel {
		Id: string;
		Name?: string;
		OrgNumber?: string;
		CustomerNumber: number;
	}
	export interface CustomerDetailsViewModel {
		Id: string;
		Name: string;
		CompanyId: string;
		DefaultInvoiceReciverData: Entities.InvoiceReceiverData;
		DefaultInvoiceSenderData: Entities.InvoiceSenderData;
		SendToEmails: string;
		Deleted: boolean;
		HasPublishedInvoices: boolean;
		ReceiverContactDetails: Invoices.Contract.Commands.CustomerCommands.ViewCustomerContactDetails[];
	}
	export interface CustomerListResponse {
		Customers: Invoices.Controllers.CustomerListViewModel[];
		Summary: Invoices.Controllers.CustomerListSummary;
	}
	export interface CustomerListSummary {
		Sum: number;
		TotalSum: number;
		Debt: number;
		DelayedDebt: number;
	}
	export interface CustomerListViewModel {
		Id: string;
		Sum: number;
		TotalSum: number;
		Debt: number;
		DelayedDebt: number;
		DefaultInvoiceReciverData: Invoices.Controllers.InvoiceReceiverDataViewModel;
	}
	export interface DailyTakingsVerificationForView {
		DailyTakingsId: string;
		VerificationNumber: string;
		VerificationId: string;
		Description: string;
		Status: Entities.Sales.DailyTakingsStatus[];
		Date: Date;
		Amount: number;
		Relation: Invoices.Controllers.DailyTakingsVerificationRelation;
		VerificationType: Entities.Sales.DailyTakingsVerificationRelationType;
	}
	export enum DailyTakingsVerificationRelation {
		NotSet = "NotSet",
		Cancels = "Cancels",
		Cancelled = "Cancelled",
		ChildIsCorrectedByParent = "ChildIsCorrectedByParent",
	}
	export enum DeleteAlienInvoiceError {
		InvoiceHasPayment = "InvoiceHasPayment",
	}
	export interface DeleteImportPreviewDto {
		CanBeDeleted: Invoices.ViewModels.ArticleForList[];
		CannotBeDeleted: Invoices.ViewModels.ArticleForList[];
	}
	export enum FactoringError {
		None = "None",
		FactoringSystemUnavailable = "FactoringSystemUnavailable",
		OrgNumberDoesNotMatchSubscription = "OrgNumberDoesNotMatchSubscription",
		ValidationError = "ValidationError",
		InitiateOnboardingError = "InitiateOnboardingError",
		AlreadyActiveButNotThroughBokio = "AlreadyActiveButNotThroughBokio",
	}
	export enum InvoiceDeletePaymentError {
		General = "General",
		CannotDeleteVerification = "CannotDeleteVerification",
		HardDeleteVerificationNotAllowed = "HardDeleteVerificationNotAllowed",
	}
	export interface InvoiceForConnection {
		Id: string;
		InvoiceNumberWithPrefix: string;
		CustomerName: string;
		State: Entities.Invoices.InvoiceState;
		CurrentCreditedById?: string;
		CompanyId: string;
	}
	export interface InvoicePaymentMethodTemplatesViewModel {
		Templates: Core.Invoices.InvoicePaymentMethodTemplate[];
	}
	export interface InvoiceReceiverDataViewModel {
		Name?: string;
		CustomerNumber: number;
		ContactName: string;
		OrgNumber: string;
		Phone: string;
		Type: Entities.CustomerType;
		Email: string;
		Address: Entities.Address;
	}
	export interface InvoiceReconcilingForView {
		Id: string;
		InvoiceNumberWithPrefix: string;
		InvoiceNumberPrefix: string;
		InvoiceNumber: number;
		InvoiceDate: Date;
		Deadline: Date;
		TotalSumSEK: number;
		IsConvertible: boolean;
		WarnForRotRut: boolean;
	}
	export interface IsFirstPublishResponse {
		IsFirstPublish: boolean;
	}
	export interface ListRequest {
		Pagination?: Bokio.Common.Contract.Pagination.Pagination;
	}
	export enum OnboardingStep {
		CompanyInfo = "CompanyInfo",
		ExternalOnboarding = "ExternalOnboarding",
	}
	export interface PaymentDataViewModel {
		ExpectedPayment: number;
		PaidSoFar: number;
		Remainder: number;
		PaymentDate: Day;
		IsSettled: boolean;
		IsForeignCurrency: boolean;
		InvoiceSystem: Entities.Invoices.InvoiceSystem;
		InvoiceType: Entities.Invoices.InvoiceType;
		FromPaymentLink: boolean;
		PeriodisationWarningFromDate?: Day;
	}
	export interface ResyncDailyTakingsRequest {
		Dates: Date[];
	}
	export interface ResyncDailyTakingsResponse {
		Results: Invoices.Controllers.ResyncDailyTakingsResult[];
	}
	export interface ResyncDailyTakingsResult {
		Date: Date;
		Status: string;
	}
	export interface SimpleCustomerListResponse {
		Customers: Invoices.Controllers.CustomerDetailsViewModel[];
	}
	export interface StartFactoringOnboardingViewModel {
		StartingStep: Invoices.Controllers.OnboardingStep;
		CompanyInfoAndKYC: Invoices.Contract.ViewData.FactoringOnboardingPayload;
	}
	export interface ToggleBookkeepingDto {
		InvoiceId: string;
		DisableBookkeeping: boolean;
	}
	export interface ToggleBookkeepingResult {
		IsDisabled: boolean;
	}
	export interface TogglePeriodiseDto {
		InvoiceId: string;
		Periodise: boolean;
	}
	export interface ToggleRoundingDto {
		InvoiceId: string;
		DisableRounding: boolean;
	}
	export interface ToggleRoundingResult {
		IsDisabled: boolean;
	}
	export interface ToggleShowVATDto {
		InvoiceId: string;
		IsVatIncludedInRowTotal: boolean;
	}
	export interface ToggleShowVATResult {
		IsDisabled: boolean;
	}
}
export namespace Invoices.Infrastructure.TimeTracking {
	export interface TimeTrackingClient {
		ExternalId: string;
		Name: string;
	}
	export interface TimeTrackingEntry {
		Start?: Date;
		Stop?: Date;
		Units: number;
		ExternalProjectId: string;
		Project?: Invoices.Infrastructure.TimeTracking.TimeTrackingProject;
		Price?: number;
	}
	export interface TimeTrackingProject {
		ExternalId: string;
		Name: string;
		Client?: Invoices.Infrastructure.TimeTracking.TimeTrackingClient;
	}
	export interface TimeTrackingWorkspace {
		Id: number;
		Name: string;
	}
}
export namespace Invoices.ViewModels {
	export interface ActivityData {
		Type: Entities.Invoices.QuoteActivityType;
		CreatedBy?: string;
	}
	export enum AdditionalFieldsInputType {
		TextInput = "TextInput",
		AddressInput = "AddressInput",
		DateInput = "DateInput",
	}
	export interface AdditionalFieldsListItem {
		Type: Invoices.ViewModels.AdditionalFieldsType;
		Value: string;
		FieldType: Invoices.ViewModels.AdditionalFieldsInputType;
		HasValue: boolean;
	}
	export enum AdditionalFieldsType {
		ContractReference = "ContractReference",
		ProjectReference = "ProjectReference",
		OrderReference = "OrderReference",
		BuyerReference = "BuyerReference",
		DeliveryInformation = "DeliveryInformation",
		InvoicePeriod = "InvoicePeriod",
	}
	export interface AlienInvoiceForList {
		Id: string;
		CustomerId?: string;
		CustomerName: string;
		AmountSEK: number;
		InvoiceDate: Day;
		Deadline: Day;
		InvoiceNumber: number;
		Notes: string;
		Type: Invoices.ViewModels.AlienInvoiceType;
		RemainingSum: number;
		State: Entities.Invoices.InvoiceState;
	}
	export enum AlienInvoiceType {
		Receivables = "Receivables",
		Payables = "Payables",
	}
	export interface ArticleForList {
		Id: string;
		ProductCode?: string;
		Description?: string;
		UnitPrice: number;
		Tax: number;
		Kind: Entities.Invoices.InvoiceRowKind;
		UnitType: Entities.Invoices.InvoiceRowUnitType;
		IsTextRow: boolean;
		TemplateName?: string;
		BookkeepingAccountNumber?: number;
	}
	export interface BalanceData {
		Sum: number;
		Balance: number;
	}
	export interface CompleteFactoringOnboardingViewModel {
		OnboardingState: Invoices.ViewModels.OnboardingState;
	}
	export enum CreateCustomerError {
		None = "None",
		CustomerNumberTaken = "CustomerNumberTaken",
		OrgNumberInvalid = "OrgNumberInvalid",
		EInvoiceServiceError = "EInvoiceServiceError",
		CustomerContactDetailsMissing = "CustomerContactDetailsMissing",
		CustomerContactDetailsInvalidEmail = "CustomerContactDetailsInvalidEmail",
		CustomerChangeOrgEInvoice = "CustomerChangeOrgEInvoice",
	}
	export interface CreditInvoiceData {
		CreditInvoiceId: string;
		CreditInvoiceNumberWithPrefix: string;
	}
	export interface CreditNoteForPortal {
		Id: string;
		CreditNoteNumber: string;
		Amount: number;
		CreditNoteLinkId: string;
		AccessToken: string;
	}
	export interface CustomerForView {
		Id: string;
		CompanyId: string;
		DefaultInvoiceReciverData: Entities.InvoiceReceiverData;
		SendToEmails: string;
	}
	export interface DailyTakingGapToFill {
		HaveGapToFill: boolean;
		FromDate: Date;
		ToDate: Date;
	}
	export interface DailyTakingsByDateForView {
		Date: Day;
		DailyTakingsId?: string;
		DailyTakingsVerifications: Invoices.Controllers.DailyTakingsVerificationForView[];
		Status: Entities.Sales.DailyTakingsStatus[];
		SalesAmount: number;
		CanBeReprocessed: boolean;
		IsVatPeriodOpen: boolean;
		IsFiscalYearOpen: boolean;
		LastChangedUtc?: Date;
	}
	export interface DailyTakingsByMonthForView {
		Year: number;
		Month: number;
		SalesAmount: number;
		PayoutAmount: number;
		FeesAmount: number;
		Status: Entities.Sales.DailyTakingsStatus;
	}
	export interface DeleteInvoiceResult {
		CreditInvoiceId: string;
	}
	export interface DeliveryData {
		DeliveryId: string;
		Method: Entities.Invoices.InvoiceDeliveryMethod;
	}
	export interface EInvoicePartySearchParams {
		OrgNumber: string;
		GLN: string;
		VAT: string;
	}
	export interface FactoringEventData {
		FinancingId: string;
		FinancingType: Entities.Invoices.InvoiceFinancingType;
		ProviderName: string;
		Sum: number;
		Cost?: number;
		WithheldPayment?: number;
	}
	export interface FactoringExternalOnboardingInformationViewModel {
		RedirectLink: string;
	}
	export interface FactoringOnboardingViewModel {
		ServiceOnboardingId: string;
		CompanyOnboardingInfo: Entities.Invoices.FactoringOnboardingModel;
		RedirectUrl: string;
	}
	export interface FactoringPublishResult {
		Deposition: number;
		Payment: number;
		State: Entities.Invoices.InvoiceState;
		CostIncVAT: number;
		InvoiceId: string;
		InvoiceFinancingId: string;
	}
	export enum FactoringQuoteStatus {
		None = "None",
		HasOffer = "HasOffer",
		DeniedByProvider = "DeniedByProvider",
	}
	export interface FactoringQuoteViewModel {
		Id: string;
		OfferValidTime?: Date;
		Status: Invoices.ViewModels.FactoringQuoteStatus;
		FinancedVolume?: number;
		PaidDirectly?: number;
		CostIncVAT?: number;
	}
	export interface FileAttachmentViewModel {
		Id: string;
		FileName: string;
		MimeType: string;
		FileSize: number;
	}
	export interface InvoiceForList {
		Id: string;
		InvoiceNumberWithPrefix: string;
		Amount: number;
		InvoiceDate: Day;
		Deadline: Day;
		CustomerName: string;
		CustomerId?: string;
		ContactName: string;
		State: Entities.Invoices.InvoiceState;
		Currency: string;
		AmountSEK: number;
		RemainingSum: number;
		Type: Entities.Invoices.InvoiceType;
		System: Entities.Invoices.InvoiceSystem;
		CreditsId?: string;
		EmailDeliveryStatus?: Core.ViewData.EmailActivityDto;
		CurrentDeliveryStatus?: Entities.Invoices.InvoiceDeliveryStatus;
		IsRecurringInvoice: boolean;
		ReminderEmail?: string;
	}
	export interface InvoiceForPortal {
		Id: string;
		SenderData: Invoices.ViewModels.PortalSenderData;
		ReceiverName: string;
		State: Entities.Invoices.InvoiceState;
		InvoiceDate: Day;
		Deadline: Day;
		InvoiceNumber: string;
		Amount: number;
		RemainingAmount: number;
		Currency: string;
		StripePaymentsEnabled: boolean;
		ReceiverEmail: string;
		CompanyLogo: string;
		CrediteNotes: Invoices.ViewModels.CreditNoteForPortal[];
		UniquePaymentReference?: string;
		PortalPaymentMethods: Invoices.Contract.DTOs.InvoicePortalPaymentMethodDto[];
		PaymentIntent?: Invoices.ViewModels.PaymentIntentForPortal;
		PaidMark?: Invoices.Contract.DTOs.InvoicePortalPaidMarkDto;
	}
	export enum InvoiceHistoryType {
		InvoiceCreated = "InvoiceCreated",
		Payment = "Payment",
		ReminderFee = "ReminderFee",
		/** @deprecated */
		CurrencyLosses = "CurrencyLosses",
		/** @deprecated */
		DebtCancellation = "DebtCancellation",
		Credit = "Credit",
		Status = "Status",
		Delivery = "Delivery",
		Settlement = "Settlement",
		InvoiceRelation = "InvoiceRelation",
		FactoringSettled = "FactoringSettled",
		FactoringRejected = "FactoringRejected",
	}
	export interface InvoiceHistoryViewModel {
		InvoiceId: string;
		Label: string;
		Type: Invoices.ViewModels.InvoiceHistoryType;
		RegistredUtc: Date;
		RoundedOffLoss?: number;
		DisableBookkeeping?: boolean;
		Balance: Invoices.ViewModels.BalanceData;
		CreditInvoice?: Invoices.ViewModels.CreditInvoiceData;
		Verification?: Invoices.ViewModels.VerificationData;
		Payment?: Invoices.ViewModels.PaymentData;
		Delivery?: Invoices.ViewModels.DeliveryData;
		Factoring?: Invoices.ViewModels.FactoringEventData;
		Settlement?: Invoices.ViewModels.SettlementData;
		StatusEvent?: Invoices.ViewModels.StatusEventData;
		Relation?: Invoices.ViewModels.RelationData;
		Date: Day;
		DueDate?: Day;
	}
	export interface InvoiceReminderSummary {
		InvoiceId: string;
		ReminderCount: number;
		TotalReminderFee: number;
		LastReminderDate?: Date;
		IsEligible: boolean;
		IneligibilityReason?: string;
	}
	export enum OnboardingState {
		InProgress = "InProgress",
		Finished = "Finished",
	}
	export interface PaymentData {
		PaymentId: string;
		IsLastPayment: boolean;
		PaymentSystem: Entities.Invoices.InvoicePaymentSystem;
		SettlesInvoice?: boolean;
	}
	export interface PaymentIntentForPortal {
		Id: string;
		Status: Entities.Invoices.InvoicePaymentIntentStatus;
		Amount: number;
		ReceiptUrl: string;
		PaidAt?: Date;
		PaymentMethod: Invoices.Contract.OnlinePayments.StripePaymentIntentPaymentMethod;
		ReceiptNumber: string;
	}
	export enum PaymentIntentStatus {
		Enabled = "Enabled",
		Disabled = "Disabled",
	}
	export interface PaymentIntentViewModel {
		Id: string;
		Token: string;
		Status: Invoices.ViewModels.PaymentIntentStatus;
		AccountId: string;
		PublishableKey: string;
	}
	export enum PdfDocumentType {
		Invoice = "Invoice",
		Reminder = "Reminder",
	}
	export interface PdfDocumentVersionViewModel {
		Id: string;
		SourceId: string;
		FileName: string;
		Type: Invoices.ViewModels.PdfDocumentType;
		CreatedAt: Date;
		ParentId?: string;
	}
	export interface PeriodicReportViewModel {
		From: Day;
		To: Day;
		IncludeNonEUSales: boolean;
		Goods: number;
		Services: number;
		Total: number;
		Customers: Invoices.ViewModels.PeriodicViewModelCustomer[];
	}
	export interface PeriodicViewModelCustomer {
		CustomerId: string;
		VatNumber: string;
		CustomerName: string;
		CustomerType: Entities.CustomerType;
		Country: Classes.Country;
		Goods: number;
		Services: number;
		Total: number;
	}
	export interface PortalSenderData {
		CompanyName: string;
		Address: Entities.Address;
		Email: string;
		Phone: string;
		CountryCode: string;
		InvoicePaymentMethod: Entities.Invoices.InvoicePaymentMethod;
	}
	export interface QuoteForList {
		Id: string;
		QuoteNumber: number;
		Amount: number;
		ValidToDate: Day;
		ValidFromDate: Day;
		CustomerName: string;
		CustomerId?: string;
		ContactName: string;
		State: Entities.Invoices.QuoteState;
		Currency: string;
		AmountSEK: number;
		RemainingSum: number;
		EmailDeliveryStatus?: Core.ViewData.EmailActivityDto;
	}
	export enum QuoteHistoryType {
		QuoteCreated = "QuoteCreated",
		EmailSent = "EmailSent",
		Activity = "Activity",
	}
	export interface QuoteHistoryViewModel {
		QuoteId: string;
		Type: Invoices.ViewModels.QuoteHistoryType;
		CreatedAt: Day;
		QuoteDeliveryDto: Invoices.Contract.ViewData.QuoteDeliveryDto[];
		ActivityData: Invoices.ViewModels.ActivityData;
		InvoiceData?: Invoices.Contract.ViewData.InvoiceForQuote;
	}
	export interface RelationData {
		RelationInvoiceId: string;
		RelationInvoiceNumberWithPrefix: string;
		RelationInvoiceType: Invoices.ViewModels.RelationType;
	}
	export enum RelationType {
		Claim = "Claim",
	}
	export interface SetInvoiceNumberError {
		Min: number;
		Max: number;
		Value: number;
		Prefix: string;
		MaxLength: number;
	}
	export interface SettlementData {
		SettlementId: string;
		SettlementType: Entities.Invoices.InvoiceSettlementType;
		Sum: number;
		Date: Date;
		AccountNumber?: number;
	}
	export interface StatusEventData {
		Status: Entities.Invoices.InvoiceStatus;
	}
	export interface TimeTrackingAccountForView {
		Id: string;
		CompanyId: string;
		System: Entities.Invoices.SourceSystem;
		Name: string;
		AuthJson: string;
	}
	export interface UploadCompanyImageResult {
		Version: number;
		MimeType: string;
		Length: number;
	}
	export interface VerificationData {
		VerificationNumber: string;
		VerificationId: string;
	}
}
export namespace Model.Commands.Accounting.Closures {
	export interface BookkeepDividendsDecisionPart {
		ClosureId: string;
		DividendsAmount: number;
		verificationDate: Day;
	}
	export interface BookkeepTransferBalancedResultPart {
		Date: Day;
		ClosureId: string;
	}
	export interface ChooseArsredovisningOnlineClosure {
		ClosureId: string;
	}
	export interface ChooseBokioClosure {
		ClosureId: string;
		InquiryId?: string;
		InquiryType: Entities.InquiryType;
		ContactEmail: string;
	}
	export interface ChooseManualClosure {
		ClosureId: string;
	}
	export interface FinishAccountingPart {
		ClosureId: string;
		Result: number;
		VerificationId?: string;
	}
	export interface FinishArsredovisningOnlinePart {
		ClosureId: string;
	}
	export interface FinishChecklistPart {
		ClosureId: string;
	}
	export interface FinishDepreciationPart {
		ClosureId: string;
		RelevantInformation: string;
	}
	export interface FinishPeriodisationPart {
		ClosureId: string;
		Periodisation: Entities.Accounting.PeriodisationsDto;
		ThisYearVerificationId?: string;
		NextYearVerificationId?: string;
		MarkAsFinish: boolean;
	}
	export interface FinishProvisionPart {
		ClosureId: string;
		RelevantInformation: string;
	}
	export interface FinishResultPart {
		ClosureId: string;
	}
	export interface FinishStartPart {
		ClosureId: string;
	}
	export interface FinishTaxPart {
		ClosureId: string;
		TaxCalculationAdjustments: Bokio.Accounting.Contract.Tax.Dtos.FinalTaxCalculationAdjustmentsDto;
	}
	export interface ReactivateAccountingPart {
		ClosureId: string;
	}
	export interface ReactivateArsredovisningOnlinePart {
		ClosureId: string;
	}
	export interface ReactivateClosurePackage {
		ClosureId: string;
	}
	export interface ReactivateDepreciationPart {
		ClosureId: string;
	}
	export interface ReactivatePeriodisationPart {
		ClosureId: string;
	}
	export interface ReactivateProvisionPart {
		ClosureId: string;
	}
	export interface ReactivateResultPart {
		ClosureId: string;
	}
	export interface ReactivateTaxPart {
		ClosureId: string;
	}
	export interface SkipAccountingPart {
		ClosureId: string;
	}
	export interface SkipDividendsDecisionPart {
		ClosureId: string;
		NotPayingDividends: boolean;
	}
	export interface SkipTaxPart {
		ClosureId: string;
	}
	export interface SkipTransferBalancedResultPart {
		ClosureId: string;
	}
	export interface SkipTransferResultPart {
		ClosureId: string;
	}
	export enum StartPartStateName {
		BookkeepingIncomeAndExpenses = "BookkeepingIncomeAndExpenses",
		CompleteVATReport = "CompleteVATReport",
	}
	export interface UndoBookkeepDividendsDecisionPart {
		ClosureId: string;
	}
	export interface UndoBookkeepTransferBalancedResult {
		ClosureId: string;
	}
	export interface UpdateStartPartState {
		SettingsId: string;
		ClosureId: string;
		Name: Model.Commands.Accounting.Closures.StartPartStateName;
		State: Entities.Accounting.ClosureSubState;
	}
}
export namespace Model.Commands.Accounting.CompanyMembershipCommands {
	export interface InviteAgencyToCompanyRequest {
		AgencyId: string;
		Email: string;
		Membership: Entities.MembershipType[];
	}
	export interface InviteNewAccountantToCompanyRequest {
		Email: string;
		Membership: Entities.MembershipType[];
		Message: string;
	}
	export interface RemoveCompanyMembership {
		MembershipUserId: string;
		AllowDeletionOfOwner: boolean;
	}
}
export namespace Model.Commands.Accounting.Disbursements {
	export interface CreateDisbursement {
		DisbursementId: string;
		Expenses: string[];
		EmployeeId: string;
		PayDate: Day;
		Status?: Entities.DisbursementStatus;
	}
	export interface DeleteDisbursement {
		DisbursementId: string;
	}
	export interface SetDisbursementAsPaid {
		DisbursementId: string;
	}
	export interface UndoDisbursement {
		DisbursementId: string;
	}
}
export namespace Model.Commands.Accounting.FiscalYears {
	export interface CreateNextYear {
		AccountingForm: Entities.AccountingType;
		ExpectedTurnover: number;
	}
	export interface CreatePreviousYear {
		VatSetting: Entities.VatSetting;
		AccountingForm: Entities.AccountingType;
		ExpectedTurnover: number;
	}
	export interface DeleteYear {
		Id: string;
	}
	export interface UpdateYear {
		SettingsId: string;
		StartDate: Day;
		EndDate: Day;
		AccountingForm: Entities.AccountingType;
		ExpectedTurnover: number;
		IgnoreMovedVerifications: boolean;
		Force?: boolean;
	}
}
export namespace Model.Commands.Accounting.Imports {
	export interface ConversionBalance {
		Account: number;
		Value: number;
	}
	export interface YearToClose {
		Date: Day;
	}
}
export namespace Model.Commands.Accounting.Reciepts {
	export interface AttestReceipt {
		DenyAttestation: boolean;
		ReceiptId: string;
	}
	export interface DeleteReceipt {
		ReceiptId: string;
	}
	export interface DeleteReceipts {
		ReceiptIds: string[];
	}
	export interface UndoDeleteExtraPage {
		ExtraPageId: string;
		PageNumber: number;
	}
}
export namespace Model.Commands.Accounting.Verifications {
	export enum CorrectionEntityType {
		NotSet = "NotSet",
		Invoice = "Invoice",
		Closure = "Closure",
		SupplierInvoice = "SupplierInvoice",
		Salary = "Salary",
		VatReport = "VatReport",
		Disbursement = "Disbursement",
		ConversionBalance = "ConversionBalance",
		Asset = "Asset",
		Vacation = "Vacation",
		Expense = "Expense",
		Periodisation = "Periodisation",
	}
	export interface GetRecipeDefsRequest {
		IsInvoice: boolean;
	}
}
export namespace Model.Commands.Billing {
	export enum UserExtendTrialError {
		ReasonCategoryRequired = "ReasonCategoryRequired",
		ReasonDetailsRequired = "ReasonDetailsRequired",
		ExpectedStartDateRequired = "ExpectedStartDateRequired",
		ExpectedStartDateInPast = "ExpectedStartDateInPast",
	}
}
export namespace Model.Commands.Feedback {
	export interface SetNPSRating {
		RatingId?: string;
		Rating?: number;
		Reason?: string;
		OneThingThatWouldImproveRating?: string;
		DontWantToAnswer: boolean;
	}
}
export namespace Model.Commands.ImportantDate {
	export interface SetImportantDateStateCommand {
		ImportantDateId: string;
		State: Entities.ImportantDate.ImportantDateState;
	}
	export interface ToggleHideCategoryCommand {
		ImportantDateId: string;
		Hide: boolean;
	}
	export interface ToggleHideImportantDateCommand {
		ImportantDateId: string;
		Hide: boolean;
	}
}
export namespace Model.Commands.Invoices.BookkeepCommands {
	export interface BookkeepInvoiceSettlementCommand {
		SettlementId: string;
	}
}
export namespace Model.Commands.Partners.PartnerCompanyApplicationCommands {
	export enum Agency {
		Unknown = "Unknown",
		Deskjockeys = "Deskjockeys",
		Aspia = "Aspia",
		WinWin = "WinWin",
		OneEconomy = "OneEconomy",
		Studac = "Studac",
		Bronn = "Bronn",
	}
	export interface BusinessDescriptionObject {
		ShortDescription?: Model.Commands.Partners.PartnerCompanyApplicationCommands.TranslationObject;
		LongDescription?: Model.Commands.Partners.PartnerCompanyApplicationCommands.TranslationObject;
	}
	export interface PartnerCompanyApplicationCommandInfo {
		NumberOfEmployees: Entities.NumberRange;
		NumberOfMonthlyVerifications: Entities.NumberRange;
		Status: Entities.Partners.ApplicationStatus;
		CompanyMainActivity: string;
		YearlyTurnover: Entities.DecimalRange;
		PartnerStartDate: Day;
		TypeOfApplication: Entities.PartnerCompanyType;
		WhatDoYouNeedHelpWith?: string;
	}
	export interface TranslationObject {
		Sv?: string;
		EnSv?: string;
		EnGb?: string;
	}
}
export namespace Model.Commands.Payment {
	export interface ResetUserExperiment {
		ExperimentId: string;
	}
}
export namespace Model.Commands.Promotions {
	export interface CompletePromotion {
		PromotionActivationId: string;
	}
	export interface NotInterestedInPromotion {
		PromotionActivationId: string;
	}
	export interface PostponePromotion {
		PromotionActivationId: string;
		Duration: number;
	}
}
export namespace Model.Commands.Settings {
	export interface AddExportReason {
		Type: Entities.ExportReasonType;
		Reason: string;
		Notify: boolean;
	}
	export interface DeleteCompany {
		DeleteCompanyId: string;
	}
	export enum InviteAccountantFromAgencyError {
		Unknown = "Unknown",
		InvitationAlreadyExists = "InvitationAlreadyExists",
		AlreadyConnectedToAgency = "AlreadyConnectedToAgency",
		EmailCouldNotBeSent = "EmailCouldNotBeSent",
		AlreadyInvitedOtherAgency = "AlreadyInvitedOtherAgency",
		AccountantIsTheCompanyOwner = "AccountantIsTheCompanyOwner",
	}
	export interface LeaveCompany {
		LeaveCompanyId: string;
		LeaveUserId?: string;
	}
	export interface SetProprietorshipSettings {
		OtherIncome?: number;
		LocalTax?: number;
	}
	export interface UpdateUser {
		FirstName: string;
		Language: string;
		LastName: string;
		PhoneNumber: string;
		UserResearchGroup: boolean;
	}
	export enum UpdateUserEmailError {
		NoError = "NoError",
		Completed = "Completed",
		WrongCodeOrRequest = "WrongCodeOrRequest",
		NoLongerValid = "NoLongerValid",
		InvalidEmail = "InvalidEmail",
		EmailNotAvailable = "EmailNotAvailable",
		EmailFailed = "EmailFailed",
		WrongUser = "WrongUser",
	}
}
export namespace Model.Commands.Support {
	export interface CloseSupportTicket {
		SupportTicketId: string;
		PartnerId?: string;
		Comment: string;
	}
	export interface CreateSupportTicket {
		SupportTicketId: string;
		ReceiptId?: string;
		TransactionId?: string;
		Comment: string;
	}
	export interface UpdateSupportTicket {
		SupportTicketId: string;
		PartnerId?: string;
		Comment: string;
		ActionRequired: boolean;
		Status?: Entities.Support.SupportTicketStatus;
		CloseReason?: Entities.Support.CloseReason;
	}
}
export namespace Partner.Controllers {
	export interface AcceptInvitationFormData {
		FirstName: string;
		LastName: string;
		AcceptedTermsVersion: number;
		Password: Bokio.Common.Types.SecretString;
	}
	export interface PartnerStatusViewModel {
		Id: string;
		Name: string;
		Access: Bokio.BackOffice.PartnerAccessDto;
	}
}
export namespace Settings.Controllers {
	export interface AccountingDetailsDto {
		AccountingType: Entities.AccountingType;
		VatSetting: Entities.VatSetting;
		StartDate: Day;
		EndDate: Day;
	}
	export interface ActivationStatusDto {
		BookkeepingSoft: boolean;
		BookkeepingHard: boolean;
	}
	export interface AllAgencyForView {
		agencyForViews: Bokio.BackOffice.AgencyForView[];
		partnerAgencyForView: Model.Commands.Partners.PartnerCompanyApplicationCommands.Agency;
	}
	export interface AuditHistoryForList {
		Id: number;
		TimeUtc: Date;
		UserEmail: string;
		EventType: string;
		ItemName: string;
		UserId?: string;
		ItemId: string;
		Ip: string;
	}
	export interface AuditHistoryViewModel {
		Items: Settings.Controllers.AuditHistoryForList[];
		Page: number;
		TotalItems: number;
	}
	export interface CanLeaveCompanyDto {
		CanLeave: boolean;
		CannotLeaveReason: Settings.Controllers.CannotLeaveReason;
	}
	export enum CannotLeaveReason {
		None = "None",
		IsOwner = "IsOwner",
		IsBbaOwner = "IsBbaOwner",
	}
	export interface ClientRequestViewModel {
		RequestId: string;
		InviteeUserId: string;
		InviteeFirstName: string;
		InviteeLastName: string;
		InviteeEmail: string;
		Type: Entities.MembershipType[];
		AgencyId: string;
		AgencyName: string;
		HasExpired: boolean;
	}
	export enum CompanyDraftGenericError {
		WrongStep = "WrongStep",
		CouldNotSendOwnerInvitation = "CouldNotSendOwnerInvitation",
		InvalidClientCompanyOwner = "InvalidClientCompanyOwner",
	}
	export interface CompanyExpenseInvitationRequest {
		Email: string;
		EmployeeId?: string;
	}
	export interface CompanyInfoForView {
		MoneyAccountSetting: Bokio.Bank.Contract.MoneyAccount.MoneyAccountSettingsForView;
		OrgNumber: string;
		VatRegistrationNumber: string;
		Name: string;
		AccountingMethodNotSet: boolean;
		Id: string;
		CompanyType: Entities.CompanyType;
		Country: CountryCode;
		CountrySubdivision?: CountrySubdivision;
		InfoFetchState: Entities.InfoFetchState;
		VatSettingMissingOrNotCoveringFiscalYears: boolean;
		ActiveVatSetting: Entities.VatSetting;
		CompanyVatSettings: Core.ViewData.CompanyVatSettingDto[];
		ActiveAccountingMethod: Entities.AccountingType;
		FiscalYearStatus: Core.FiscalYearStatus;
		IsInvoiceMethodVariant: boolean;
		RegisteredUtc: Date;
		InvoiceNumber: number;
		AutomaticChecking: Entities.AutomaticCheckingEnum;
		Image: Entities.CompanyImage;
		AddressPosition: Entities.CompanyAddressPosition;
		CompanyColor: string;
		StartFirstFiscalYear?: Date;
		NotValidForPayment: boolean;
		PartnerStatus?: Core.PartnerStatus;
		VacationTrackingEnabled: boolean;
		CountryMetadata: Classes.CountryMetadata;
		InvoiceData: Entities.CompanyInvoiceData;
		CompanySystem: Entities.CompanySystem;
		HasActivePartner: boolean;
		ActiveBankConnections: Core.ActiveBankConnection[];
		Plan: Entities.BokioPlan;
		BillingPaymentState?: Entities.BillingSubscriptionPaymentState;
		ActiveAgencyStatus?: Core.PartnerStatus;
		HasSveaNonConsentCompanyWithEmptyBankAccount: boolean;
		BBASveaPsuId?: string;
		CompanyAssetDepreciationFrequency: Entities.Accounting.DepreciationFrequency;
	}
	export interface CompanyInvitationViewModel {
		Id: string;
		MembershipType: Entities.MembershipType;
		Email: string;
		HasExpired: boolean;
		Type: Entities.CompanyInvitationType;
	}
	export interface CompanyMembershipViewModel {
		UserId: string;
		Type: Entities.MembershipType[];
		Email: string;
		FirstName: string;
		LastName: string;
		Has2FA: boolean;
		IsUsingUserSeat: boolean;
	}
	export enum ConversionBalanceErrors {
		Unknown = "Unknown",
		VerificationValidationError = "VerificationValidationError",
	}
	export interface CreateCompanyDraftRequest {
		VoucherCode?: string;
		Source: Entities.CompanyDraftSource;
		AgencyId?: string;
	}
	export interface CreateUserInvitationRequest {
		Email: string;
		EmployeeId?: string;
		MembershipType: Entities.MembershipType[];
		Type: Entities.CompanyInvitationType;
	}
	export enum DeleteActiveUserError {
		Unknown = "Unknown",
		CannotRemoveSelf = "CannotRemoveSelf",
		CannotRemoveOwner = "CannotRemoveOwner",
		CannotRemoveBbaOwner = "CannotRemoveBbaOwner",
	}
	export interface EditAgencyDefaultPermissionViewModel {
		AgencyId: string;
		MembershipType: Entities.MembershipType[];
	}
	export interface EditClientCompanyOwnerDto {
		Email: string;
	}
	export interface EditPermissionViewModel {
		MembershipUserId: string;
		MembershipType: Entities.MembershipType[];
	}
	export interface ExportYearsViewModel {
		StartDate: Day;
		EndDate: Day;
		VerificationCount: number;
		Id: string;
	}
	export interface FilenameWithOrgNumber {
		Filename: string;
		OrgNumber: string;
	}
	export interface FiscalYearAndAccountingType {
		FiscalYear: Core.ViewData.FiscalYearViewModel;
		AccountingForm: Entities.AccountingType;
	}
	export interface HelpCreateResult {
		Email: string;
	}
	export interface ImportResult {
		Success: boolean;
		State: string;
		SpecJson: string;
	}
	export interface ImportResult2 {
		Success: boolean;
		State: string;
		ImportSpec: Settings.Viewmodels.Import.ImportSpecViewModel;
	}
	export interface ImportYearsError {
	}
	export interface ImportYearsResult {
		State: string;
		IdMap: { [key: string]: string; };
	}
	export interface IsUsingUserSeatDto {
		MembershipType: Entities.MembershipType[];
	}
	export interface PartnerMembershipDto {
		PartnerId: string;
		PartnerName: string;
		IsActive: boolean;
		UserId: string;
	}
	export interface PickCompanyDto {
		OrgNumber: string;
	}
	export interface RegisterSearchDto {
		SearchString: string;
		ResultCount: number;
	}
	export interface RequiredDeleteCompanyActionDto {
		Type: Settings.Controllers.RequiredDeleteCompanyType;
		Data: string;
	}
	export enum RequiredDeleteCompanyType {
		BokioBusinessAccountActive = "BokioBusinessAccountActive",
		UnpaidSentInvoices = "UnpaidSentInvoices",
		ActiveSubscriptions = "ActiveSubscriptions",
		MoreUsersConnected = "MoreUsersConnected",
		ActiveBokioPlan = "ActiveBokioPlan",
		BokioBusinessAccountActiveOnboarding = "BokioBusinessAccountActiveOnboarding",
	}
	export interface ResendInviteAgencyToCompanyRequest {
		AgencyId: string;
		RequestId: string;
		InvitedUserId: string;
	}
	export enum SetAccountDetailsError {
		InvalidFiscalYear = "InvalidFiscalYear",
		AlreadyCompleted = "AlreadyCompleted",
		WrongStep = "WrongStep",
	}
	export interface SetCompanyDetailsDto {
		OrgNumber: string;
		CompanyName: string;
		CompanyType: Entities.CompanyType;
		Address: Entities.Address;
		PhoneNumber: string;
	}
	export interface SetCountrySubdivisionRequest {
		SubdivisionCode: string;
	}
	export interface SetRegistrationDateDto {
		RegistrationDate?: Date;
	}
	export enum SetRegistrationDateError {
		InvalidDate = "InvalidDate",
		CouldNotUpdateRegistrationDate = "CouldNotUpdateRegistrationDate",
		WrongStep = "WrongStep",
	}
	export interface SetTypeDto {
		Type: Entities.CompanyDraftType;
	}
	export interface SetupAgencyTestCompanyDto {
		AgencyId: string;
	}
	export interface SetupTestCompanyDto {
		CompanyName: string;
		CompanyType: Entities.CompanyType;
	}
	export interface SetupTestCompanyThroughPortalDto {
		CompanyName: string;
		CompanyDraftSource: Entities.CompanyDraftSource;
	}
	export interface StartDisableBankIdRequest {
		Password: Bokio.Common.Types.SecretString;
		TotpCode: Bokio.Common.Types.SecretString;
	}
	export interface StartEnableBokioPayBankIdAuthRequest {
		Password: Bokio.Common.Types.SecretString;
		TotpCode: Bokio.Common.Types.SecretString;
	}
	export interface StatusDto {
		LoggedIn: boolean;
		Email: string;
		UserId: string;
		EmployeeId?: string;
		Company: Settings.Controllers.CompanyInfoForView;
		UserConfiguration: Settings.Controllers.UserConfiguration;
		Access: Settings.Controllers.UserAccess;
		Name: string;
		FirstName: string;
		LastName: string;
		PhoneNumber: string;
		Features: Core.FeatureState[];
		EmailConfirmedUtc?: Date;
		UserHasBankIdLogin: boolean;
	}
	export enum TransferRoleError {
		Unknown = "Unknown",
		UserDoesNotHaveTransferredRole = "UserDoesNotHaveTransferredRole",
		NonOwnerTryingToAssignOwnership = "NonOwnerTryingToAssignOwnership",
	}
	export enum UpdateSenderDataError {
		GeneralError = "GeneralError",
		RequireNewLoginError = "RequireNewLoginError",
		SharedBBABlockError = "SharedBBABlockError",
	}
	export interface UploadedFileAndConfirmDto {
		ImportState: Entities.ImportState;
		Spec: Settings.Viewmodels.Import.ImportSpecViewModel;
		State: Entities.ImportState;
		SuggestedSettings: Settings.Viewmodels.Import.SuggestedSettings;
		FilesWithOrgNumber: Settings.Controllers.FilenameWithOrgNumber[];
		UploadedFilesHaveDifferentOrgNumbers: boolean;
		NeedConfirmBeforeImport: boolean;
	}
	export interface UploadedFileError {
		ParseErrors: string[];
	}
	export interface UserAccess {
		ViewBookkeeping: boolean;
		Bookkeep: boolean;
		UploadReceipt: boolean;
		UploadBank: boolean;
		Closures: boolean;
		Partner: boolean;
		Reports: boolean;
		SupportUser: boolean;
		Attest: boolean;
		Disbursements: boolean;
		UploadExpense: boolean;
		ImportantDates: boolean;
		Salaries: boolean;
		Invoices: boolean;
		AccountingSettings: boolean;
		InvoiceSettings: boolean;
		SalarySettings: boolean;
		CompanySettings: boolean;
		Inbox: boolean;
		AdminUsers: boolean;
		SupplierInvoices: boolean;
		BbaAccess: boolean;
	}
	export interface UserConfiguration {
		PrioSupport: boolean;
		Lang: string;
		SupportedLanguages: Core.Culture.CultureChoice[];
		ActivationStatus: Settings.Controllers.ActivationStatusDto;
	}
	export interface UserModel {
		UserId: string;
		FirstName: string;
		LastName: string;
		Email: string;
	}
	export interface UserPermissionModel {
		Invitations: Settings.Controllers.CompanyInvitationViewModel[];
		Users: Settings.Controllers.CompanyMembershipViewModel[];
		RequestToAgency: Settings.Controllers.ClientRequestViewModel;
		Accountants: Settings.Controllers.CompanyMembershipViewModel[];
		AgencyPermissions?: Entities.MembershipType[];
		PartnerHasAccess: boolean;
		AgencyName?: string;
		AgencyId?: string;
	}
	export interface UsersModel {
		Users: Settings.Controllers.UserModel[];
	}
	export interface UserToInvite {
		Id: string;
		Email: string;
	}
}
export namespace Settings.Models {
	export interface UpdateMoneyAccountRequest {
		MoneyAccounts: Settings.Viewmodels.MoneyAccountViewModel[];
	}
}
export namespace Settings.Requests {
	export interface AddCompanySavedPaymentMethodRequestDto {
		IsForeign: boolean;
		PaymentMethod: Entities.Invoices.InvoicePaymentMethod;
	}
	export interface AddToInboxWhitelistRequestDto {
		InboxId: string;
		Email: string;
		EmailUserId?: string;
		AllowUnsafeEmails: boolean;
	}
	export interface ConnectEmployeeToUserRequestDto {
		UserIdToConnect: string;
		EmployeeId: string;
		AllowedUploadExpense?: boolean;
	}
	export interface CreateInboxRequestDto {
		Name: string;
	}
	export interface DeleteInboxRequestDto {
		InboxId: string;
	}
	export interface EditCompanySavedPaymentMethodRequestDto {
		PaymentMethodId: string;
		PaymentMethod: Entities.Invoices.InvoicePaymentMethod;
	}
	export interface EditCompanyVatSettingRequestDto {
		CompanyVatSettingId: string;
		VatSetting: Entities.VatSetting;
	}
	export interface RemoveCompanyVatSettingRequestDto {
		CompanyVatSettingId: string;
	}
	export interface RemoveFromInboxWhitelistRequestDto {
		InboxId: string;
		Email: string;
	}
	export interface SaveDepreciationSettingsRequest {
		DepreciationFrequency: Entities.Accounting.DepreciationFrequency;
	}
	export interface SetAccountingMethodRequestDto {
		AccountingType: Entities.AccountingType;
	}
	export interface SetCompanyTypeRequestDto {
		CompanyType: Entities.CompanyType;
	}
	export interface SetNewCompanyVatSettingRequestDto {
		VatSetting: Entities.VatSetting;
		StartDate: Day;
	}
	export interface SetSenderDataRequestDto {
		SenderData: Entities.InvoiceSenderData;
	}
	export interface SetSenderFraudThresholdRequestDto {
		InboxId: string;
		Email: string;
		AllowUnsafeEmails: boolean;
	}
	export interface TransferRoleRequestDto {
		RoleUserId: string;
		Role: Entities.CompanyUserRoleType;
	}
	export interface UndoConnectEmployeeToUserRequestDto {
		UserIdToConnect: string;
		EmployeeId: string;
	}
	export interface UpdateInboxRequestDto {
		InboxId: string;
		Name: string;
	}
}
export namespace Settings.Viewmodels {
	export interface AccountOption {
		Label: string;
		AccountNumber: number;
	}
	export interface AccountOption {
		Label: string;
		AccountNumber: number;
	}
	export interface AccountOptionsViewModel {
		AssetAccounts: Settings.Viewmodels.AccountOption[];
		EquityAndLiabilitiesAccounts: Settings.Viewmodels.AccountOption[];
	}
	export interface Balance {
		Account: number;
		Value: number;
	}
	export interface BalancesViewModel {
		AssetBalances: Settings.Viewmodels.Balance[];
		EquityAndLiabilitiesBalances: Settings.Viewmodels.Balance[];
	}
	export interface CompanyPaymentMethodViewModel {
		Id: string;
		CompanyId: string;
		IsForeign: boolean;
		InvoicePaymentMethod: Entities.Invoices.InvoicePaymentMethod;
	}
	export interface CompanySettingsChangeFieldBlock {
		Field: Bokio.Common.Contract.CompanyContactSettings.BlockedFieldKey;
		Blocks: Bokio.Common.Contract.CompanyContactSettings.FieldBlock[];
	}
	export interface CompanyViewModel {
		Id: string;
		SenderData: Entities.InvoiceSenderData;
		Image: Entities.CompanyImage;
		CompanyColor: string;
		AddressPosition: Entities.CompanyAddressPosition;
		Payday: number;
		SignupEmail: string;
		FieldChangeBlocks: Settings.Viewmodels.CompanySettingsChangeFieldBlock[];
		HasFetchedCompanyInfo: boolean;
	}
	export interface ConversionBalancesForView {
		ConversionBalances: Model.Commands.Accounting.Imports.ConversionBalance[];
		ConversionDate?: Day;
		Accounts: Settings.Viewmodels.AccountOption[];
	}
	export interface MoneyAccountsViewModel {
		MoneyAccounts: Settings.Viewmodels.MoneyAccountViewModel[];
	}
	export interface MoneyAccountViewModel {
		Name: string;
		AccountName: string;
		AccountNumber: number;
		PreselectedInBookkeeping: boolean;
		PreselectedInInvoices: boolean;
		PreselectedInSalary: boolean;
		BankAccountType?: Entities.Bank.BankAccountType;
		ExternalSystem?: Entities.Bank.ExternalSystem;
	}
	export interface OpeningBalances {
		Assets: { [key: string]: number; };
		EquityAndLiabilities: { [key: string]: number; };
		SettingsId: string;
	}
	export interface OpeningBalancesError {
		ErrorCode: Settings.Viewmodels.OpeningBalancesErrorCode;
		ErrorMessage: string;
	}
	export enum OpeningBalancesErrorCode {
		MultipleInitialFiscalYears = "MultipleInitialFiscalYears",
		BalancesDoNotMatchFiscalYear = "BalancesDoNotMatchFiscalYear",
	}
	export interface OpeningBalancesViewModel {
		FirstFiscalYearId: string;
		Errors: Settings.Viewmodels.OpeningBalancesError[];
		FiscalYearStartDate: Day;
		FiscalYearEndDate: Day;
		AccountOptions: Settings.Viewmodels.AccountOptionsViewModel;
		Balances: Settings.Viewmodels.BalancesViewModel;
		FirstOpenFiscalYearId: string;
		IsUserSet: boolean;
	}
}
export namespace Settings.ViewModels {
	export interface ExitFeedbackDto {
		FeedbackOption: Entities.Feedback.FeedbackOption;
		FeedbackText: string;
		DisconnectType: Entities.Feedback.DisconnectType;
	}
	export interface ExportAuditHistoryMetaData {
		TotalItems: number;
		PageSize: number;
		PagesAvailable: number;
	}
	export interface InviteViewModel {
		Status: Entities.CompanyInvitationStatus;
		EmployeeId?: string;
		Email: string;
	}
	export interface SetCompanySystemDto {
		Confirmed: boolean;
		ChangeTo: Entities.CompanySystem;
	}
}
export namespace Settings.Viewmodels.Import {
	export interface CustomAccountViewModel {
		Settings: Core.ViewData.CompanySettingsForView;
		SettingsId: string;
		IsDelete: boolean;
		ConnectedTo?: number;
		Id: number;
		Text: string;
	}
	export interface ImportSpecViewModel {
		Years: Settings.Viewmodels.Import.ImportYearViewModel[];
		FiscalYearMismatches: Bokio.Accounting.Contract.SIE.Dtos.FiscalYearMismatch[];
		DigitsOnlyVerificationSeries: boolean;
		AccountsToAdd: Settings.Viewmodels.Import.CustomAccountViewModel[];
		OrgNumber: string;
		CompanyName: string;
		MismatchingSettingsAndImportYears: Bokio.Accounting.Contract.SIE.Dtos.SettingMissmatch[];
		FiscalYearsNeedingToBeOpened: Core.Services.FiscalYears.FiscalYearRangeDto[];
	}
	export interface ImportYearViewModel {
		IsUpdate: boolean;
		FiscalYear: Core.ViewData.FiscalYearViewModel;
		IncommingBalances: { [key: number]: number; };
		Verifications: Settings.Viewmodels.Import.VerificationWithSerieInfoViewModel[];
		FaultyVerifications: Bokio.Accounting.Contract.SIE.Dtos.FaultyVerification[];
		Setting: Core.ViewData.CompanySettingsForView;
		MissingVerifications: string[];
		IsTouched: boolean;
		VericationNumber: number;
		VerificationCount: number;
		IgnoredVerifications: Settings.Viewmodels.Import.VerificationWithSerieInfoViewModel[];
		VerificationCountDescription: string;
	}
	export interface SuggestedSettings {
		AccountingType: Entities.AccountingType;
		VatSetting: Entities.VatSetting;
		Name: string;
		OrgNumber: string;
		Differences: Settings.Viewmodels.Import.SuggestedSettingsDifferences[];
		ShowDiffenceWarnings: boolean;
	}
	export enum SuggestedSettingsDifferences {
		Name = "Name",
		OrgNumber = "OrgNumber",
		VatSetting = "VatSetting",
		AccountingMethod = "AccountingMethod",
	}
	export interface VerificationWithSerieInfoViewModel {
		Verification: Core.ViewData.VerificationForList;
		VerificationSerieLabel: string;
		VerificationSequenceNumber?: number;
	}
}
export namespace SettingsNoConflict.ViewModels {
	export interface CompanyMembershipDto {
		CompanyId: string;
		CompanyName: string;
		IsActive: boolean;
		OrgNumber: string;
		CompanyType: Entities.CompanyType;
		UserId: string;
		CompanySystem: Entities.CompanySystem;
		CurrentBokioPlan: Entities.BokioPlan;
	}
}
